/* eslint-disable */
// @ts-nocheck
import * as XlsxExport from './xlsx-export';
import {
  COHORT_METHODS, COHORT_METHOD_LABEL, COHORT_N_LIMITS, DEFAULT_COHORT_RULE,
  COHORT_CHIP_NAME, COHORT_METHOD_TIP, COHORT_SCREEN_NAME, NEWER_COHORTS, OLDER_COHORTS, PICKER_MAIN, PICKER_METHODS, PICKER_OTHER, RECENT_N_LIMITS,
  cohortInputKey, cohortRuleTag, defaultRuleFor, describeCohortChoice, describeCohortRule, describeCohortRuleFull, describeSplitRule, forecastCohortRates,
  isPickerMethod, migrateCohortRule, normalizeCohortRule, parseCohortYm, resolveCohortRule, sameCohortRule, sanitizeCohortInput
} from './cohort-forecast';
import { COHORT_GUARD_ENGINE_VERSION, GUARD_IDS, GUARD_OF_PARAM, GUARD_PARAMS, RETENTION_PARAMS, TREND_WINDOW_CHOICES, cohortGuardKey, forecastGuardedCohorts, frozenGuardValues, isValidGuardParam, resolveConstants, sanitizeCohortGuards, usesFlatTail, usesRetentionChange, usesSeasonRatio } from './cohort-guards';
import { AUTO_MIN_MONTHS, FULL_YEAR_WINDOW, actualMonthsOf, backTestWindow, pickAutoRule, sanitizeAutoChoices, seasonAllowed, trendAllowed, tuneCohortSettings } from './cohort-auto';
import { FIXED_CONVERTED_NOTE, SYSTEM_ACTOR, cellReviewKey, reviewHolds, reviewReopened, sanitizeFlagReviews, sanitizeOverrideInfo } from './cohort-review';
import { CLIENT_PARAMS, CONSTANT_GUIDE, GUARD_FLAG_RULE, GUARD_LABEL, PARAM_GUIDE, ageGroupsOf, formatConstant, formatGuardValue, formatMonth, guardStateOf, guardValueText, limitPct, maxYearlyChange, parseGuardConstant, parseGuardValue, parseLimitPct } from './cohort-guard-guide';
import { guardHelp } from './cohort-guard-help';
import { METHOD_CONSTANTS } from './cohort-guard-defaults';
import { MANUAL_CATEGORY_NOTE, MANUAL_MIX_ACTUAL_NOTE, describeMixRule, forecastMix, mixInputKey, mixRuleSources, mixRuleTag, resolveMixRule, sanitizeMixInput } from './mix-forecast';
import {
  CPS_METHODS, CPS_MISSING_NOTE, DEFAULT_CPS_RULE, DIRECT_RULE, MANUAL_ACTUAL_NOTE, MANUAL_SOURCE_NOTE, PEAK_NOTE, SESSION_METHODS, SOURCE_METHOD_LABEL,
  defaultSourceRuleFor, describeSourceRule, forecastSources, normalizeSourceRule, resolveCpsRule, resolveSessionRule,
  sanitizeCpsInput, sanitizeSessionInput, seededSessionRule, sourceDriverKey, sourceRuleLimits, sourceRuleTag
} from './source-forecast';
import { MODEL_GUIDE_SHEET, buildModelGuide } from './model-guide';
import { FORMULA_FUNCTIONS, ROLLUP_FUNCTIONS, ROLLUP_SOURCE, TOTALS_MODES, cohortEntrantsToken, combineTotals, evaluateRows, formulaFunctions, formulaLevers, formulaRefs, formulaToExcel, isArithmeticFormula, isInputSource, isOverwriteInput, isRollupSource, isValidFormula, isValidRollup, OVERWRITE_INPUT, overwriteRefs, parseFormula, rollupChannels, scenarioLever, skippedNote, sumCells, totalsModeOf } from './driver-calc';

const DIMS = ["channel", "order_type", "product"];
const FN = FORMULA_FUNCTIONS.concat(["c", "t", "p"]);
const MN = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const ml = ym => MN[(ym % 100) - 1] + " " + String(ym).slice(2, 4);
const GUARD_STATE_TEXT = { on: "On", off: "Off", needs: "Needs a decision" };
const CHANGE_LOG_PAGE = 50;
const DELETED_DRIVER_SOURCE = "DELETE";
const CREATED_DRIVER_SOURCE = "CREATE";
const PUBLISH_SOURCE = "PUBLISH";
const SCENARIO_SOURCE = "SCENARIO";
const CUTOFF_SOURCE = "CUTOFF";
const AUTO_SOURCE = "AUTO";
const SETTING_LABEL = Object.freeze({
  key: "Driver key",
  name: "Name",
  section: "Section",
  source: "Plan source",
  formula: "Formula",
  binding: "Binding",
  unit: "Unit",
  totals: "Totals",
  totals_formula: "Totals formula",
  rollup: "Rollup rule"
});
const CHANGE_LOG_FILTER = Object.freeze({ from: "", to: "", user: "", channel: "", driver: "" });
const CHANGE_LOG_EMPTY = Object.freeze({ batches: [], total: 0, changes: 0, loading: false, loaded: false, error: "" });
const atLabel = at => {
  if (!Number.isFinite(at)) return "—";
  const d = new Date(at);
  const pad = n => String(n).padStart(2, "0");
  return pad(d.getDate()) + " " + MN[d.getMonth()] + " " + d.getFullYear() + " " + pad(d.getHours()) + ":" + pad(d.getMinutes());
};
const parseAt = v => {
  const ms = v ? Date.parse(v) : NaN;
  return Number.isFinite(ms) ? ms : null;
};
function buildHorizonOptions(horizonNow) {
  const h = Math.max(0, +horizonNow || 0);
  const set = new Set();
  if (h > 0) set.add(h);
  const max = Math.max(h + 24, h);
  for (let x = 6; x <= max; x += 6) set.add(x);
  return Array.from(set).filter(x => x > 0).sort((a, b) => a - b).map(x => ({ value: String(x), label: String(x) + " months" }));
}
const ROUNDING_DP = [0, 1, 2, 3, 4];
function roundingDp(v) {
  return ROUNDING_DP.indexOf(v) >= 0 ? v : null;
}
const NO_COHORT_INPUT = {};
const LIVE_AUTO = {};
const flagRulesOf = list => (list || []).map(f => f.rule).filter((r, i, all) => all.indexOf(r) === i).sort();
function dayText(at) {
  const d = at ? new Date(at) : null;
  return d && !isNaN(d.getTime()) ? d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "2-digit" }) : "";
}
function guardUserNote(info) {
  const when = dayText(info.at);
  return ["Set by user", [info.by, when ? "on " + when : ""].filter(Boolean).join(" ")].filter(Boolean).join(" · ");
}
function thresholdSource(R) {
  const info = R.params.ownHistoryMinMonths;
  if (info && info.source === "user") return "by " + (info.by || "a user") + (dayText(info.at) ? " on " + dayText(info.at) : "");
  return "from your data" + (dayText(R.ownChangedAt) ? ", last changed " + dayText(R.ownChangedAt) : "");
}
const RETENTION_CHANGE_DESC = "Plan a change in how many customers come back. +5% lifts every forecast repeat rate, the bundle included, by 5% from the start month. 0% follows the data.";
const RETENTION_START_DESC = "The first month the retention change applies. Earlier months, first month orders and typed rates never change.";
const reviewRulesText = rules => rules.length ? rules.map(r => GUARD_FLAG_RULE[r] || r).join(", ") : "none";
const pctOfRate = v => (Math.round(v * 1e4) / 100).toFixed(2) + "%";
function reopenText(change) {
  if (change.why === "rules") return "Reopened: the rules broken changed from " + reviewRulesText(change.before) + " to " + reviewRulesText(change.after);
  return change.after === null ? "Reopened: the cell no longer has a value" : "Reopened: the value changed from " + pctOfRate(change.before) + " to " + pctOfRate(change.after);
}
const SYSTEM_FIT_RULE = Object.freeze({ method: "seasonal", n: 3 });
function systemFitSeries(months, cut, series) {
  const history = {};
  months.forEach((ym, i) => {
    const v = series ? series[i] : null;
    if (i <= cut && typeof v === "number" && Number.isFinite(v)) history[ym] = v;
  });
  return forecastMix({ months, cut, cats: [{ name: "", base: null, history }], ruleFor: () => SYSTEM_FIT_RULE, allowNegative: true }).values[0];
}
const UNIT_SYMBOL = { currency: "£", percentage: "%", ratio: "×", count: "#" };
const ALL_BLOCKS = "all";
let CHANNEL_NS = {};
let BL = {};

function channelCode(ch) {
  return String(ch || "").toUpperCase();
}
function channelNs(ch) {
  if (ch === "all") return "group";
  return CHANNEL_NS[ch] || String(ch || "");
}
function channelBlocks(ch, D) {
  const conf = D && D.channels ? D.channels[ch] : null;
  if (ch === "all") {
    const all = [];
    Object.keys((D && D.channels) || {}).forEach(c => channelBlocks(c, D).forEach(b => { if (all.indexOf(b) < 0) all.push(b); }));
    return all;
  }
  return conf && Array.isArray(conf.blocks) ? conf.blocks.map(b => String(b).toLowerCase()) : [];
}
function isCombined(D, ch) {
  const conf = D && D.channels ? D.channels[ch] : null;
  return !!conf && Array.isArray(conf.members) && conf.members.length > 0;
}
function isCustom(D, ch) {
  const conf = D && D.channels ? D.channels[ch] : null;
  return !!conf && String(conf.model || "").toLowerCase() === "custom" && !isCombined(D, ch);
}
function refChannelOf(D, ch, token) {
  const t = String(token || "").trim(), dot = t.indexOf(".");
  if (dot <= 0) return null;
  const head = t.slice(0, dot);
  const ids = Object.keys((D && D.channels) || {}).filter(c => c !== "all" && c !== ch && !isCustom(D, c));
  const cid = ids.find(c => channelNs(c) === head) || ids.find(c => c === head);
  return cid ? { cid, local: t.slice(dot + 1) } : null;
}
function membersOf(D, ch) {
  if (!isCombined(D, ch)) return [];
  return D.channels[ch].members.filter(m => m !== ch && D.channels[m] && !isCombined(D, m));
}
function baseChannels(D) {
  return Object.keys((D && D.channels) || {}).filter(c => c !== "all" && D.channels[c] && !isCombined(D, c));
}
function applyChannelNamespaces(D) {
  CHANNEL_NS = {};
  const labels = (D && D.blockLabels) || {};
  BL = Object.assign({}, labels);
  Object.keys((D && D.channels) || {}).forEach(ch => {
    const conf = D.channels[ch];
    if (conf && conf.namespace) CHANNEL_NS[ch] = String(conf.namespace);
    channelBlocks(ch, D).forEach(b => { if (!BL[b]) BL[b] = b.toUpperCase(); });
  });
}

const keyLeaf = key => String(key || "").split(".").pop();
const keyLocal = key => String(key || "").split(".").slice(1).join(".");
function currentDriverKey(D, key) {
  const catalogs = (D && D.catalog) || {};
  for (const ch of Object.keys(catalogs)) {
    const hit = (catalogs[ch] || []).find(c => c && (c.previousKeys || []).indexOf(key) >= 0);
    if (hit) return hit.key;
  }
  return key;
}

function acqRowOf(conf, k) {
  const rows = conf && Array.isArray(conf.acqRows) ? conf.acqRows : [];
  return rows.find(r => r && r.key === k) || null;
}

const originKey = r => (r.previousKeys && r.previousKeys.length ? r.previousKeys[r.previousKeys.length - 1] : r.key);

function leafOwners(rows) {
  const owners = {};
  rows.forEach(r => {
    const leaf = keyLeaf(originKey(r));
    (owners[leaf] = owners[leaf] || new Set()).add(r.k);
  });
  return owners;
}

function bindKeyOf(r, owners) {
  const origin = originKey(r), leaf = keyLeaf(origin);
  return owners[leaf] && owners[leaf].size === 1 ? leaf : keyLocal(origin).replace(/\./g, "_");
}

function actualsKeyOf(binding) {
  const text = String(binding || "").trim();
  if (!text || text === "—") return null;
  const named = text.match(/driver_key\s*=\s*([A-Za-z][A-Za-z0-9_.]*)/i);
  if (named) return named[1];
  return /^[A-Za-z][A-Za-z0-9_.]*$/.test(text) ? text : null;
}

function bindCandidates(r, owners) {
  const out = [];
  const put = k => { const t = String(k || "").trim(); if (t && out.indexOf(t) < 0) out.push(t); };
  put(bindKeyOf(r, owners));
  put(r.key);
  put(keyLocal(r.key));
  put(keyLocal(r.key).replace(/\./g, "_"));
  put(r.k);
  (r.previousKeys || []).forEach(p => { put(p); put(keyLocal(p)); put(keyLocal(p).replace(/\./g, "_")); });
  return out;
}

function resolveBindKey(conf, r, owners) {
  const bound = actualsKeyOf(r.binding);
  if (bound) return bound;
  const candidates = bindCandidates(r, owners);
  const hit = candidates.find(k => actualSeriesOf(conf, k));
  return hit || candidates[0] || r.k;
}

function rowTokenMap(rows) {
  const valid = (rows || []).filter(r => r && r.key && r.k);
  const owners = leafOwners(valid);
  const map = {};
  const put = (t, k) => { if (t && !map[t]) map[t] = k; };
  valid.forEach(r => { put(r.key, r.k); put(keyLocal(r.key), r.k); });
  valid.forEach(r => { put(bindKeyOf(r, owners), r.k); put(keyLocal(r.key).replace(/\./g, "_"), r.k); });
  valid.forEach(r => put(r.k, r.k));
  valid.forEach(r => (r.previousKeys || []).forEach(p => { put(p, r.k); put(keyLocal(p), r.k); }));
  return map;
}

function renameCatalogKey(D, ch, from, to) {
  const cat = D && D.catalog ? D.catalog[ch] : null;
  const idx = Array.isArray(cat) ? cat.findIndex(c => c && c.key === from) : -1;
  if (idx < 0 || cat.some(c => c && c.key === to)) return false;
  const row = cat[idx];
  cat[idx] = Object.assign({}, row, { key: to, previousKeys: [from].concat((row.previousKeys || []).filter(k => k !== from && k !== to)) });
  return true;
}

function actualSeriesOf(conf, key) {
  const actuals = conf && conf.actuals;
  if (!actuals || typeof actuals !== "object" || !key) return null;
  const want = String(key).toLowerCase();
  const hit = Object.keys(actuals).find(k => k.toLowerCase() === want);
  return hit && Array.isArray(actuals[hit]) ? actuals[hit] : null;
}

function actualRoute(ch, D, r) {
  if (!r) return null;
  if (r.store) return r.store;
  return r.src === "input" || r.src === "binding" ? "inputs" : null;
}

function rowBlock(r) {
  return r.block || r.opens || r.homeSec || r.sec;
}

function storeHolder(ch, D, r, create) {
  const conf = D && D.channels ? D.channels[ch] : null;
  const route = actualRoute(ch, D, r);
  if (!conf || !route) return null;
  const own = (obj, prop) => {
    if (!obj[prop] || typeof obj[prop] !== "object") {
      if (!create) return null;
      obj[prop] = {};
    }
    return obj[prop];
  };
  const [scope, field] = route.split(".");
  if (scope === "acq") {
    if (!Array.isArray(conf.acqRows)) { if (!create) return null; conf.acqRows = []; }
    let row = acqRowOf(conf, r.k);
    if (!row) { if (!create) return null; conf.acqRows.push(row = { key: r.k, label: r.name, values: null }); }
    return { obj: row, prop: "values" };
  }
  if (scope === "block") { const blk = own(conf, rowBlock(r)); return blk ? { obj: blk, prop: field } : null; }
  if (scope === "total") { const tot = own(conf, "total"); return tot ? { obj: tot, prop: field } : null; }
  if (scope === "inputs") {
    if (!D.inputs) { if (!create) return null; D.inputs = {}; }
    const one = own(D.inputs, ch);
    return one ? { obj: one, prop: r.k } : null;
  }
  if (scope === "kpis") { const kpis = own(conf, "kpis"); return kpis ? { obj: kpis, prop: r.k } : null; }
  return null;
}

function storedSeries(ch, D, r) {
  const h = r ? storeHolder(ch, D, r, false) : null;
  return h && Array.isArray(h.obj[h.prop]) ? h.obj[h.prop] : null;
}

function actualSlot(ch, D, r) {
  const h = storeHolder(ch, D, r, true);
  if (!h) return null;
  if (!Array.isArray(h.obj[h.prop])) h.obj[h.prop] = D.months.map(() => null);
  const arr = h.obj[h.prop];
  while (arr.length < D.months.length) arr.push(null);
  return arr;
}

function bindChannelActuals(D, rowsOf) {
  const rows = rowsOf || (ch => buildRows(ch, D));
  Object.keys(D.channels || {}).forEach(ch => {
    const conf = D.channels[ch];
    if (ch === "all" || !conf || !conf.actuals) return;
    rows(ch).forEach(r => {
      const series = actualSeriesOf(conf, r.bindKey);
      const slot = series ? actualSlot(ch, D, r) : null;
      if (!slot) return;
      series.forEach((v, i) => { if (i < slot.length && v !== null && v !== undefined) slot[i] = +v; });
    });
  });
}

function plannedSeries(D, rowsOf) {
  const out = {};
  Object.keys(D.channels || {}).forEach(ch => {
    const conf = D.channels[ch];
    if (ch === "all" || !conf) return;
    const one = out[ch] = {};
    (conf.acqRows || []).forEach(row => { if (row && row.key && Array.isArray(row.values)) one[row.key] = row.values.slice(); });
    rowsOf(ch).forEach(r => {
      if (!r.ed) return;
      const s = storedSeries(ch, D, r);
      if (s) one[r.ed] = s.slice();
    });
  });
  return out;
}

function keepPlannedMonths(inputs, planned, cut) {
  Object.keys(planned).forEach(ch => {
    const one = inputs[ch];
    if (!one) return;
    Object.keys(one).forEach(key => {
      const p = planned[ch][key], arr = one[key];
      if (!Array.isArray(p) || !Array.isArray(arr)) return;
      for (let i = cut + 1; i < arr.length && i < p.length; i++) {
        if (p[i] !== null && p[i] !== undefined) arr[i] = p[i];
      }
    });
  });
}

const SECTION_LABEL = { acq: "Acquisition", subs: "Subs revenue", otp: "OTP revenue", total: "Total revenue", pl: "Profit", kpi: "Other" };
const PLAN_SOURCES = ["input", "formula", "binding", "cohort", "mix", ROLLUP_SOURCE];
const MODEL_SOURCES = ["cohort", "mix"];
const COMBINED_SOURCES = [ROLLUP_SOURCE, "input", "formula"];
const SRC_LABEL = { input: "INPUT", formula: "FORMULA", binding: "SOURCE", cohort: "COHORT", mix: "MIX", rollup: "ROLLUP" };
const SRC_ALIAS = { source: "binding", base: "cohort" };
const MEMBER_SOURCES = { binding: "binding", source: "binding", snowflake: "binding", cohort: "cohort", base: "cohort", mix: "mix" };
const COMBINED_SRC_NOTE = {
  binding: "Each channel copies its actual values from your data.",
  cohort: "Each channel works it out with its cohort model.",
  mix: "Each channel works it out from its product mix."
};
const SRC_NOTE = {
  input: "Planners type the forecast values on the plan. Actuals still come from your data up to the cutoff.",
  formula: "Worked out from other drivers with the formula below.",
  binding: "Copies the actual values from your data for every month up to the cutoff.",
  source: "Comes from the session sources connected to this channel.",
  cohort: "Worked out by the cohort model from entrants and repurchase rates.",
  base: "Worked out by the cohort model from entrants and repurchase rates.",
  mix: "Worked out from the product mix.",
  rollup: "Rolled up from the channels it combines with the rule below, for actuals and forecast.",
  fitted: "The model estimates it from other drivers, for example CAC = ad spend ÷ new customers."
};
const UNIT_LABEL = { currency: "Money", percentage: "Percentage", count: "Count", ratio: "Ratio" };
const MANUAL_DRIVER_NOTE = "Manual driver · saved in the app, not Snowflake. Every month is editable, including actuals, and accepts + or − values.";
const DIM_LABEL = { channel: "Channel", order_type: "Order type", product: "Product" };
const TMP_LABEL = { activity: "By month", cohort: "By cohort and month", none: "No time split" };
const TOTALS_LABEL = { add_up: "Add up", formula: "Formula", no_totals: "No totals" };
const editDistance = (s, t) => {
  let prev = Array.from({ length: t.length + 1 }, (_, j) => j);
  for (let i = 1; i <= s.length; i++) {
    const cur = [i];
    for (let j = 1; j <= t.length; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (s[i - 1] === t[j - 1] ? 0 : 1));
    prev = cur;
  }
  return prev[t.length];
};
const suggestDriverKeys = (token, rows, limit = 3) => {
  const qualified = token.indexOf(".") >= 0;
  const local = token.split(".").pop().toLowerCase();
  if (local.length < 3) return [];
  return rows
    .map(r => {
      const last = r.key.split(".").pop();
      const forms = [last, r.k, driverKeySlug(r.name)].map(f => String(f || "").toLowerCase()).filter(Boolean);
      const score = Math.min(...forms.map(f => {
        const ratio = editDistance(local, f) / Math.max(local.length, f.length);
        return f.length >= 4 && (f.indexOf(local) >= 0 || local.indexOf(f) >= 0) ? Math.min(ratio, 0.3) : ratio;
      }));
      return { key: qualified ? r.key : last, name: r.name, score };
    })
    .filter(s => s.score <= 0.4)
    .sort((x, y) => x.score - y.score)
    .filter((s, i, all) => all.findIndex(o => o.key === s.key) === i)
    .slice(0, limit);
};
const FORMULA_PART_LABEL = Object.freeze({
  formula: "Formula",
  fallback: "Fallback formula",
  overwrite: "Overwrite formula",
  rollup: "Rollup rule",
  totals: "Totals formula"
});
const FORMULA_WORDS = DIMS.concat(["c", "t", "p", "entrants"]);
const ROLLUP_RULE_FUNCTIONS = FORMULA_FUNCTIONS.concat(ROLLUP_FUNCTIONS);
const driverFormulas = r => {
  const src = String(r.src || "").toLowerCase();
  const parts = [];
  if (isRollupSource(src)) parts.push(["rollup", r.rollup]);
  else if (isInputSource(src)) {
    parts.push(["fallback", r.fallback], ["overwrite", src === "input" ? r.overwrite : ""]);
    if (r.combined) parts.push(["rollup", r.rollup]);
  } else parts.push(["formula", r.formula]);
  if (totalsModeOf(r) === "formula") parts.push(["totals", r.totalsFormula]);
  return parts.filter(p => String(p[1] || "").trim());
};
const formulaProblem = (part, text, row, rows, resolve, resolveAny) => {
  const node = parseFormula(text);
  if (!node) return { title: "formula can't be read" };
  const allowed = part === "rollup" ? ROLLUP_RULE_FUNCTIONS : FORMULA_FUNCTIONS;
  const badFns = formulaFunctions(node).filter(f => allowed.indexOf(f) < 0);
  if (badFns.length) return { title: "unknown function " + badFns.join(", ") };
  const refs = formulaRefs(node).filter(t => FORMULA_WORDS.indexOf(t) < 0 && !(part === "overwrite" && isOverwriteInput(t)));
  const unknown = refs.filter(t => !resolve(t) && !resolveAny(t));
  if (unknown.length) {
    const fixes = unknown.map(t => suggestDriverKeys(t, rows, 1)[0]).filter(Boolean).map(s => s.key);
    return { title: "unknown driver key " + unknown.join(", "), hint: fixes.length ? "Did you mean " + fixes.join(", ") + "?" : "" };
  }
  if ((part === "formula" || part === "fallback") && refs.some(t => resolve(t) === row.k)) return { title: "formula refers to itself" };
  return null;
};
const replaceFormulaToken = (formula, from, to) => String(formula || "")
  .replace(new RegExp("(^|[^A-Za-z0-9_.])" + from.replace(/\./g, "\\.") + "(?![A-Za-z0-9_.])", "g"), (m, p) => p + to);
const driverKeySlug = name => String(name || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "") || "new_driver";
const unitIdOf = unit => unit === "£" ? "currency" : unit === "%" ? "percentage" : unit === "×" ? "ratio" : "count";
const dimsOf = dim => String(dim || "[]").replace(/[\[\]\s]/g, "").split(",").filter(Boolean);
const PLAN_SECTIONS = ["acq", "subs", "otp", "total", "pl", "kpi"];
const trendPeriodText = w => (w === 12 ? "a year" : "per " + w + " months");
const trendTimesText = (w, n) => (w === 12 ? n + (n === 1 ? " year" : " years") : "applied " + (n === 1 ? "once" : n + " times"));

function isPlanSection(sec) {
  return PLAN_SECTIONS.indexOf(sec) >= 0;
}
function planSectionOf(sec) {
  const s = String(sec || "").trim().toLowerCase();
  return isPlanSection(s) ? s : "kpi";
}
const RAW_KEY_NAME = /^[a-z][a-z0-9]*(_[a-z0-9]+)*$/;
const KEY_WORDS = {
  aov: "AOV", otp: "OTP", subs: "subs", cogs: "COGS", sku: "SKU", ltv: "LTV", cac: "CAC", roas: "ROAS", kpi: "KPI",
  po: "per order", pu: "per unit", pct: "%", txn: "transaction", disc: "discount", ret: "return", rev: "revenue",
  ship: "shipping", conv: "conversion", upo: "units per order", opex: "opex", qty: "quantity", avg: "average", fy: "FY"
};
function readableDriverName(name, fallback) {
  const s = String(name || "").trim();
  const fb = String(fallback || "").trim();
  if (s && !RAW_KEY_NAME.test(s)) return s;
  if (fb && !RAW_KEY_NAME.test(fb)) return fb;
  const words = (s || fb).split("_").filter(Boolean).map(w => KEY_WORDS[w] || w).join(" ");
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : "";
}
function planSectionsFor(blocks) {
  return ["acq"].concat(blocks).concat(blocks.length > 1 ? ["total"] : []).concat(["pl", "kpi"]);
}

function retargetChannelRefs(text, from, to) {
  if (text == null) return text;
  const swap = { [channelNs(from)]: channelNs(to), [from]: to };
  return String(text).replace(/(^|[^A-Za-z0-9_.])([A-Za-z_][A-Za-z0-9_]*)\./g, (m, pre, head) => (Object.prototype.hasOwnProperty.call(swap, head) ? pre + swap[head] + "." : m));
}

function retargetDriverKey(key, from, to) {
  const next = retargetChannelRefs(key, from, to);
  return next !== key ? next : channelNs(to) + "." + keyLeaf(key);
}

const CLONE_REF_SKIP = FN.concat(DIMS, ROLLUP_FUNCTIONS, [OVERWRITE_INPUT, "entrants"]);

function clonedDriverRefs(d) {
  const texts = [];
  if (String(d.src || "formula").toLowerCase() === "formula") texts.push(d.formula);
  if (totalsModeOf(d) === "formula") texts.push(d.totalsFormula);
  texts.push(d.overwrite, d.rollup);
  const refs = [];
  texts.forEach(t => (String(t || "").replace(/"[^"]*"/g, " ").match(/[A-Za-z_][A-Za-z0-9_.]*/g) || []).forEach(x => {
    if (CLONE_REF_SKIP.indexOf(x) < 0 && refs.indexOf(x) < 0) refs.push(x);
  }));
  return refs;
}

const PRODUCT_MIX_DEFAULT = {};
let PRODUCT_MIX = {};
let SESSION_SOURCES = {};

const capCogsPct = v => Math.min(1, v);

function applyProductMixFromSettings(settings) {
  const src = settings && settings.productMix;
  if (!src || typeof src !== "object") {
    PRODUCT_MIX = {};
    return;
  }
  const next = {};
  Object.keys(src).forEach(ch => {
    const rows = src[ch];
    if (!Array.isArray(rows) || !rows.length) {
      next[ch] = [];
      return;
    }
    const equal = 1 / rows.length;
    next[ch] = rows.map(r => {
      const name = r.name || r.Name || "Category";
      const mix = r.mixPct != null ? +r.mixPct : (r.MixPct != null ? +r.MixPct : equal);
      const cogs = r.cogsPct != null ? +r.cogsPct : (r.CogsPct != null ? +r.CogsPct : null);
      const hist = r.mixByPeriod || r.MixByPeriod;
      const cogsHist = r.cogsByPeriod || r.CogsByPeriod;
      const cogsByPeriod = cogsHist && typeof cogsHist === "object"
        ? Object.keys(cogsHist).reduce((acc, k) => { const v = +cogsHist[k]; if (Number.isFinite(v)) acc[k] = capCogsPct(v); return acc; }, {})
        : null;
      const manual = r.manual === true || r.Manual === true;
      const mixHist = hist && typeof hist === "object" ? (manual ? Object.assign({}, hist) : hist) : null;
      return [name, Number.isFinite(mix) ? mix : equal, cogs !== null && Number.isFinite(cogs) ? capCogsPct(cogs) : null, mixHist, cogsByPeriod, manual];
    });
  });
  PRODUCT_MIX = next;
}

function applySessionSourcesFromSettings(settings, months) {
  const src = settings && settings.sessionSources;
  if (!src || typeof src !== "object") {
    SESSION_SOURCES = {};
    return;
  }
  const n = Array.isArray(months) ? months.length : 0;
  const next = {};
  Object.keys(src).forEach(ch => {
    const rows = Array.isArray(src[ch]) ? src[ch] : [];
    next[ch] = rows.map(r => {
      const name = String(r.name || r.Name || "").trim();
      const key = String(r.key || r.Key || "").trim() || sourceKeyOf(ch, name);
      const ad = Array.isArray(r.adSpend) ? r.adSpend.slice() : (Array.isArray(r.AdSpend) ? r.AdSpend.slice() : []);
      const sess = Array.isArray(r.sessions) ? r.sessions.slice() : (Array.isArray(r.Sessions) ? r.Sessions.slice() : []);
      const cps = Array.isArray(r.costPerSession) ? r.costPerSession.slice() : (Array.isArray(r.CostPerSession) ? r.CostPerSession.slice() : []);
      while (ad.length < n) ad.push(null);
      while (sess.length < n) sess.push(null);
      while (cps.length < n) cps.push(null);
      const manual = r.manual === true || r.Manual === true;
      const actualOf = v => (Array.isArray(v) ? v.slice(0, n) : null);
      return Object.assign(
        { key, name, manual, ad: ad.slice(0, n), sess: sess.slice(0, n), cps: cps.slice(0, n) },
        manual ? null : { actualAd: actualOf(r.actualAdSpend || r.ActualAdSpend), actualSess: actualOf(r.actualSessions || r.ActualSessions) }
      );
    }).filter(r => r.name);
  });
  SESSION_SOURCES = next;
}

function channelHasSources(ch) {
  return !!(SESSION_SOURCES[ch] && SESSION_SOURCES[ch].length);
}

const SOURCE_FIELD = { ad_spend: "ad", sessions: "sess" };
const SOURCE_FILTER = { manual: s => !!(s && s.manual) };
const MANUAL_FILTER = "manual";
const sourceLever = sourceKey => "src:" + sourceKey;
const readsSource = (r, field, filter = null) => new RegExp("\\bSOURCES\\s*\\(\\s*\"" + field + "\"\\s*" + (filter ? ",\\s*\"" + filter + "\"\\s*" : "") + "\\)", "i").test(String((r && r.formula) || ""));
const readsSourceSpend = r => readsSource(r, "ad_spend");
const driverOverwrite = d => String((d && d.overwrite) || "").trim() || null;
const formulaReadsSources = r => !!r && r.src === "formula" && /\bSOURCES\s*\(/i.test(String(r.formula || ""));
const sourceBoundDef = c => !!(c && c.sourced) && ((c.sourced.src || c.src) === "source" || (c.sourced.opens || c.opens) === "source");

function spendSources(ch) {
  return (SESSION_SOURCES[ch] || []).filter(s => (s.ad || []).some(v => typeof v === "number" && v > 0));
}

const SOURCE_METRIC_LABEL = { ad: "ad spend", sess: "sessions", cps: "cost per session" };

function sourceKeyOf(ch, name) {
  return channelNs(ch) + ".marketing_source." + driverKeySlug(name);
}

function sourceCellKey(si, metric, t) {
  return metric + ":" + si + ":" + t;
}

function sourceSeriesOf(row, metric, n) {
  const field = metric === "ad" ? "ad" : metric === "cps" ? "cps" : "sess";
  if (!Array.isArray(row[field])) row[field] = new Array(n).fill(null);
  while (row[field].length < n) row[field].push(null);
  return row[field];
}

const CHANGE_GOOD_FG = "#1A7F4B";
const CHANGE_BAD_FG = "#E5484D";

const SAVED_SETTINGS_KEYS = ["drivers", "rowCfg", "rowOrd", "rowDesc", "scenarioOn", "cohortInput", "mixInput", "cogsInput", "srcInput", "cpsInput", "scenarios"];

function planWasSaved(settings) {
  return SAVED_SETTINGS_KEYS.some(k => {
    const v = settings ? settings[k] : null;
    if (Array.isArray(v)) return v.length > 0;
    return !!v && typeof v === "object" && Object.keys(v).length > 0;
  });
}

function hasTypedForecast(row, cut) {
  const typed = s => Array.isArray(s) && s.some((v, i) => i > cut && v !== null && v !== undefined);
  return typed(row.sess) || typed(row.cps);
}

function seedSessionRules(settings, cut) {
  const seeded = {};
  if (planWasSaved(settings)) return seeded;
  Object.keys(SESSION_SOURCES).forEach(ch => {
    (SESSION_SOURCES[ch] || []).forEach(row => {
      if (hasTypedForecast(row, cut)) return;
      seeded[row.key] = seededSessionRule(row.key);
    });
  });
  return seeded;
}

function periodIndex(months, period) {
  if (period === null || period === undefined || !Array.isArray(months)) return null;
  const i = months.indexOf(+period);
  return i >= 0 ? i : null;
}

function nextPeriod(ym) {
  return ym % 100 === 12 ? (Math.floor(ym / 100) + 1) * 100 + 1 : ym + 1;
}

function lastValueBefore(series, t) {
  for (let i = Math.min(t, series.length) - 1; i >= 0; i--) {
    const v = series[i];
    if (v !== null && v !== undefined) return v;
  }
  return null;
}

function dropSeededMixOverrides(settings, mov) {
  const src = settings && settings.productMix;
  const next = Object.assign({}, mov || {});
  if (!src || typeof src !== "object") return next;
  Object.keys(next).forEach(key => {
    const m = /^(.+)\|p(\d+)\|\d+$/.exec(key);
    const row = m && Array.isArray(src[m[1]]) ? src[m[1]][+m[2]] : null;
    if (!row) return;
    const mix = row.mixPct != null ? +row.mixPct : (row.MixPct != null ? +row.MixPct : null);
    if (mix != null && Math.abs(next[key] - mix) < 1e-9) delete next[key];
  });
  return next;
}

function sheetName(code, kind) {
  return (code || "CH") + "_" + kind;
}

function catalogOf(ch, D) {
  const cat = D && D.catalog && ch !== "all" ? D.catalog[ch] : null;
  return Array.isArray(cat) ? cat : [];
}

function catalogDefOfDraft(d, key, D) {
  const head = String(d.channel || d.Channel || key.split(".")[0] || "").toLowerCase();
  const ids = Object.keys((D && D.catalog) || {}).filter(id => id === head || channelNs(id) === head);
  for (const id of ids) {
    const def = catalogOf(id, D).find(c => c.key === key || (c.previousKeys || []).indexOf(key) >= 0 || (!!d.shortKey && c.id === d.shortKey));
    if (def) return { def, ch: id };
  }
  return null;
}

function withCatalogTotals(d, key, D) {
  const hit = catalogDefOfDraft(d, key, D);
  if (!hit) return { key, draft: d };
  const def = hit.def;
  const draft = Object.assign({}, d, { key: def.key, channel: hit.ch, isNew: false, totalsMode: totalsModeOf(def), totalsFormula: def.totalsFormula || "" });
  if (def.key !== key) draft.previousKey = key;
  return { key: def.key, draft };
}

function bindingText(binding) {
  const text = String(binding || "").trim();
  return text === "—" ? "" : text;
}

function catalogRow(c, ch, code, sourced) {
  const def = sourced && c.sourced ? Object.assign({}, c, c.sourced) : c;
  return {
    k: def.id,
    ch,
    sec: def.section,
    name: def.name,
    unit: UNIT_SYMBOL[def.unit] || def.unit,
    src: def.src,
    ed: def.editable ? def.id : null,
    key: def.key,
    previousKeys: def.previousKeys || [],
    formula: def.formula,
    fallback: def.fallback || null,
    binding: bindingText(def.binding),
    bind: def.binding || "—",
    dim: def.dim,
    tmp: def.tmp,
    totalsMode: totalsModeOf(def),
    totalsFormula: def.totalsFormula || "",
    down: def.down,
    total: def.total ? 1 : 0,
    hide: def.hidden ? 1 : 0,
    opens: def.opens || null,
    block: def.block || null,
    lever: def.lever || null,
    fill: def.fill || null,
    rollup: def.rollup || null,
    min: def.min ?? null,
    max: def.max ?? null,
    store: def.store || null,
    sheet: ch === "all" ? def.sheet : sheetName(code, def.sheet)
  };
}

function buildRows(ch, D) {
  const cat = catalogOf(ch, D);
  if (!cat.length) return [];
  const code = channelCode(ch), sourced = ch !== "all" && channelHasSources(ch);
  const rows = cat.map(c => catalogRow(c, ch, code, sourced));
  const owners = leafOwners(rows);
  const conf = D && D.channels ? D.channels[ch] : null;
  const combined = isCombined(D, ch);
  rows.forEach(r => {
    r.bindKey = resolveBindKey(conf, r, owners);
    if (combined) r.combined = true;
    else if (ch !== "all" && (r.src === "input" || r.src === "binding")) {
      r.bind = "growth_driver_actuals · DRIVER_KEY = " + r.bindKey;
      r.bindsActuals = true;
    }
  });
  return rows;
}

function groupRowOf(r) {
  const mode = totalsModeOf(r);
  return Object.assign({}, r, {
    ch: "all",
    key: keyLocal(r.key) ? "group." + keyLocal(r.key) : r.key,
    previousKeys: [],
    ed: null,
    src: mode === "formula" ? "formula" : "rollup",
    formula: mode === "formula" ? r.totalsFormula : mode === "no_totals" ? "No totals · not combined across channels" : "Σ channels",
    fallback: null,
    bind: "—",
    bindsActuals: false,
    scenarioPick: false,
    isDraftRow: false
  });
}

function groupRowsOf(parts) {
  const seen = {}, rows = [];
  parts.forEach(p => ((p && p.__rows) || []).forEach(r => {
    if (!r || !r.k || seen[r.k]) return;
    seen[r.k] = 1;
    rows.push(groupRowOf(r));
  }));
  return rows;
}

function nativeLevers(r) {
  if (!isInputSource(r.src)) return formulaLevers(r.formula);
  const lever = scenarioLever({ k: r.k, src: r.src, lever: r.lever });
  return lever ? [lever] : [];
}

const MONTH_FULL = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const MONTH_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const MONTH_TOKEN = /(^|[^A-Za-z])(January|February|March|April|May|June|July|August|September|October|November|December|Sept|Jan|Feb|Mar|Apr|Jun|Jul|Aug|Sep|Oct|Nov|Dec)(?![A-Za-z])/i;

export function nextVersionName(name) {
  const src = String(name || "").trim();
  if (!src) return "";
  const m = src.match(MONTH_TOKEN);
  if (m) {
    const token = m[2], lower = token.toLowerCase();
    let list = MONTH_FULL, idx = MONTH_FULL.findIndex(x => x.toLowerCase() === lower);
    if (idx < 0) {
      list = MONTH_SHORT;
      idx = MONTH_SHORT.findIndex(x => x.toLowerCase() === lower.slice(0, 3));
    }
    const nextIdx = (idx + 1) % 12;
    let next = list[nextIdx];
    if (token.length > 1 && token === token.toUpperCase()) next = next.toUpperCase();
    else if (token === lower) next = next.toLowerCase();
    const at = m.index + m[1].length;
    const rolled = src.slice(0, at) + next + src.slice(at + token.length);
    return nextIdx === 0 ? rolled.replace(/(^|[^0-9])(\d{4})(?![0-9])/, (_, pre, y) => pre + (Number(y) + 1)) : rolled;
  }
  const n = src.match(/(\d+)$/);
  if (n) return src.slice(0, n.index) + String(Number(n[1]) + 1).padStart(n[1].length, "0");
  return src + "_v2";
}

export function nextCutoffIdx(pubCutoffIdx, actualMax) {
  const max = Math.max(0, actualMax ?? 0);
  const next = typeof pubCutoffIdx === "number" ? pubCutoffIdx + 1 : max;
  return Math.min(Math.max(next, 0), max);
}

export class GrowthModelEngine {
  density = "standard";
  props = { density: "standard" };
  _listeners = [];
  _iv = null;
  _save = null;
  _out = null;
  _drag = null;
  _deletedDrivers = new Set<string>();
  onSaveDraft: ((edits: any) => void | Promise<void>) | null = null;
  onPublish: ((payload: any) => void | Promise<void>) | null = null;
  onExportDone: ((payload: any) => void) | null = null;
  refreshActualsHandler: (() => void | Promise<void>) | null = null;
  onClientSaveError: ((err: Error) => void) | null = null;
  onSwitchVersion: ((planVersionId: string | null) => void | Promise<void>) | null = null;
  onCreateVersion: ((payload: { sourceVersionId: string; name: string; cutoffPeriod?: number | null }) => void | Promise<void>) | null = null;
  onDeleteVersion: ((planVersionId: string) => void | Promise<void>) | null = null;
  changeLogLoader: ((query: any) => Promise<{ total: number; changes: number; items: any[] }>) | null = null;
  changeLogBatchLoader: ((batchId: string, query: any) => Promise<any[]>) | null = null;
  _clReq = 0;

  constructor() {
    this.setState = this.setState.bind(this);
  }

  subscribe(fn) {
    this._listeners.push(fn);
    return () => {
      this._listeners = this._listeners.filter(x => x !== fn);
    };
  }

  setState(patch) {
    const next = typeof patch === "function" ? patch(this.state) : patch;
    if (!next || !Object.keys(next).length) return;
    this.state = Object.assign({}, this.state, next);
    this._listeners.forEach(fn => fn());
  }

  boot(data) {
    this.bindOutsideClose();
    const D = data;
    if (!D || !D.channels || !Array.isArray(D.months)) return;
    const nulls = () => D.months.map(() => null);
    const inputs = {};
    delete D.channels.all;
    applyChannelNamespaces(D);
    applySessionSourcesFromSettings(D.settings || {}, D.months);
    Object.keys(D.channels).forEach(ch => {
      const conf = D.channels[ch];
      if (!conf) return;
      if (!Array.isArray(conf.acqRows)) conf.acqRows = [];
      conf.acqRows.forEach(r => {
        if (!Array.isArray(r.values)) r.values = nulls();
      });
      channelBlocks(ch, D).forEach(b => {
        if (!conf[b] || typeof conf[b] !== "object") {
          conf[b] = { aov: nulls(), sales: nulls() };
        }
        if (!Array.isArray(conf[b].aov)) conf[b].aov = nulls();
        if (!Array.isArray(conf[b].sales)) conf[b].sales = nulls();
        if (conf.model === "base" && !Array.isArray(conf[b].totalOrders)) {
          conf[b].totalOrders = nulls();
        }
        if (conf.model === "cohort" && !Array.isArray(conf[b].cohorts)) {
          conf[b].cohorts = [];
        }
        if (Array.isArray(conf[b].cohorts)) {
          conf[b].cohorts.forEach(co => {
            if (!Array.isArray(co.ratio)) co.ratio = nulls();
          });
        }
      });
      if (!conf.total || typeof conf.total !== "object") {
        conf.total = { orders: nulls(), aov: nulls(), sales: nulls() };
      } else {
        if (!Array.isArray(conf.total.orders)) {
          conf.total.orders = Array.isArray(conf.total.totalOrders) ? conf.total.totalOrders : nulls();
        }
        if (!Array.isArray(conf.total.aov)) conf.total.aov = nulls();
        if (!Array.isArray(conf.total.sales)) conf.total.sales = nulls();
      }
    });
    if (!D.audit || typeof D.audit !== "object") {
      D.audit = { amzRefs: [], amzCount: 0, hardcodedFit: [], hardcodedCount: 0, iferrorBlankCount: 0 };
    }
    if (this._save) {
      clearInterval(this._save);
      this._save = null;
    }
    this._pendingDelta = { hasChange: false, inputs: {}, rov: false, mov: false, cutoff: false, settings: false, structure: false, layout: false };
    this._lastSavedToken = null;
    this._deletedDrivers = new Set<string>();
    this.enableDraftSave();
    const settings = D.settings || {};
    applyProductMixFromSettings(settings);
    const drivers = {};
    let migratedKeys = false;
    Object.keys(settings.drivers || {}).forEach(key => {
      const d = settings.drivers[key];
      if (!d) return;
      const shortKey = String(d.shortKey || d.ShortKey || key.split(".").pop() || "").toLowerCase();
      const ch = String(d.channel || d.Channel || key.split(".")[0] || "").toLowerCase();
      if (channelHasSources(ch) && catalogOf(ch, D).some(c => c.id === shortKey && sourceBoundDef(c))) return;
      const hit = withCatalogTotals(d, key, D);
      if (hit.key !== key && drivers[hit.key]) return;
      drivers[hit.key] = hit.draft;
    });
    this.state = Object.assign({}, this.state, { data: D, fdraft: drivers });
    const bindRows = {};
    Object.keys(D.channels).forEach(ch => { bindRows[ch] = this.mergeDraftRows(buildRows(ch, D), ch); });
    const actualMax = typeof D.actualCutoffIdx === "number" ? D.actualCutoffIdx : (D.cutoffIdx ?? 0);
    const working = typeof D.workingCutoffIdx === "number" ? D.workingCutoffIdx : actualMax;
    const planned = working < actualMax ? plannedSeries(D, ch => bindRows[ch] || []) : null;
    bindChannelActuals(D, ch => bindRows[ch] || []);
    this._bindKeys = {};
    this._bindSig = this.bindSignature();
    Object.keys(bindRows).forEach(ch => {
      const one = {};
      const keys = this._bindKeys[ch] = {};
      bindRows[ch].forEach(r => {
        if (r.bindsActuals) keys[r.k] = r.bindKey;
        if (!r.ed) return;
        const s = storedSeries(ch, D, r);
        one[r.ed] = s ? s.slice() : nulls();
      });
      inputs[ch] = one;
    });
    this.restoreSavedPlannerSeries(D, inputs, drivers);
    if (planned) keepPlannedMonths(inputs, planned, working);
    Object.keys(drivers).forEach(key => {
      const d = drivers[key];
      if (!d.manual || !inputs[d.channel]) return;
      const values = Array.isArray(d.values) ? d.values : [];
      inputs[d.channel][this.draftShortKey(d)] = D.months.map((_, i) => (typeof values[i] === "number" ? values[i] : null));
    });
    const bootMov = dropSeededMixOverrides(settings, D.mov || {});
    const savedScens = Array.isArray(settings.scenarios)
      ? settings.scenarios.map((sc, i) => ({
          id: sc.id || ("scen_saved_" + (i + 1)),
          name: sc.name || ("Scenario " + (i + 1)),
          scenByCh: sc.scenByCh || {},
          inputs: sc.inputs || null,
          rov: sc.rov || {},
          createdBy: sc.createdBy || "",
          createdOn: parseAt(sc.createdOn)
        }))
      : [];
    const rowCfg = {};
    Object.keys(settings.rowCfg || {}).forEach(k => {
      const c = settings.rowCfg[k] || {};
      rowCfg[k] = { bold: !!c.bold, bg: c.bg || "none", indent: c.indent || 0, hide: !!c.hide, sec: isPlanSection(c.sec) ? c.sec : null, dp: roundingDp(c.dp), inverse: c.inverse === true, numBold: c.numBold === true };
    });
    const rowOrd = settings.rowOrd || {};
    const rowDesc = {};
    Object.keys(settings.rowDesc || {}).forEach(k => {
      const text = settings.rowDesc[k];
      if (typeof text !== "string" || !text.trim()) return;
      const nextKey = currentDriverKey(D, k);
      if (nextKey !== k) migratedKeys = true;
      rowDesc[nextKey] = text;
    });
    const scenarioOn = {};
    Object.entries(settings.scenarioOn && typeof settings.scenarioOn === "object" ? settings.scenarioOn : {}).forEach(([k, on]) => {
      if (!k.trim()) return;
      const nextKey = currentDriverKey(D, k.trim());
      if (nextKey !== k.trim()) migratedKeys = true;
      scenarioOn[nextKey] = !!on;
    });
    if (migratedKeys) Object.assign(this._pendingDelta, { hasChange: true, structure: true, layout: true });
    if (typeof D.actualCutoffIdx !== "number") D.actualCutoffIdx = actualMax;
    D.cutoffIdx = actualMax;
    this.ensureForecastCohortShells(D);
    const zero = this.zeroScen(D);
    const scenByCh = {};
    Object.keys(D.channels).concat("all").forEach(ch => { scenByCh[ch] = Object.assign({}, zero); });
    const prevCtx = this.state.versionCtx;
    const versionSwitched = !!D.versionContext && (!prevCtx || prevCtx.kind !== D.versionContext.kind || (prevCtx.loadedId || null) !== (D.versionContext.loadedId || null));
    this.setState({
      data: D,
      inputs,
      scenByCh,
      cutoffIdx: working < actualMax ? working : null,
      dirtyAt: null,
      savedAt: null,
      fyStart: settings.fyStart >= 1 && settings.fyStart <= 12 ? settings.fyStart : 5,
      ccy: settings.ccy || "GBP",
      amzCutoff: settings.amzCutoff || "",
      rounding: settings.rounding || "",
      cohortTenure: settings.cohortTenure || "",
      range: "custom",
      customFrom: periodIndex(D.months, settings.viewFrom),
      customTo: periodIndex(D.months, settings.viewTo),
      pubView: {},
      engineVersion: D.engineVersion || "",
      rowCfg,
      rowOrd,
      rowDesc,
      scenarioOn,
      cohortInput: sanitizeCohortInput(settings.cohortInput),
      cohortGuards: D.versionContext && D.versionContext.kind === "published"
        ? (settings.cohortGuards ? sanitizeCohortGuards(settings.cohortGuards) : null)
        : sanitizeCohortGuards(settings.cohortGuards, false),
      cohortAuto: sanitizeAutoChoices(settings.cohortAuto),
      flagReviews: sanitizeFlagReviews(settings.flagReviews),
      overrideInfo: sanitizeOverrideInfo(settings.overrideInfo),
      autoChanged: {},
      fixedNote: false,
      trendNote: 0,
      flagPanel: null,
      reviewCell: null,
      cohortRulePop: null,
      mixInput: sanitizeMixInput(settings.mixInput),
      cogsInput: sanitizeMixInput(settings.cogsInput),
      mixRulePop: null,
      mixRuleAt: null,
      mixRuleKind: "mix",
      srcInput: Object.assign(seedSessionRules(settings, actualMax), sanitizeSessionInput(settings.srcInput)),
      cpsInput: sanitizeCpsInput(settings.cpsInput),
      srcRulePop: null,
      srcRuleKind: "sess",
      fdraft: drivers,
      savedDrivers: this.driverSignatures(drivers),
      savedScens,
      scenSeq: savedScens.length,
      log: [],
      clServer: CHANGE_LOG_EMPTY,
      clOpen: {},
      clItems: {},
      serverOverrides: (D.governance && D.governance.overrides) || [],
      canAuthor: D.canAuthor !== false,
      canCreateVersion: typeof D.canCreateVersion === "boolean" ? D.canCreateVersion : D.canAuthor !== false,
      versionCtx: D.versionContext || null,
      workingVersions: Array.isArray(D.workingVersions) ? D.workingVersions : [],
      switchAsk: null,
      createOpen: false,
      creating: false,
      ...(versionSwitched ? { version: D.versionContext.kind === "published" && D.versionContext.loadedId ? String(D.versionContext.loadedId) : "fc_v5", cmpVersion: "none", versionOpen: false, delAsk: null } : {}),
      mov: bootMov,
      pubs: ((D.governance && D.governance.publishedVersions) || []).map(p => ({
        id: String(p.id),
        name: p.name || String(p.id),
        at: p.at || "",
        publishedBy: p.publishedBy || "",
        publishedOn: parseAt(p.publishedOn),
        cutoffIdx: typeof p.cutoffIdx === "number" ? p.cutoffIdx : null,
        inputs: p.inputs ? JSON.parse(JSON.stringify(p.inputs)) : {},
        rov: p.rov ? Object.assign({}, p.rov) : {},
        mov: p.mov ? Object.assign({}, p.mov) : {},
        settings: p.settings ? JSON.parse(JSON.stringify(p.settings)) : null,
        cohortInput: sanitizeCohortInput(p.settings && p.settings.cohortInput),
        cohortGuards: p.settings && p.settings.cohortGuards ? sanitizeCohortGuards(p.settings.cohortGuards) : null,
        cohortAuto: sanitizeAutoChoices(p.settings && p.settings.cohortAuto),
        flagReviews: sanitizeFlagReviews(p.settings && p.settings.flagReviews),
        overrideInfo: sanitizeOverrideInfo(p.settings && p.settings.overrideInfo),
        mixInput: sanitizeMixInput(p.settings && p.settings.mixInput),
        cogsInput: sanitizeMixInput(p.settings && p.settings.cogsInput)
      })),
      locks: (() => {
        const l = { actual: true, fit: true };
        ((D.governance && D.governance.publishedVersions) || []).forEach(p => { l[String(p.id)] = true; });
        return l;
      })(),
      chSel: (() => {
        const first = Object.keys(D.channels).find(c => c !== "all" && D.channels[c]);
        return first ? [first] : [];
      })()
    });
    if (this.state.screen === "changelog") void this.loadChangeLog(false);
  }

  destroy() {
    if (this._iv) clearInterval(this._iv);
    if (this._save) clearInterval(this._save);
    if (this._out && typeof document !== "undefined") document.removeEventListener("click", this._out);
    this._iv = null;
    this._save = null;
    this._draftSaveEnabled = false;
    this._out = null;
  }

  state = {
    data: null, screen: "plan", channel: "all", chSel: [], section: "all",
    publishOpen: false, authOpen: false, editing: null, fdraft: {}, savedDrivers: {}, amzCutoff: "", rounding: "", cohortTenure: "", engineVersion: "", rowCfg: {}, rowOrd: {}, rowDesc: {}, scenarioOn: {}, cohortInput: {}, cohortGuards: {}, cohortAuto: {}, flagReviews: {}, overrideInfo: {}, autoChanged: {}, fixedNote: false, trendNote: 0, flagPanel: null, reviewCell: null, cohortRulePop: null, mixInput: {}, cogsInput: {}, mixRulePop: null, mixRuleAt: null, mixRuleKind: "mix", srcInput: {}, cpsInput: {}, srcRulePop: null, srcRuleKind: "sess", settingsQuery: "", pasteNote: "", pasteAt: null, pasteBad: false, hoverRow: null, hoverX: 0, hoverY: 0, fyStart: 5, ccy: "GBP", cutoffIdx: null, cutoffOpen: false, cutoffPending: null, overwriteText: "", versionOpen: false, menuOpen: false, barsCollapsed: false, exportNote: "", scenRail: false, scenMode: false, scenNaming: false, scenName: "", savedScens: [], scenSeq: 0, scenOpen: {},
    locks: { actual: true }, delAsk: null, shadowed: [], pubs: [], pubSeq: 0, pubName: "", pubConfirm: "", publishing: false, savedAt: null, dirtyAt: null, saveSeq: 0, canAuthor: true, draftSaving: false, draftSaveFailed: false,
    mov: {}, mixView: "mix", cmpVersion: "none", cmpSel: { value: true, abs: true, pct: false }, range: "custom", customFrom: null, customTo: null, pubView: {}, gran: "month", block: "subs", view: "rate", rov: {}, groups: {}, inputs: null,
    versionCtx: null, workingVersions: [], canCreateVersion: true, switchAsk: null, createOpen: false, createName: "", createCutoff: null, creating: false,
    version: "fc_v5", log: [], batchSeq: 0, users: {}, clFilter: CHANGE_LOG_FILTER, clServer: CHANGE_LOG_EMPTY, clSavedSeq: 0, clOpen: {}, clItems: {},
    bound: [],
    scenByCh: {},
    auth: { key: "shopify.subs.repurchase_rate_fitted", name: "Repurchase rate (fitted)", unit: "percentage", src: "formula", dim: ["channel", "order_type"], tmp: "cohort", totalsMode: "add_up", totalsFormula: "", formula: "ACROSS_COHORTS(subs_orders[c, t]) / entrants[c]", binding: "", sec: "subs" }
  };

  bindOutsideClose() {
    if (this._out || typeof document === "undefined") return;
    this._out = e => {
      const t = e.target;
      const wrap = (t && t.closest) ? t.closest("[data-pop]") : null;
      const trig = (t && t.closest) ? t.closest("[data-pop-trigger]") : null;
      const key = wrap ? wrap.getAttribute("data-pop") : (trig ? trig.getAttribute("data-pop-trigger") : null);
      const s = this.state, patch = {};
      if (s.versionOpen && key !== "version") { patch.versionOpen = false; patch.delAsk = null; patch.switchAsk = null; }
      if (s.cutoffOpen && key !== "cutoff") patch.cutoffOpen = false;
      if (s.menuOpen && key !== "menu") patch.menuOpen = false;
      if (s.cohortRulePop && key !== "cohortRule") patch.cohortRulePop = null;
      if (s.mixRulePop && key !== "mixRule") { patch.mixRulePop = null; patch.mixRuleAt = null; }
      if (s.srcRulePop && key !== "srcRule") patch.srcRulePop = null;
      if (s.forecastMenu && key !== "forecastMenu") patch.forecastMenu = false;
      if (s.retentionPop && key !== "retention") patch.retentionPop = false;
      if (s.reviewCell && key !== "review") patch.reviewCell = null;
      if (Object.keys(patch).length) this.setState(patch);
    };
    document.addEventListener("click", this._out);
  }

  enableDraftSave() {
    this._saving = false;
    this._pendingFlush = false;
    this._draftSaveEnabled = true;
  }

  hasUnsavedChanges() {
    const s = this.state;
    return !!s.dirtyAt && (!s.savedAt || s.savedAt < s.dirtyAt);
  }

  workingVersionEntries() {
    const st = this.state, ctx = st.versionCtx, kind = ctx ? ctx.kind : "main";
    const loadedId = kind === "clone" && ctx.loadedId ? String(ctx.loadedId) : null;
    const entry = (id, short, target, remote, clone) => ({ id, label: short + " · live edits, save to keep", short, type: "FORECAST", grp: "working", kind: "model", target, remote, clone });
    const rows = [loadedId
      ? entry("fc_v5", ctx.name || "Working version", loadedId, false, true)
      : entry("fc_v5", "Forecast working", null, kind === "published", false)];
    if (loadedId) rows.push(entry("wv_main", "Forecast working", null, true, false));
    (st.workingVersions || []).forEach(w => {
      const id = String(w.id);
      if (id !== loadedId) rows.push(entry("wv_" + id, w.name || "Working version", id, true, true));
    });
    return rows;
  }

  loadedPublishedId() {
    const ctx = this.state.versionCtx;
    return ctx && ctx.kind === "published" && ctx.loadedId ? String(ctx.loadedId) : null;
  }

  selectVersion(v) {
    const remote = !!v.remote || (v.grp === "published" && !!this.onSwitchVersion && v.id !== this.loadedPublishedId());
    if (!remote) {
      this.setState({ version: v.id, versionOpen: false, delAsk: null, switchAsk: null });
      return;
    }
    if (!this.onSwitchVersion) return;
    const target = v.grp === "published" ? v.id : v.target || null;
    if (this.hasUnsavedChanges()) {
      this.setState({ switchAsk: { id: v.id, target, label: v.short }, delAsk: null });
      return;
    }
    this.setState({ versionOpen: false, delAsk: null, switchAsk: null });
    void Promise.resolve(this.onSwitchVersion(target));
  }

  async resolveSwitch(save) {
    const ask = this.state.switchAsk;
    if (!ask || !this.onSwitchVersion) return;
    if (save) {
      await this.flushDraftSave();
      if (this.hasUnsavedChanges() || this.state.draftSaveFailed) return;
    }
    this.setState({ switchAsk: null, versionOpen: false, delAsk: null });
    await this.onSwitchVersion(ask.target);
  }

  confirmLocalDelete() {
    this.setState(s => ({
      delAsk: null,
      version: s.version === s.delAsk ? "fc_v5" : s.version,
      cmpVersion: s.cmpVersion === s.delAsk ? "none" : s.cmpVersion,
      pubs: s.pubs.filter(p => p.id !== s.delAsk),
      savedScens: s.savedScens.filter(x => x.id !== s.delAsk),
      shadowed: s.shadowed.concat([s.delAsk]),
      locks: (() => { const l = Object.assign({}, s.locks); delete l[s.delAsk]; return l; })()
    }));
  }

  openCreateVersion() {
    const st = this.state, D = st.data;
    const pub = st.pubs.find(p => p.id === st.version);
    if (!pub || !D) return;
    const actualMax = typeof D.actualCutoffIdx === "number" ? D.actualCutoffIdx : (D.cutoffIdx ?? 0);
    this.setState({ createOpen: true, createName: nextVersionName(pub.name), createCutoff: nextCutoffIdx(pub.cutoffIdx, actualMax), creating: false, menuOpen: false, versionOpen: false });
  }

  async submitCreateVersion() {
    const st = this.state, D = st.data, name = String(st.createName || "").trim();
    const pub = st.pubs.find(p => p.id === st.version);
    if (!pub || !name || st.creating || !this.onCreateVersion) return;
    const idx = st.createCutoff;
    const cutoffPeriod = D && typeof idx === "number" && typeof D.months[idx] === "number" ? D.months[idx] : null;
    this.setState({ creating: true });
    try {
      await this.onCreateVersion({ sourceVersionId: pub.id, name, cutoffPeriod });
      this.setState({ creating: false, createOpen: false, createName: "" });
    } catch {
      this.setState({ creating: false });
    }
  }

  driverSignature(d) {
    try { return JSON.stringify(d || null); } catch { return ""; }
  }

  driverSignatures(fdraft) {
    const out = {};
    Object.keys(fdraft || {}).forEach(k => { out[k] = this.driverSignature(fdraft[k]); });
    return out;
  }

  withoutSavedRenames(sent, savedDrivers) {
    const current = this.state.fdraft || {};
    let next = null;
    Object.keys(sent || {}).forEach(k => {
      const d = current[k];
      if (!d || !d.previousKey || savedDrivers[k] !== this.driverSignature(d)) return;
      next = next || Object.assign({}, current);
      next[k] = Object.assign({}, d, { previousKey: null });
      savedDrivers[k] = this.driverSignature(next[k]);
    });
    return next;
  }

  isDriverUnsaved(key) {
    const d = this.state.fdraft[key];
    return !!d && (this.state.savedDrivers || {})[key] !== this.driverSignature(d);
  }

  async flushDraftSave() {
    if (!this.onSaveDraft || !this._draftSaveEnabled) return;
    if (this._saving) {
      this._pendingFlush = true;
      return;
    }
    const s = this.state;
    if (!this.hasUnsavedChanges()) return;

    const delta = this.consumePendingDelta();
    if (!delta) {
      this.setState({ savedAt: Date.now(), draftSaving: false, draftSaveFailed: false, savedDrivers: this.driverSignatures(this.state.fdraft) });
      return;
    }

    const driverErrors = this.validateDriversForSave(delta.drivers);
    if (driverErrors.length) {
      this.restorePendingDelta(delta);
      this.setState({ draftSaving: false, draftSaveFailed: true });
      const err = new Error(driverErrors.join("\n"));
      if (typeof this.onClientSaveError === "function") this.onClientSaveError(err);
      return;
    }

    let token;
    try {
      token = JSON.stringify(delta);
    } catch {
      token = String(s.dirtyAt);
    }
    const savedDrivers = this.driverSignatures(s.fdraft);
    if (token === this._lastSavedToken) {
      this.setState({ savedAt: Date.now(), draftSaving: false, draftSaveFailed: false, savedDrivers });
      return;
    }

    this._saving = true;
    this.setState({ draftSaving: true, draftSaveFailed: false });
    const dirtyAt = s.dirtyAt;
    const savedSeq = s.batchSeq;
    try {
      await Promise.resolve(this.onSaveDraft(delta));
      this._lastSavedToken = token;
      this.confirmDeletedDrivers(delta.deletedDrivers);
      const clSavedSeq = Math.max(this.state.clSavedSeq || 0, savedSeq);
      const fdraft = this.withoutSavedRenames(delta.drivers, savedDrivers);
      const saved = Object.assign(fdraft ? { savedDrivers, clSavedSeq, fdraft } : { savedDrivers, clSavedSeq }, delta.cohortAuto !== undefined ? { autoChanged: {} } : null);
      if (this.state.dirtyAt === dirtyAt) {
        this.setState({ savedAt: Date.now(), saveSeq: this.state.saveSeq + 1, draftSaving: false, draftSaveFailed: false, ...saved });
      } else {
        this.setState({ draftSaving: false, ...saved });
      }
      if (this.state.screen === "changelog") void this.loadChangeLog(false);
    } catch {
      this.restorePendingDelta(delta);
      this.setState({ draftSaving: false, draftSaveFailed: true });
    } finally {
      this._saving = false;
      if (this._pendingFlush) {
        this._pendingFlush = false;
        void this.flushDraftSave();
      }
    }
  }

  consumePendingDelta() {
    const pending = this._pendingDelta;
    const s = this.state;
    if (!pending || !pending.hasChange) {
      if (!s.dirtyAt) return null;
      const inputs = {};
      Object.keys(s.inputs || {}).forEach(ch => {
        if (ch === "all") return;
        inputs[ch] = s.inputs[ch];
      });
      return this.buildSettingsDelta({
        inputs,
        rov: s.rov,
        mov: s.mov,
        cutoffIdx: s.cutoffIdx,
        settings: true,
        structure: false,
        layout: true
      });
    }
    const n = (s.data && s.data.months) ? s.data.months.length : 0;
    const inputs = {};
    Object.keys(pending.inputs || {}).forEach(ch => {
      if (ch === "all") return;
      inputs[ch] = {};
      Object.keys(pending.inputs[ch]).forEach(key => {
        const series = new Array(n).fill(null);
        Object.keys(pending.inputs[ch][key]).forEach(i => {
          if (+i < n) series[+i] = pending.inputs[ch][key][i];
        });
        inputs[ch][key] = series;
      });
    });
    const delta = this.buildSettingsDelta({
      inputs: Object.keys(inputs).length ? inputs : undefined,
      rov: pending.rov ? s.rov : undefined,
      mov: pending.mov ? s.mov : undefined,
      cutoffIdx: pending.cutoff
        ? (s.cutoffIdx === null || s.cutoffIdx === undefined
          ? (s.data && typeof s.data.cutoffIdx === "number" ? s.data.cutoffIdx : undefined)
          : s.cutoffIdx)
        : undefined,
      settings: pending.settings,
      structure: pending.structure,
      layout: pending.layout,
      overrides: pending.overrides
    });
    this._pendingDelta = { hasChange: false, inputs: {}, rov: false, mov: false, cutoff: false, settings: false, structure: false, layout: false, overrides: false };
    if (!delta.inputs && delta.rov === undefined && delta.mov === undefined && delta.cutoffIdx === undefined
      && delta.fyStart === undefined && delta.ccy === undefined && delta.amzCutoff === undefined && delta.rounding === undefined
      && delta.rowCfg === undefined && delta.rowOrd === undefined && delta.rowDesc === undefined && delta.scenarioOn === undefined && delta.drivers === undefined
      && delta.deletedDrivers === undefined && delta.scenarios === undefined && delta.productMix === undefined && delta.sessionSources === undefined && delta.overrides === undefined
      && delta.cohortInput === undefined && delta.cohortGuards === undefined && delta.mixInput === undefined && delta.cogsInput === undefined
      && delta.srcInput === undefined && delta.cpsInput === undefined && delta.cohortAuto === undefined && delta.flagReviews === undefined
      && delta.overrideInfo === undefined) return null;
    return delta;
  }

  snapshotProductMix() {
    return Object.keys(PRODUCT_MIX).reduce((acc, ch) => {
      acc[ch] = (PRODUCT_MIX[ch] || []).map(row => Object.assign({
        name: row[0],
        mixPct: row[1],
        cogsPct: row[2]
      }, row[5] ? { manual: true, mixByPeriod: Object.assign({}, row[3]), cogsByPeriod: Object.assign({}, row[4]) } : null));
      return acc;
    }, {});
  }

  snapshotViewPeriods() {
    const s = this.state;
    const M = (s.data && s.data.months) || [];
    const pick = i => (i !== null && i !== undefined && M[i] !== undefined ? M[i] : null);
    return { viewFrom: pick(s.customFrom), viewTo: pick(s.customTo) };
  }

  setViewBounds(from, to) {
    const cur = this.fyRange(this.state.range);
    const a = from === null ? cur[0] : from;
    const b = to === null ? cur[1] : to;
    const lo = Math.min(a, b), hi = Math.max(a, b);
    if (this.state.version === "fc_v5") {
      this.setState({ range: "custom", customFrom: lo, customTo: hi });
      if (this.state.canAuthor !== false) this.noteSettingsDirty();
      return;
    }
    this.setState(s => ({ range: "custom", pubView: Object.assign({}, s.pubView, { [s.version]: [lo, hi] }) }));
  }

  snapshotSessionSources() {
    return Object.keys(SESSION_SOURCES).reduce((acc, ch) => {
      const resolved = this.resolvedSources(ch);
      acc[ch] = (SESSION_SOURCES[ch] || []).map((row, si) => Object.assign({
        key: row.key,
        name: row.name,
        adSpend: (row.ad || []).slice(),
        sessions: resolved[si] ? resolved[si].sessions.slice() : (row.sess || []).slice(),
        costPerSession: (row.cps || []).slice()
      }, row.manual ? { manual: true } : null));
      return acc;
    }, {});
  }

  buildSettingsDelta(base) {
    const s = this.state;
    const delta = {};
    if (base && base.inputs) delta.inputs = base.inputs;
    if (base && base.rov !== undefined) delta.rov = base.rov;
    if (base && base.mov !== undefined) delta.mov = base.mov;
    if (base && base.cutoffIdx !== undefined && base.cutoffIdx !== null) delta.cutoffIdx = base.cutoffIdx;
    if (base && base.settings) {
      delta.fyStart = s.fyStart;
      delta.ccy = s.ccy;
      delta.amzCutoff = s.amzCutoff;
      delta.rounding = s.rounding;
      const view = this.snapshotViewPeriods();
      if (view.viewFrom !== null) delta.viewFrom = view.viewFrom;
      if (view.viewTo !== null) delta.viewTo = view.viewTo;
      delta.scenarios = this.scenariosForApi();
      delta.productMix = this.snapshotProductMix();
      delta.sessionSources = this.snapshotSessionSources();
      delta.cohortInput = s.cohortInput || {};
      if (s.cohortGuards) delta.cohortGuards = this.cohortGuardsForSave();
      delta.cohortAuto = s.cohortAuto || {};
      delta.flagReviews = s.flagReviews || {};
      delta.overrideInfo = Object.fromEntries(Object.entries(s.overrideInfo || {}).filter(([k]) => (s.rov || {})[k] !== undefined || (s.cohortInput || {})[k] !== undefined));
      delta.mixInput = s.mixInput || {};
      delta.cogsInput = s.cogsInput || {};
      delta.srcInput = s.srcInput || {};
      delta.cpsInput = s.cpsInput || {};
    }
    if (base && base.layout) {
      delta.rowCfg = s.rowCfg || {};
      delta.rowOrd = s.rowOrd || {};
      delta.rowDesc = s.rowDesc || {};
      delta.scenarioOn = s.scenarioOn || {};
    }
    if (base && base.structure) {
      const drivers = {};
      Object.keys(s.fdraft || {}).forEach(key => {
        const d = s.fdraft[key];
        if (!d) return;
        if (d.manual) {
          drivers[key] = this.withManualValues(d);
          return;
        }
        if (d.isNew) {
          drivers[key] = d;
          return;
        }
        if (String(d.src || "").toLowerCase() === "formula" && !String(d.formula || "").trim()) return;
        drivers[key] = d;
      });
      if (Object.keys(drivers).length) delta.drivers = drivers;
      const deleted = this.deletedDriverKeys();
      if (deleted.length) delta.deletedDrivers = deleted;
    }
    if (base && base.overrides === true) {
      delta.overrides = (s.serverOverrides || []).map(o => ({
        id: o.id,
        driver: o.driver,
        driverKey: o.driverKey,
        channel: o.channel,
        period: o.period,
        source: o.source,
        value: o.value,
        reason: o.reason || ""
      }));
    }
    return delta;
  }

  validateDriversForSave(drivers) {
    if (!drivers || typeof drivers !== "object") return [];
    const errors = [];
    Object.keys(drivers).forEach(key => {
      const d = drivers[key];
      if (!d) return;
      const src = String(d.src || "").toLowerCase();
      const formula = String(d.formula || "").trim();
      if (src === "formula" && !formula && d.isNew) {
        errors.push("Formula required for " + (d.key || key));
      }
      if (isRollupSource(src) && d.isNew && !String(d.rollup || "").trim()) {
        errors.push("Rollup rule required for " + (d.key || key));
      }
      if (totalsModeOf(d) === "formula" && !isArithmeticFormula(d.totalsFormula)) {
        const k = d.key || key;
        errors.push("Quarter and year totals formula required for " + (d.name ? d.name + " (" + k + ")" : k));
      }
    });
    return errors;
  }

  restorePendingDelta(delta) {
    if (!delta) return;
    const pending = this._pendingDelta || { hasChange: false, inputs: {}, rov: false, mov: false, cutoff: false, settings: false, structure: false, layout: false };
    if (delta.inputs) {
      Object.keys(delta.inputs).forEach(ch => {
        pending.inputs[ch] = pending.inputs[ch] || {};
        Object.keys(delta.inputs[ch]).forEach(key => {
          pending.inputs[ch][key] = pending.inputs[ch][key] || {};
          (delta.inputs[ch][key] || []).forEach((v, i) => {
            if (v !== null && v !== undefined) pending.inputs[ch][key][i] = v;
          });
        });
      });
    }
    if (delta.rov) pending.rov = true;
    if (delta.mov) pending.mov = true;
    if (delta.cutoffIdx !== undefined) pending.cutoff = true;
    if (delta.fyStart !== undefined || delta.ccy !== undefined || delta.amzCutoff !== undefined || delta.rounding !== undefined
      || delta.viewFrom !== undefined || delta.viewTo !== undefined || delta.cohortInput !== undefined || delta.cohortGuards !== undefined
      || delta.mixInput !== undefined || delta.cogsInput !== undefined || delta.cohortAuto !== undefined || delta.flagReviews !== undefined
      || delta.overrideInfo !== undefined) pending.settings = true;
    if (delta.rowCfg !== undefined || delta.rowOrd !== undefined || delta.rowDesc !== undefined || delta.scenarioOn !== undefined) pending.layout = true;
    if (delta.drivers !== undefined || delta.deletedDrivers !== undefined) pending.structure = true;
    pending.hasChange = true;
    this._pendingDelta = pending;
  }

  notePendingFromItems(items) {
    const pending = this._pendingDelta || { hasChange: false, inputs: {}, rov: false, mov: false, cutoff: false, settings: false, structure: false, layout: false };
    (items || []).forEach(it => {
      if (it.kind === "input" && it.ch && it.ch !== "all" && it.key != null && it.i != null) {
        pending.inputs[it.ch] = pending.inputs[it.ch] || {};
        pending.inputs[it.ch][it.key] = pending.inputs[it.ch][it.key] || {};
        pending.inputs[it.ch][it.key][it.i] = it.after;
        pending.hasChange = true;
      } else if (it.kind === "rate") {
        pending.rov = true;
        pending.settings = true;
        pending.hasChange = true;
      } else if (it.kind === "structure") {
        pending.structure = true;
        pending.hasChange = true;
      } else if (it.kind === "mix") {
        pending.mov = true;
        pending.hasChange = true;
      } else if (it.kind === "source") {
        pending.settings = true;
        pending.hasChange = true;
      } else if (it.kind === "cutoff") {
        pending.cutoff = true;
        pending.hasChange = true;
      } else if (it.kind === "settings" || it.kind === "cohort_input" || it.kind === "cohort_guards" || it.kind === "mix_input" || it.kind === "cogs_input" || it.kind === "src_input" || it.kind === "cps_input" || it.kind === "flag_review") {
        pending.settings = true;
        pending.hasChange = true;
      } else if (it.kind === "layout") {
        pending.layout = true;
        pending.hasChange = true;
      } else if (it.kind === "overrides") {
        pending.overrides = true;
        pending.hasChange = true;
      }
    });
    this._pendingDelta = pending;
  }

  noteSettingsDirty() {
    this._settingsSeq = (this._settingsSeq || 0) + 1;
    this.notePendingFromItems([{ kind: "settings" }]);
    this.markDirty();
  }

  noteLayoutDirty() {
    this.notePendingFromItems([{ kind: "layout" }]);
    this.markDirty();
  }

  markDirty() {
    this.setState({ dirtyAt: Date.now() });
  }

  ensureForecastCohortShells(D) {
    if (!D || !Array.isArray(D.months) || !D.channels) return D;
    const n = D.months.length;
    Object.keys(D.channels).forEach(cid => {
      const ch = D.channels[cid];
      if (!ch || ch.model !== "cohort") return;
      (channelBlocks(cid, D) || []).forEach(b => {
        if (!ch[b]) return;
        const existing = Array.isArray(ch[b].cohorts) ? ch[b].cohorts : [];
        const byLabel = {};
        existing.forEach(c => {
          if (c && c.label != null) byLabel[String(c.label)] = c;
        });
        const pad = co => {
          co.ratio = Array.isArray(co.ratio) ? co.ratio.slice() : [];
          while (co.ratio.length < n) co.ratio.push(null);
          if (co.ratio.length > n) co.ratio.length = n;
          return co;
        };
        const rebuilt = [];
        const pre = existing.find(c => c && /^pre/i.test(String(c.label))) || { label: "pre", size: null, ratio: [] };
        rebuilt.push(pad({ ...pre }));
        D.months.forEach(ym => {
          const label = String(ym);
          const found = byLabel[label];
          rebuilt.push(pad(found ? { ...found, label } : { label, size: null, ratio: [] }));
        });
        ch[b].cohorts = rebuilt;
      });
    });
    return D;
  }

  reviewFindings(channels, gridOf, cut) {
    const st = this.state, D = st.data, n = D.months.length;
    const grids = channels.map(cid => ({ cid, g: gridOf(cid) }));
    const resolveAny = this.calcResolver([].concat(...grids.map(x => x.g.__rows || [])));
    const span = idxs => idxs.length > 3
      ? ml(D.months[idxs[0]]) + " to " + ml(D.months[idxs[idxs.length - 1]])
      : idxs.map(i => ml(D.months[i])).join(", ");
    const out = [];
    grids.forEach(({ cid, g }) => {
      const rows = g.__rows || [];
      const resolve = this.calcResolver(rows);
      const resolveRefs = this.refResolver(cid, rows);
      const cyclic = (g.__meta && g.__meta.cyclic) || [];
      const combined = isCombined(D, cid);
      rows.forEach(r => {
        const where = D.channels[cid].label + " · " + r.name;
        const edit = () => this.editDriverIn(cid, r);
        if (cyclic.indexOf(r.k) >= 0) {
          out.push({ id: cid + "|" + r.k + "|cycle", kind: "formula", title: where + ": circular reference", detail: "Its formula depends on itself through other drivers, so it can't be calculated.", hint: "", action: "Edit driver", onAction: edit });
        }
        const d = st.fdraft[r.key] || st.fdraft[r.k];
        if (d) {
          const drafted = Object.assign({}, r, {
            src: d.src || r.src,
            formula: d.formula != null ? d.formula : r.formula,
            rollup: d.rollup != null ? d.rollup : r.rollup,
            totalsMode: d.totalsMode ? totalsModeOf(d) : r.totalsMode,
            totalsFormula: d.totalsMode ? String(d.totalsFormula || "") : r.totalsFormula
          });
          driverFormulas(drafted).forEach(([part, text]) => {
            const problem = formulaProblem(part, text, r, rows, part === "formula" || part === "fallback" ? resolveRefs : resolve, resolveAny);
            if (problem) out.push({ id: cid + "|" + r.k + "|" + part, kind: "formula", title: where + ": " + problem.title, detail: FORMULA_PART_LABEL[part] + " · " + text, hint: problem.hint || "", action: "Edit driver", onAction: edit });
          });
        }
        if (!combined && r.ed && this.srcOf(r) === "input" && !this.cfgOf(r.k, cid).hide) {
          const values = g[r.k] || [];
          const empty = [];
          for (let i = cut + 1; i < n; i++) if (typeof values[i] !== "number") empty.push(i);
          if (empty.length && values.some(v => typeof v === "number")) {
            out.push({
              id: cid + "|" + r.k + "|missing", kind: "missing", title: where + ": no forecast value",
              detail: "Empty in " + empty.length + (empty.length === 1 ? " forecast month: " : " forecast months: ") + span(empty) + ".",
              hint: "", action: "Open in plan",
              onAction: () => this.setState(s => ({ chSel: [cid], screen: "plan", version: s.versionCtx && s.versionCtx.kind === "published" ? s.version : "fc_v5" }))
            });
          }
        }
      });
    });
    return out;
  }

  guardFindings(channels, gridOf) {
    const D = this.state.data;
    const out = [];
    channels.forEach(cid => {
      const meta = gridOf(cid).__meta || {};
      if (!meta.guards || D.channels[cid].model !== "cohort") return;
      channelBlocks(cid, D).forEach(b => {
        const resolved = meta.guards[b];
        if (!resolved || ((!resolved.needs || !resolved.needs.length) && !resolved.fadeNeeds)) return;
        const label = D.channels[cid].label + " · " + (BL[b] || b) + " cohorts";
        GUARD_IDS.forEach(gid => {
          const params = (resolved.needs || []).filter(p => GUARD_OF_PARAM[p] === gid && CLIENT_PARAMS.indexOf(p) >= 0);
          const reasons = params.map(p => PARAM_GUIDE[p].label + ": " + resolved.params[p].reason);
          if (gid === "tail" && resolved.fadeNeeds) reasons.push("No well-evidenced ages and no bundle history to measure the monthly fade. Set " + PARAM_GUIDE.legacyRetention.label + " in " + GUARD_LABEL.legacy);
          if (!reasons.length) return;
          out.push({
            id: cid + "|" + b + "|guard|" + gid, kind: "guard",
            cid, b, fadeNeeds: gid === "tail" && !!resolved.fadeNeeds,
            title: label + ": " + GUARD_LABEL[gid] + " needs a decision",
            detail: reasons.join(". ") + ". This rule is skipped on this draft until a value is set.",
            hint: "", action: "Open settings",
            onAction: () => this.openGuardSettings(cid, b)
          });
        });
      });
    });
    return out;
  }

  openGuardSettings(cid, b) {
    this.setState({ screen: "authoring", chSel: [cid], guardScope: cohortGuardKey(cid, b), settingsQuery: "" });
  }

  openDriverEditor(r) {
    const d = this.state.fdraft[r.key] || {};
    this.setState({
      authOpen: true, editing: r.k,
      auth: {
        key: d.key || r.key,
        name: readableDriverName(d.name, r.name),
        unit: d.unit || unitIdOf(r.unit),
        src: d.src || (r.src === "rollup" && !r.combined ? "formula" : r.src),
        rollup: d.rollup != null ? d.rollup : (r.rollup || ""),
        dim: d.dim || dimsOf(r.dim),
        tmp: d.tmp || (/cohort/.test(r.tmp || "") ? "cohort" : "activity"),
        totalsMode: totalsModeOf(r),
        totalsFormula: r.totalsFormula || "",
        formula: d.formula != null ? d.formula : (r.formula || ""),
        binding: r.binding || (r.bind && r.bind !== "—" ? r.bind : ""),
        overwrite: d.overwrite || r.overwrite || "",
        sec: planSectionOf(r.sec)
      }
    });
  }

  editDriverIn(cid, r) {
    if (!this.state.canAuthor) return;
    const moved = this.cfgOf(r.k, cid).sec;
    this.setState({ chSel: [cid], screen: "authoring", version: "fc_v5" });
    this.openDriverEditor(moved && !r.isDraftRow ? Object.assign({}, r, { sec: moved }) : r);
  }

  scenariosForApi() {
    const channels = (this.state.data && this.state.data.channels) || {};
    const ids = Object.keys(channels).filter(c => c !== "all" && channels[c]);
    const pick = obj => {
      const out = {};
      Object.keys(obj || {}).forEach(k => { if (ids.indexOf(k) >= 0) out[k] = obj[k]; });
      return out;
    };
    return (this.state.savedScens || []).map(sc => ({
      id: sc.id,
      name: sc.name,
      scenByCh: pick(sc.scenByCh),
      inputs: sc.inputs ? pick(sc.inputs) : undefined,
      rov: sc.rov || {}
    }));
  }

  restoreSavedPlannerSeries(data, inputs, drivers) {
    Object.keys(inputs).forEach(ch => {
      const conf = data.channels[ch];
      if (ch === "all" || !conf || !Array.isArray(conf.acqRows)) return;
      const base = {}, keys = [];
      buildRows(ch, data).forEach(r => {
        base[r.key] = r;
        base[r.k] = r;
        if (r.ed && r.store === "inputs") keys.push(r.k);
      });
      Object.keys(drivers).forEach(key => {
        const d = drivers[key];
        if (String(d.src || "").toLowerCase() !== "input") return;
        if (d.channel && d.channel !== "all" && d.channel !== ch && d.channel !== channelNs(ch)) return;
        const native = this.draftBaseRow(d, key, base);
        const k = native ? native.k : this.draftShortKey(Object.assign({}, d, { key: d.key || key }));
        if (keys.indexOf(k) < 0) keys.push(k);
      });
      keys.forEach(k => {
        const row = conf.acqRows.find(r => r && String(r.key || "").toLowerCase() === k.toLowerCase());
        if (!row || !Array.isArray(row.values)) return;
        const cur = Array.isArray(inputs[ch][k]) ? inputs[ch][k] : [];
        inputs[ch][k] = data.months.map((_, i) => (row.values[i] !== null && row.values[i] !== undefined ? row.values[i] : (cur[i] === undefined ? null : cur[i])));
      });
    });
  }

  nativeEditable(ch) {
    return buildRows(ch, this.state.data || D).filter(r => r.ed).map(r => r.ed);
  }

  editable(ch) {
    const out = this.nativeEditable(ch);
    if (ch === "all") return out;
    const base = this.baseRowIndex(ch);
    Object.keys(this.state.fdraft || {}).forEach(key => {
      const d = this.state.fdraft[key];
      if (!d || d.src !== "input") return;
      if (d.channel && d.channel !== "all" && d.channel !== ch) return;
      const native = this.draftBaseRow(d, key, base);
      const shortKey = native ? native.k : this.draftShortKey(Object.assign({}, d, { key: d.key || key }));
      if (out.indexOf(shortKey) < 0) out.push(shortKey);
    });
    return out;
  }

  setUsers(list) {
    const users = {};
    (list || []).forEach(u => {
      const name = [u && u.firstName, u && u.lastName].filter(Boolean).join(" ").trim();
      if (u && u.userId && name) users[u.userId] = name;
    });
    this.setState({ users });
  }
  changeLogQuery() {
    const f = this.state.clFilter || CHANGE_LOG_FILTER;
    return {
      from: f.from ? new Date(f.from + "T00:00:00").toISOString() : undefined,
      to: f.to ? new Date(f.to + "T23:59:59.999").toISOString() : undefined,
      userId: f.user || undefined,
      channel: f.channel || undefined,
      driverKey: f.driver || undefined
    };
  }
  async loadChangeLog(append) {
    if (typeof this.changeLogLoader !== "function") return;
    const skip = append ? this.state.clServer.batches.length : 0;
    const req = ++this._clReq;
    this.setState(s => Object.assign(
      { clServer: Object.assign({}, s.clServer, { loading: true, error: "" }) },
      append ? {} : { clOpen: {}, clItems: {} }
    ));
    try {
      const page = await this.changeLogLoader(Object.assign(this.changeLogQuery(), { skip, take: CHANGE_LOG_PAGE }));
      if (req !== this._clReq) return;
      const batches = (page && Array.isArray(page.items)) ? page.items : [];
      this.setState(s => ({
        clServer: {
          batches: append ? s.clServer.batches.concat(batches) : batches,
          total: (page && page.total) || 0,
          changes: (page && page.changes) || 0,
          loading: false,
          loaded: true,
          error: ""
        }
      }));
    } catch {
      if (req !== this._clReq) return;
      this.setState(s => ({ clServer: Object.assign({}, s.clServer, { loading: false, error: "Couldn't load the change log." }) }));
    }
  }
  async loadChangeLogBatch(batchId) {
    if (typeof this.changeLogBatchLoader !== "function") return;
    const req = this._clReq;
    const put = entry => this.setState(s => ({ clItems: Object.assign({}, s.clItems, { [batchId]: entry }) }));
    put({ loading: true, error: "", items: [] });
    try {
      const items = await this.changeLogBatchLoader(batchId, this.changeLogQuery());
      if (req === this._clReq) put({ loading: false, error: "", items: Array.isArray(items) ? items : [] });
    } catch {
      if (req === this._clReq) put({ loading: false, error: "Couldn't load these changes.", items: [] });
    }
  }
  toggleChangeLogBatch(batchId, server) {
    const open = !this.state.clOpen[batchId];
    this.setState(s => ({ clOpen: Object.assign({}, s.clOpen, { [batchId]: open }) }));
    const loaded = this.state.clItems[batchId];
    if (open && server && (!loaded || loaded.error)) void this.loadChangeLogBatch(batchId);
  }
  setChangeLogFilter(key, value) {
    this.setState(s => ({ clFilter: Object.assign({}, s.clFilter, { [key]: value }, key === "channel" ? { driver: "" } : {}) }));
    void this.loadChangeLog(false);
  }
  clearChangeLogFilters() {
    this.setState({ clFilter: CHANGE_LOG_FILTER });
    void this.loadChangeLog(false);
  }
  pushBatch(items, source) {
    if (!items.length) return;
    const now = new Date();
    const ts = String(now.getHours()).padStart(2, "0") + ":" + String(now.getMinutes()).padStart(2, "0") + " BST";
    const at = now.getTime();
    this.notePendingFromItems(items);
    this.setState(s => ({
      batchSeq: s.batchSeq + 1,
      dirtyAt: at,
      log: [{ batch: "batch_" + (s.batchSeq + 1), seq: s.batchSeq + 1, ts: ts, at, dirtyBefore: s.dirtyAt || null, actor: "User", source: source || "UI", items: items }].concat(s.log)
    }));
  }

  pendingRuleItem(kind, ckey) {
    const saved = this.state.clSavedSeq || 0;
    let found = null;
    this.state.log.forEach(l => {
      if ((l.seq || 0) <= saved) return;
      const it = l.items.find(x => x.kind === kind && x.ckey === ckey);
      if (it) found = it;
    });
    return found;
  }

  pushRuleChange(item) {
    const st = this.state, saved = st.clSavedSeq || 0;
    const same = it => it.kind === item.kind && it.ckey === item.ckey;
    const pending = st.log.filter(l => (l.seq || 0) > saved);
    const prior = pending.filter(l => l.items.some(same));
    if (!prior.length) return this.pushBatch([item], "UI");
    const first = this.pendingRuleItem(item.kind, item.ckey);
    const chain = pending.slice().reverse();
    const oldest = chain[0], newest = chain[chain.length - 1];
    const onlyThis = prior.length === pending.length && prior.every(l => l.items.length === 1);
    const unbroken = chain.every((l, i) => (i === 0 ? l.dirtyBefore !== undefined : l.dirtyBefore === chain[i - 1].at));
    const cleanBefore = !oldest.dirtyBefore || (!!st.savedAt && oldest.dirtyBefore <= st.savedAt);
    const log = st.log.map(l => (prior.indexOf(l) < 0 ? l : Object.assign({}, l, { items: l.items.filter(it => !same(it)) }))).filter(l => l.items.length);
    this.setState(Object.assign({ log }, onlyThis && unbroken && cleanBefore && st.dirtyAt === newest.at ? { dirtyAt: oldest.dirtyBefore } : null));
    if (!sameCohortRule(first.beforeRule || null, item.afterRule || null)) {
      return this.pushBatch([Object.assign({}, item, { before: first.before, beforeRule: first.beforeRule }, first.autoRule ? { autoRule: first.autoRule } : null)], "UI");
    }
    this.notePendingFromItems([item]);
  }
  undoBatch(batchId) {
    const pendingEntry = this.state.log.find(l => l.batch === batchId);
    const touchesCohortInput = !!pendingEntry && pendingEntry.items.some(it => it.kind === "cohort_input");
    const touchesMixInput = !!pendingEntry && pendingEntry.items.some(it => it.kind === "mix_input");
    const touchesCogsInput = !!pendingEntry && pendingEntry.items.some(it => it.kind === "cogs_input");
    const touchesSrcInput = !!pendingEntry && pendingEntry.items.some(it => it.kind === "src_input");
    const touchesCpsInput = !!pendingEntry && pendingEntry.items.some(it => it.kind === "cps_input");
    const guardItems = pendingEntry ? pendingEntry.items.filter(it => it.kind === "cohort_guards") : [];
    const touchesReviews = !!pendingEntry && pendingEntry.items.some(it => it.kind === "flag_review");
    if (touchesCohortInput || touchesMixInput || touchesCogsInput || touchesSrcInput || touchesCpsInput || guardItems.length || touchesReviews) this.notePendingFromItems([{ kind: "cohort_input" }]);
    if (pendingEntry && pendingEntry.items.some(it => it.kind === "input" && this.isManualInput(it.ch, it.key))) this.notePendingFromItems([{ kind: "structure" }]);
    const sourceItems = pendingEntry ? pendingEntry.items.filter(it => it.kind === "source" && it.srcKey) : [];
    if (sourceItems.length) {
      const n = this.state.data.months.length;
      sourceItems.forEach(it => {
        const row = (SESSION_SOURCES[it.ch] || []).find(r => r.key === it.srcKey);
        if (row) sourceSeriesOf(row, it.metric, n)[it.t] = it.before;
      });
      this.notePendingFromItems([{ kind: "source" }]);
    }
    this.setState(s => {
      const entry = s.log.find(l => l.batch === batchId);
      if (!entry) return {};
      const inputs = Object.assign({}, s.inputs), rov = Object.assign({}, s.rov), mov = Object.assign({}, s.mov);
      const cohortInput = touchesCohortInput ? Object.assign({}, s.cohortInput) : s.cohortInput;
      const mixInput = touchesMixInput ? Object.assign({}, s.mixInput) : s.mixInput;
      const cogsInput = touchesCogsInput ? Object.assign({}, s.cogsInput) : s.cogsInput;
      const srcInput = touchesSrcInput ? Object.assign({}, s.srcInput) : s.srcInput;
      const cpsInput = touchesCpsInput ? Object.assign({}, s.cpsInput) : s.cpsInput;
      const flagReviews = touchesReviews ? Object.assign({}, s.flagReviews) : s.flagReviews;
      let cutoffIdx = s.cutoffIdx;
      entry.items.forEach(it => {
        if (it.kind === "rate") {
          if (it.before === null) delete rov[it.rkey]; else rov[it.rkey] = it.before;
          return;
        }
        if (it.kind === "mix") {
          if (it.before === null) delete mov[it.rkey]; else mov[it.rkey] = it.before;
          return;
        }
        if (it.kind === "flag_review") {
          if (it.beforeReview) flagReviews[it.rkey] = it.beforeReview; else delete flagReviews[it.rkey];
          return;
        }
        if (it.kind === "cohort_input") {
          if (it.beforeRule) cohortInput[it.ckey] = it.beforeRule; else delete cohortInput[it.ckey];
          return;
        }
        if (it.kind === "mix_input" || it.kind === "cogs_input" || it.kind === "src_input" || it.kind === "cps_input") {
          const map = it.kind === "mix_input" ? mixInput : it.kind === "cogs_input" ? cogsInput : it.kind === "src_input" ? srcInput : cpsInput;
          if (it.beforeRule) map[it.ckey] = it.beforeRule; else delete map[it.ckey];
          return;
        }
        if (it.kind === "cutoff") {
          const D2 = s.data, back = D2.months.indexOf(it.before);
          cutoffIdx = (back < 0 || back === D2.cutoffIdx) ? null : back;
          return;
        }
        if (!inputs[it.ch] || !inputs[it.ch][it.key]) return;
        const one = Object.assign({}, inputs[it.ch]);
        one[it.key] = one[it.key].slice(); one[it.key][it.i] = it.before;
        inputs[it.ch] = one;
      });
      return Object.assign(
        { inputs: inputs, rov: rov, mov: mov, cohortInput: cohortInput, mixInput: mixInput, cogsInput: cogsInput, srcInput: srcInput, cpsInput: cpsInput, flagReviews: flagReviews, cutoffIdx: cutoffIdx, log: s.log.filter(l => l.batch !== batchId), dirtyAt: Date.now() },
        guardItems.length ? { cohortGuards: guardItems[0].beforeGuards } : null
      );
    });
    this.syncSourceChannels(sourceItems);
  }
  pasteRow(ch, key, i, unit, text, rowName) {
    const D = this.state.data, n = D.months.length;
    const cut = this.cutIdx();
    const parts = String(text).split(/[\t\n\r]+/).map(x => x.trim()).filter(x => x !== "");
    if (parts.length < 2) return false;
    const items = [], vals = [];
    const manual = this.isManualInput(ch, key);
    let past = 0, skipped = 0, locked = 0;
    parts.forEach((p, k) => {
      const t = i + k;
      if (t >= n) { past++; return; }
      if (t <= cut && !manual) { locked++; return; }
      const num = parseFloat(p.replace(/[^0-9.\-]/g, ""));
      if (isNaN(num)) { skipped++; return; }
      const v = unit === "%" ? num / 100 : num;
      vals.push([t, v]);
      const series = (this.state.inputs[ch] || {})[key];
      items.push({ kind: "input", ch: ch, key: key, i: t, label: key, period: D.months[t], before: Array.isArray(series) ? series[t] : null, after: v });
    });
    const ml2 = ym => ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][(ym % 100) - 1] + " " + String(Math.floor(ym / 100)).slice(2);
    const note = [
      vals.length ? "Pasted " + vals.length + (vals.length === 1 ? " month" : " months") + " into " + (rowName || key) + " from " + ml2(D.months[vals[0][0]]) : "Nothing pasted",
      locked ? locked + " landed on actual months and were ignored" : "",
      skipped ? skipped + " non-numeric " + (skipped === 1 ? "value" : "values") + " skipped" : "",
      past ? past + " past the last column, ignored" : ""
    ].filter(Boolean).join(" · ");
    this.setState({ pasteNote: note, pasteAt: Date.now(), pasteBad: !vals.length || !!(skipped || locked || past) });
    if (!vals.length) return true;
    this.setState(s => {
      const inputs = Object.assign({}, s.inputs), one = Object.assign({}, inputs[ch]);
      one[key] = Array.isArray(one[key]) ? one[key].slice() : new Array(n).fill(null);
      vals.forEach(v => one[key][v[0]] = v[1]);
      inputs[ch] = one;
      return { inputs: inputs };
    });
    if (manual) items.push({ kind: "structure", ch, label: "manual · " + (rowName || key), period: D.months[vals[0][0]], before: "—", after: vals.length + " months" });
    this.pushBatch(items, "UI");
    return true;
  }
  scenarioLevers(ch, D = this.state.data) {
    const out = [], seen = {};
    const add = (lever, r, extra = null) => {
      if (seen[lever]) {
        if (seen[lever].keys.indexOf(r.key) < 0) seen[lever].keys.push(r.key);
        seen[lever].rows.push(r);
        return;
      }
      seen[lever] = Object.assign({ lever, row: r, rows: [r], keys: [r.key], name: r.name }, extra);
      out.push(seen[lever]);
    };
    const ids = ch === "all" ? Object.keys((D && D.channels) || {}) : [ch].concat(membersOf(D, ch));
    ids.forEach(c => this.mergeDraftRows(buildRows(c, D), c).forEach(r => {
      if (channelHasSources(c) && readsSourceSpend(r)) {
        spendSources(c).forEach(s => add(sourceLever(s.key), r, { name: s.name, group: c + "|" + r.key, groupCh: c }));
        return;
      }
      const own = nativeLevers(r);
      own.forEach(l => add(l, r));
      if (!own.length && r.scenarioPick) add(r.k, r);
    }));
    return out;
  }

  zeroScen(D = this.state.data) {
    const { fdraft, scenarioOn } = this.state, memo = this._zeroScen, srcSeq = this._srcSeq || 0;
    if (memo && memo.D === D && memo.fdraft === fdraft && memo.scenarioOn === scenarioOn && memo.srcSeq === srcSeq) return Object.assign({}, memo.zero);
    const zero = {};
    this.scenarioLevers("all", D).forEach(l => { zero[l.lever] = 0; });
    this._zeroScen = { D, fdraft, scenarioOn, srcSeq, zero };
    return Object.assign({}, zero);
  }

  scenFor(ch) {
    const by = this.state.scenByCh, zero = this.zeroScen();
    if (ch !== "all") return Object.assign({}, zero, by[ch]);
    const ids = Object.keys(by).filter(k => k !== "all"), out = {};
    Object.keys(zero).forEach(k => {
      const first = ids.length ? (by[ids[0]][k] || 0) : 0;
      out[k] = ids.every(cid => (by[cid][k] || 0) === first) ? first : 0;
    });
    return out;
  }
  commitDrag() {
    const d = this._drag;
    if (!d) return;
    this._drag = null;
    if (this.scenFor(d.ch)[d.field] === d.v) return;
    this.setScen(d.ch, d.field, d.v);
  }
  setScen(ch, field, v) {
    this.setState(s => {
      const by = Object.assign({}, s.scenByCh);
      const targets = ch === "all" ? Object.keys(by) : [ch].concat(membersOf(s.data, ch));
      targets.forEach(cid => { by[cid] = Object.assign({}, by[cid], { [field]: v }); });
      return { scenByCh: by };
    });
  }

  // ---- Excel export: exact grid + live formulas ----
  exportExcel(view, X) {
    const S = X.S, cn = X.colName, D = this.state.data, st = this.state;
    const n = D.months.length, cut = typeof view.cut === "number" ? view.cut : this.cutIdx();
    const MN2 = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const mlab = ym => MN2[(ym % 100) - 1] + " " + String(ym).slice(2, 4);
    const C0 = 4;
    const [ra, rb] = view.range;
    const idxs = []; for (let i = ra; i <= rb; i++) idxs.push(i);
    const col = k => cn(C0 + k);
    const styleFor = (unit, actual) => unit === "£" ? (actual ? S.moneyA : S.money) : unit === "%" ? (actual ? S.pctA : S.pct) : unit === "×" ? (actual ? S.decA : S.dec) : (actual ? S.intA : S.int);
    const rowStyle = (r, actual) => {
      const dp = this.rowDp(r);
      return dp !== null ? X.dpStyle(r.unit, dp, actual) : styleFor(r.unit, actual);
    };

    const sheets = [];
    const chanSheets = {};
    const checkCells = [];
    let cohortChecked = false;
    const GRID_HEAD = 4;
    const extRow = (cid, token) => {
      const ext = this.channelRef(cid, token);
      if (!ext) return undefined;
      const ri = ext.k ? (view.rowDefs[ext.cid] || []).findIndex(r => r.k === ext.k) : -1;
      return ri < 0 ? null : { sheet: "'" + D.channels[ext.cid].label + "'!", row: GRID_HEAD + ri + 1 };
    };

    const buildChannel = (cid, sheetName) => {
      const conf = D.channels[cid], blocks = view.blocks[cid], combined = isCombined(D, cid), cohort = conf.model === "cohort" && !combined;
      if (cohort) cohortChecked = true;
      const rows = [], rowOf = {};
      rows.push([{ t: "s", v: conf.label + " · " + view.versionLabel, s: S.title }]);
      rows.push([{ t: "s", v: "Cutoff " + mlab(D.months[cut]) + " · actual months shaded · forecast months carry formulas", s: S.plain }]);
      rows.push([]);
      const head = [{ t: "s", v: "Driver", s: S.head }, { t: "s", v: "driver_key", s: S.head }, { t: "s", v: "Unit", s: S.head }];
      idxs.forEach((i, k) => head.push({ t: "s", v: mlab(D.months[i]), s: S.head }));
      rows.push(head);
      const headerRows = GRID_HEAD;

      const defs = view.rowDefs[cid];
      defs.forEach((r, ri) => { rowOf[r.k] = headerRows + ri + 1; });
      const q = s => "'" + s + "'!";
      const g = view.grid[cid];
      const resolve = this.calcResolver((g && g.__rows) || defs);

      const blockRef = {}, cohortSheets = [];
      if (cohort) {
        blocks.forEach(b => {
          const bn = sheetName + " " + (b === "subs" ? "subs" : "OTP") + " cohorts";
          const entrantsId = (() => {
            let token = null;
            defs.some(r => (token = cohortEntrantsToken(r.formula, b)));
            return token ? resolve(token) : null;
          })();
          const sizeCell = (c, j) => {
            const birth = D.months.indexOf(+c.label), k = idxs.indexOf(birth);
            if (birth > cut && k >= 0 && shown(birth) && entrantsId && rowOf[entrantsId]) return { f: q(sheetName) + col(k) + rowOf[entrantsId], s: S.int };
            return (sizes[j] === null || sizes[j] === undefined) ? "" : { v: Math.round(sizes[j]), s: S.int };
          };
          const brows = [];
          const sizes = view.sizes[cid][b] || [];
          const gridMeta = view.grid[cid] && view.grid[cid].__meta ? view.grid[cid].__meta : null;
          const filled = gridMeta && gridMeta.rates ? gridMeta.rates[b] : null;
          const legacy = gridMeta && gridMeta.legacy ? gridMeta.legacy[b] : null;
          const bFlags = gridMeta && gridMeta.flags ? gridMeta.flags[b] : null;
          const resolved = gridMeta && gridMeta.guards ? gridMeta.guards[b] : null;
          const bSources = gridMeta && gridMeta.rateSources ? gridMeta.rateSources[b] : null;
          const bKinds = gridMeta && gridMeta.rateKinds ? gridMeta.rateKinds[b] : null;
          const bMethods = gridMeta && gridMeta.methods ? gridMeta.methods[b] : null;
          const retention = resolved && resolved.v3 && typeof resolved.retention.start === "number" ? resolved.retention : null;
          const changeCell = "$B$3";
          const r6 = v => Math.round(v * 1e6) / 1e6;
          const capAt = age => {
            if (!resolved || !resolved.on.cap) return null;
            let band = -1;
            resolved.bands.forEach((start, x) => { if (age >= start) band = x; });
            const v = band >= 0 ? resolved.caps[band] : null;
            return typeof v === "number" ? v : null;
          };
          const methodOf = j => {
            const use = bMethods ? bMethods[j] : null;
            if (!use) return "";
            if (use === "own") return "Latest actual + typical decay · own history";
            const src = bSources && bSources[j] ? bSources[j].find((s, i) => i > cut && s && s.rule) : null;
            return src ? describeCohortChoice(src.rule) + (use === "user" ? " · set by user" : "") : "";
          };
          brows.push([{ t: "s", v: conf.label + " · " + (b === "subs" ? "Subscription" : "One time purchase") + " cohorts", s: S.title }]);
          brows.push([{ t: "s", v: "Repurchase % by cohort · edit a rate and every dependent figure recalculates", s: S.plain }]);
          brows.push(retention ? [{ t: "s", v: "Retention change", s: S.bold }, { v: retention.value, s: S.pctIn }, { t: "s", v: "from " + mlab(retention.start) + " · edit to change every forecast rate from that month", s: S.plain }] : []);
          const bh = [{ t: "s", v: "Cohort", s: S.head }, { t: "s", v: "Cohort size", s: S.head }, { t: "s", v: "Method", s: S.head }];
          idxs.forEach(i => bh.push({ t: "s", v: mlab(D.months[i]), s: S.head }));
          brows.push(bh);
          let legacyRow = 0;
          if (legacy) {
            const line = [{ t: "s", v: "Pre " + mlab(legacy.cutoff) }, "", { t: "s", v: "Bundle", s: S.plain }];
            idxs.forEach(i => {
              const v = legacy.orders[i];
              const src = legacy.sources ? legacy.sources[i] : null;
              if (typeof v !== "number" || !shown(i)) return line.push("");
              if (retention && i > cut && D.months[i] >= retention.start && src && src.method !== "actual") {
                return line.push({ f: Math.round(src.base * Math.pow(src.retention, src.power) * 1e4) / 1e4 + "*(1+" + changeCell + ")", s: S.int });
              }
              line.push({ v: Math.round(v * 1e4) / 1e4, s: i <= cut ? S.intA : S.int });
            });
            brows.push(line);
            legacyRow = brows.length;
          }
          const first = brows.length + 1;
          conf[b].cohorts.forEach((c, j) => {
            if (legacy && legacy.folded[j]) return;
            const method = methodOf(j);
            const line = [
              { t: "s", v: isNaN(+c.label) ? String(c.label) : mlab(+c.label) },
              sizeCell(c, j),
              method ? { t: "s", v: method, s: S.plain } : ""
            ];
            const birth = D.months.indexOf(+c.label);
            idxs.forEach(i => {
              const rate = filled && filled[j] ? filled[j][i] : i > cut ? this.rate(cid, b, j, i, c.ratio[i]) : c.ratio[i];
              const flagged = bFlags && bFlags[j] && bFlags[j][i];
              if (rate === null || rate === undefined || !shown(i)) return line.push("");
              const style = flagged ? S.pctFlag : i <= cut ? S.pctA : S.pct;
              const src = bSources && bSources[j] ? bSources[j][i] : null;
              const kind = bKinds && bKinds[j] ? bKinds[j][i] : null;
              if (retention && i > cut && birth >= 0 && D.months[i] >= retention.start && src && src.method !== "carry" && (kind === "rule" || kind === "fallback")) {
                const capNote = (src.guards || []).find(x => x.guard === "cap");
                const pre = src.change ? src.change.before : capNote ? capNote.before : rate;
                const cap = capAt(i - birth);
                const grown = r6(pre) + "*(1+" + changeCell + ")";
                return line.push({ f: cap === null ? grown : "MIN(" + r6(cap) + "," + grown + ")", s: style });
              }
              line.push({ v: r6(rate), s: style });
            });
            brows.push(line);
          });
          const last = brows.length;
          const totalRow = [{ t: "s", v: "Orders in month", s: S.bold }, "", ""];
          idxs.forEach((i, k) => {
            const c = col(k);
            totalRow.push(live(i, "SUMPRODUCT($B" + first + ":$B" + last + "," + c + first + ":" + c + last + ")" + (legacyRow ? "+N(" + c + legacyRow + ")" : ""), S.int));
          });
          brows.push(totalRow);
          blockRef[b] = { sheet: bn, row: brows.length };
          cohortSheets.push({ name: bn, rows: brows, opts: { freeze: [3, 4], cols: [16, 12, 30].concat(idxs.map(() => 9)) } });
        });
      }

      defs.forEach(r => {
        const line = [
          { t: "s", v: r.name },
          { t: "s", v: r.key, s: S.plain },
          { t: "s", v: r.unit, s: S.plain }
        ];
        idxs.forEach((i, k) => {
          const c = col(k), actual = i <= cut;
          if (!shown(i)) return line.push("");
          const val = g[r.k] ? g[r.k][i] : null;
          const num = () => (val === null || val === undefined) ? "" : { v: Math.round(val * 1e4) / 1e4, s: rowStyle(r, actual) };
          if (isInputSource(r.src) || (combined && isRollupSource(r.src))) return line.push(num());
          const ref = token => {
            const ext = extRow(cid, token);
            if (ext !== undefined) return ext ? ext.sheet + c + ext.row : null;
            const id = resolve(token);
            return id && rowOf[id] ? c + rowOf[id] : null;
          };
          const xl = formulaToExcel(r.formula, ref, (name, args, emit) => {
            if (name === "SCENARIO") return "1";
            const b = args[0] && args[0].t === "str" ? args[0].v : null;
            if (name === "COHORT_ORDERS") return cohort && blockRef[b] ? q(blockRef[b].sheet) + c + blockRef[b].row : null;
            if (name === "BASE_ORDERS") {
              const entr = args[1] ? emit(args[1]) : null;
              return k > 0 && rowOf["carry_" + b] && entr ? col(k - 1) + rowOf[r.k] + "*" + c + rowOf["carry_" + b] + "+" + entr : null;
            }
            return null;
          });
          if (cohort && xl && (typeof val !== "number" || !Number.isFinite(val))) checkCells.push(conf.label + " · " + r.name + " · " + mlab(D.months[i]));
          line.push(xl ? { f: xl, s: rowStyle(r, actual) } : num());
        });
        rows.push(line);
      });

      const name = sheetName;
      sheets.push({ name: name, rows: rows, opts: { freeze: [3, 4], cols: [34, 32, 5].concat(idxs.map(() => 11)) } }, ...cohortSheets);
      const byK = {};
      defs.forEach(r => { byK[r.k] = r; });
      chanSheets[cid] = { name: name, rowOf: rowOf, defs: byK };
    };

    const safeName = s => String(s).replace(/[\[\]:*?\/\\]/g, " ").slice(0, 31);
    const shown = i => !view.truncate || i <= cut;
    const cell = (i, v, style) => (shown(i) && typeof v === "number" && Number.isFinite(v) ? { v: Math.round(v * 1e6) / 1e6, s: style } : "");
    const gridHead = () => [{ t: "s", v: "Driver", s: S.head }, { t: "s", v: "driver_key", s: S.head }, { t: "s", v: "Unit", s: S.head }].concat(idxs.map(i => ({ t: "s", v: mlab(D.months[i]), s: S.head })));
    const band = label => [{ t: "s", v: label, s: S.bold }];
    const label3 = (name, key, unit, style) => [{ t: "s", v: name, s: style || S.plain }, { t: "s", v: key, s: S.plain }, { t: "s", v: unit, s: S.plain }];
    const colSum = (k, from, to, style) => (shown(idxs[k]) ? { f: "SUM(" + col(k) + from + ":" + col(k) + to + ")", s: style } : "");
    const live = (i, f, style) => (shown(i) ? { f, s: style } : "");

    const buildMix = cid => {
      const cats = PRODUCT_MIX[cid] || [];
      if (!cats.length) return;
      const conf = D.channels[cid], g = view.grid[cid] || {}, meta = g.__meta || {}, ns = channelNs(cid);
      const blocks = view.blocks[cid] || [];
      const gross = g.tot_sales || g[blocks[0] + "_sales"] || [];
      const mixAt = (ci, i) => (meta.mix && meta.mix.values[ci] ? meta.mix.values[ci][i] : this.mixPct(cid, ci, i, cats[ci][1]));
      const cogsAt = (ci, i) => (meta.cogs && meta.cogs.values[ci] ? meta.cogs.values[ci][i] : this.cogsPct(cid, ci, i, cats[ci][2]));
      const keyOf = (ci, suffix) => ns + ".product_mix." + driverKeySlug(cats[ci][0]) + "." + suffix;
      const rows = [];
      rows.push([{ t: "s", v: conf.label + " · Product mix · " + view.versionLabel, s: S.title }]);
      rows.push([{ t: "s", v: "Actual months are bound values · product gross sales and COGS £ are live formulas", s: S.plain }]);
      rows.push([]);
      rows.push(gridHead());
      const pctRows = (title, at, suffix) => {
        rows.push(band(title));
        const start = rows.length + 1;
        cats.forEach((c, ci) => rows.push(label3(c[0], keyOf(ci, suffix), "%").concat(idxs.map(i => cell(i, at(ci, i), i <= cut ? S.pctA : S.pct)))));
        return start;
      };
      const mixStart = pctRows("1 · % mix", mixAt, "mix_pct");
      const mixEnd = rows.length;
      rows.push(label3("Mix total", ns + ".product_mix.mix_total", "%", S.bold).concat(idxs.map((i, k) => colSum(k, mixStart, mixEnd, S.pct))));
      rows.push(band("2 · Gross sales excl discounts and tax"));
      const grossRow = rows.length + 1;
      rows.push(label3("Gross sales", ns + ".total.gross_sales", "£", S.bold).concat(idxs.map(i => cell(i, gross[i], i <= cut ? S.moneyA : S.money))));
      const catGrossStart = rows.length + 1;
      cats.forEach((c, ci) => rows.push(label3(c[0], keyOf(ci, "gross_sales"), "£").concat(idxs.map((i, k) => live(i, col(k) + grossRow + "*" + col(k) + (mixStart + ci), i <= cut ? S.moneyA : S.money)))));
      const cogsStart = pctRows("3 · Product COGS %", cogsAt, "cogs_pct");
      rows.push(band("4 · Product COGS £"));
      const cogsGbpStart = rows.length + 1;
      cats.forEach((c, ci) => rows.push(label3(c[0], keyOf(ci, "cogs"), "£").concat(idxs.map((i, k) => live(i, col(k) + (catGrossStart + ci) + "*" + col(k) + (cogsStart + ci), i <= cut ? S.moneyA : S.money)))));
      const cogsGbpEnd = rows.length;
      rows.push(label3("Product COGS", ns + ".cogs.total", "£", S.bold).concat(idxs.map((i, k) => colSum(k, cogsGbpStart, cogsGbpEnd, S.money))));
      rows.push(label3("Blended product COGS %", ns + ".cogs.blended_cogs_pct", "%", S.bold).concat(idxs.map((i, k) => live(i, "IFERROR(" + col(k) + rows.length + "/" + col(k) + grossRow + ",\"\")", S.pct))));
      sheets.push({ name: safeName(conf.label + " product mix"), rows, opts: { freeze: [3, 4], cols: [30, 40, 5].concat(idxs.map(() => 11)) } });
    };

    const buildSources = cid => {
      const list = SESSION_SOURCES[cid] || [];
      if (!list.length) return;
      const conf = D.channels[cid], resolved = this.resolvedSources(cid, (view.sourceScale && view.sourceScale[cid]) || null);
      const rows = [];
      rows.push([{ t: "s", v: conf.label + " · Marketing sources · " + view.versionLabel, s: S.title }]);
      rows.push([{ t: "s", v: "Actual months are bound values · totals and cost per session are live formulas", s: S.plain }]);
      rows.push([]);
      rows.push(gridHead());
      const block = (title, metric, series, unit, styleOf) => {
        rows.push(band(title));
        const start = rows.length + 1;
        list.forEach((s, si) => {
          const r = resolved[si] || {};
          rows.push(label3(s.name, sourceDriverKey(s.key, metric), unit).concat(idxs.map(i => cell(i, (r[series] || [])[i], styleOf(i <= cut)))));
        });
        return start;
      };
      const sessStart = block("1 · Sessions #", "sess", "sessions", "#", a => (a ? S.intA : S.int));
      const sessEnd = rows.length;
      rows.push(label3("Sessions total", "", "#", S.bold).concat(idxs.map((i, k) => colSum(k, sessStart, sessEnd, S.int))));
      const adStart = block("2 · Ad spend £", "ad", "ad", "£", a => (a ? S.moneyA : S.money));
      const adEnd = rows.length;
      rows.push(label3("Ad spend total", "", "£", S.bold).concat(idxs.map((i, k) => colSum(k, adStart, adEnd, S.money))));
      rows.push(band("3 · Cost per session £"));
      list.forEach((s, si) => rows.push(label3(s.name, sourceDriverKey(s.key, "cps"), "£").concat(idxs.map((i, k) => live(i, "IFERROR(" + col(k) + (adStart + si) + "/" + col(k) + (sessStart + si) + ",\"\")", i <= cut ? S.decA : S.dec)))));
      sheets.push({ name: safeName(conf.label + " sources"), rows, opts: { freeze: [3, 4], cols: [30, 40, 5].concat(idxs.map(() => 11)) } });
    };

    const buildCompare = cid => {
      const cmp = view.compare, cs = chanSheets[cid];
      if (!cmp || !cs) return;
      const label = cid === "all" ? "All channels" : D.channels[cid].label, cg = cmp.grid[cid] || {}, sel = cmp.sel || {};
      const defs = cid === "all" ? cs.list : view.rowDefs[cid];
      const rows = [];
      rows.push([{ t: "s", v: label + " · " + view.versionLabel + " vs " + cmp.label, s: S.title }]);
      rows.push([{ t: "s", v: "Value links to the " + cs.name + " sheet · Change = value − " + cmp.label + " · Change % = Change ÷ " + cmp.label, s: S.plain }]);
      rows.push([]);
      rows.push(gridHead());
      defs.forEach(r => {
        if (!cs.rowOf[r.k]) return;
        const at = k => "'" + cs.name + "'!" + col(k) + cs.rowOf[r.k];
        let baseRow = 0;
        const lines = [];
        if (sel.value !== false) lines.push(["value", r.name, S.bold]);
        lines.push(["base", sel.value !== false ? "vs " + cmp.label : r.name + " · " + cmp.label, S.plain]);
        if (sel.abs) lines.push(["abs", "Change", S.plain]);
        if (sel.pct) lines.push(["pct", "Change %", S.plain]);
        lines.forEach(([kind, label, style]) => {
          const rowNo = rows.length + 1;
          if (kind === "base") baseRow = rowNo;
          const head = label3(label, kind === "value" || kind === "base" ? r.key : "", kind === "pct" ? "%" : r.unit, style);
          rows.push(head.concat(idxs.map((i, k) => {
            const st2 = kind === "pct" ? S.pct : rowStyle(r, i <= cut);
            const v = at(k), b = col(k) + baseRow;
            if (kind === "value") return live(i, "IF(" + v + "=\"\",\"\"," + v + ")", st2);
            if (kind === "base") return cell(i, cg[r.k] ? cg[r.k][i] : null, st2);
            if (kind === "abs") return live(i, "IF(OR(" + v + "=\"\"," + b + "=\"\"),\"\"," + v + "-" + b + ")", st2);
            return live(i, "IF(OR(" + v + "=\"\"," + b + "=\"\"," + b + "=0),\"\",(" + v + "-" + b + ")/" + b + ")", st2);
          })));
        });
      });
      sheets.push({ name: safeName(label + " vs " + cmp.label), rows, opts: { freeze: [3, 4], cols: [34, 32, 5].concat(idxs.map(() => 11)) } });
    };

    view.channels.forEach(cid => {
      buildChannel(cid, D.channels[cid].label);
      buildMix(cid);
      buildSources(cid);
      buildCompare(cid);
    });

    // group rollup sheet
    const rollupIds = (view.rollup || view.channels).filter(cid => view.grid[cid]);
    if (view.channels.length > 1 && rollupIds.length) {
      const rows = [];
      rows.push([{ t: "s", v: "All channels · " + view.versionLabel, s: S.title }]);
      rows.push([{ t: "s", v: "Add up drivers are live sums across the channel sheets · Formula drivers rerun their totals formula on these figures", s: S.plain }]);
      rows.push([]);
      const head = [{ t: "s", v: "Driver", s: S.head }, { t: "s", v: "driver_key", s: S.head }, { t: "s", v: "Unit", s: S.head }];
      idxs.forEach(i => head.push({ t: "s", v: mlab(D.months[i]), s: S.head }));
      rows.push(head);
      const group = this.runGroup(rollupIds.map(cid => view.grid[cid]), rollupIds);
      const gdefs = this.ordered((group.__rows || []).filter(r => !r.hide), ["acq", "subs", "otp", "total", "pl", "kpi"], "all").filter(r => !this.cfgOf(r.k, "all").hide);
      const gRowOf = {};
      gdefs.forEach((r, ri) => { gRowOf[r.k] = rows.length + ri + 1; });
      const gResolve = this.calcResolver(group.__rows || []);
      gdefs.forEach(r => {
        const line = [{ t: "s", v: r.name }, { t: "s", v: r.key, s: S.plain }, { t: "s", v: r.unit, s: S.plain }];
        idxs.forEach((i, k) => {
          const c = col(k), style = rowStyle(r, i <= cut);
          if (!shown(i)) return line.push("");
          const val = group[r.k] ? group[r.k][i] : null;
          const num = () => (val === null || val === undefined) ? "" : { v: Math.round(val * 1e4) / 1e4, s: style };
          const mode = totalsModeOf(r);
          let xl = null;
          if (mode === "formula") {
            xl = formulaToExcel(r.formula, token => { const id = gResolve(token); return id && gRowOf[id] ? c + gRowOf[id] : null; });
          } else if (mode === "add_up") {
            const terms = rollupIds
              .map(cid => chanSheets[cid])
              .filter(cs => cs && cs.rowOf[r.k])
              .map(cs => "'" + cs.name + "'!" + c + cs.rowOf[r.k]);
            if (terms.length) xl = "SUM(" + terms.join(",") + ")";
          }
          line.push(xl ? { f: xl, s: style } : num());
        });
        rows.push(line);
      });
      sheets.push({ name: "All channels", rows: rows, opts: { freeze: [3, 4], cols: [30, 26, 5].concat(idxs.map(() => 11)) } });
      chanSheets.all = { name: "All channels", rowOf: gRowOf, list: gdefs };
      buildCompare("all");
    }

    // rolled-up view
    if (view.gran !== "month") view.channels.forEach(cid => {
      const cs = chanSheets[cid];
      const rows = [];
      rows.push([{ t: "s", v: (view.gran === "quarter" ? "Quarterly" : "Annual") + " rollup · " + D.channels[cid].label, s: S.title }]);
      rows.push([{ t: "s", v: "Add up drivers sum the monthly sheet · Formula drivers run their totals formula on these figures", s: S.plain }]);
      rows.push([]);
      const groupsMap = [];
      idxs.forEach((i, k) => {
        const fs = st.fyStart, ym = D.months[i], y = ym % 100 >= fs ? Math.floor(ym / 100) : Math.floor(ym / 100) - 1;
        const key = view.gran === "year" ? "FY-" + String(y).slice(2) + "/" + String(y + 1).slice(2)
          : "Q" + (Math.floor((((ym % 100) - fs) + 12) % 12 / 3) + 1) + " FY" + String(y).slice(2);
        let g = groupsMap.find(x => x.key === key);
        if (!g) { g = { key: key, ks: [] }; groupsMap.push(g); }
        g.ks.push(k);
      });
      const head = [{ t: "s", v: "Driver", s: S.head }, { t: "s", v: "Unit", s: S.head }];
      groupsMap.forEach(g => head.push({ t: "s", v: g.key, s: S.head }));
      rows.push(head);
      const src = "'" + cs.name + "'!";
      const range = (g, rk) => src + col(g.ks[0]) + cs.rowOf[rk] + ":" + col(g.ks[g.ks.length - 1]) + cs.rowOf[rk];
      const qCol = gi => cn(3 + gi);
      const listed = Object.keys(cs.defs).filter(rk => cs.rowOf[rk] && totalsModeOf(cs.defs[rk]) !== "no_totals");
      const qRowOf = {};
      listed.forEach((rk, ri) => { qRowOf[rk] = rows.length + ri + 1; });
      const qResolve = this.calcResolver(Object.keys(cs.defs).map(rk => cs.defs[rk]));
      listed.forEach(rk => {
        const r = cs.defs[rk];
        const line = [{ t: "s", v: r.name }, { t: "s", v: r.unit, s: S.plain }];
        groupsMap.forEach((g, gi) => {
          const f = totalsModeOf(r) === "formula"
            ? formulaToExcel(r.totalsFormula, token => {
              const ext = extRow(cid, token);
              if (ext !== undefined) return ext ? "SUM(" + ext.sheet + col(g.ks[0]) + ext.row + ":" + col(g.ks[g.ks.length - 1]) + ext.row + ")" : null;
              const id = qResolve(token);
              if (id && qRowOf[id]) return qCol(gi) + qRowOf[id];
              return id && cs.rowOf[id] ? "SUM(" + range(g, id) + ")" : null;
            })
            : "SUM(" + range(g, rk) + ")";
          line.push(f ? { f, s: rowStyle(r, false) } : "");
        });
        rows.push(line);
      });
      const rollupName = view.gran === "year" ? "Annual" : "Quarterly";
      sheets.push({ name: view.channels.length > 1 ? safeName(D.channels[cid].label + " " + rollupName.toLowerCase()) : rollupName, rows: rows, opts: { cols: [26, 5].concat(groupsMap.map(() => 14)) } });
    });

    const guardScopes = [];
    view.channels.forEach(cid => {
      const conf = D.channels[cid], gm = view.grid[cid] && view.grid[cid].__meta;
      if (!conf || conf.model !== "cohort" || isCombined(D, cid) || !gm || !gm.guards) return;
      (view.blocks[cid] || []).forEach(b => {
        if (gm.guards[b]) guardScopes.push({ cid, b, label: conf.label + " · " + (BL[b] || b) + " cohorts", resolved: gm.guards[b], gm, cohorts: (conf[b] && conf[b].cohorts) || [] });
      });
    });
    const qaFlags = guardScopes.reduce((a, x) => a + (x.gm.flagCount[x.b] || 0), 0);
    if (guardScopes.length) {
      const txt = (v, s) => ({ t: "s", v: String(v), s: s === undefined ? S.plain : s });
      const state = (x, gid) => GUARD_STATE_TEXT[guardStateOf(x.resolved, gid)];
      const grows = [[txt("Forecast guardrails · " + view.versionLabel, S.title)], [txt("Engine " + COHORT_GUARD_ENGINE_VERSION + " · every rule, its values and the cells it changed, per channel and cohort model")], []];
      grows.push([txt("Channel and cohort model", S.head)].concat(GUARD_IDS.map(gid => txt(GUARD_LABEL[gid], S.head)), [txt("Red cells", S.head)]));
      guardScopes.forEach(x => {
        const changed = x.gm.changed[x.b] || {};
        grows.push([txt(x.label, S.bold)].concat(GUARD_IDS.map(gid => {
          const on = guardStateOf(x.resolved, gid) === "on";
          return txt([state(x, gid), on ? guardValueText(x.resolved, gid) : "", on && gid !== "qa" ? (changed[gid] || 0) + " changed" : ""].filter(Boolean).join(" · "));
        }), [{ v: x.gm.flagCount[x.b] || 0, s: S.int }]));
      });
      grows.push([]);
      grows.push(["Channel and cohort model", "Rule", "State", "Setting", "parameter_key", "Value", "Source", "Reason", "Set by", "Set at"].map(h => txt(h, S.head)));
      guardScopes.forEach(x => GUARD_PARAMS.forEach(p => {
        const info = x.resolved.params[p];
        if (!info) return;
        const fromData = x.resolved.v4 && p === "ownHistoryMinMonths" && info.source !== "user";
        grows.push([txt(x.label), txt(GUARD_LABEL[GUARD_OF_PARAM[p]]), txt(state(x, GUARD_OF_PARAM[p])), txt(PARAM_GUIDE[p].label), txt(p), txt(info.value === null ? "Needs a decision" : formatGuardValue(p, info.value)), txt(info.source === "user" ? "Set by user" : fromData ? "Set from your data" : "System default"), txt(info.reason), txt(info.by || ""), txt(fromData ? x.resolved.ownChangedAt || "" : info.at || "")]);
      }));
      guardScopes.forEach(x => {
        const R = x.resolved;
        if (!R.v4) return;
        MN.forEach((name, m) => grows.push([txt(x.label), txt("Monthly seasonality"), txt(R.seasonUsed ? "On" : "Off"), txt("Month factor · " + name), txt("monthFactor"), txt(this.numFixed(R.monthFactors[m], 3)), txt("From data"),
          txt(!R.factorsMeasured ? "Under 12 months of actuals, so every month uses 1.000" : R.monthYears[m] ? "Rests on " + R.monthYears[m] + (R.monthYears[m] === 1 ? " year" : " years") + " against the months around it" : "Too few well-sized cohorts, so it uses 1.000"), txt(""), txt("")]));
        const bundle = R.bundle;
        if (bundle) grows.push([txt(x.label), txt(GUARD_LABEL.legacy), txt(state(x, "legacy")), txt("Bundle fade"), txt("bundleFade"), txt(Math.round(bundle.yearly * 1000) / 10 + "% kept a year"), txt("From data"),
          txt("Latest " + bundle.window + " months " + mlab(D.months[bundle.months[0]]) + " to " + mlab(D.months[bundle.months[bundle.months.length - 1]]) + " against the " + bundle.window + " months before"), txt(""), txt("")]);
      });
      guardScopes.forEach(x => {
        const R = x.resolved;
        if (typeof R.fade !== "number") return;
        const reason = R.fadeFrom === "curve" ? "Size-weighted month on month change over ages " + R.fadeAges[0] + " to " + R.fadeAges[R.fadeAges.length - 1] : "Share of bundle orders kept each month";
        grows.push([txt(x.label), txt(GUARD_LABEL.tail), txt(state(x, "tail")), txt("Long-term fade"), txt("tailFade"), txt(this.numFixed(R.fade * 100, 1) + "% kept each month"), txt(R.fadeFrom === "curve" ? "From mature cohorts" : "From the bundle"), txt(reason), txt(""), txt("")]);
      });
      grows.push([]);
      grows.push(["Channel and cohort model", "Cohort", "Month", "Rate", "Reason", "Threshold", "Expected"].map(h => txt(h, S.head)));
      guardScopes.forEach(x => (x.gm.flags[x.b] || []).forEach((row, j) => (row || []).forEach((list, t) => {
        if (!list) return;
        const label = x.cohorts[j] ? x.cohorts[j].label : "";
        const rate = x.gm.rates[x.b] && x.gm.rates[x.b][j] ? x.gm.rates[x.b][j][t] : null;
        list.forEach(f => grows.push([
          txt(x.label), txt(isNaN(+label) ? String(label) : mlab(+label)), txt(mlab(D.months[t])),
          typeof rate === "number" ? { v: Math.round(rate * 1e6) / 1e6, s: S.pctFlag } : "",
          txt(GUARD_FLAG_RULE[f.rule]), { v: Math.round(f.threshold * 1e6) / 1e6, s: S.pct },
          typeof f.expected === "number" ? { v: Math.round(f.expected * 1e6) / 1e6, s: S.pct } : ""
        ]));
      })));
      sheets.push({ name: "Guardrails", rows: grows, opts: { cols: [30, 26, 18, 22, 18, 26, 16, 70, 18, 22] } });
      if (view.flagReviews) {
        const rrows = [[txt("Flag review · " + view.versionLabel, S.title)], [txt("Every red cell, the rules it breaks, and who accepted it and why. Publishing waits until each one is accepted or changed.")], []];
        rrows.push(["Channel and cohort model", "Cohort", "Month", "Rate", "Rules", "Status", "Note", "Accepted by", "Accepted at"].map(h => txt(h, S.head)));
        guardScopes.forEach(x => (x.gm.flags[x.b] || []).forEach((row, j) => (row || []).forEach((list, t) => {
          if (!list || !list.length || (x.gm.legacy && x.gm.legacy[x.b] && x.gm.legacy[x.b].folded[j])) return;
          const label = x.cohorts[j] ? x.cohorts[j].label : "";
          const rate = x.gm.rates[x.b] && x.gm.rates[x.b][j] ? x.gm.rates[x.b][j][t] : null;
          const review = view.flagReviews[cellReviewKey(x.cid, x.b, j, t)];
          const held = reviewHolds(review, rate, flagRulesOf(list));
          rrows.push([
            txt(x.label), txt(isNaN(+label) ? String(label) : mlab(+label)), txt(mlab(D.months[t])),
            typeof rate === "number" ? { v: Math.round(rate * 1e6) / 1e6, s: S.pctFlag } : "",
            txt(list.map(f => GUARD_FLAG_RULE[f.rule]).join(" · ")),
            txt(held ? "Accepted" : "Open"),
            txt(held ? review.note || "" : ""), txt(held ? review.by || "" : ""), txt(held ? review.at || "" : "")
          ]);
        })));
        sheets.push({ name: "Flag review", rows: rrows, opts: { cols: [30, 14, 12, 12, 60, 12, 60, 22, 24] } });
      }
    }

    // metadata
    const meta = [[{ t: "s", v: "Export metadata", s: S.title }], []];
    const metaLines = view.meta.map(m => m[0] === "engine_version" && guardScopes.length ? ["engine_version", view.guardEngine || COHORT_GUARD_ENGINE_VERSION] : m);
    if (guardScopes.length) {
      metaLines.push(["qa_flags", String(qaFlags)]);
      guardScopes.forEach(x => {
        const auto = x.gm.auto && x.gm.auto[x.b];
        const R = x.resolved;
        if (R.v4) {
          const rule = view.cohortInput[cohortInputKey(x.cid, x.b)] || (auto ? auto.rule : DEFAULT_COHORT_RULE);
          metaLines.push([x.label + " · forecast method", describeSplitRule(rule)]);
          metaLines.push([x.label + " · Auto", auto
            ? "On" + (typeof auto.accuracy === "number" ? " · " + Math.round(auto.accuracy * 100) + "% accurate" : "") + (auto.window ? " · " + auto.window + " months tested" : "")
            : "Off · forecast method set by user"]);
          metaLines.push([x.label + " · older cohort threshold", R.ownMinMonths === null ? "None yet · every cohort uses the newer cohort method" : R.ownMinMonths + " actual months · Set " + thresholdSource(R)]);
        } else metaLines.push([x.label + " · Auto", auto
          ? "On · " + (typeof auto.accuracy === "number" ? Math.round(auto.accuracy * 100) + "% accurate · " : "") + "using " + describeCohortChoice(auto.rule)
          : "Off · forecast method set by user"]);
        const offRules = GUARD_IDS.filter(gid => x.resolved.off[gid]).map(gid => GUARD_LABEL[gid]);
        if (offRules.length) metaLines.push([x.label + " · rules off", offRules.join(", ")]);
        GUARD_PARAMS.forEach(p => {
          const info = x.resolved.params[p];
          if (info) metaLines.push([x.label + " · " + p, (info.value === null ? "Needs a decision" : formatGuardValue(p, info.value)) + " · " + (info.source === "user" ? "Set by user" : /^Set by back test/.test(info.reason) ? info.reason : "System default")]);
        });
        if (x.resolved.v3) {
          const uses = (x.gm.methods && x.gm.methods[x.b]) || [];
          const count = m => uses.filter(u => u === m).length;
          if (!R.v4) metaLines.push([x.label + " · methods", "Own history " + count("own") + " · Tab method " + count("tab") + " · Set by user " + count("user")]);
          const bundle = x.resolved.bundle;
          if (bundle) metaLines.push([x.label + " · bundle retention", "Latest " + bundle.window + " months " + mlab(D.months[bundle.months[0]]) + " to " + mlab(D.months[bundle.months[bundle.months.length - 1]]) + " · " + Math.round(bundle.now) + " orders vs " + Math.round(bundle.before) + " a year earlier · " + Math.round(bundle.yearly * 1000) / 10 + "% kept a year"]);
          else if (x.resolved.bundleNeeds) metaLines.push([x.label + " · bundle retention", "Fewer matched months after the bundle cutoff than the window, so the share kept uses the last 12 months against the 12 before"]);
          if (typeof x.resolved.tunedError === "number") metaLines.push([x.label + " · back test error", Math.round(x.resolved.tunedError * 1000) / 10 + "%"]);
        }
      });
    }
    if (cohortChecked) metaLines.push(["export_check", checkCells.length ? checkCells.length + (checkCells.length === 1 ? " formula cell has" : " formula cells have") + " no value in the app. Check these in Excel" : "Every cohort channel formula cell has a value in the app"]);
    checkCells.slice(0, 50).forEach(x => metaLines.push(["check", x]));
    metaLines.forEach(m => meta.push([{ t: "s", v: m[0], s: S.bold }, { t: "s", v: String(m[1]) }]));
    sheets.push({ name: "Meta", rows: meta, opts: { cols: [30, 62] } });

    const guideStyle = { title: S.title, section: S.head, sub: S.bold, text: S.plain, head: S.head, cell: S.plain };
    const guide = buildModelGuide(this.guideContext(view, cut));
    sheets.push({ name: MODEL_GUIDE_SHEET, rows: guide.map(r => r.cells.map(v => ({ t: "s", v, s: guideStyle[r.style] }))), opts: { cols: [34, 40, 10, 16, 16, 30, 110] } });

    const size = X.writeXlsx(sheets, view.filename);
    this.setState({ exportNote: "Exported " + view.filename + " · " + Math.round(size / 1024) + " kB · " + sheets.length + " sheets" + (checkCells.length ? " · " + checkCells.length + " formula cells to check, listed on Meta" : ""), exportAt: Date.now() });
    if (this.onExportDone) this.onExportDone({ filename: view.filename, blobSize: size });
  }

  guideContext(view, cut) {
    const D = this.state.data, st = this.state;
    const metaOf = key => {
      const m = (view.meta || []).find(x => x[0] === key);
      return m ? String(m[1]) : "";
    };
    return {
      version: metaOf("version"),
      versionType: metaOf("version_type"),
      exported: metaOf("exported"),
      cutoff: ml(D.months[cut]),
      actualThrough: ml(D.months[this.actualCutIdx()]),
      period: metaOf("period exported"),
      scenario: metaOf("scenario applied") || "no",
      currency: st.ccy,
      fyStart: MN[((st.fyStart || 1) - 1) % 12],
      engine: view.guardEngine || null,
      constants: resolveConstants(view.guardConstants),
      forecastRules: !!view.mixInput,
      channels: view.channels.map(cid => this.guideChannel(cid, view))
    };
  }

  guideChannel(cid, view) {
    const D = this.state.data, conf = D.channels[cid], combined = isCombined(D, cid);
    const mixMap = view.mixInput || {}, cogsMap = view.cogsInput || {};
    const resolved = combined ? [] : this.resolvedSources(cid);
    const ruleKeys = Object.keys(mixMap).concat(Object.keys(cogsMap));
    return {
      label: conf.label,
      model: combined ? "Combined" : isCustom(D, cid) ? "Custom" : conf.model === "cohort" ? "Cohort model" : conf.model === "base" ? "Base model" : String(conf.model || ""),
      blocks: (view.blocks[cid] || []).map(b => BL[b] || b),
      members: membersOf(D, cid).map(m => D.channels[m].label),
      drivers: (view.rowDefs[cid] || []).map(r => ({
        name: r.name, key: r.key, unit: r.unit, section: SECTION_LABEL[r.sec] || r.sec || "", src: String(r.src || ""),
        formula: r.formula, fallback: r.fallback, rollup: r.rollup, fill: r.fill, levers: nativeLevers(r), min: r.min, max: r.max,
        totalsMode: totalsModeOf(r), totalsFormula: r.totalsFormula
      })),
      sources: (SESSION_SOURCES[cid] || []).map((s, si) => {
        const r = resolved[si];
        const sessionRule = r ? r.sessionRule : this.sessionRuleFor(s.key);
        return {
          name: s.name, key: s.key, manual: !!s.manual,
          sessions: describeSourceRule(sessionRule),
          cps: sessionRule.method === "spend" ? describeSourceRule(r ? r.cpsRule : this.cpsRuleFor(s.key)) : "Not used"
        };
      }),
      categories: (PRODUCT_MIX[cid] || []).map(c => ({
        name: c[0], manual: !!c[5],
        mix: describeMixRule(resolveMixRule(mixMap, cid, c[0])),
        cogs: describeMixRule(resolveMixRule(cogsMap, cid, c[0])),
        monthRules: ruleKeys.filter(k => k.indexOf(mixInputKey(cid, c[0]) + "|") === 0).length
      }))
    };
  }

  mixKey(ch, ci, t) { return ch + "|p" + ci + "|" + t; }
  cogsKey(ch, ci, t) { return ch + "|c" + ci + "|" + t; }
  prodKey(kind, ch, ci, t) { return kind === "cogs" ? this.cogsKey(ch, ci, t) : this.mixKey(ch, ci, t); }
  prodLabel(kind, ch, ci) { return (PRODUCT_MIX[ch][ci] || [])[0] + (kind === "cogs" ? " COGS %" : " mix %"); }
  mixPct(ch, ci, t, base, mov) {
    const map = mov || this.state.mov || {};
    const o = map[this.mixKey(ch, ci, t)];
    if (o !== undefined) return o;
    const row = (PRODUCT_MIX[ch] || [])[ci];
    const month = this.state.data && this.state.data.months ? this.state.data.months[t] : undefined;
    const h = row && row[3] && month !== undefined ? row[3][String(month)] : undefined;
    return typeof h === "number" && Number.isFinite(h) ? h : base;
  }
  cogsPct(ch, ci, t, base) {
    const o = (this.state.mov || {})[this.cogsKey(ch, ci, t)];
    if (o !== undefined) return o;
    const row = (PRODUCT_MIX[ch] || [])[ci];
    const month = this.state.data && this.state.data.months ? this.state.data.months[t] : undefined;
    const h = row && row[4] && month !== undefined ? row[4][String(month)] : undefined;
    return typeof h === "number" && Number.isFinite(h) ? h : base;
  }
  pasteMix(ch, ci, i, text, kind) {
    const D = this.state.data, n = D.months.length, cut = this.cutIdx();
    const parts = String(text).split(/[\t\n\r]+/).map(x => x.trim()).filter(x => x !== "");
    if (parts.length < 2) return false;
    const items = [], vals = [];
    const hist = this.manualMixHistory(ch, ci, kind);
    let past = 0, skipped = 0, lockedM = 0, actuals = 0;
    parts.forEach((p, k) => {
      const t = i + k;
      if (t >= n) { past++; return; }
      if (t <= cut && !hist) { lockedM++; return; }
      const num = parseFloat(p.replace(/[^0-9.\-]/g, ""));
      if (isNaN(num)) { skipped++; return; }
      if (t <= cut) {
        const period = String(D.months[t]);
        items.push({ kind: "settings", label: this.prodLabel(kind, ch, ci), period: D.months[t], before: typeof hist[period] === "number" ? hist[period] : null, after: num / 100 });
        hist[period] = num / 100;
        actuals++;
        return;
      }
      const v = hist ? num / 100 : Math.max(0, num / 100);
      const key = this.prodKey(kind, ch, ci, t);
      vals.push([key, v]);
      items.push({ kind: "mix", rkey: key, ch: ch, label: this.prodLabel(kind, ch, ci), period: D.months[t], before: this.state.mov[key] === undefined ? null : this.state.mov[key], after: v });
    });
    const name = (PRODUCT_MIX[ch][ci] || [])[0];
    const count = vals.length + actuals;
    this.setState(s => {
      const mov = Object.assign({}, s.mov);
      vals.forEach(v => { mov[v[0]] = v[1]; });
      return {
        mov: mov,
        pasteNote: [
          count ? "Pasted " + count + (count === 1 ? " month" : " months") + " into " + name : "Nothing pasted",
          lockedM ? lockedM + " landed on actual months and were ignored" : "",
          skipped ? skipped + " non-numeric " + (skipped === 1 ? "value" : "values") + " skipped" : "",
          past ? past + " past the last column, ignored" : ""
        ].filter(Boolean).join(" · "),
        pasteAt: Date.now(), pasteBad: !count || !!(skipped || lockedM || past)
      };
    });
    if (actuals) this.noteSettingsDirty();
    if (items.length) this.pushBatch(items, "UI");
    return true;
  }

  manualMixHistory(ch, ci, kind) {
    const row = (PRODUCT_MIX[ch] || [])[ci];
    if (!row || !row[5]) return null;
    const at = kind === "cogs" ? 4 : 3;
    if (!row[at] || typeof row[at] !== "object") row[at] = {};
    return row[at];
  }

  editManualMixActual(ch, ci, t, val, kind) {
    const hist = this.manualMixHistory(ch, ci, kind);
    if (!hist) return;
    const period = String(this.state.data.months[t]);
    const before = typeof hist[period] === "number" ? hist[period] : null;
    if (val === before) return;
    if (val === null) delete hist[period]; else hist[period] = val;
    this.noteSettingsDirty();
    this.pushBatch([{ kind: "settings", label: this.prodLabel(kind, ch, ci), period: this.state.data.months[t], before: before, after: val }], "UI");
  }

  editMix(ch, ci, t, raw, kind) {
    if (this.state.version !== "fc_v5") return;
    const manual = !!((PRODUCT_MIX[ch] || [])[ci] || [])[5];
    const text = raw === null || raw === undefined ? "" : String(raw).trim();
    const num = parseFloat(text.replace(/[^0-9.\-]/g, ""));
    if (manual && t <= this.cutIdx()) {
      if (isNaN(num) && text !== "") return;
      this.editManualMixActual(ch, ci, t, isNaN(num) ? null : num / 100, kind);
      return;
    }
    const key = this.prodKey(kind, ch, ci, t);
    const before = this.state.mov[key] === undefined ? null : this.state.mov[key];
    if (isNaN(num) && (text !== "" || before === null)) return;
    const val = isNaN(num) ? null : (kind === "cogs" || manual) ? num / 100 : Math.max(0, num / 100);
    if (val === before) return;
    this.setState(s => {
      const mov = Object.assign({}, s.mov);
      if (val === null) delete mov[key]; else mov[key] = val;
      return { mov };
    });
    this.pushBatch([{ kind: "mix", rkey: key, ch: ch, label: this.prodLabel(kind, ch, ci), period: this.state.data.months[t], before: before, after: val }], "UI");
  }

  addProductCategory(ch, name, mixPct, cogsPct) {
    if (this.state.version !== "fc_v5" || !ch) return;
    const label = String(name || "").trim() || "Category";
    const list = (PRODUCT_MIX[ch] || []).slice();
    if (list.some(r => String(r[0]).toLowerCase() === label.toLowerCase())) return;
    const mix = mixPct != null && Number.isFinite(+mixPct) ? Math.max(0, +mixPct) : (list.length ? 0 : 1);
    const cogs = cogsPct != null && Number.isFinite(+cogsPct) ? capCogsPct(+cogsPct) : 0.3;
    list.push([label, mix, cogs, null, null, true]);
    PRODUCT_MIX[ch] = list;
    this.noteSettingsDirty();
    this.pushBatch([{ kind: "settings", label: "Add product category · " + label }], "UI");
  }

  addSessionSource(ch, name) {
    if (this.state.version !== "fc_v5" || !ch || !this.state.data) return;
    const label = String(name || "").trim();
    const list = SESSION_SOURCES[ch];
    if (!label || !list || !list.length) return;
    if (list.some(r => String(r.name).toLowerCase() === label.toLowerCase())) return;
    const n = this.state.data.months.length;
    const blank = () => new Array(n).fill(null);
    SESSION_SOURCES[ch] = list.concat([{ key: sourceKeyOf(ch, label), name: label, manual: true, ad: blank(), sess: blank(), cps: blank() }]);
    this._srcSeq = (this._srcSeq || 0) + 1;
    this.syncChannelTotalsFromSources(ch);
    this.noteSettingsDirty();
    this.pushBatch([{ kind: "settings", label: "Add marketing source · " + label }], "UI");
  }

  removeSessionSource(ch, si) {
    if (this.state.version !== "fc_v5" || !ch) return;
    const list = SESSION_SOURCES[ch] || [];
    const row = list[si];
    if (!row || !row.manual) return;
    SESSION_SOURCES[ch] = list.filter((_, k) => k !== si);
    this._srcSeq = (this._srcSeq || 0) + 1;
    this.setState(s => {
      const srcInput = Object.assign({}, s.srcInput);
      const cpsInput = Object.assign({}, s.cpsInput);
      delete srcInput[row.key];
      delete cpsInput[row.key];
      return { srcInput, cpsInput, srcRulePop: null };
    });
    this.syncChannelTotalsFromSources(ch);
    this.noteSettingsDirty();
    this.pushBatch([{ kind: "settings", label: "Remove marketing source · " + row.name }], "UI");
  }

  planDriverTaken(ch, name) {
    const D = this.state.data;
    const label = String(name || "").trim().toLowerCase();
    if (!label || !D || !D.channels[ch]) return false;
    const slug = driverKeySlug(label);
    if ((this.state.fdraft || {})[channelNs(ch) + "." + slug]) return true;
    return this.mergeDraftRows(buildRows(ch, D), ch)
      .some(r => r.k === slug || keyLeaf(r.key) === slug || String(r.name || "").trim().toLowerCase() === label);
  }

  addPlanDriver(ch, name, sec, unit) {
    const D = this.state.data;
    const label = String(name || "").trim();
    if (this.state.version !== "fc_v5" || !ch || ch === "all" || !D || !D.channels[ch] || !label) return;
    if (this.planDriverTaken(ch, label)) return;
    const shortKey = driverKeySlug(label);
    const key = channelNs(ch) + "." + shortKey;
    const u = UNIT_LABEL[unit] ? unit : "count";
    this._deletedDrivers.delete(key);
    this.setState(prev => {
      const n = prev.data.months.length;
      const fdraft = Object.assign({}, prev.fdraft, {
        [key]: {
          key,
          previousKey: null,
          name: label,
          src: "input",
          unit: u,
          dim: ["channel"],
          tmp: "activity",
          totalsMode: u === "currency" || u === "count" ? "add_up" : "no_totals",
          totalsFormula: "",
          formula: "",
          binding: "",
          isNew: true,
          shortKey,
          channel: ch,
          section: planSectionOf(sec),
          manual: true,
          values: new Array(n).fill(null)
        }
      });
      const inputs = Object.assign({}, prev.inputs, { [ch]: Object.assign({}, prev.inputs[ch], { [shortKey]: new Array(n).fill(null) }) });
      return { fdraft, inputs };
    });
    this.pushBatch([{ kind: "structure", ch, key, label: "new driver · " + label, before: "—", after: "manual" }], "UI");
  }

  removePlanDriver(ch, key) {
    const D = this.state.data;
    if (this.state.version !== "fc_v5" || !D || !ch || ch === "all") return;
    const d = (this.state.fdraft || {})[key];
    const def = catalogOf(ch, D).find(c => c.key === key);
    if (!def && !(d && d.isNew)) return;
    const shortKey = def ? def.id : this.draftShortKey(d);
    const driverKey = def ? def.key : key;
    const shared = Object.keys(D.channels).some(c => c !== ch && c !== "all" && this.mergeDraftRows(buildRows(c, D), c).some(r => r.k === shortKey));
    this._deletedDrivers.add((d && d.previousKey) || driverKey);
    const pending = this._pendingDelta && this._pendingDelta.inputs && this._pendingDelta.inputs[ch];
    if (pending) delete pending[shortKey];
    this.setState(prev => {
      const fdraft = Object.assign({}, prev.fdraft);
      delete fdraft[key];
      delete fdraft[driverKey];
      const inputs = Object.assign({}, prev.inputs);
      if (inputs[ch]) {
        inputs[ch] = Object.assign({}, inputs[ch]);
        delete inputs[ch][shortKey];
      }
      const rowDesc = Object.assign({}, prev.rowDesc);
      delete rowDesc[key];
      delete rowDesc[driverKey];
      const scenarioOn = Object.assign({}, prev.scenarioOn);
      delete scenarioOn[key];
      delete scenarioOn[driverKey];
      const next: any = { fdraft, inputs, rowDesc, scenarioOn, hoverRow: null };
      if (def) {
        prev.data.catalog[ch] = catalogOf(ch, prev.data).filter(c => c.key !== driverKey);
        this._tokenIdx = null;
        next.data = prev.data;
      }
      if (prev.editing === shortKey) Object.assign(next, { editing: null, authOpen: false });
      const rowCfg = Object.assign({}, prev.rowCfg);
      delete rowCfg[ch + "|" + shortKey];
      if (!shared) delete rowCfg[shortKey];
      const rowOrd = {};
      Object.keys(prev.rowOrd || {}).forEach(s => {
        rowOrd[s] = !shared || s.startsWith(ch + "|") ? prev.rowOrd[s].filter(k => k !== shortKey) : prev.rowOrd[s];
      });
      Object.assign(next, { rowCfg, rowOrd });
      return next;
    });
    this.noteLayoutDirty();
    const name = (def && def.name) || (d && d.name) || shortKey;
    const before = def ? def.src : (d.manual ? "manual" : d.src);
    this.pushBatch([{ kind: "structure", ch, key: driverKey, label: "remove driver · " + name, before, after: "—" }], "UI");
  }

  cloneItem(from, to, src, draft, rows) {
    const st = this.state, D = st.data;
    const label = D.channels[to].label || to;
    const item: any = { k: src.k, name: src.name, reason: "", replaces: [], missing: [], moved: "" };
    let key, home;
    if (draft && draft.isNew) {
      key = retargetDriverKey(src.key, from, to);
      const clash = rows.find(r => r.key !== key && (r.k === src.k || keyLeaf(r.key) === src.k));
      if (clash) {
        item.reason = label + " already has " + clash.name + " with the key " + src.k;
        return item;
      }
      home = planSectionOf(draft.section);
    } else {
      const def = catalogOf(to, D).find(c => c.id === src.k);
      if (!def) {
        item.reason = src.name + " is not part of " + label;
        return item;
      }
      key = def.key;
      home = def.section;
    }
    const allowed = planSectionsFor(channelBlocks(to, D));
    const fit = s => (allowed.indexOf(s) >= 0 ? s : channelBlocks(to, D)[0] || "kpi");
    let cfg = st.rowCfg[from + "|" + src.k] || st.rowCfg[src.k] || null;
    const ownSec = cfg && isPlanSection(cfg.sec);
    const shownIn = ownSec ? cfg.sec : home;
    if (fit(shownIn) !== shownIn) {
      item.moved = fit(shownIn);
      if (ownSec) cfg = Object.assign({}, cfg, { sec: item.moved });
    }
    home = fit(home);
    const toCombined = isCombined(D, to) && !isCombined(D, from);
    const cloned = draft ? Object.assign({}, draft, {
      key, previousKey: null, channel: to, shortKey: src.k, section: home,
      formula: retargetChannelRefs(draft.formula, from, to),
      totalsFormula: retargetChannelRefs(draft.totalsFormula, from, to)
    }, draft.rollup != null ? { rollup: retargetChannelRefs(draft.rollup, from, to) } : null,
      draft.overwrite != null ? { overwrite: retargetChannelRefs(draft.overwrite, from, to) } : null,
      draft.manual ? { values: [] } : null) : null;
    const next = cloned && toCombined ? this.combinedClone(cloned, src.k) : cloned;
    if (next) {
      const known = rows.filter(r => r.key !== key);
      item.missing = clonedDriverRefs(next).filter(t => t !== key && t !== src.k && !known.some(r => r.k === t || r.key === t || keyLeaf(r.key) === t || (r.previousKeys || []).indexOf(t) >= 0));
      if (st.fdraft[key] && this.driverSignature(st.fdraft[key]) !== this.driverSignature(next)) item.replaces.push("driver definition");
    }
    const ownCfg = st.rowCfg[to + "|" + src.k];
    if (ownCfg && JSON.stringify(ownCfg) !== JSON.stringify(cfg || {})) item.replaces.push("look on the plan");
    const desc = st.rowDesc[src.key];
    if (desc && st.rowDesc[key] && st.rowDesc[key] !== desc) item.replaces.push("description");
    return Object.assign(item, { key, draft: next, cfg: cfg || (ownCfg ? {} : null), desc, scen: st.scenarioOn[src.key] });
  }

  combinedClone(draft, k) {
    const out = Object.assign({}, draft, { binding: "" });
    delete out.overwrite;
    delete out.manual;
    delete out.values;
    if (out.src === "formula" && String(out.formula || "").trim()) return Object.assign(out, { rollup: "" });
    return Object.assign(out, { src: ROLLUP_SOURCE, formula: "", rollup: "SUM(" + k + ")" });
  }

  clonePlan(from, to, k) {
    const D = this.state.data;
    const label = D.channels[to].label || to;
    const plan: any = { id: to, label, reason: "", replaces: [], items: [] };
    if (isCombined(D, from) && !isCombined(D, to)) {
      plan.reason = label + " is not a combined channel";
      return plan;
    }
    const srcRows = this.mergeDraftRows(buildRows(from, D), from);
    const rows = this.mergeDraftRows(buildRows(to, D), to);
    const drafts = this.state.fdraft || {};
    const queue = [k], items = [];
    for (let i = 0; i < queue.length; i++) {
      const src = srcRows.find(r => r.k === queue[i]);
      const item = this.cloneItem(from, to, src, drafts[src.key] || null, rows);
      if (item.reason) {
        plan.reason = i ? "Also needs " + src.name + ": " + item.reason : item.reason;
        return plan;
      }
      for (const t of item.missing) {
        const back = retargetChannelRefs(t, to, from);
        const dep = srcRows.find(r => r.k === back || r.key === back || keyLeaf(r.key) === back || (r.previousKeys || []).indexOf(back) >= 0);
        if (!dep) {
          plan.reason = "Needs " + t + " on " + label + " first";
          return plan;
        }
        if (queue.indexOf(dep.k) < 0) queue.push(dep.k);
      }
      items.push(item);
    }
    plan.items = items;
    plan.replaces = items.reduce((acc, it, i) => acc.concat(i ? it.replaces.map(r => it.name + " " + r) : it.replaces), []);
    return plan;
  }

  cloneSource(ch, k) {
    const D = this.state.data;
    if (!D || !ch || ch === "all" || !D.channels[ch]) return null;
    return this.mergeDraftRows(buildRows(ch, D), ch).find(r => r.k === k) || null;
  }

  cloneTargets(ch, k) {
    if (!this.cloneSource(ch, k)) return [];
    const D = this.state.data;
    return Object.keys(D.channels)
      .filter(c => c !== ch && c !== "all" && D.channels[c])
      .map(c => {
        const p = this.clonePlan(ch, c, k);
        const also = p.items.slice(1).map(it => it.name);
        const notes = (also.length ? ["Also clones " + also.join(", ")] : [])
          .concat(p.items.filter(it => it.moved).map(it => it.name + " goes to " + (SECTION_LABEL[it.moved] || it.moved)));
        return { id: p.id, label: p.label, disabled: !!p.reason, reason: p.reason, replaces: p.replaces, note: notes.join(". ") };
      });
  }

  cloneRowToChannels(ch, k, ids) {
    const st = this.state, D = st.data;
    if (st.version !== "fc_v5" || !st.canAuthor) return [];
    const src = this.cloneSource(ch, k);
    if (!src) return [];
    const plans = Array.from(new Set(ids || []))
      .filter(c => c !== ch && c !== "all" && D.channels[c])
      .map(c => this.clonePlan(ch, c, k))
      .filter(p => !p.reason);
    if (!plans.length) return [];
    plans.forEach(p => p.items.forEach(it => { if (it.draft) this._deletedDrivers.delete(it.key); }));
    this.setState(prev => {
      const n = prev.data.months.length;
      const fdraft = Object.assign({}, prev.fdraft), rowCfg = Object.assign({}, prev.rowCfg);
      const rowDesc = Object.assign({}, prev.rowDesc), scenarioOn = Object.assign({}, prev.scenarioOn), inputs = Object.assign({}, prev.inputs);
      plans.forEach(p => p.items.forEach(it => {
        if (it.draft) {
          fdraft[it.key] = it.draft;
          if (it.draft.src === "input" && !Array.isArray((inputs[p.id] || {})[it.k])) inputs[p.id] = Object.assign({}, inputs[p.id], { [it.k]: new Array(n).fill(null) });
        }
        if (it.cfg) rowCfg[p.id + "|" + it.k] = Object.assign({}, it.cfg);
        if (it.desc) rowDesc[it.key] = it.desc;
        if (it.scen !== undefined) scenarioOn[it.key] = it.scen;
      }));
      return { fdraft, rowCfg, rowDesc, scenarioOn, inputs };
    });
    this.noteLayoutDirty();
    const from = D.channels[ch].label || ch;
    this.pushBatch(plans.reduce((acc, p) => acc.concat(p.items.map(it => ({ kind: "structure", ch: p.id, key: it.key, label: "clone · " + it.name + " from " + from, before: it.replaces.length ? it.replaces.join(", ") : "—", after: from }))), []), "UI");
    return plans.map(p => p.id);
  }

  deletedDriverKeys() {
    return Array.from(this._deletedDrivers);
  }

  cohortGuardsForSave() {
    const g = this.state.cohortGuards;
    if (!g) return null;
    const scopes = {};
    Object.keys(g.scopes || {}).forEach(key => {
      const s = g.scopes[key] || {};
      const next = Object.assign({}, s.off && s.off.length ? { off: s.off.slice() } : null, s.user && Object.keys(s.user).length ? { user: Object.assign({}, s.user) } : null, s.tuned ? { tuned: Object.assign({}, s.tuned) } : null);
      if (Object.keys(next).length) scopes[key] = next;
    });
    return Object.assign({ scopes }, g.constants && Object.keys(g.constants).length ? { constants: Object.assign({}, g.constants) } : null);
  }

  cohortGuardsForPublish() {
    const base = this.cohortGuardsForSave();
    const D = this.state.data;
    if (!base || !D || !D.channels) return base;
    const zero = this.zeroScen(D);
    Object.keys(D.channels).forEach(cid => {
      const conf = D.channels[cid];
      if (cid === "all" || !conf || conf.model !== "cohort") return;
      const meta = this.run(cid, zero).__meta || {};
      channelBlocks(cid, D).forEach(b => {
        const resolved = meta.guards ? meta.guards[b] : null;
        if (!resolved) return;
        const key = cohortGuardKey(cid, b);
        base.scopes[key] = Object.assign({}, base.scopes[key], { system: frozenGuardValues(resolved) });
      });
    });
    base.engine = COHORT_GUARD_ENGINE_VERSION;
    return base;
  }

  withManualValues(d) {
    if (!d || !d.manual) return d;
    const series = ((this.state.inputs || {})[d.channel] || {})[this.draftShortKey(d)];
    return Object.assign({}, d, { values: Array.isArray(series) ? series.slice() : (d.values || []) });
  }

  driversForApi() {
    const drafts = this.state.fdraft || {};
    return Object.keys(drafts).reduce((acc, k) => {
      if (drafts[k]) acc[k] = this.withManualValues(drafts[k]);
      return acc;
    }, {});
  }

  confirmDeletedDrivers(keys) {
    (keys || []).forEach(k => { if (!(this.state.fdraft || {})[k]) this._deletedDrivers.delete(k); });
  }

  removeProductCategory(ch, ci) {
    if (this.state.version !== "fc_v5" || !ch) return;
    const list = (PRODUCT_MIX[ch] || []).slice();
    if (ci < 0 || ci >= list.length) return;
    const removed = list[ci];
    list.splice(ci, 1);
    PRODUCT_MIX[ch] = list;
    const months = (this.state.data && this.state.data.months) || [];
    const prefix = mixInputKey(ch, removed[0]);
    const prune = map => {
      const out = {};
      Object.keys(map || {}).forEach(k => { if (k !== prefix && !k.startsWith(prefix + "|")) out[k] = map[k]; });
      return out;
    };
    this.setState(s => {
      const mov = {};
      Object.keys(s.mov || {}).forEach(k => {
        if (!k.startsWith(ch + "|p") && !k.startsWith(ch + "|c")) mov[k] = s.mov[k];
      });
      list.forEach((_, nci) => {
        months.forEach((__, t) => {
          ["mix", "cogs"].forEach(kind => {
            const prevKey = this.prodKey(kind, ch, nci < ci ? nci : nci + 1, t);
            if (s.mov[prevKey] !== undefined) mov[this.prodKey(kind, ch, nci, t)] = s.mov[prevKey];
          });
        });
      });
      return { mov, mixInput: prune(s.mixInput), cogsInput: prune(s.cogsInput), mixRulePop: null, mixRuleAt: null };
    });
    this.noteSettingsDirty();
    this.pushBatch([{ kind: "settings", label: "Remove product category · " + ((removed && removed[0]) || ci) }], "UI");
  }

  seedDefaultProductMix(ch) {
    if (this.state.version !== "fc_v5" || !ch) return;
    if ((PRODUCT_MIX[ch] || []).length) return;
    PRODUCT_MIX[ch] = [["Core", 0.6, 0.3, null], ["Other", 0.4, 0.35, null]];
    this.noteSettingsDirty();
    this.pushBatch([{ kind: "settings", label: "Seed default product mix · " + ch }], "UI");
  }

  editProductCogs(ch, ci, raw) {
    if (this.state.version !== "fc_v5" || !ch) return;
    const num = parseFloat(String(raw).replace(/[^0-9.\-]/g, ""));
    if (isNaN(num)) return;
    const list = PRODUCT_MIX[ch];
    if (!list || !list[ci]) return;
    const before = list[ci][2];
    const after = capCogsPct(num / 100);
    list[ci] = [list[ci][0], list[ci][1], after, list[ci][3] || null, list[ci][4] || null, !!list[ci][5]];
    PRODUCT_MIX[ch] = list.slice();
    this.noteSettingsDirty();
    this.pushBatch([{ kind: "settings", label: list[ci][0] + " COGS %", before: before, after: after }], "UI");
  }

  sessionRuleFor(sourceKey) {
    return resolveSessionRule(this.state.srcInput, sourceKey);
  }

  cpsRuleFor(sourceKey) {
    return resolveCpsRule(this.state.cpsInput, sourceKey);
  }

  sourceScale(ch, scen) {
    let scale = null;
    (SESSION_SOURCES[ch] || []).forEach(s => {
      const v = scen && scen[sourceLever(s.key)];
      if (typeof v === "number" && v !== 0) (scale = scale || {})[s.key] = 1 + v;
    });
    return scale;
  }

  resolvedSources(ch, scale = null) {
    const D = this.state.data;
    const list = SESSION_SOURCES[ch] || [];
    if (!D || !list.length) return [];
    const cut = this.cutIdx();
    const cache = this._srcCache;
    const stamp = [this._srcSeq || 0, cut, D.months.length].join("|");
    if (!cache || cache.stamp !== stamp || cache.srcInput !== this.state.srcInput || cache.cpsInput !== this.state.cpsInput) {
      this._srcCache = { stamp, srcInput: this.state.srcInput, cpsInput: this.state.cpsInput, byCh: {} };
    }
    const store = this._srcCache.byCh;
    const id = scale ? ch + "|" + Object.keys(scale).sort().map(k => k + "=" + scale[k]).join(",") : ch;
    if (!store[id]) {
      const sources = scale
        ? list.map(s => scale[s.key] ? Object.assign({}, s, { ad: s.ad.map((v, t) => t > cut && typeof v === "number" ? v * scale[s.key] : v) }) : s)
        : list;
      store[id] = forecastSources({
        months: D.months,
        cut,
        sources,
        sessionRuleFor: src => this.sessionRuleFor(src.key),
        cpsRuleFor: src => this.cpsRuleFor(src.key)
      });
    }
    return store[id];
  }

  sourceVal(ch, si, metric, t, scale = null) {
    const row = this.resolvedSources(ch, scale)[si];
    if (!row) return null;
    const series = metric === "ad" ? row.ad : metric === "cps" ? row.cps : row.sessions;
    const v = series && t < series.length ? series[t] : null;
    return v === undefined ? null : v;
  }

  sourceTyped(ch, si, metric, t) {
    const row = (SESSION_SOURCES[ch] || [])[si];
    if (!row) return null;
    const series = metric === "ad" ? row.ad : metric === "cps" ? row.cps : row.sess;
    const v = series && t < series.length ? series[t] : null;
    return v === undefined ? null : v;
  }

  syncChannelTotalsFromSources(ch) {
    const list = SESSION_SOURCES[ch] || [];
    if (!list.length || !this.state.inputs || !this.state.inputs[ch]) return;
    const n = this.state.data.months.length;
    const ad = new Array(n).fill(null);
    const sess = new Array(n).fill(null);
    const spp = new Array(n).fill(null);
    for (let t = 0; t < n; t++) {
      let aAcc = null, sAcc = null;
      list.forEach((_, si) => {
        const a = this.sourceVal(ch, si, "ad", t);
        const s = this.sourceVal(ch, si, "sess", t);
        if (typeof a === "number") aAcc = (aAcc === null ? 0 : aAcc) + a;
        if (typeof s === "number") sAcc = (sAcc === null ? 0 : sAcc) + s;
      });
      ad[t] = aAcc;
      sess[t] = sAcc;
      spp[t] = (aAcc && sAcc !== null) ? sAcc / aAcc : null;
    }
    this.setState(s => {
      const inputs = Object.assign({}, s.inputs);
      inputs[ch] = Object.assign({}, inputs[ch], { ad_spend: ad, spp: spp });
      return { inputs };
    });
  }

  editSource(ch, si, metric, t, raw) {
    if (this.state.version !== "fc_v5") return;
    const num = parseFloat(String(raw).replace(/[^0-9.\-]/g, ""));
    if (isNaN(num)) return;
    const list = SESSION_SOURCES[ch] || [];
    const row = list[si];
    if (!row) return;
    const series = sourceSeriesOf(row, metric, this.state.data.months.length);
    const before = series[t] === undefined ? null : series[t];
    const after = row.manual ? num : Math.max(0, num);
    series[t] = after;
    this._srcSeq = (this._srcSeq || 0) + 1;
    this.syncChannelTotalsFromSources(ch);
    this.pushBatch([{
      kind: "source",
      rkey: sourceDriverKey(row.key, metric) + "|" + t,
      ch: ch,
      srcKey: row.key,
      metric,
      t,
      label: row.name + " " + SOURCE_METRIC_LABEL[metric],
      period: this.state.data.months[t],
      before: before,
      after: after
    }], "UI");
  }

  setSourceRule(ch, si, rule, kind) {
    if (this.state.version !== "fc_v5") return;
    const row = (SESSION_SOURCES[ch] || [])[si];
    if (!row) return;
    const sessions = kind !== "cps";
    const field = sessions ? "srcInput" : "cpsInput";
    const next = rule ? normalizeSourceRule(rule, sessions ? SESSION_METHODS : CPS_METHODS) : null;
    if (rule && !next) return;
    const key = row.key;
    const prev = this.state[field][key] || null;
    if (sameCohortRule(prev, next)) return;
    const map = Object.assign({}, this.state[field]);
    if (next) map[key] = next; else delete map[key];
    const D = this.state.data;
    const scope = (D && D.channels[ch] ? D.channels[ch].label : ch) + " · " + row.name + (sessions ? " sessions" : " cost per session");
    const fallback = describeSourceRule(sessions ? DIRECT_RULE : DEFAULT_CPS_RULE);
    this.setState({ [field]: map });
    this.syncChannelTotalsFromSources(ch);
    this.pushRuleChange({
      kind: sessions ? "src_input" : "cps_input", ckey: key, label: "forecast method · " + scope,
      before: prev ? describeSourceRule(prev) : fallback, after: next ? describeSourceRule(next) : fallback,
      beforeRule: prev, afterRule: next
    });
  }

  sourceRuleFields(ch, si, kind, canEdit) {
    const row = (SESSION_SOURCES[ch] || [])[si];
    if (!row) return null;
    const sessions = kind !== "cps";
    const field = sessions ? "srcInput" : "cpsInput";
    const rule = sessions ? this.sessionRuleFor(row.key) : this.cpsRuleFor(row.key);
    const fallback = sessions ? DIRECT_RULE : DEFAULT_CPS_RULE;
    const own = !!this.state[field][row.key];
    const limits = sourceRuleLimits(rule);
    const apply = next => this.setSourceRule(ch, si, next, sessions ? "sess" : "cps");
    const popKey = row.key + "|" + (sessions ? "sess" : "cps");
    const open = this.state.srcRulePop === popKey;
    return {
      title: row.name + (sessions ? " · sessions method" : " · cost per session method"),
      method: rule.method,
      methodOpts: (sessions ? SESSION_METHODS : CPS_METHODS).map(m => ({ value: m, label: SOURCE_METHOD_LABEL[m] })),
      isFixed: rule.method === "fixed",
      nLabel: "months",
      nValue: limits ? String(rule.n) : "",
      nHint: limits ? limits[0] + "–" + limits[1] : "",
      canDec: !!limits && canEdit && rule.n > limits[0],
      canInc: !!limits && canEdit && rule.n < limits[1],
      onDec: () => { if (limits && rule.n > limits[0]) apply({ method: rule.method, n: rule.n - 1 }); },
      onInc: () => { if (limits && rule.n < limits[1]) apply({ method: rule.method, n: rule.n + 1 }); },
      pctValue: rule.method === "fixed" ? this.numFixed(rule.value * 100, 1) : "",
      summary: describeSourceRule(rule),
      inherited: !own,
      inheritedLabel: "Default · ",
      scopeLabel: "this source",
      disabled: !canEdit,
      onMethod: e => apply(defaultSourceRuleFor(e.target.value, rule)),
      onN: raw => {
        const v = parseInt(String(raw).replace(/[^0-9]/g, ""), 10);
        if (!isNaN(v) && limits) apply({ method: rule.method, n: Math.max(limits[0], Math.min(limits[1], v)) });
      },
      onPct: raw => {
        const v = parseFloat(String(raw).replace(/[^0-9.]/g, ""));
        if (!isNaN(v)) apply({ method: "fixed", value: Math.max(0, Math.min(100, v)) / 100 });
      },
      canReset: canEdit && own,
      resetLabel: "Reset to " + describeSourceRule(fallback),
      onReset: () => { apply(null); this.setState({ srcRulePop: null }); },
      onClose: () => this.setState({ srcRulePop: null }),
      tag: sourceRuleTag(rule),
      pillLabel: (sessions ? "sessions method for " : "cost per session method for ") + row.name,
      own,
      open,
      onToggle: () => this.setState({ srcRulePop: open ? null : popKey })
    };
  }

  sourceExplain(ch, si, metric, t) {
    const D = this.state.data;
    const r = this.resolvedSources(ch)[si];
    if (!D || !r) return null;
    const cut = this.cutIdx();
    const money = v => (typeof v === "number" && Number.isFinite(v)) ? Math.round(v).toLocaleString("en-GB") : "—";
    const rate = v => (typeof v === "number" && Number.isFinite(v)) ? this.numFixed(v, 2) : "—";
    const fmt = metric === "cps" ? rate : money;
    const series = metric === "ad" ? r.ad : metric === "cps" ? r.cps : r.sessions;
    const label = metric === "ad" ? "ad spend" : metric === "cps" ? "cost per session" : "sessions";
    const title = r.name + " · " + label + " · " + ml(D.months[t]);
    const result = fmt(series[t]);
    const actual = t <= cut;
    const cell = (m, i) => ({ key: sourceCellKey(si, m, i), tone: i <= cut ? "actual" : "forecast" });

    const manual = !!((SESSION_SOURCES[ch] || [])[si] || {}).manual;
    if (metric === "ad") {
      return {
        title, result, rows: [], steps: [],
        note: actual
          ? (manual ? MANUAL_ACTUAL_NOTE : "Bound actual ad spend for this month.")
          : "Planned spend. Type it for each forecast month or paste a row.",
        highlights: []
      };
    }

    if (actual && manual && metric === "sess") {
      return { title, result, rows: [], steps: [], note: MANUAL_ACTUAL_NOTE, highlights: [] };
    }

    if (actual) {
      if (metric === "cps") {
        return {
          title, result,
          rows: [
            { tone: "actual", label: "Ad spend", value: money(r.ad[t]) },
            { tone: "actual", label: "Sessions", value: money(r.sessions[t]) }
          ],
          steps: [money(r.ad[t]) + " ÷ " + money(r.sessions[t]) + " = " + result],
          note: "Actual cost per session. Blank when there was no spend.",
          highlights: [cell("ad", t), cell("sess", t)]
        };
      }
      return { title, result, rows: [], steps: [], note: "Bound actual sessions for this month.", highlights: [] };
    }

    const rule = metric === "cps" ? r.cpsRule : r.sessionRule;

    if (metric === "sess" && r.spendDriven) {
      return {
        title, result,
        rows: [
          { tone: "forecast", label: "Ad spend", value: money(r.ad[t]) },
          { tone: "forecast", label: "Cost per session", value: rate(r.cps[t]) }
        ],
        steps: [r.cpsMissing[t]
          ? CPS_MISSING_NOTE
          : money(r.ad[t]) + " ÷ " + rate(r.cps[t]) + " = " + result],
        note: "Spend driven · cost per session follows " + describeSourceRule(r.cpsRule) + ".",
        highlights: [cell("ad", t), cell("cps", t)]
      };
    }

    if (metric === "sess" && r.directSessions) {
      return { title, result, rows: [], steps: ["Typed value " + result], note: "Direct input · sessions are typed for each forecast month.", highlights: [] };
    }

    if (metric === "cps" && r.cpsTyped[t]) {
      return { title, result, rows: [], steps: ["Typed value " + result], note: "Typed values win. Clear the cell to go back to " + describeSourceRule(rule) + ".", highlights: [] };
    }

    if (rule.method === "direct") {
      return { title, result, rows: [], steps: [], note: "Direct input · type a cost per session for each forecast month.", highlights: [] };
    }

    if (rule.method === "fixed") {
      return { title, result, rows: [], steps: ["Fixed " + result], note: "Method · " + describeSourceRule(rule), highlights: [] };
    }

    const srcs = mixRuleSources(rule, t).filter(i => i >= 0).sort((a, b) => a - b);
    const has = srcs.filter(i => typeof series[i] === "number");
    const rows = srcs.map(i => ({ tone: i <= cut ? "actual" : "forecast", label: ml(D.months[i]), value: fmt(series[i]) }));
    let step = "";
    if (!has.length) step = "Not enough history · last value carried = " + result;
    else if (rule.method === "prev") step = ml(D.months[srcs[0]]) + " = " + result;
    else if (rule.method === "avg") step = "(" + has.map(i => fmt(series[i])).join(" + ") + ") ÷ " + has.length + " = " + result;
    else if (rule.method === "wavg") step = "Σ(" + label + " × weight) ÷ Σ weight over " + has.length + " months = " + result;
    else if (rule.method === "chain") step = fmt(series[t - 1]) + " × own curve = " + result;
    else step = fmt(series[t - 12]) + " × trend = " + result;

    return {
      title, result, rows, steps: [step],
      note: "Method · " + describeSourceRule(rule),
      highlights: srcs.map(i => cell(metric, i))
    };
  }

  sourceScreenRows(ch, cols, cut, canEdit) {
    const cats = SESSION_SOURCES[ch] || [];
    if (!cats.length) return [];
    const resolved = this.resolvedSources(ch);
    const grid = this.run(ch, this.zeroScen());
    const driverRows = grid.__rows || [];
    const sourcedIds = new Set(catalogOf(ch, this.state.data).filter(c => c.sourced).map(c => c.id));
    const sessDriver = driverRows.find(r => readsSource(r, "sessions")) || null;
    const adDriver = driverRows.find(r => readsSource(r, "ad_spend")) || null;
    const manualSessDriver = driverRows.find(r => readsSource(r, "sessions", MANUAL_FILTER)) || null;
    const manualAdDriver = driverRows.find(r => readsSource(r, "ad_spend", MANUAL_FILTER)) || null;
    const derivedDrivers = driverRows.filter(r => sourcedIds.has(r.k) && r.src !== "source" && r.opens !== "source");
    const totalKs = new Set([sessDriver, adDriver, manualSessDriver, manualAdDriver].concat(derivedDrivers).filter(Boolean).map(r => r.k));
    const tokens = rowTokenMap(driverRows);
    const tokenRow = t => { const k = tokens[t] || tokens[keyLocal(t)]; return k ? driverRows.find(r => r.k === k) || null : null; };
    const driverTotal = (r, idxs) => this.periodValue(grid, r.k, idxs);
    const out = [];
    const edge = c3 => c3.idxs[c3.idxs.length - 1] === cut ? "2px solid #08234C" : "1px solid transparent";
    const money = v => (v === null || v === undefined || isNaN(v)) ? "—" : Math.round(v).toLocaleString("en-GB");
    const count = money;
    const rate = v => (v === null || v === undefined || isNaN(v)) ? "—" : this.numFixed(v, 2);
    const sumIdxs = (series, idxs) => idxs.reduce((a, i) => (typeof series[i] === "number" ? (a === null ? 0 : a) + series[i] : a), null);
    const toneOf = c3 => (c3.idxs.every(i => i <= cut) ? "actual" : "forecast");
    const totalCellKey = (k, t) => "total:" + k + ":" + t;
    const unitFmt = r => (r && (r.unit === "£" || r.unit === "#")) ? money : rate;
    const pretty = s => s.replace(/\s*\*\s*/g, " × ").replace(/\s*\/\s*/g, " ÷ ");

    const sourceTotalExplain = (metric, label, c3, manualOnly = false) => {
      const tone = toneOf(c3), single = c3.idxs.length === 1;
      const parts = cats
        .map((c2, si) => ({ si, name: c2.name, manual: !!c2.manual, v: sumIdxs(metric === "ad" ? resolved[si].ad : resolved[si].sessions, c3.idxs) }))
        .filter(p => (!manualOnly || p.manual) && typeof p.v === "number" && p.v !== 0);
      const total = parts.reduce((a, p) => a + p.v, 0);
      return {
        title: label + " · " + c3.label,
        result: parts.length ? money(total) : "—",
        rows: parts.map(p => ({ tone, label: p.name, value: money(p.v) })),
        steps: parts.length ? [parts.map(p => money(p.v)).join(" + ") + " = " + money(total)] : [],
        note: "Sum of every " + (manualOnly ? "manual" : "marketing") + " source" + (single ? "" : " over " + c3.range) + ". Sources at zero are left out.",
        highlights: single ? parts.map(p => ({ key: sourceCellKey(p.si, metric, c3.idxs[0]), tone })) : []
      };
    };
    const sourceTotal = (metric, idxs, manualOnly = false) => resolved.reduce((acc, r, si) => {
      if (manualOnly && !cats[si].manual) return acc;
      const v = sumIdxs(metric === "ad" ? r.ad : r.sessions, idxs);
      return typeof v === "number" ? (acc === null ? 0 : acc) + v : acc;
    }, null);
    const manualTotalRow = (driver, metric, fmt) => {
      if (!driver) return;
      row({
        label: driver.name, key: driver.key, tag: "TOTAL", fmt, fw: 600, totalBg: true,
        totalKey: driver.k, explainOf: c3 => sourceTotalExplain(metric, driver.name, c3, true),
        cellOf: c3 => ({ v: sourceTotal(metric, c3.idxs, true) })
      });
    };

    const derivedTotalExplain = (r, c3) => {
      const tone = toneOf(c3), single = c3.idxs.length === 1;
      const formula = String(r.formula || "").trim();
      const used = [];
      formula.replace(/[A-Za-z_][A-Za-z0-9_.]*/g, t => {
        const x = FN.indexOf(t) < 0 ? tokenRow(t) : null;
        if (x && x.k !== r.k && used.indexOf(x) < 0) used.push(x);
        return t;
      });
      const swap = f => pretty(formula.replace(/[A-Za-z_][A-Za-z0-9_.]*/g, t => {
        const x = FN.indexOf(t) < 0 ? tokenRow(t) : null;
        return x ? f(x) : t;
      }));
      const result = rate(driverTotal(r, c3.idxs));
      const steps = [r.name + " = " + swap(x => x.name)];
      const mode = totalsModeOf(r);
      if (single) steps.push("= " + swap(x => unitFmt(x)(driverTotal(x, c3.idxs))) + " = " + result);
      else if (mode === "formula") steps.push(c3.label + " = " + pretty(String(r.totalsFormula || "")) + " on the period totals = " + result);
      else if (mode === "add_up") steps.push(c3.label + " = sum of the months = " + result);
      else steps.push(c3.label + " = no quarter or year total");
      return {
        title: r.name + " · " + c3.label,
        result,
        rows: used.map(x => ({ tone, label: x.name, sub: x.key, value: unitFmt(x)(driverTotal(x, c3.idxs)) })),
        steps,
        note: single ? "Uses the totals above. Change the formula in Settings." : c3.range + ". Change the formula or the quarter and year total in Settings.",
        highlights: single ? used.filter(x => totalKs.has(x.k)).map(x => ({ key: totalCellKey(x.k, c3.idxs[0]), tone })) : []
      };
    };

    const band = label => out.push({
      label, key: "", rule: null, indent: "20px",
      nameBg: "#E4EBF7", labelFg: "#08234C", fw: 600, size: "10.5px", ls: "0.1em", tt: "uppercase",
      tag: "", hasTag: false, tagFg: "#4D6389", tagBg: "transparent",
      cells: cols.map(c3 => ({ isInput: false, isText: true, text: "", onChange: null, bg: "#E4EBF7", fg: "#4D6389", fw: 400, edge: edge(c3), title: "" }))
    });

    const TAG_FG = { INPUT: "#0052CD", CALC: "#4D6389", TOTAL: "#8094B5", MANUAL: "#B26A00" };
    const TAG_BG = { INPUT: "#EAF1FD", CALC: "#EDF1F8", TOTAL: "#F5F8FA", MANUAL: "#FFF4E5" };

    const row = (opts) => out.push({
      label: opts.label, key: opts.key || "", title: opts.title || "",
      onDelete: opts.onDelete || null,
      rule: opts.rule || null, indent: opts.indent || "20px",
      nameBg: "#FFFFFF", labelFg: "var(--ink)", fw: opts.fw || 400, size: "12.5px", ls: "0", tt: "none",
      tag: opts.tag, hasTag: true, tagFg: TAG_FG[opts.tag] || "#8094B5", tagBg: TAG_BG[opts.tag] || "#F5F8FA",
      cells: cols.map(c3 => {
        const single = c3.idxs.length === 1, actual = c3.idxs.every(i => i <= cut);
        const c = opts.cellOf(c3, single, actual);
        const has = c.v !== null && c.v !== undefined && !isNaN(c.v);
        const traced = opts.metric && single;
        return {
          isInput: !!c.editable, isText: !c.editable,
          text: has ? opts.fmt(c.v) : (c.editable ? "" : "—"),
          onCommit: c.commit || null, onChange: c.commit || null, onPaste: c.paste || null,
          cellKey: traced ? sourceCellKey(opts.si, opts.metric, c3.idxs[0]) : (opts.totalKey && single ? totalCellKey(opts.totalKey, c3.idxs[0]) : ""),
          explain: traced ? (() => this.sourceExplain(ch, opts.si, opts.metric, c3.idxs[0])) : (opts.explainOf ? (() => opts.explainOf(c3)) : null),
          bg: c.editable ? "#FFFDEB" : c.warn ? "#FFF4E5" : opts.totalBg ? "#F5F8FA" : actual ? "#EDF1F8" : "#FBFCFE",
          fg: c.err ? "#E5484D" : c.editable ? "#0052CD" : "#4D6389",
          fw: opts.fw || (c.typed ? 600 : 400),
          title: c.title || "",
          edge: edge(c3)
        };
      })
    });

    const pasteOf = (si, metric, t) => e => {
      const txt = e.clipboardData && e.clipboardData.getData("text");
      if (txt && this.pasteSource(ch, si, metric, t, txt)) e.preventDefault();
    };

    const deleteOf = (c2, si) => c2.manual && canEdit ? () => this.removeSessionSource(ch, si) : null;

    band("1 · Sessions #");
    cats.forEach((c2, si) => {
      const r = resolved[si];
      row({
        label: c2.name, key: sourceDriverKey(c2.key, "sess"), fmt: count, metric: "sess", si,
        tag: c2.manual ? "MANUAL" : r.directSessions ? "INPUT" : "CALC",
        title: c2.manual ? MANUAL_SOURCE_NOTE : "",
        onDelete: deleteOf(c2, si),
        rule: this.sourceRuleFields(ch, si, "sess", canEdit),
        cellOf: (c3, single, actual) => {
          const t = c3.idxs[0];
          const editable = canEdit && single && (actual ? !!c2.manual : r.directSessions);
          return {
            v: single ? r.sessions[t] : sumIdxs(r.sessions, c3.idxs),
            editable,
            err: single && r.cpsMissing[t],
            title: single && r.cpsMissing[t] ? CPS_MISSING_NOTE : "",
            commit: editable ? (raw => this.editSource(ch, si, "sess", t, raw)) : null,
            paste: editable ? pasteOf(si, "sess", t) : null
          };
        }
      });
    });
    row({
      label: "Sessions total", key: sessDriver ? sessDriver.key : "", tag: "TOTAL", fmt: count, fw: 600, totalBg: true,
      totalKey: sessDriver ? sessDriver.k : "", explainOf: c3 => sourceTotalExplain("sess", "Sessions total", c3),
      cellOf: c3 => ({ v: sourceTotal("sess", c3.idxs) })
    });
    manualTotalRow(manualSessDriver, "sess", count);

    band("2 · Ad spend £");
    cats.forEach((c2, si) => {
      const r = resolved[si];
      row({
        label: c2.name, key: sourceDriverKey(c2.key, "ad"), tag: c2.manual ? "MANUAL" : "INPUT", fmt: money, metric: "ad", si,
        title: c2.manual ? MANUAL_SOURCE_NOTE : "",
        onDelete: deleteOf(c2, si),
        cellOf: (c3, single, actual) => {
          const t = c3.idxs[0];
          const editable = canEdit && single && (!actual || !!c2.manual);
          return {
            v: single ? r.ad[t] : sumIdxs(r.ad, c3.idxs),
            editable,
            warn: single && r.peak[t],
            title: single && r.peak[t] ? PEAK_NOTE : "",
            commit: editable ? (raw => this.editSource(ch, si, "ad", t, raw)) : null,
            paste: editable ? pasteOf(si, "ad", t) : null
          };
        }
      });
      if (!r.spendDriven) return;
      row({
        label: "Cost per session", key: sourceDriverKey(c2.key, "cps"), indent: "36px", fmt: rate,
        tag: "INPUT", metric: "cps", si,
        rule: this.sourceRuleFields(ch, si, "cps", canEdit),
        cellOf: (c3, single, actual) => {
          if (actual) {
            const ad = sumIdxs(r.ad, c3.idxs), sess = sumIdxs(r.sessions, c3.idxs);
            return { v: ad && sess ? ad / sess : null };
          }
          const t = c3.idxs[0];
          const editable = canEdit && single;
          return {
            v: single ? r.cps[t] : (() => { const ad = sumIdxs(r.ad, c3.idxs), sess = sumIdxs(r.sessions, c3.idxs); return ad && sess ? ad / sess : null; })(),
            editable,
            typed: single && r.cpsTyped[t],
            err: single && r.cpsMissing[t],
            title: single && r.cpsMissing[t] ? CPS_MISSING_NOTE : "",
            commit: editable ? (raw => this.editSource(ch, si, "cps", t, raw)) : null,
            paste: editable ? pasteOf(si, "cps", t) : null
          };
        }
      });
    });
    row({
      label: "Ad spend total", key: adDriver ? adDriver.key : "", tag: "TOTAL", fmt: money, fw: 600, totalBg: true,
      totalKey: adDriver ? adDriver.k : "", explainOf: c3 => sourceTotalExplain("ad", "Ad spend total", c3),
      cellOf: c3 => ({ v: sourceTotal("ad", c3.idxs) })
    });
    manualTotalRow(manualAdDriver, "ad", money);
    derivedDrivers.forEach(r => row({
      label: r.name + " total", key: r.key, tag: "TOTAL", fmt: rate, fw: 600, totalBg: true,
      totalKey: r.k, explainOf: c3 => derivedTotalExplain(r, c3),
      cellOf: c3 => ({ v: driverTotal(r, c3.idxs) })
    }));

    return out;
  }

  summedScreenKit(members, cols, cut) {
    const D = this.state.data;
    const num = v => typeof v === "number" && Number.isFinite(v);
    const sumOf = (series, idxs) => idxs.reduce((a, i) => (series && num(series[i]) ? (a === null ? 0 : a) + series[i] : a), null);
    const addUp = vals => vals.reduce((a, v) => (num(v) ? (a === null ? 0 : a) + v : a), null);
    const money = v => num(v) ? Math.round(v).toLocaleString("en-GB") : "—";
    const pct = v => num(v) ? this.numFixed(v * 100, 1) + "%" : "—";
    const toneOf = c3 => (c3.idxs.every(i => i <= cut) ? "actual" : "forecast");
    const edge = c3 => c3.idxs[c3.idxs.length - 1] === cut ? "2px solid #08234C" : "1px solid transparent";
    const note = "Read only · summed from " + members.map(m => D.channels[m].label).join(" + ") + ". Edit on each channel.";
    const sumExplain = (title, parts, c3, fmt) => {
      const used = parts.filter(p => num(p.v));
      const total = addUp(used.map(p => p.v));
      return {
        title: title + " · " + c3.label, result: fmt(total), note, highlights: [],
        rows: used.map(p => ({ tone: toneOf(c3), label: p.label, value: fmt(p.v) })),
        steps: used.length ? [used.map(p => fmt(p.v)).join(" + ") + " = " + fmt(total)] : []
      };
    };
    const ratioExplain = (title, parts, c3, fmtNum, fmtDen, fmtRate, numLabel, denLabel) => {
      const used = parts.filter(p => num(p.num) || num(p.den));
      const n0 = addUp(used.map(p => p.num)), d0 = addUp(used.map(p => p.den));
      const rate = n0 !== null && d0 ? n0 / d0 : null;
      return {
        title: title + " · " + c3.label, result: fmtRate(rate), note, highlights: [],
        rows: used.map(p => ({ tone: toneOf(c3), label: p.label, sub: fmtNum(p.num) + " " + numLabel + " ÷ " + fmtDen(p.den) + " " + denLabel, value: num(p.num) && p.den ? fmtRate(p.num / p.den) : "—" })),
        steps: used.length ? ["(" + used.map(p => fmtNum(p.num)).join(" + ") + ") ÷ (" + used.map(p => fmtDen(p.den)).join(" + ") + ") = " + fmtRate(rate)] : []
      };
    };
    const cellsOf = (cellOf, fmt, totalBg) => cols.map(c3 => {
      const actual = c3.idxs.every(i => i <= cut);
      const c = cellOf(c3);
      return {
        isInput: false, isText: true, text: num(c.v) ? fmt(c.v) : "—",
        onCommit: null, onChange: null, onPaste: null, cellKey: "",
        explain: c.explain ? (() => c.explain(c3)) : null,
        bg: c.bad ? "#FDECEC" : totalBg ? "#F5F8FA" : actual ? "#EDF1F8" : "#FBFCFE",
        fg: c.bad ? "#E5484D" : "#4D6389", fw: totalBg ? 600 : 400, title: "", edge: edge(c3)
      };
    });
    return { num, sumOf, addUp, money, pct, edge, note, sumExplain, ratioExplain, cellsOf };
  }

  combinedSourceRows(ch, members, cols, cut) {
    const D = this.state.data;
    if (!D || !members.length) return [];
    const kit = this.summedScreenKit(members, cols, cut);
    const { sumOf, addUp, money, sumExplain, ratioExplain, cellsOf } = kit;
    const rate = v => kit.num(v) ? this.numFixed(v, 2) : "—";
    const zero = this.zeroScen();
    const combinedGrid = this.run(ch, zero);
    const memberParts = members.map(m => {
      const resolved = this.resolvedSources(m);
      return { m, label: D.channels[m].label, sources: (SESSION_SOURCES[m] || []).map((c2, si) => ({ name: String(c2.name), manual: !!c2.manual, r: resolved[si] })).filter(s => s.r) };
    });
    const memberGrids = members.map(m => ({ label: D.channels[m].label, grid: this.run(m, zero) }));
    const combinedRows = combinedGrid.__rows || [];
    const names = [];
    memberParts.forEach(p => p.sources.forEach(s => { if (!names.some(x => x.toLowerCase() === s.name.toLowerCase())) names.push(s.name); }));
    const partsFor = name => memberParts.map(p => ({ label: p.label, src: p.sources.find(s => s.name.toLowerCase() === name.toLowerCase()) })).filter(p => p.src);
    const metricOf = (src, metric) => metric === "ad" ? src.r.ad : src.r.sessions;
    const memberTotal = (p, metric, idxs, manualOnly = false) => addUp(p.sources.filter(s => !manualOnly || s.manual).map(s => sumOf(metricOf(s, metric), idxs)));
    const out = [];
    const band = label => out.push({
      label, key: "", rule: null, indent: "20px", title: "", onDelete: null,
      nameBg: "#E4EBF7", labelFg: "#08234C", fw: 600, size: "10.5px", ls: "0.1em", tt: "uppercase",
      tag: "", hasTag: false, tagFg: "#4D6389", tagBg: "transparent",
      cells: cols.map(c3 => ({ isInput: false, isText: true, text: "", onChange: null, bg: "#E4EBF7", fg: "#4D6389", fw: 400, edge: kit.edge(c3), title: "" }))
    });
    const row = (label, tag, cellOf, fmt, opts) => out.push({
      label, key: (opts && opts.key) || "", rule: null, indent: (opts && opts.indent) || "20px", title: kit.note, onDelete: null,
      nameBg: "#FFFFFF", labelFg: "var(--ink)", fw: opts && opts.total ? 600 : 400, size: "12.5px", ls: "0", tt: "none",
      tag, hasTag: true, tagFg: "#8094B5", tagBg: "#F5F8FA",
      cells: cellsOf(cellOf, fmt, !!(opts && opts.total))
    });
    const summed = (label, list) => c3 => {
      const parts = list.map(p => ({ label: p.label, v: p.v(c3.idxs) }));
      return { v: addUp(parts.map(p => p.v)), explain: () => sumExplain(label, parts, c3, money) };
    };
    const sourceParts = (name, metric) => partsFor(name).map(p => ({ label: p.label, v: idxs => sumOf(metricOf(p.src, metric), idxs) }));
    const totalParts = (metric, manualOnly = false) => memberParts.map(p => ({ label: p.label, v: idxs => memberTotal(p, metric, idxs, manualOnly) }));
    const manualTotalRow = (field, metric) => {
      const driver = memberGrids.map(g => (g.grid.__rows || []).find(r => readsSource(r, field, MANUAL_FILTER))).find(Boolean);
      if (!driver) return;
      const own = combinedRows.find(x => x.k === driver.k);
      row(driver.name, "TOTAL", summed(driver.name, totalParts(metric, true)), money, { total: true, key: own ? own.key : "" });
    };

    band("1 · Sessions #");
    names.forEach(name => row(name, "ROLLUP", summed(name + " · sessions", sourceParts(name, "sess")), money));
    row("Sessions total", "TOTAL", summed("Sessions total", totalParts("sess")), money, { total: true });
    manualTotalRow("sessions", "sess");

    band("2 · Ad spend £");
    names.forEach(name => {
      row(name, "ROLLUP", summed(name + " · ad spend", sourceParts(name, "ad")), money);
      const parts = partsFor(name);
      if (!parts.some(p => p.src.r.spendDriven)) return;
      row("Cost per session", "ROLLUP", c3 => {
        const ratio = parts.map(p => ({ label: p.label, num: sumOf(p.src.r.ad, c3.idxs), den: sumOf(p.src.r.sessions, c3.idxs) }));
        const ad = addUp(ratio.map(p => p.num)), sess = addUp(ratio.map(p => p.den));
        return { v: ad !== null && sess ? ad / sess : null, explain: () => ratioExplain(name + " · cost per session", ratio, c3, money, money, rate, "ad spend", "sessions") };
      }, rate, { indent: "36px" });
    });
    row("Ad spend total", "TOTAL", summed("Ad spend total", totalParts("ad")), money, { total: true });
    manualTotalRow("ad_spend", "ad");

    const sourcedIds = new Set(catalogOf(members[0], D).filter(c => c.sourced).map(c => c.id));
    (memberGrids[0].grid.__rows || []).filter(r => sourcedIds.has(r.k) && r.src !== "source" && r.opens !== "source").forEach(r => {
      const own = combinedRows.find(x => x.k === r.k);
      if (!own) return;
      const fmt = own.unit === "£" || own.unit === "#" ? money : rate;
      row(own.name + " total", "TOTAL", c3 => {
        const v = this.periodValue(combinedGrid, own.k, c3.idxs);
        return {
          v,
          explain: () => ({
            title: own.name + " · " + c3.label, result: fmt(v), steps: [], highlights: [],
            rows: memberGrids.map(g => ({ tone: c3.idxs.every(i => i <= cut) ? "actual" : "forecast", label: g.label, value: fmt(this.periodValue(g.grid, own.k, c3.idxs)) })),
            note: "Read only · rolled up with this channel's rule for " + own.name + ". Edit on each channel."
          })
        };
      }, fmt, { total: true, key: own.key });
    });
    return out;
  }

  combinedMixRows(ch, members, gridOf, cols, cut) {
    const D = this.state.data;
    if (!D || !members.length) return [];
    const kit = this.summedScreenKit(members, cols, cut);
    const { num, sumOf, addUp, money, pct, sumExplain, ratioExplain, cellsOf } = kit;
    const pctCell = v => num(v) ? this.numFixed(v * 100, 1) : "—";
    const parts = members.map(m => {
      const g = gridOf(m) || {}, cats = PRODUCT_MIX[m] || [], meta = g.__meta || {};
      const blocks = channelBlocks(m, D);
      const gross = g.tot_sales || g[blocks[0] + "_sales"] || [];
      const mixAt = (ci, t) => meta.mix && meta.mix.values[ci] ? meta.mix.values[ci][t] : this.mixPct(m, ci, t, cats[ci][1]);
      const cogsAt = (ci, t) => meta.cogs && meta.cogs.values[ci] ? meta.cogs.values[ci][t] : this.cogsPct(m, ci, t, cats[ci][2]);
      const catOf = name => cats.findIndex(c => String(c[0]).toLowerCase() === name.toLowerCase());
      const over = (idxs, f) => addUp(idxs.map(f));
      return {
        label: D.channels[m].label,
        names: cats.map(c => String(c[0])),
        gross: idxs => sumOf(gross, idxs),
        sales: (name, idxs) => { const ci = catOf(name); return ci < 0 ? null : over(idxs, t => num(gross[t]) && num(mixAt(ci, t)) ? gross[t] * mixAt(ci, t) : null); },
        cogs: (name, idxs) => { const ci = catOf(name); return ci < 0 ? null : over(idxs, t => num(gross[t]) && num(mixAt(ci, t)) && num(cogsAt(ci, t)) ? gross[t] * mixAt(ci, t) * cogsAt(ci, t) : null); },
        cogsTotal: idxs => sumOf(g.cogs, idxs)
      };
    });
    const names = [];
    parts.forEach(p => p.names.forEach(nm => { if (!names.some(x => x.toLowerCase() === nm.toLowerCase())) names.push(nm); }));
    const out = [];
    const band = label => out.push({
      label, nameBg: "#E4EBF7", labelFg: "#08234C", fw: 600, size: "10.5px", ls: "0.1em", tt: "uppercase",
      tag: "", hasTag: false, tagFg: "#4D6389", tagBg: "transparent", rule: null, onDelete: null,
      cells: cols.map(c3 => ({ isInput: false, isText: true, text: "", onChange: null, bg: "#E4EBF7", fg: "#4D6389", fw: 400, edge: kit.edge(c3) }))
    });
    const row = (label, tag, cellOf, fmt, total) => out.push({
      label, nameBg: "#FFFFFF", labelFg: "var(--ink)", fw: total ? 600 : 400, size: "12.5px", ls: "0", tt: "none",
      tag, hasTag: true, tagFg: "#8094B5", tagBg: "#F5F8FA", tagTitle: kit.note,
      title: kit.note, onDelete: null, rule: null,
      cells: cellsOf(cellOf, fmt, total)
    });
    const grossTotal = idxs => addUp(parts.map(p => p.gross(idxs)));
    const mixOf = (name, idxs) => { const s = addUp(parts.map(p => p.sales(name, idxs))), g = grossTotal(idxs); return s !== null && g ? s / g : null; };
    const cogsTotal = idxs => addUp(names.map(nm => addUp(parts.map(p => p.cogs(nm, idxs)))));

    band("1 · % mix");
    names.forEach(name => row(name, "rollup", c3 => ({
      v: mixOf(name, c3.idxs),
      explain: () => ratioExplain(name + " mix", parts.map(p => ({ label: p.label, num: p.sales(name, c3.idxs), den: p.gross(c3.idxs) })), c3, money, money, pct, "sales", "gross")
    }), pctCell));
    row("Mix total", "check", c3 => {
      const tot = addUp(names.map(nm => mixOf(nm, c3.idxs)));
      return { v: tot, bad: tot !== null && Math.abs(tot - 1) > 0.0005 };
    }, pctCell, true);

    band("2 · Gross sales excl discounts and tax");
    names.forEach(name => row(name, "rollup", c3 => {
      const list = parts.map(p => ({ label: p.label, v: p.sales(name, c3.idxs) }));
      return { v: addUp(list.map(p => p.v)), explain: () => sumExplain(name + " gross sales", list, c3, money) };
    }, money));
    row("Gross sales", "total", c3 => {
      const list = parts.map(p => ({ label: p.label, v: p.gross(c3.idxs) }));
      return { v: grossTotal(c3.idxs), explain: () => sumExplain("Gross sales", list, c3, money) };
    }, money, true);

    band("3 · Product COGS %");
    names.forEach(name => row(name, "rollup", c3 => {
      const list = parts.map(p => ({ label: p.label, num: p.cogs(name, c3.idxs), den: p.sales(name, c3.idxs) }));
      const c0 = addUp(list.map(p => p.num)), s0 = addUp(list.map(p => p.den));
      return { v: c0 !== null && s0 ? c0 / s0 : null, explain: () => ratioExplain(name + " COGS %", list, c3, money, money, pct, "COGS", "sales") };
    }, pctCell));
    row("Blended product COGS %", "total", c3 => {
      const list = parts.map(p => ({ label: p.label, num: addUp(names.map(nm => p.cogs(nm, c3.idxs))), den: p.gross(c3.idxs) }));
      const c0 = cogsTotal(c3.idxs), g0 = grossTotal(c3.idxs);
      return { v: c0 !== null && g0 ? c0 / g0 : null, explain: () => ratioExplain("Blended product COGS %", list, c3, money, money, pct, "COGS", "gross") };
    }, pctCell, true);

    band("4 · Product COGS £");
    names.forEach(name => row(name, "rollup", c3 => {
      const list = parts.map(p => ({ label: p.label, v: p.cogs(name, c3.idxs) }));
      return { v: addUp(list.map(p => p.v)), explain: () => sumExplain(name + " product COGS", list, c3, money) };
    }, money));
    row("Product COGS", "total", c3 => {
      const list = parts.map(p => ({ label: p.label, v: p.cogsTotal(c3.idxs) }));
      return { v: addUp(list.map(p => p.v)), explain: () => sumExplain("Product COGS", list, c3, money) };
    }, money, true);
    return out;
  }

  pasteSource(ch, si, metric, i, text) {
    const D = this.state.data, n = D.months.length, cut = this.cutIdx();
    const parts = String(text).split(/[\t\n\r]+/).map(x => x.trim()).filter(x => x !== "");
    if (parts.length < 2) return false;
    const list = SESSION_SOURCES[ch] || [];
    const row = list[si];
    if (!row) return false;
    const series = sourceSeriesOf(row, metric, n);
    const items = [];
    let past = 0, skipped = 0, lockedM = 0, count = 0;
    parts.forEach((p, k) => {
      const t = i + k;
      if (t >= n) { past++; return; }
      if (t <= cut && !row.manual) { lockedM++; return; }
      const num = parseFloat(p.replace(/[^0-9.\-]/g, ""));
      if (isNaN(num)) { skipped++; return; }
      const before = series[t] === undefined ? null : series[t];
      const after = row.manual ? num : Math.max(0, num);
      series[t] = after;
      count++;
      items.push({
        kind: "source",
        rkey: sourceDriverKey(row.key, metric) + "|" + t,
        ch: ch,
        label: row.name + " " + SOURCE_METRIC_LABEL[metric],
        period: D.months[t],
        before: before,
        after: after
      });
    });
    this._srcSeq = (this._srcSeq || 0) + 1;
    this.syncChannelTotalsFromSources(ch);
    this.setState({
      pasteNote: [
        count ? "Pasted " + count + (count === 1 ? " month" : " months") + " into " + row.name : "Nothing pasted",
        lockedM ? lockedM + " landed on actual months and were ignored" : "",
        skipped ? skipped + " non-numeric " + (skipped === 1 ? "value" : "values") + " skipped" : "",
        past ? past + " past the last column, ignored" : ""
      ].filter(Boolean).join(" · "),
      pasteAt: Date.now(), pasteBad: !count || !!(skipped || lockedM || past)
    });
    if (items.length) {
      this.pushBatch(items, "UI");
    }
    return true;
  }

  rovKey(ch, blk, j, t) { return ch + "|" + blk + "|" + j + "|" + t; }
  rate(ch, blk, j, t, fileRatio, rov) {
    const map = rov || this.state.rov;
    const o = map[this.rovKey(ch, blk, j, t)];
    if (o !== undefined) return o;
    if (fileRatio === null || fileRatio === undefined) return null;
    return fileRatio;
  }
  editRate(ch, blk, j, t, raw) {
    if (this.state.version !== "fc_v5") return;
    const D = this.state.data;
    const co = D && D.channels && D.channels[ch] && D.channels[ch][blk] && Array.isArray(D.channels[ch][blk].cohorts)
      ? D.channels[ch][blk].cohorts[j]
      : null;
    if (co && co.label != null && Array.isArray(D.months)) {
      const label = String(co.label).trim();
      let birthYm = NaN;
      if (/^\d{6}$/.test(label)) birthYm = +label;
      else {
        const m = /^(\d{4})[-/]?(\d{1,2})$/.exec(label);
        if (m) birthYm = (+m[1]) * 100 + (+m[2]);
      }
      const birthIdx = D.months.indexOf(birthYm);
      if (birthIdx === t) return;
    }
    const key = this.rovKey(ch, blk, j, t);
    const before = this.state.rov[key] === undefined ? null : this.state.rov[key];
    const text = raw === null || raw === undefined ? "" : String(raw).trim();
    const num = parseFloat(text.replace(/[^0-9.\-]/g, ""));
    if (isNaN(num) && (text !== "" || before === null)) return;
    const val = isNaN(num) ? null : Math.max(0, num / 100);
    if (val === before) return;
    const info = this.actorStamp();
    this.setState(s => {
      const rov = Object.assign({}, s.rov);
      const overrideInfo = Object.assign({}, s.overrideInfo);
      if (val === null) { delete rov[key]; delete overrideInfo[key]; } else { rov[key] = val; overrideInfo[key] = info; }
      return { rov, overrideInfo };
    });
    this.pushBatch([{ kind: "rate", rkey: key, ch: ch, blk: blk, j: j, t: t, label: (BL[blk] || blk) + " repurchase %", period: this.state.data.months[t], before: before, after: val }], "UI");
  }
  setCohortInput(ch, blk, label, rule) {
    if (this.state.version !== "fc_v5") return;
    const current = this.isCurrentDraft();
    const normalized = rule ? normalizeCohortRule(rule) : null;
    if (rule && !normalized) return;
    if (current && normalized && !isPickerMethod(normalized.method) && normalized.method !== "seasonal") return;
    const wanted = current && normalized ? migrateCohortRule(normalized) : normalized;
    const key = cohortInputKey(ch, blk, label);
    const prev = this.state.cohortInput[key] || null;
    const first = this.pendingRuleItem("cohort_input", key);
    const autoRule = first ? (!first.beforeRule && first.autoRule) || null : !prev && !label && current ? this.autoRuleOf(ch, blk) : null;
    const next = first && autoRule && wanted && sameCohortRule(wanted, autoRule) ? null : wanted;
    if (sameCohortRule(prev, next)) return;
    const map = Object.assign({}, this.state.cohortInput);
    if (next) map[key] = next; else delete map[key];
    const D = this.state.data;
    const scope = (D && D.channels[ch] ? D.channels[ch].label : ch) + " " + (BL[blk] || blk) + (label ? " · " + ml(+label) : "");
    const fallback = label ? "Follows the tab" : current ? "Auto" : describeCohortRule(DEFAULT_COHORT_RULE);
    const split = !label && current && usesSeasonRatio(this.state.cohortGuards && this.state.cohortGuards.engine);
    const describe = split ? describeSplitRule : describeCohortRule;
    const overrideInfo = Object.assign({}, this.state.overrideInfo);
    if (label && next) overrideInfo[key] = this.actorStamp(); else if (label) delete overrideInfo[key];
    this.setState({ cohortInput: map, overrideInfo });
    this.pushRuleChange(Object.assign({
      kind: "cohort_input", ckey: key, label: "forecast method · " + scope,
      before: prev ? describe(prev) : fallback, after: next ? describe(next) : fallback,
      beforeRule: prev, afterRule: next
    }, autoRule ? { autoRule } : null));
  }
  autoRuleOf(ch, blk) {
    const meta = this.run(ch, this.zeroScen(this.state.data)).__meta || {};
    const auto = meta.auto && meta.auto[blk];
    return auto && auto.rule ? migrateCohortRule(auto.rule) : null;
  }
  setActor(name) {
    this.setState({ actorName: String(name || "").trim() });
  }
  actorStamp() {
    const by = this.state.actorName;
    return Object.assign({ at: new Date().toISOString() }, by ? { by } : null);
  }
  currentRate(ch, blk, j, t) {
    const meta = this.run(ch, this.zeroScen(this.state.data)).__meta || {};
    const rates = meta.rates && meta.rates[blk];
    const v = rates && rates[j] ? rates[j][t] : null;
    return typeof v === "number" ? v : null;
  }
  currentFlagRules(ch, blk, j, t) {
    const meta = this.run(ch, this.zeroScen(this.state.data)).__meta || {};
    const row = meta.flags && meta.flags[blk] ? meta.flags[blk][j] : null;
    return row && row[t] ? flagRulesOf(row[t]) : [];
  }
  acceptFlag(ch, blk, j, t) {
    if (this.state.version !== "fc_v5") return false;
    const value = this.currentRate(ch, blk, j, t);
    if (value === null) return false;
    const key = cellReviewKey(ch, blk, j, t);
    const before = this.state.flagReviews[key] || null;
    const review = Object.assign({ value, rules: this.currentFlagRules(ch, blk, j, t) }, this.actorStamp());
    this.setState(s => ({ flagReviews: Object.assign({}, s.flagReviews, { [key]: review }), reviewCell: null }));
    this.pushBatch([{ kind: "flag_review", rkey: key, ch, blk, j, t, label: (BL[blk] || blk) + " flag review", period: this.state.data.months[t], before: before ? "Accepted" : "Open", after: "Accepted", beforeReview: before, afterReview: review }], "UI");
    return true;
  }
  reopenFlag(ch, blk, j, t) {
    if (this.state.version !== "fc_v5") return;
    const key = cellReviewKey(ch, blk, j, t);
    const before = this.state.flagReviews[key];
    if (!before) return;
    this.setState(s => {
      const flagReviews = Object.assign({}, s.flagReviews);
      delete flagReviews[key];
      return { flagReviews, reviewCell: null };
    });
    this.pushBatch([{ kind: "flag_review", rkey: key, ch, blk, j, t, label: (BL[blk] || blk) + " flag review", period: this.state.data.months[t], before: "Accepted", after: "Open", beforeReview: before, afterReview: null }], "UI");
  }
  openReview(ch, blk, j, t) {
    this.setState({ reviewCell: { ch, blk, j, t } });
  }
  closeReview() {
    this.setState({ reviewCell: null });
  }
  openFlagPanel(tab, filter) {
    this.setState(s => ({ flagPanel: { tab: tab || "flags", filter: filter || "open", only: s.flagPanel ? !!s.flagPanel.only : false, at: -1 } }));
  }
  setFlagPanel(patch) {
    this.setState(s => (s.flagPanel ? { flagPanel: Object.assign({}, s.flagPanel, patch) } : {}));
  }
  closeFlagPanel() {
    this.setState({ flagPanel: null, focusCell: null });
  }
  goToCohortCell(ch, blk, j, t) {
    const D = this.state.data;
    const co = D && D.channels[ch] && D.channels[ch][blk] ? D.channels[ch][blk].cohorts[j] : null;
    const ym = co ? parseCohortYm(co.label) : NaN;
    const patch = { chSel: [ch], block: blk, focusCell: { ch, blk, j, t } };
    if (!isNaN(ym)) patch.groups = Object.assign({}, this.state.groups, { [String(Math.floor(ym / 100))]: true });
    if (typeof t === "number") {
      const [from, to] = this.fyRange(this.state.range);
      if (t < from || t > to) Object.assign(patch, { range: "custom", customFrom: Math.min(from, t), customTo: Math.max(to, t) });
    }
    this.setState(patch);
  }
  clearOverride(key) {
    const parts = String(key).split("|");
    if (parts.length === 4) {
      this.editRate(parts[0], parts[1], +parts[2], +parts[3], "");
      return;
    }
    if (parts.length === 3) this.setCohortInput(parts[0], parts[1], parts[2], null);
  }
  dismissAutoChanged(key) {
    this.setState(s => {
      const autoChanged = Object.assign({}, s.autoChanged);
      delete autoChanged[key];
      return { autoChanged };
    });
  }
  guardScopeLabel(key) {
    const [cid, b] = String(key).split("|");
    const D = this.state.data;
    return (D && D.channels[cid] ? D.channels[cid].label : cid) + " " + (BL[b] || b) + " cohorts";
  }
  guardResolved(key) {
    const [cid, b] = String(key).split("|");
    const D = this.state.data;
    if (!D || !D.channels[cid] || !this.state.cohortGuards) return null;
    const meta = this.run(cid, this.zeroScen(D)).__meta || {};
    return meta.guards ? meta.guards[b] || null : null;
  }
  commitCohortGuards(mutate, label, before, after, ch) {
    const st = this.state;
    if (st.version !== "fc_v5" || !st.cohortGuards) return false;
    const pinned = st.cohortGuards.engine ? { engine: st.cohortGuards.engine } : null;
    const prev = sanitizeCohortGuards(st.cohortGuards, false);
    const draft = JSON.parse(JSON.stringify(prev));
    draft.scopes = draft.scopes || {};
    mutate(draft);
    const next = Object.assign(sanitizeCohortGuards(draft, false), pinned);
    if (JSON.stringify(next) === JSON.stringify(Object.assign(prev, pinned))) return false;
    this.setState({ cohortGuards: next });
    this.pushBatch([Object.assign({ kind: "cohort_guards", label, before, after, beforeGuards: st.cohortGuards, afterGuards: next }, ch ? { ch } : null)], "UI");
    return true;
  }
  writeGuardUser(key, param, value, label, before, after) {
    const by = this.state.actorName;
    return this.commitCohortGuards(g => {
      const scope = g.scopes[key] || (g.scopes[key] = {});
      scope.user = Object.assign({}, scope.user, { [param]: Object.assign({ value, at: new Date().toISOString() }, by ? { by } : null) });
    }, label, before, after, key.split("|")[0]);
  }
  setGuardParam(key, param, text) {
    if (this.state.version !== "fc_v5") return false;
    if (!String(text || "").trim()) {
      this.resetGuardParam(key, param);
      return true;
    }
    const value = parseGuardValue(param, text);
    if (value === undefined) return false;
    const resolved = this.guardResolved(key);
    const before = resolved && resolved.params[param] ? formatGuardValue(param, resolved.params[param].value) || "Needs a decision" : "—";
    this.writeGuardUser(key, param, value, PARAM_GUIDE[param].label + " · " + this.guardScopeLabel(key), before, formatGuardValue(param, value));
    return true;
  }
  setGuardLimit(key, index, text) {
    if (this.state.version !== "fc_v5") return false;
    const resolved = this.guardResolved(key);
    if (!resolved) return false;
    const size = resolved.bands.length * 2;
    if (index < 0 || index >= size) return false;
    const blank = !String(text || "").trim();
    const pctValue = blank ? null : parseLimitPct(text);
    if (!blank && pctValue === undefined) return false;
    const side = index % 2 === 0 ? "fall" : "rise";
    const own = this.state.cohortGuards.scopes && this.state.cohortGuards.scopes[key] && this.state.cohortGuards.scopes[key].user && this.state.cohortGuards.scopes[key].user.trendLimits;
    const prev = own && Array.isArray(own.value) && own.value.length === size ? own.value.slice() : new Array(size).fill(null);
    const next = prev.slice();
    next[index] = blank ? null : Math.round((side === "fall" ? 1 - pctValue / 100 : 1 + pctValue / 100) * 1e6) / 1e6;
    if (next[index] === prev[index]) return true;
    const group = ageGroupsOf(resolved.bands)[Math.floor(index / 2)];
    const label = (side === "fall" ? "Largest fall a year" : "Largest rise a year") + " · " + group.name + " · " + this.guardScopeLabel(key);
    const before = limitPct(resolved.limits[index], side) + "%";
    if (next.every(v => v === null)) {
      this.commitCohortGuards(g => {
        const scope = g.scopes[key];
        if (scope && scope.user) delete scope.user.trendLimits;
      }, label, before, "System default", key.split("|")[0]);
      return true;
    }
    this.writeGuardUser(key, "trendLimits", next, label, before, blank ? "System default" : pctValue + "%");
    return true;
  }
  resetGuardParam(key, param) {
    const resolved = this.guardResolved(key);
    const before = resolved && resolved.params[param] ? formatGuardValue(param, resolved.params[param].value) : "—";
    return this.commitCohortGuards(g => {
      const scope = g.scopes[key];
      if (scope && scope.user) delete scope.user[param];
    }, PARAM_GUIDE[param].label + " · " + this.guardScopeLabel(key), before, "System default", key.split("|")[0]);
  }
  retentionStartMonths(R) {
    const info = R && R.params.retentionChangeStart;
    const value = info && typeof info.value === "number" ? info.value : null;
    const system = info ? info.system : null;
    const months = this.state.data.months.slice(this.cutIdx() + 1);
    if (value !== null && months.indexOf(value) < 0) months.push(value);
    return {
      value,
      options: months.sort((a, b) => a - b).map(ym => ({ value: ym, label: formatMonth(ym) + (ym === system ? " · from data" : "") }))
    };
  }
  setRetentionChange(key, changeText, startYm) {
    if (this.state.version !== "fc_v5") return false;
    const R = this.guardResolved(key);
    if (!R || !R.params.retentionChange || !R.params.retentionChangeStart) return false;
    const changeInfo = R.params.retentionChange, startInfo = R.params.retentionChangeStart;
    const text = String(changeText || "").trim();
    const change = text ? parseGuardValue("retentionChange", text) : null;
    if (text && (change === undefined || !isValidGuardParam("retentionChange", change))) return false;
    if (!isValidGuardParam("retentionChangeStart", startYm)) return false;
    const changeUser = changeInfo.source === "user";
    const writeChange = text ? !(changeUser && change === changeInfo.value) : changeUser;
    const writeStart = startYm !== startInfo.value;
    if (!writeChange && !writeStart) return true;
    const summary = (v, ym) => formatGuardValue("retentionChange", v) + " from " + formatMonth(ym);
    const nextChange = writeChange ? (text ? change : changeInfo.system) : changeInfo.value;
    const by = this.state.actorName;
    const stamp = value => Object.assign({ value, at: new Date().toISOString() }, by ? { by } : null);
    this.commitCohortGuards(g => {
      const scope = g.scopes[key] || (g.scopes[key] = {});
      const user = Object.assign({}, scope.user);
      if (writeChange) {
        if (text) user.retentionChange = stamp(change);
        else delete user.retentionChange;
      }
      if (writeStart) user.retentionChangeStart = stamp(startYm);
      scope.user = user;
    }, "Retention change · " + this.guardScopeLabel(key), summary(changeInfo.value, startInfo.value), summary(nextChange, startYm), key.split("|")[0]);
    return true;
  }
  resetRetentionChange(key) {
    if (this.state.version !== "fc_v5") return false;
    const R = this.guardResolved(key);
    if (!R || !R.params.retentionChange || !R.params.retentionChangeStart) return false;
    const changeInfo = R.params.retentionChange, startInfo = R.params.retentionChangeStart;
    if (changeInfo.source !== "user" && startInfo.source !== "user") return true;
    const before = formatGuardValue("retentionChange", changeInfo.value) + " from " + formatMonth(startInfo.value);
    this.commitCohortGuards(g => {
      const scope = g.scopes[key];
      if (!scope || !scope.user) return;
      const user = Object.assign({}, scope.user);
      delete user.retentionChange;
      delete user.retentionChangeStart;
      scope.user = user;
    }, "Retention change · " + this.guardScopeLabel(key), before, "System default", key.split("|")[0]);
    return true;
  }
  setGuardConstant(key, text) {
    if (this.state.version !== "fc_v5") return false;
    if (!String(text || "").trim()) {
      this.resetGuardConstant(key);
      return true;
    }
    const value = parseGuardConstant(key, text);
    if (value === undefined) return false;
    const current = resolveConstants(Object.assign({}, this.state.cohortGuards && this.state.cohortGuards.constants, { [key]: value }));
    if (current.matureAgeFrom > current.matureAgeTo) return false;
    const before = this.state.cohortGuards && this.state.cohortGuards.constants && key in this.state.cohortGuards.constants ? this.state.cohortGuards.constants[key] : METHOD_CONSTANTS[key];
    this.commitCohortGuards(g => {
      g.constants = Object.assign({}, g.constants, { [key]: value });
    }, CONSTANT_GUIDE[key].label, String(before), String(value));
    return true;
  }
  resetGuardConstant(key) {
    const g0 = this.state.cohortGuards;
    const before = g0 && g0.constants && key in g0.constants ? String(g0.constants[key]) : String(METHOD_CONSTANTS[key]);
    return this.commitCohortGuards(g => {
      if (g.constants) delete g.constants[key];
    }, CONSTANT_GUIDE[key].label, before, String(METHOD_CONSTANTS[key]));
  }
  setMixInput(ch, name, rule, period, kind) {
    if (this.state.version !== "fc_v5") return;
    const next = rule ? normalizeCohortRule(rule) : null;
    if (rule && !next) return;
    const field = kind === "cogs" ? "cogsInput" : "mixInput";
    const key = mixInputKey(ch, name, period);
    const prev = this.state[field][key] || null;
    if (sameCohortRule(prev, next)) return;
    const map = Object.assign({}, this.state[field]);
    if (next) map[key] = next; else delete map[key];
    const D = this.state.data;
    const scope = (D && D.channels[ch] ? D.channels[ch].label : ch) + (kind === "cogs" ? " COGS %" : " mix") + (name ? " · " + name : "") + (name && period ? " · " + ml(period) : "");
    const fallback = name ? "Default" : describeMixRule(DEFAULT_COHORT_RULE);
    this.setState({ [field]: map });
    this.pushRuleChange({
      kind: kind === "cogs" ? "cogs_input" : "mix_input", ckey: key, label: "forecast method · " + scope,
      before: prev ? describeMixRule(prev) : fallback, after: next ? describeMixRule(next) : fallback,
      beforeRule: prev, afterRule: next
    });
  }
  fitCarry(orders, entrants, cut) {
    let num = 0, den = 0;
    const ord = Array.isArray(orders) ? orders : [];
    const ent = Array.isArray(entrants) ? entrants : [];
    for (let t = 1; t <= cut; t++) {
      const y1 = ord[t - 1], y = ord[t], a = ent[t];
      if (typeof y1 !== "number" || typeof y !== "number" || typeof a !== "number") continue;
      num += y1 * (y - a); den += y1 * y1;
    }
    const r = den ? num / den : null;
    if (r === null || isNaN(r)) return null;
    return Math.max(0.01, Math.min(0.99, r));
  }

  // stable identity token for an immutably-replaced state object
  tok(o) {
    if (o === null || o === undefined) return "0";
    if (typeof o !== "object") return String(o);
    if (!o.__tok) { this._tokN = (this._tokN || 0) + 1; try { Object.defineProperty(o, "__tok", { value: "t" + this._tokN, enumerable: false }); } catch (e) { return "x"; } }
    return o.__tok;
  }
  run(ch, scen, hold, src) {
    const st = this.state;
    const moves = Object.keys(st.rowCfg || {}).filter(k => st.rowCfg[k] && st.rowCfg[k].sec).sort().map(k => k + ":" + st.rowCfg[k].sec).join(",");
    const key = ch + "|" + JSON.stringify(scen || 0) + "|" + (hold === null || hold === undefined ? "-" : hold) + "|" +
      this.tok(src && src.inputs ? src.inputs : st.inputs) + "|" + this.tok(src && src.rov ? src.rov : st.rov) + "|" +
      this.tok(src && src.mov ? src.mov : st.mov) + "|" + this.tok(src && src.cohortInput ? src.cohortInput : st.cohortInput) + "|" +
      this.tok(src && src.cohortGuards !== undefined ? src.cohortGuards : st.cohortGuards) + "|" +
      this.tok(src && src.cohortAuto !== undefined ? src.cohortAuto : st.cohortAuto) + "|" +
      this.tok(src && src.mixInput ? src.mixInput : st.mixInput) + "|" +
      this.tok(src && src.cogsInput ? src.cogsInput : st.cogsInput) + "|" +
      this.tok(st.fdraft) + "|" +
      ((src && typeof src.cutoffIdx === "number") ? src.cutoffIdx : st.cutoffIdx) + "|" + moves + "|" + (this._settingsSeq || 0) + "|" + (this._srcSeq || 0) +
      (src && src.actual ? "|actual" + (src.truncate ? "T" : "") : "");
    this._runMemo = this._runMemo || {};
    if (this._runMemo[key]) return this._runMemo[key];
    const out = this.runUncached(ch, scen, hold, src);
    if (Object.keys(this._runMemo).length > 60) this._runMemo = {};
    this._runMemo[key] = out;
    return out;
  }
  runUncached(ch, scen, hold, src) {
    if (ch !== "all") return this.runOne(ch, scen, hold, src);
    const D = this.state.data;
    if (!D || !Array.isArray(D.months)) return { __rows: [], __meta: { sizes: {}, fit: {} } };
    const parts = this.chIds().map(cid => this.runOne(cid, (scen && scen.__byCh) ? scen.__byCh[cid] : scen, hold, src));
    return this.runGroup(parts);
  }

  runGroup(parts, ids = this.chIds()) {
    const D = this.state.data, n = D.months.length;
    const rows = groupRowsOf(parts);
    const res = rollupChannels(rows, parts.map((p, i) => ({
      label: D.channels[ids[i]] ? D.channels[ids[i]].label : ids[i],
      values: p,
      skipped: (p.__meta && p.__meta.skipped) || {}
    })), n, this.calcResolver(rows));
    const g = res.values;
    g.__rows = rows;
    g.__raw = res.raw;
    g.__meta = { sizes: {}, fit: {}, skipped: res.skipped };
    return g;
  }

  periodTotals(grid, idxs) {
    const memo = this._periodMemo || (this._periodMemo = new WeakMap());
    let byGrid = memo.get(grid);
    if (!byGrid) { byGrid = {}; memo.set(grid, byGrid); }
    const key = idxs.join(",");
    if (byGrid[key]) return byGrid[key];
    const rows = grid.__rows || [];
    const base = grid.__raw || grid;
    const out = combineTotals(rows, this.calcResolver(rows), id => sumCells(idxs.map(i => (base[id] ? base[id][i] : null))));
    byGrid[key] = out;
    return out;
  }

  periodValue(grid, k, idxs) {
    if (!grid || !idxs.length) return null;
    if (idxs.length === 1) return grid[k] ? grid[k][idxs[0]] ?? null : null;
    return this.periodTotals(grid, idxs)[k] ?? null;
  }

  forecastMonthsRemovable() {
    const D = this.state.data;
    if (!D || this.state.version !== "fc_v5") return 0;
    return Math.max(0, D.months.length - this.cutIdx() - 2);
  }

  trimHorizon(k) {
    const drop = Math.min(k, this.forecastMonthsRemovable());
    if (drop <= 0) return;
    const s = this.state;
    const D = JSON.parse(JSON.stringify(s.data));
    const inputs = JSON.parse(JSON.stringify(s.inputs));
    const target = D.months.length - drop;
    const clip = a => { if (Array.isArray(a)) a.length = Math.min(a.length, target); };
    D.months.length = target;
    Object.keys(D.channels).forEach(cid => {
      const c = D.channels[cid];
      (c.acqRows || []).forEach(r => clip(r.values));
      channelBlocks(cid, s.data || D).forEach(b => {
        const blk = c[b]; if (!blk) return;
        clip(blk.totalOrders); clip(blk.aov); clip(blk.newOrders); clip(blk.sales);
        (blk.cohorts || []).forEach(co => clip(co.ratio));
        blk.cohorts = (blk.cohorts || []).filter((co, j) => j === 0 || j - 1 < target);
      });
      if (c.total) { clip(c.total.orders); clip(c.total.aov); clip(c.total.sales); }
    });
    Object.keys(inputs).forEach(cid => Object.keys(inputs[cid]).forEach(k2 => clip(inputs[cid][k2])));
    const sourced = Object.keys(SESSION_SOURCES).filter(channelHasSources);
    sourced.forEach(cid => SESSION_SOURCES[cid].forEach(row => { clip(row.ad); clip(row.sess); clip(row.cps); }));
    this._srcSeq = (this._srcSeq || 0) + 1;
    const mov = {};
    let movTrimmed = false;
    Object.keys(s.mov || {}).forEach(key => {
      if (+key.split("|").pop() >= target) { movTrimmed = true; return; }
      mov[key] = s.mov[key];
    });
    const clampIdx = i => (i === null || i === undefined ? i : Math.min(i, target - 1));
    this.setState({ data: D, inputs, mov, customFrom: clampIdx(s.customFrom), customTo: clampIdx(s.customTo), dirtyAt: Date.now() });
    this.noteHorizonInputsDirty();
    const extra = [];
    if (movTrimmed) extra.push({ kind: "mix" });
    if (sourced.length) extra.push({ kind: "source" });
    if (this.hasManualDrivers()) extra.push({ kind: "structure" });
    if (extra.length) this.notePendingFromItems(extra);
  }

  extendHorizon(k) {
    if (this.state.version !== "fc_v5" || !(k > 0)) return;
    const s = this.state;
    const D = JSON.parse(JSON.stringify(s.data));
    const inputs = JSON.parse(JSON.stringify(s.inputs));
    const sourced = Object.keys(SESSION_SOURCES).filter(channelHasSources);
    for (let step = 0; step < k; step++) {
      const t = D.months.length;
      D.months.push(nextPeriod(D.months[t - 1]));
      Object.keys(D.channels).forEach(cid => {
        const c = D.channels[cid];
        (c.acqRows || []).forEach(r => { if (r && r.values) r.values.push(null); });
        channelBlocks(cid, s.data || D).forEach(b => {
          if (!c[b] || !c[b].cohorts) {
            if (c[b]) {
              if (c[b].aov) c[b].aov.push(null);
              if (c[b].totalOrders) c[b].totalOrders.push(null);
              if (c[b].sales) c[b].sales.push(null);
            }
            return;
          }
          if (c[b].aov) c[b].aov.push(null);
          if (c[b].totalOrders) c[b].totalOrders.push(null);
          if (c[b].sales) c[b].sales.push(null);
          c[b].cohorts.forEach((co) => co.ratio.push(null));
          const fresh = { label: String(D.months[t]), size: null, ratio: new Array(t + 1).fill(null) };
          fresh.ratio[t] = 1;
          c[b].cohorts.push(fresh);
        });
        if (c.total) { if (c.total.orders) c.total.orders.push(null); if (c.total.aov) c.total.aov.push(null); if (c.total.sales) c.total.sales.push(null); }
      });
      Object.keys(inputs).forEach(cid => {
        const fromSources = sourced.indexOf(cid) >= 0;
        const sourcedIds = catalogOf(cid, D).filter(c => c.sourced).map(c => c.id);
        Object.keys(inputs[cid]).forEach(key => {
          const arr = inputs[cid][key];
          if (!Array.isArray(arr)) return;
          arr.push(fromSources && sourcedIds.indexOf(key) >= 0 ? null : lastValueBefore(arr, t));
        });
      });
      sourced.forEach(cid => SESSION_SOURCES[cid].forEach(row => {
        sourceSeriesOf(row, "ad", t);
        sourceSeriesOf(row, "sess", t);
        sourceSeriesOf(row, "cps", t);
        row.ad.push(lastValueBefore(row.ad, t));
        row.sess.push(row.sess[t - 1] ?? null);
        row.cps.push(lastValueBefore(row.cps, t));
      }));
      this._srcSeq = (this._srcSeq || 0) + 1;
    }
    this.setState({ data: D, inputs, dirtyAt: Date.now() });
    sourced.forEach(cid => this.syncChannelTotalsFromSources(cid));
    this.noteHorizonInputsDirty();
    if (sourced.length) this.notePendingFromItems([{ kind: "source" }]);
    if (this.hasManualDrivers()) this.notePendingFromItems([{ kind: "structure" }]);
  }

  hasManualDrivers() {
    const drafts = this.state.fdraft || {};
    return Object.keys(drafts).some(k => drafts[k] && drafts[k].manual);
  }

  noteHorizonInputsDirty() {
    const after = this.state;
    const items = [];
    Object.keys(after.inputs || {}).forEach(ch => {
      if (ch === "all") return;
      Object.keys(after.inputs[ch] || {}).forEach(key => {
        const arr = after.inputs[ch][key];
        if (!Array.isArray(arr)) return;
        arr.forEach((v, i) => items.push({ kind: "input", ch, key, i, after: v }));
      });
    });
    if (items.length) this.notePendingFromItems(items);
    else {
      const pending = this._pendingDelta || { hasChange: false, inputs: {}, rov: false, mov: false, cutoff: false, settings: false, structure: false, layout: false, overrides: false };
      pending.hasChange = true;
      this._pendingDelta = pending;
    }
  }

  cutIdx() {
    const D = this.state.data;
    if (!D) return 0;
    return this.state.cutoffIdx === null || this.state.cutoffIdx === undefined ? (D.cutoffIdx ?? 0) : this.state.cutoffIdx;
  }

  actualCutIdx() {
    const D = this.state.data;
    if (!D) return 0;
    return typeof D.actualCutoffIdx === "number" ? D.actualCutoffIdx : (D.cutoffIdx ?? 0);
  }

  systemFit(cut, pristine) {
    const D = this.state.data;
    const memo = this._fitMemo;
    if (memo && memo.D === D && memo.cut === cut && memo.sig === this._bindSig) return memo.fit;
    const inputs = {}, cohortInput = {}, mixInput = {};
    Object.keys(pristine).forEach(cid => {
      const one = {};
      Object.keys(pristine[cid]).forEach(k => { one[k] = systemFitSeries(D.months, cut, pristine[cid][k]); });
      inputs[cid] = one;
      if (cid === "all" || !D.channels[cid]) return;
      (channelBlocks(cid, D) || []).forEach(b => { cohortInput[cohortInputKey(cid, b)] = SYSTEM_FIT_RULE; });
      mixInput[mixInputKey(cid)] = SYSTEM_FIT_RULE;
    });
    const fit = { inputs, cohortInput, mixInput };
    this._fitMemo = { D, cut, sig: this._bindSig, fit };
    return fit;
  }

  boundActualValue(ch, key, i) {
    const D = this.state.data;
    if (!D || !D.channels || !D.channels[ch]) return null;
    const row = buildRows(ch, D).find(r => r.ed === key);
    const s = row ? storedSeries(ch, D, row) : (D.inputs && D.inputs[ch] && Array.isArray(D.inputs[ch][key]) ? D.inputs[ch][key] : null);
    return s && s[i] != null ? s[i] : null;
  }

  restoreBoundActualsThrough(toIdx) {
    const D = this.state.data;
    if (!D || toIdx < 0) return;
    this.setState(s => {
      const inputs = JSON.parse(JSON.stringify(s.inputs || {}));
      Object.keys(D.channels || {}).forEach(cid => {
        if (cid === "all" || !inputs[cid]) return;
        Object.keys(inputs[cid]).forEach(key => {
          if (!Array.isArray(inputs[cid][key])) return;
          for (let i = 0; i <= toIdx && i < inputs[cid][key].length; i++) {
            inputs[cid][key][i] = this.boundActualValue(cid, key, i);
          }
        });
      });
      return { inputs };
    });
  }

  applyCutoff(i) {
    if (this.state.version !== "fc_v5") return;
    const D = this.state.data;
    if (!D || typeof i !== "number" || i < 0 || i > D.cutoffIdx) return;
    const before = D.months[this.cutIdx()];
    const after = D.months[i];
    if (before === after && (this.state.cutoffIdx === null || this.state.cutoffIdx === i || (i === D.cutoffIdx && this.state.cutoffIdx == null))) {
      this.setState({ cutoffOpen: false, cutoffPending: null, overwriteText: "" });
      return;
    }
    const forward = i > this.cutIdx();
    const cleared = forward ? this.typedValuesThrough(i) : [];
    if (forward) this.restoreBoundActualsThrough(i);
    const restored = forward ? this.restoreSourceActualsThrough(i) : [];
    this.setState(s => {
      const rov = Object.assign({}, s.rov), mov = Object.assign({}, s.mov), overrideInfo = Object.assign({}, s.overrideInfo);
      cleared.forEach(it => {
        if (it.kind === "rate") { delete rov[it.rkey]; delete overrideInfo[it.rkey]; } else delete mov[it.rkey];
      });
      return Object.assign({
        cutoffIdx: i === D.cutoffIdx ? null : i,
        cutoffPending: null,
        overwriteText: "",
        cutoffOpen: false,
        dirtyAt: Date.now()
      }, cleared.length ? { rov, mov, overrideInfo } : null);
    });
    this.syncSourceChannels(restored);
    if (this.isCurrentDraft() && this.state.canAuthor !== false && this.tuneCohortGuards()) this._pendingDelta.settings = true;
    this.pushBatch([{
      kind: "cutoff",
      ch: this.state.chSel && this.state.chSel.length === 1 ? this.state.chSel[0] : "all",
      key: "cutoff_period",
      i: i,
      label: "actuals cutoff",
      period: after,
      before: before,
      after: after
    }].concat(cleared, restored), "UI");
  }

  restoreSourceActualsThrough(toIdx) {
    const D = this.state.data;
    const n = D.months.length;
    const last = Math.min(toIdx, D.cutoffIdx ?? toIdx, n - 1);
    const out = [];
    Object.keys(SESSION_SOURCES).forEach(ch => {
      const list = SESSION_SOURCES[ch] || [];
      if (!list.some(row => Array.isArray(row.actualAd) || Array.isArray(row.actualSess))) return;
      list.forEach(row => {
        if (row.manual) return;
        [["ad", row.actualAd], ["sess", row.actualSess]].forEach(([metric, actual]) => {
          const series = sourceSeriesOf(row, metric, n);
          for (let t = 0; t <= last; t++) {
            const v = Array.isArray(actual) && typeof actual[t] === "number" ? actual[t] : null;
            const was = typeof series[t] === "number" ? series[t] : null;
            if (v === was) continue;
            series[t] = v;
            out.push({ kind: "source", rkey: sourceDriverKey(row.key, metric) + "|" + t, ch, srcKey: row.key, metric, t, label: row.name + " " + SOURCE_METRIC_LABEL[metric], period: D.months[t], before: was, after: v });
          }
        });
      });
    });
    return out;
  }

  syncSourceChannels(items) {
    const chs = Array.from(new Set(items.filter(it => it.kind === "source" && it.srcKey).map(it => it.ch)));
    if (!chs.length) return;
    this._srcSeq = (this._srcSeq || 0) + 1;
    chs.forEach(ch => this.syncChannelTotalsFromSources(ch));
  }

  typedValuesThrough(toIdx) {
    const { data: D, rov, mov } = this.state;
    const out = [];
    Object.keys(rov || {}).forEach(key => {
      const [ch, blk, j, t] = key.split("|");
      if (!(+t <= toIdx)) return;
      out.push({ kind: "rate", rkey: key, ch, blk, j: +j, t: +t, label: (BL[blk] || blk) + " repurchase %", period: D.months[+t], before: rov[key], after: null });
    });
    Object.keys(mov || {}).forEach(key => {
      const [ch, part, t] = key.split("|");
      if (!(+t <= toIdx)) return;
      const name = (((PRODUCT_MIX[ch] || [])[+part.slice(1)] || [])[0]) || "Product";
      out.push({ kind: "mix", rkey: key, ch, label: name + (part.charAt(0) === "c" ? " COGS %" : " mix %"), period: D.months[+t], before: mov[key], after: null });
    });
    return out;
  }

  buildCutoffOpts(cut, D, st, fyOf, fyLabel, qOf, ml) {
    const max = typeof D.cutoffIdx === "number" ? D.cutoffIdx : 0;
    const unit = st.gran === "year" ? "y" : st.gran === "quarter" ? "q" : "m";
    const buckets = [];
    if (st.gran === "month") {
      for (let i = 0; i <= max; i++) buckets.push({ label: ml(D.months[i]), i });
    } else {
      const seen = {};
      for (let i = 0; i <= max; i++) {
        const ym = D.months[i];
        const key = st.gran === "year" ? fyLabel(ym) : "Q" + qOf(ym) + " " + fyLabel(ym).replace("FY-", "");
        if (!seen[key]) {
          seen[key] = { label: key, i };
          buckets.push(seen[key]);
        } else {
          seen[key].i = i;
        }
      }
    }
    const out = [];
    for (let b = buckets.length - 1; b >= 0; b--) {
      const opt = buckets[b];
      const i = opt.i;
      const hold = max - i;
      out.push({
        label: opt.label,
        note: i === max ? "latest actuals" : "hold back " + hold + unit,
        bg: i === cut ? "#EAF1FD" : "transparent",
        fg: i === cut ? "#0052CD" : "#08234C",
        fw: i === cut ? 500 : 400,
        onClick: () => {
          if (i === cut) {
            this.setState({ cutoffOpen: false });
            return;
          }
          if (i > cut) {
            this.setState({ cutoffPending: i, overwriteText: "", cutoffOpen: false });
            return;
          }
          this.applyCutoff(i);
        }
      });
    }
    return out;
  }

  // presentation + source overrides a user has applied to a driver
  cfgOf(k, ch) {
    const all = this.state.rowCfg;
    const c = (ch && all[ch + "|" + k]) || all[k] || {};
    return { bold: !!c.bold, bg: c.bg || "none", indent: c.indent || 0, hide: !!c.hide, sec: isPlanSection(c.sec) ? c.sec : null, dp: roundingDp(c.dp), inverse: c.inverse === true, numBold: c.numBold === true };
  }
  rowDp(r) {
    return r && r.k ? this.cfgOf(r.k, r.ch).dp : null;
  }
  changeFg(d, inverse) {
    return (d > 0) !== !!inverse ? CHANGE_GOOD_FG : CHANGE_BAD_FG;
  }
  cfgBg(id) {
    return { none: "", tint: "#EDF1F8", lime: "#F1F6DC", amber: "#FFF8E0", cyan: "#E3F3FC" }[id] || "";
  }
  // effective source: a user can convert input → formula and back
  srcOf(r) {
    if (r && (r.opens === "source" || r.src === "source")) return "source";
    const d = this.state.fdraft[r.key] || (r.k ? this.state.fdraft[r.k] : null);
    let src = (d && d.src) ? d.src : r.src;
    if (src === "snowflake" && r.ed) src = "input";
    return src;
  }
  memberSourceRows(ch) {
    const D = this.state.data;
    if (!isCombined(D, ch)) return null;
    const order = Object.keys(D.channels);
    const byKey = {};
    membersOf(D, ch).slice().sort((x, y) => order.indexOf(x) - order.indexOf(y)).forEach(m => {
      this.mergeDraftRows(buildRows(m, D), m).forEach(row => {
        const local = keyLocal(row.key) || row.k;
        if (!byKey[local]) byKey[local] = row;
      });
    });
    return byKey;
  }
  memberSource(r, memberRows) {
    if (!r || !r.combined || !memberRows) return null;
    const m = memberRows[keyLocal(r.key) || r.k];
    const src = m ? this.srcOf(m) : null;
    const option = src ? MEMBER_SOURCES[src] : null;
    return option ? { src, option, opens: src === "source" || src === "mix" ? src : src === "cohort" ? m.opens || null : null } : null;
  }
  memberLink(r, memberRows) {
    return r && isRollupSource(this.srcOf(r)) ? this.memberSource(r, memberRows) : null;
  }
  shownSrc(r, memberRows) {
    const link = this.memberLink(r, memberRows);
    return link ? link.src : this.srcOf(r);
  }
  // section order with any user moves applied
  ordered(ROWS, secOrder, ch) {
    const st = this.state, out = [];
    secOrder.forEach(sec => {
      const nat = ROWS.filter(r => r.sec === sec);
      const saved = (ch && st.rowOrd[ch + "|" + sec]) || st.rowOrd[sec];
      if (!saved) { out.push.apply(out, nat); return; }
      const byK = {}; nat.forEach(r => { byK[r.k] = r; });
      saved.forEach(k => { if (byK[k]) { out.push(byK[k]); delete byK[k]; } });
      nat.forEach(r => { if (byK[r.k]) out.push(r); });
    });
    ROWS.forEach(r => { if (secOrder.indexOf(r.sec) < 0) out.push(r); });
    return out;
  }
  moveRow(ROWS, sec, k, dir, ch) {
    const own = ch ? ch + "|" + sec : sec;
    this.setState(s => {
      const nat = ROWS.filter(r => r.sec === sec).map(r => r.k);
      const cur = (s.rowOrd[own] || s.rowOrd[sec] || nat).slice();
      nat.forEach(x => { if (cur.indexOf(x) < 0) cur.push(x); });
      const i = cur.indexOf(k), j = i + dir;
      if (i < 0 || j < 0 || j >= cur.length) return {};
      cur[i] = cur[j]; cur[j] = k;
      return { rowOrd: Object.assign({}, s.rowOrd, { [own]: cur }) };
    });
    this.noteLayoutDirty();
  }
  setCfg(k, patch, ch) {
    const own = ch ? ch + "|" + k : k;
    this.setState(s => ({ rowCfg: Object.assign({}, s.rowCfg, { [own]: Object.assign({}, s.rowCfg[own] || s.rowCfg[k] || {}, patch) }) }));
    this.noteLayoutDirty();
  }
  setScenarioLever(ch, levers, keys, on) {
    this.setState(s => {
      const scenarioOn = Object.assign({}, s.scenarioOn);
      keys.forEach(k => { scenarioOn[k] = on; });
      if (on) return { scenarioOn };
      const scenByCh = Object.assign({}, s.scenByCh);
      [ch, "all"].forEach(c => {
        if (!scenByCh[c] || !levers.some(l => scenByCh[c][l])) return;
        scenByCh[c] = Object.assign({}, scenByCh[c]);
        levers.forEach(l => { if (scenByCh[c][l]) scenByCh[c][l] = 0; });
      });
      return { scenarioOn, scenByCh };
    });
    this.noteLayoutDirty();
  }

  setRowDesc(key, raw) {
    const text = String(raw || "").trim();
    if (text === (this.state.rowDesc[key] || "")) return;
    this.setState(s => {
      const rowDesc = Object.assign({}, s.rowDesc);
      if (text) rowDesc[key] = text; else delete rowDesc[key];
      return { rowDesc };
    });
    this.noteLayoutDirty();
  }

  draftShortKey(draft) {
    if (draft && draft.shortKey) return draft.shortKey;
    const key = (draft && draft.key) || "";
    const parts = key.split(".").filter(Boolean);
    return (parts.length ? parts[parts.length - 1] : "custom_driver").replace(/-/g, "_");
  }

  tokenIndex() {
    const D = this.state && this.state.data;
    if (this._tokenIdx && this._tokenIdx.D === D) return this._tokenIdx.map;
    const rows = D && D.channels ? Object.keys(D.channels).reduce((acc, ch) => acc.concat(buildRows(ch, D)), []) : [];
    const map = rowTokenMap(rows);
    this._tokenIdx = { D, map };
    return map;
  }

  resolveFormulaToken(token) {
    const t = String(token || "").trim();
    const map = this.tokenIndex();
    if (map[t]) return map[t];
    if (t.indexOf(".") < 0) return t;
    const tail = keyLeaf(t);
    return map[tail] || tail;
  }

  bindSignature() {
    const drafts = this.state.fdraft || {};
    return Object.keys(drafts).sort().map(k => {
      const d = drafts[k] || {};
      return [k, d.src || "", d.binding || "", d.shortKey || ""].join("|");
    }).join(";");
  }

  syncActualsBindings() {
    const sig = this.bindSignature();
    if (sig === this._bindSig) return;
    this._bindSig = sig;
    this.rebindActuals();
  }

  rebindActuals(chList) {
    const D = this.state.data;
    if (!D || !D.channels || !this.state.inputs) return;
    const list = (chList && chList.length ? chList : Object.keys(D.channels)).filter(c => c !== "all" && D.channels[c]);
    if (!list.length) return;
    const cut = this.cutIdx();
    const seen = this._bindKeys || (this._bindKeys = {});
    const inputs = Object.assign({}, this.state.inputs);
    list.forEach(ch => {
      const conf = D.channels[ch];
      const rows = this.mergeDraftRows(buildRows(ch, D), ch);
      const keys = seen[ch] || (seen[ch] = {});
      rows.forEach(r => {
        if (!r.bindsActuals) return;
        const stale = keys[r.k] && keys[r.k] !== r.bindKey ? actualSeriesOf(conf, keys[r.k]) : null;
        const slot = stale ? storedSeries(ch, D, r) : null;
        if (slot) stale.forEach((v, i) => { if (i < slot.length && v !== null && v !== undefined) slot[i] = null; });
        keys[r.k] = r.bindKey;
      });
      bindChannelActuals(D, cid => (cid === ch ? rows : []));
      const one = Object.assign({}, inputs[ch]);
      rows.forEach(r => {
        if (!r.ed || !r.bindsActuals) return;
        const stored = storedSeries(ch, D, r);
        if (!stored && !Array.isArray(one[r.ed])) return;
        const next = Array.isArray(one[r.ed]) ? one[r.ed].slice() : D.months.map(() => null);
        for (let i = 0; i <= cut && i < next.length; i++) next[i] = stored && stored[i] !== undefined ? stored[i] : null;
        one[r.ed] = next;
      });
      inputs[ch] = one;
    });
    this.state = Object.assign({}, this.state, { inputs });
  }

  mergeDraftRows(baseRows, ch) {
    const drafts = this.state.fdraft || {};
    const combined = isCombined(this.state.data, ch);
    const rows = baseRows.slice();
    const byKey = {};
    const natives = new Map();
    rows.forEach(r => { byKey[r.key] = r; byKey[r.k] = r; });
    rows.forEach(r => (r.previousKeys || []).forEach(p => { if (!byKey[p]) byKey[p] = r; }));
    Object.keys(drafts).forEach(key => {
      const d = drafts[key];
      if (!d) return;
      const draftKey = String(d.key || key || "");
      if (d.channel && d.channel !== "all" && d.channel !== ch) {
        const prefix = (channelNs(ch) || ch) + ".";
        if (!draftKey.startsWith(prefix) && !draftKey.startsWith(ch + ".")) return;
      }
      const existing = byKey[key] || byKey[d.previousKey] || byKey[d.shortKey] || byKey[this.draftShortKey(d)];
      if (existing) {
        const binding = bindingText(d.binding);
        if (d.binding != null && (binding || existing.binding)) {
          existing.binding = binding;
          if (!existing.bindsActuals) existing.bind = binding || "—";
        }
        if (existing.opens === "source" || existing.src === "source") {
          if (d.name) existing.name = readableDriverName(d.name, existing.name);
          return;
        }
        if (d.name) existing.name = readableDriverName(d.name, existing.name);
        if (!natives.has(existing)) natives.set(existing, { src: existing.src, formula: existing.formula, rollup: existing.rollup });
        if (d.src) existing.src = d.src;
        if (d.formula != null) existing.formula = d.formula;
        if (d.rollup != null) existing.rollup = d.rollup || null;
        if (d.unit) existing.unit = d.unit === "currency" ? "£" : d.unit === "percentage" ? "%" : d.unit === "ratio" ? "×" : d.unit === "count" ? "#" : existing.unit;
        if (d.totalsMode) {
          existing.totalsMode = totalsModeOf(d);
          existing.totalsFormula = existing.totalsMode === "formula" ? String(d.totalsFormula || "") : "";
        }
        if (d.dim) existing.dim = "[" + d.dim.join(", ") + "]";
        if (d.tmp) existing.tmp = d.tmp === "cohort" ? "[cohort_period, activity_period]" : d.tmp === "none" ? "[]" : "[activity_period]";
        if (d.src === "input" && !existing.ed) existing.ed = existing.k;
        existing.overwrite = existing.src === "input" && !combined && !existing.manual ? driverOverwrite(d) : null;
        if (d.src === "binding") {
          existing.bind = "growth_driver_actuals · DRIVER_KEY = " + (existing.bindKey || keyLeaf(existing.key));
          existing.bindsActuals = true;
        }
        return;
      }
      if (!d.isNew) return;
      const shortKey = this.draftShortKey(d);
      if (byKey[shortKey]) return;
      const row = {
        k: shortKey,
        ch,
        sec: planSectionOf(d.section),
        name: readableDriverName(d.name, shortKey),
        unit: d.unit === "currency" ? "£" : d.unit === "percentage" ? "%" : d.unit === "ratio" ? "×" : "#",
        src: d.src || "formula",
        ed: d.src === "input" ? shortKey : null,
        key: d.key || key,
        formula: d.formula || (d.src === "input" ? "manual input · scenario controllable" : d.src === "fitted" ? "fitted · evaluate-time" : d.src === "binding" ? "binding · bound actuals" : ""),
        binding: bindingText(d.binding),
        bind: d.src === "binding" ? "growth_driver_actuals · DRIVER_KEY = " + shortKey : (bindingText(d.binding) || "—"),
        bindsActuals: d.src === "binding",
        bindKey: shortKey,
        dim: d.dim && d.dim.length ? "[" + d.dim.join(", ") + "]" : "[]",
        tmp: d.tmp === "cohort" ? "[cohort_period, activity_period]" : d.tmp === "none" ? "[]" : "[activity_period]",
        totalsMode: totalsModeOf(d),
        totalsFormula: totalsModeOf(d) === "formula" ? String(d.totalsFormula || "") : "",
        rollup: d.rollup || null,
        down: "draft driver",
        sheet: "catalog",
        isDraftRow: true,
        manual: !!d.manual && d.src === "input",
        overwrite: d.src === "input" && !d.manual && !combined ? driverOverwrite(d) : null,
        ...(combined ? { combined: true } : null)
      };
      rows.push(row);
      byKey[row.key] = row;
      byKey[row.k] = row;
    });
    const conf = (this.state.data && this.state.data.channels) ? this.state.data.channels[ch] : null;
    const owners = leafOwners(rows);
    rows.forEach(r => {
      if ((r.src !== "input" && r.src !== "binding") || r.manual || r.combined) return;
      r.bindKey = resolveBindKey(conf, r, owners);
      r.bind = "growth_driver_actuals · DRIVER_KEY = " + r.bindKey;
      r.bindsActuals = true;
    });
    const resolve = this.calcResolver(rows);
    natives.forEach((native, r) => {
      if (r.rollup && !isValidRollup(r.rollup, resolve)) r.rollup = native.rollup;
      if (isRollupSource(r.src) && !r.combined) {
        r.src = native.src;
        r.formula = native.formula;
      } else if (isInputSource(r.src)) {
        if (!isInputSource(native.src) && !r.fallback) r.fallback = native.formula;
      } else if (!isRollupSource(r.src) && (r.src !== native.src || r.formula !== native.formula) && !isValidFormula(r.formula, resolve)) {
        r.src = native.src;
        r.formula = native.formula;
      }
    });
    const picks = this.state.scenarioOn || {};
    rows.forEach(r => { r.scenarioPick = picks[r.key] === true && r.src !== "rollup" && !nativeLevers(r).length; });
    return rows.map(r => {
      const moved = this.cfgOf(r.k, ch).sec;
      return moved && !r.isDraftRow && moved !== r.sec ? Object.assign({}, r, { sec: moved, homeSec: r.sec }) : r;
    });
  }

  rowTokenResolver(rows) {
    const map = rowTokenMap(rows);
    return token => {
      const t = String(token || "").trim();
      return map[t] || map[keyLocal(t)] || this.resolveFormulaToken(t);
    };
  }

  baseRowIndex(ch) {
    const byKey = {};
    buildRows(ch, this.state.data || D).forEach(r => { byKey[r.key] = r; byKey[r.k] = r; });
    return byKey;
  }

  draftBaseRow(d, key, byKey) {
    return byKey[key] || byKey[d.key] || byKey[d.previousKey] || byKey[d.shortKey] || null;
  }

  rowDraft(r, ch) {
    return {
      key: r.key,
      previousKey: null,
      name: r.name,
      src: r.src === "rollup" && !r.combined ? "formula" : r.src,
      unit: unitIdOf(r.unit),
      dim: dimsOf(r.dim),
      tmp: /cohort/.test(r.tmp || "") ? "cohort" : "activity",
      totalsMode: totalsModeOf(r),
      totalsFormula: r.totalsFormula || "",
      formula: r.formula || "",
      binding: r.bindsActuals ? "" : (r.binding || ""),
      isNew: false,
      shortKey: r.k,
      channel: ch,
      section: planSectionOf(r.homeSec || r.sec)
    };
  }

  rewriteDriverRefs(fdraft, rows, ch, target, previousKey, key, combined) {
    const owners = rowTokenMap(rows);
    const swaps = [];
    const local = keyLocal(key) || key;
    [[previousKey, key], [keyLocal(previousKey), local], [keyLeaf(previousKey), local], [target.k, local]].forEach(([from, to]) => {
      if (from && to && from !== to && owners[from] === target.k && !swaps.some(s => s[0] === from)) swaps.push([from, to]);
    });
    if (!swaps.length) return [];
    const swap = text => swaps.reduce((s, [from, to]) => replaceFormulaToken(s, from, to), String(text || ""));
    const changed = [];
    rows.forEach(o => {
      if (o.k === target.k || !o.key) return;
      const d = fdraft[o.key];
      const formula = d && d.formula != null ? d.formula : (o.formula || "");
      const totals = d && d.totalsFormula != null ? d.totalsFormula : (o.totalsFormula || "");
      const rollup = d && d.rollup != null ? d.rollup : (o.rollup || "");
      const src = d && d.src ? d.src : o.src;
      const nextFormula = src === "formula" ? swap(formula) : formula;
      const nextTotals = totalsModeOf(d || o) === "formula" ? swap(totals) : totals;
      const nextRollup = combined ? swap(rollup) : rollup;
      if (nextFormula === formula && nextTotals === totals && nextRollup === rollup) return;
      fdraft[o.key] = Object.assign({}, d || this.rowDraft(o, ch), { formula: nextFormula, totalsFormula: nextTotals }, combined ? { rollup: nextRollup } : null);
      changed.push(o.name);
    });
    return changed;
  }

  structRow(r, num, st, ROWS, rolledFrom, memberRows) {
    const draft = st.fdraft[r.key];
    const cfg = this.cfgOf(r.k, r.ch), eSrc = this.srcOf(r), bg = this.cfgBg(cfg.bg);
    const rolled = !!r.combined && (isRollupSource(eSrc) || isInputSource(eSrc));
    const rule = String((draft && draft.rollup != null ? draft.rollup : r.rollup) || "").trim();
    return {
      isBand: 0, isRow: true,
      n: String(num), name: r.name, key: r.key, src: this.shownSrc(r, memberRows),
      desc: st.rowDesc[r.key] || "",
      onDesc: st.canAuthor ? (raw => this.setRowDesc(r.key, raw)) : null,
      fw: (cfg.bold || r.total) ? 600 : 400,
      rowBg: bg || "transparent",
      indent: cfg.indent ? (cfg.indent * 16) + "px" : "0px",
      hidden: cfg.hide, shownOpacity: cfg.hide ? "0.45" : "1",
      hideLabel: cfg.hide ? "Show" : "Hide",
      onToggleHide: e => { e.stopPropagation(); this.setCfg(r.k, { hide: !cfg.hide }, r.ch); },
      canEdit: true,
      onEdit: e => {
        e.stopPropagation();
        if (st.canAuthor) this.openDriverEditor(r);
      },
      srcFg: eSrc === "input" ? "#0052CD" : eSrc === "rollup" ? "#4D6389" : "#8094B5",
      srcBg: eSrc === "input" ? "#EAF1FD" : "#F5F8FA",
      formula: rolled ? (rule || "No rollup rule") : (draft && draft.formula) ? draft.formula : r.formula,
      isDraft: this.isDriverUnsaved(r.key),
      bind: r.combined
        ? (!rolled ? "" : isInputSource(eSrc) ? "forecast typed on the plan · actual months roll up" : "rolled up from " + (rolledFrom || "member channels"))
        : r.bind && r.bind !== "—" ? "bound to " + r.bind : (eSrc === "input" ? "no binding — planner input" : ""),
      binding: !r.combined && r.bindsActuals ? r.binding || "" : ""
    };
  }

  chIds() {
    const D = this.state.data;
    const all = baseChannels(D).filter(c => !isCustom(D, c));
    const sel = (this.state.chSel || []).filter(c => all.indexOf(c) >= 0);
    return sel.length ? sel : all;
  }

  calcResolver(rows) {
    const map = rowTokenMap(rows);
    return token => {
      const t = String(token || "").trim();
      return map[t] || map[keyLocal(t)] || null;
    };
  }

  channelRows(cid) {
    const D = this.state.data, fdraft = this.state.fdraft;
    const memo = this._refRows;
    if (!memo || memo.D !== D || memo.fdraft !== fdraft || memo.seq !== this._settingsSeq) this._refRows = { D, fdraft, seq: this._settingsSeq, rows: {} };
    const cache = this._refRows.rows;
    if (!cache[cid]) {
      const rows = this.mergeDraftRows(buildRows(cid, D), cid);
      cache[cid] = { rows, resolve: this.calcResolver(rows) };
    }
    return cache[cid];
  }

  channelRef(ch, token) {
    const D = this.state.data;
    if (!isCustom(D, ch)) return null;
    const head = refChannelOf(D, ch, token);
    if (!head) return null;
    const { rows, resolve } = this.channelRows(head.cid);
    const k = resolve(head.local);
    return { cid: head.cid, k, row: k ? rows.find(r => r.k === k) || null : null };
  }

  refResolver(ch, rows) {
    const local = this.calcResolver(rows);
    if (!isCustom(this.state.data, ch)) return local;
    return token => {
      const x = this.channelRef(ch, token);
      return x ? (x.k ? x.cid + ":" + x.k : null) : local(token);
    };
  }

  channelValues(ch, scenIn, src) {
    const refs = new Map(), runs = {};
    return (token, i) => {
      if (!refs.has(token)) refs.set(token, this.channelRef(ch, token));
      const x = refs.get(token);
      if (!x || !x.k) return null;
      const g = runs[x.cid] || (runs[x.cid] = this.run(x.cid, scenIn, null, src));
      return g[x.k] ? g[x.k][i] : null;
    };
  }

  runOne(ch, scenIn, hold, src) {
    const D = this.state.data;
    const conf = D && D.channels ? D.channels[ch] : null;
    if (!D || !conf || !Array.isArray(D.months)) return { __rows: [], __meta: { sizes: {}, fit: {} } };
    const actual = !!(src && src.actual);
    const I = (actual ? null : ((src && src.inputs) ? src.inputs[ch] : (this.state.inputs && this.state.inputs[ch]))) || {};
    const n = D.months.length;
    const cut = (src && typeof src.cutoffIdx === "number") ? src.cutoffIdx : this.cutIdx();
    const rows = this.mergeDraftRows(buildRows(ch, D), ch);
    const scen = Object.assign({}, (scenIn && scenIn.__byCh && scenIn.__byCh[ch]) ? scenIn.__byCh[ch] : (scenIn || {}));
    if (channelHasSources(ch)) rows.filter(readsSourceSpend).forEach(r => nativeLevers(r).forEach(l => { scen[l] = 0; }));
    const meta = { sizes: {}, fit: {}, rates: {}, rateKinds: {}, rateSources: {}, legacy: {}, guards: {}, flags: {}, flagCount: {}, changed: {}, auto: {}, methods: {}, guardIns: {} };
    const ctx = {
      D, conf, n, cut, scen, meta, src,
      rov: (src && src.rov) ? src.rov : this.state.rov,
      cohortInput: (src && src.cohortInput) ? src.cohortInput : this.state.cohortInput,
      cohortGuards: src && src.cohortGuards !== undefined ? src.cohortGuards : this.state.cohortGuards,
      cohortAuto: src && src.cohortAuto !== undefined ? src.cohortAuto : this.state.cohortAuto
    };
    const stored = (r, i) => {
      const s = storedSeries(ch, D, r) || actualSeriesOf(conf, r.bindKey);
      return s ? s[i] : null;
    };
    const input = (r, i) => {
      const k = r.ed || r.k;
      if (hold && hold.keys && hold.keys.indexOf(k) >= 0 && i >= hold.range[0] && i <= hold.range[1]) {
        const v = hold.vals[k];
        return Array.isArray(v) ? v[i] : v;
      }
      return Array.isArray(I[k]) ? I[k][i] : stored(r, i);
    };
    const res = evaluateRows(rows, {
      n,
      cut,
      resolve: this.refResolver(ch, rows),
      input,
      scenario: (lever, i) => (!actual && i > cut ? 1 + ((scen && scen[lever]) || 0) : 1),
      functions: this.modelFunctions(ch, ctx),
      override: actual && !isCombined(D, ch) ? stored : undefined,
      members: this.memberCells(ch, rows, scenIn, src),
      external: isCustom(D, ch) ? this.channelValues(ch, scenIn, src) : undefined
    });
    if (!meta.mix && (PRODUCT_MIX[ch] || []).length) this.blendedCogs(ch, null, ctx);
    const g = res.values;
    if (src && src.truncate) Object.keys(g).forEach(k => { for (let i = cut + 1; i < n; i++) g[k][i] = null; });
    meta.skipped = res.skipped;
    meta.overwrite = res.overwrite;
    meta.cyclic = res.cyclic;
    g.__meta = meta;
    g.__rows = rows;
    return g;
  }

  memberCells(ch, rows, scenIn, src) {
    const members = membersOf(this.state.data, ch);
    if (!members.length) return undefined;
    const runs = members.map(m => this.run(m, scenIn, null, src));
    const pick = runs.map(p => this.calcResolver(p.__rows || []));
    const local = {};
    rows.forEach(r => { local[r.k] = keyLocal(r.key) || r.k; });
    return (id, i) => runs.map((p, m) => {
      const mid = pick[m](local[id] || id);
      return mid && p[mid] ? p[mid][i] : null;
    });
  }

  modelFunctions(ch, ctx) {
    const cache = {};
    const once = (key, make) => (cache[key] || (cache[key] = { v: make() })).v;
    const lever = name => 1 + ((ctx.scen && ctx.scen[name]) || 0);
    const scale = ctx.src && ctx.src.actual ? null : this.sourceScale(ch, ctx.scen);
    const sourceSum = (field, i, keep = null) => {
      let acc = null;
      (SESSION_SOURCES[ch] || []).forEach((s, si) => {
        if (keep && !keep(s)) return;
        const v = this.sourceVal(ch, si, field, i, scale);
        if (typeof v === "number") acc = (acc === null ? 0 : acc) + v;
      });
      return acc;
    };
    return {
      SOURCES: c => {
        const field = SOURCE_FIELD[c.text(c.args[0])];
        const keep = c.args.length > 1 ? SOURCE_FILTER[String(c.text(c.args[1]) || "").trim().toLowerCase()] : null;
        if (!field || (c.args.length > 1 && !keep)) return null;
        return sourceSum(field, c.i, keep);
      },
      SOURCE_RATIO: c => {
        const num = SOURCE_FIELD[c.text(c.args[0])], den = SOURCE_FIELD[c.text(c.args[1])];
        if (c.i <= ctx.cut || !num || !den) return null;
        return once("ratio|" + num + "|" + den, () => {
          for (let t = ctx.cut; t >= 0; t--) {
            const a = sourceSum(den, t), s = sourceSum(num, t);
            if (typeof a === "number" && a > 0 && typeof s === "number") return s / a;
          }
          return null;
        });
      },
      COHORT_ORDERS: c => {
        const b = c.text(c.args[0]);
        return once("cohort|" + b, () => this.cohortOrders(ch, b, c.series(c.args[1]), ctx))[c.i];
      },
      BASE_ORDERS: c => {
        const b = c.text(c.args[0]);
        return once("base|" + b, () => this.baseOrders(b, c.series(c.args[1]), lever(c.text(c.args[2])), ctx))[c.i];
      },
      PRODUCT_COGS_PCT: c => {
        if (!(PRODUCT_MIX[ch] || []).length || c.value(c.args[0]) === null) return null;
        return once("cogs", () => this.blendedCogs(ch, c.series(c.args[0]), ctx))[c.i];
      }
    };
  }

  cohortOrders(ch, b, entrants, ctx) {
    const { D, conf, n, cut, meta, rov, cohortInput, cohortGuards, cohortAuto } = ctx;
    const blk = conf[b] || {};
    const cohorts = Array.isArray(blk.cohorts) ? blk.cohorts : [];
    const cutoffYm = D.months[cut];
    const parseCohortYm = label => {
      if (label === null || label === undefined) return NaN;
      if (typeof label === "number") return label;
      const s = String(label).trim();
      if (/^\d{6}$/.test(s)) return +s;
      const m = /^(\d{4})[-/]?(\d{1,2})$/.exec(s);
      if (m) return (+m[1]) * 100 + (+m[2]);
      return +s;
    };
    const sizes = cohorts.map((c, j) => {
      const own = c && c.size != null ? c.size : null;
      if (j === 0) return own;
      const ym = parseCohortYm(c && c.label);
      if (isNaN(ym)) return own;
      const birthIdx = D.months.indexOf(ym);
      if (birthIdx >= 0) return birthIdx <= cut ? own : (typeof entrants[birthIdx] === "number" ? entrants[birthIdx] : null);
      return cutoffYm != null && ym <= cutoffYm ? own : null;
    });
    const base = {
      months: D.months,
      cut,
      cohorts,
      sizes,
      override: (j, t) => rov[this.rovKey(ch, b, j, t)],
      ruleFor: label => resolveCohortRule(cohortInput, ch, b, label),
      explain: true
    };
    let filled;
    if (cohortGuards) {
      const guardIn = Object.assign(base, {
        channelRule: resolveCohortRule(cohortInput, ch, b),
        scope: (cohortGuards.scopes || {})[cohortGuardKey(ch, b)] || null,
        constants: cohortGuards.constants || null,
        engine: cohortGuards.engine || null,
        cohortSet: label => !!(cohortInput || {})[cohortInputKey(ch, b, label)]
      });
      const tabRule = (cohortInput || {})[cohortInputKey(ch, b)];
      if (!usesFlatTail(guardIn.engine) && !tabRule) {
        const stored = (cohortAuto || {})[cohortGuardKey(ch, b)];
        const live = stored ? null : this.autoPickFor(ch, b, guardIn);
        const pick = stored || live;
        meta.auto[b] = { rule: pick.rule, accuracy: typeof pick.accuracy === "number" ? pick.accuracy : null, tested: stored ? typeof stored.accuracy === "number" : live.tested, window: backTestWindow(guardIn) };
        guardIn.channelRule = pick.rule;
        guardIn.ruleFor = label => (cohortInput || {})[cohortInputKey(ch, b, label)] || pick.rule;
      }
      meta.guardIns[b] = guardIn;
      filled = forecastGuardedCohorts(guardIn);
    } else {
      filled = forecastCohortRates(base);
    }
    const legacy = filled.legacy && filled.legacy.on ? filled.legacy : null;
    const out = new Array(n).fill(null);
    for (let t = 0; t < n; t++) {
      for (let j = 0; j < sizes.length; j++) {
        if (legacy && legacy.folded[j]) continue;
        const ratio = filled.rates[j] ? filled.rates[j][t] : null;
        if (ratio === null || sizes[j] === null || sizes[j] === undefined) continue;
        out[t] = (out[t] === null ? 0 : out[t]) + sizes[j] * ratio;
      }
      if (legacy && typeof legacy.orders[t] === "number") out[t] = (out[t] === null ? 0 : out[t]) + legacy.orders[t];
    }
    meta.sizes[b] = sizes;
    meta.rates[b] = filled.rates;
    meta.rateKinds[b] = filled.kinds;
    meta.rateSources[b] = filled.sources || null;
    meta.legacy[b] = legacy;
    meta.guards[b] = filled.guards || null;
    meta.flags[b] = filled.flags || null;
    meta.flagCount[b] = filled.flagCount || 0;
    meta.changed[b] = filled.changed || null;
    meta.methods[b] = filled.methods || null;
    return out;
  }

  autoPickFor(ch, b, guardIn) {
    const cohorts = guardIn.cohorts;
    if (!this._autoCache || this._autoCache.data !== this.state.data) this._autoCache = { data: this.state.data, byCohorts: new WeakMap() };
    let bucket = this._autoCache.byCohorts.get(cohorts);
    if (!bucket) { bucket = {}; this._autoCache.byCohorts.set(cohorts, bucket); }
    const key = [ch, b, guardIn.cut, guardIn.engine || "", JSON.stringify(guardIn.scope || null), JSON.stringify(guardIn.constants || null)].join("§");
    if (!bucket[key]) bucket[key] = pickAutoRule(Object.assign({}, guardIn, { override: undefined, explain: false }));
    return bucket[key];
  }

  cohortBlocks() {
    const D = this.state.data;
    const out = [];
    if (!D || !D.channels) return out;
    Object.keys(D.channels).forEach(ch => {
      const conf = D.channels[ch];
      if (!conf || conf.model !== "cohort" || isCombined(D, ch)) return;
      (channelBlocks(ch, D) || []).forEach(b => {
        if (conf[b] && Array.isArray(conf[b].cohorts)) out.push({ ch, b, cohorts: conf[b].cohorts });
      });
    });
    return out;
  }

  isCurrentDraft() {
    const st = this.state, D = st.data;
    if (!D || !st.cohortGuards || usesFlatTail(st.cohortGuards.engine)) return false;
    return !(D.versionContext && D.versionContext.kind === "published");
  }

  prepareCohortDraft() {
    if (!this.isCurrentDraft()) return;
    const dirty = this.migrateCohortRules();
    const tuned = this.tuneCohortGuards();
    const synced = this.syncAutoChoices();
    if (this.state.canAuthor === false || (!dirty && !synced && !tuned)) return;
    this._pendingDelta.settings = true;
    if (!dirty) return;
    Object.assign(this._pendingDelta, { hasChange: true }, dirty === "rov" ? { rov: true } : null);
    this.markDirty();
  }

  migrateCohortRules() {
    const st = this.state, D = st.data;
    const source = st.cohortInput || {};
    const v3 = usesRetentionChange(st.cohortGuards && st.cohortGuards.engine);
    const withTrend = v3 ? Object.keys(source).filter(k => source[k].trend || source[k].method === "seasonal").length : 0;
    if (!withTrend && !Object.keys(source).some(k => source[k].method === "seasonal" || source[k].method === "fixed")) return false;
    const cohortInput = {};
    Object.keys(source).forEach(k => {
      if (source[k].method === "fixed") return;
      const rule = Object.assign({}, migrateCohortRule(source[k]));
      if (v3) delete rule.trend;
      cohortInput[k] = rule;
    });
    const rov = Object.assign({}, st.rov);
    const overrideInfo = Object.assign({}, st.overrideInfo);
    const at = new Date().toISOString();
    const cut = this.cutIdx();
    const n = D.months.length;
    let converted = false;
    this.cohortBlocks().forEach(({ ch, b, cohorts }) => {
      const tab = source[cohortInputKey(ch, b)];
      cohorts.forEach((co, j) => {
        const label = co && co.label != null ? String(co.label) : "";
        const rule = source[cohortInputKey(ch, b, label)] || tab;
        if (!rule || rule.method !== "fixed") return;
        const pre = /^pre/i.test(label);
        const birth = pre ? -1 : D.months.indexOf(parseCohortYm(label));
        if (!pre && birth < 0) return;
        for (let t = Math.max(cut + 1, birth + 1); t < n; t++) {
          const key = this.rovKey(ch, b, j, t);
          if (rov[key] !== undefined) continue;
          rov[key] = rule.value;
          overrideInfo[key] = { at, by: SYSTEM_ACTOR, note: FIXED_CONVERTED_NOTE };
          converted = true;
        }
      });
    });
    this.setState({ cohortInput, rov, overrideInfo, fixedNote: converted || Object.keys(source).some(k => source[k].method === "fixed"), trendNote: withTrend });
    return converted ? "rov" : true;
  }

  tuneCohortGuards() {
    const st = this.state, D = st.data;
    const guards = st.cohortGuards;
    if (!guards || !usesRetentionChange(guards.engine)) return false;
    const cutYm = D.months[this.cutIdx()];
    const stable = usesSeasonRatio(guards.engine);
    const through = D.months[this.actualCutIdx()];
    const scopes = Object.assign({}, guards.scopes);
    const zero = this.zeroScen(D);
    const seen = {};
    let dirty = false;
    this.cohortBlocks().forEach(({ ch, b }) => {
      const key = cohortGuardKey(ch, b);
      const scope = scopes[key] || {};
      const prior = scope.tuned;
      if (prior && (stable ? prior.through === through : prior.cut === cutYm)) return;
      if (!seen[ch]) seen[ch] = this.run(ch, zero, null).__meta || {};
      const guardIn = seen[ch].guardIns && seen[ch].guardIns[b];
      if (!guardIn) return;
      const tuned = tuneCohortSettings(guardIn);
      const at = new Date().toISOString();
      if (stable) {
        const same = prior && prior.ownHistoryMinMonths === tuned.ownHistoryMinMonths;
        Object.assign(tuned, { through, changedAt: same && prior.changedAt ? prior.changedAt : at });
      }
      scopes[key] = Object.assign({}, scope, { tuned: Object.assign(tuned, { at }) });
      dirty = true;
    });
    if (dirty) this.setState({ cohortGuards: Object.assign({}, guards, { scopes }) });
    return dirty;
  }

  syncAutoChoices() {
    const st = this.state;
    const picks = Object.assign({}, st.cohortAuto);
    const autoChanged = Object.assign({}, st.autoChanged);
    let dirty = false;
    const zero = this.zeroScen(st.data);
    const seen = {};
    this.cohortBlocks().forEach(({ ch, b }) => {
      if ((st.cohortInput || {})[cohortInputKey(ch, b)]) return;
      const key = cohortGuardKey(ch, b);
      if (!seen[ch]) seen[ch] = this.run(ch, zero, null, { cohortAuto: LIVE_AUTO }).__meta || {};
      const live = seen[ch].auto && seen[ch].auto[b];
      if (!live) return;
      const prev = picks[key];
      const accuracy = typeof live.accuracy === "number" ? Math.round(live.accuracy * 1e4) / 1e4 : null;
      if (prev && sameCohortRule(prev.rule, live.rule) && prev.accuracy === accuracy) return;
      picks[key] = { rule: live.rule, accuracy, at: new Date().toISOString() };
      if (prev && !sameCohortRule(prev.rule, live.rule)) autoChanged[key] = { from: { rule: prev.rule, accuracy: prev.accuracy }, to: { rule: live.rule, accuracy } };
      dirty = true;
    });
    if (dirty) this.setState({ cohortAuto: picks, autoChanged });
    return dirty;
  }

  baseOrders(b, entrants, mult, ctx) {
    const { conf, n, cut, meta } = ctx;
    const blk = conf[b] || {};
    const obs = Array.isArray(blk.totalOrders) ? blk.totalOrders : new Array(n).fill(null);
    const carry = this.fitCarry(obs, entrants, cut);
    const raw = carry === null ? null : carry * mult;
    const rFit = raw === null || isNaN(raw) ? null : Math.max(0.01, Math.min(0.99, raw));
    const ent = t => (typeof entrants[t] === "number" ? entrants[t] : 0);
    const out = new Array(n).fill(null);
    for (let t = 0; t < n; t++) {
      if (t <= cut) { out[t] = typeof obs[t] === "number" ? obs[t] : null; continue; }
      if (rFit === null) continue;
      out[t] = (typeof out[t - 1] === "number" ? out[t - 1] * rFit : 0) + ent(t);
    }
    const bt = [];
    if (rFit !== null) {
      for (let t = Math.max(1, cut - 11); t <= cut; t++) {
        if (typeof obs[t - 1] !== "number" || typeof obs[t] !== "number") continue;
        const p = obs[t - 1] * rFit + ent(t);
        bt.push({ i: t, actual: obs[t], pred: p, err: p - obs[t] });
      }
    }
    const mape = bt.length ? bt.reduce((s, x) => s + Math.abs(x.err) / Math.abs(x.actual), 0) / bt.length : 0;
    meta.fit[b] = { r: rFit, mape, backtest: bt, workbook: obs };
    return out;
  }

  blendedCogs(ch, weights, ctx) {
    const { D, n, cut, meta, rov, src } = ctx;
    const cats = PRODUCT_MIX[ch] || [];
    const movMap = (rov && rov.__mov) || this.state.mov || {};
    const run = (inputMap, baseIdx, historyIdx, keyOf, allowNegative, zeroMissing) => forecastMix({
      months: D.months,
      cut,
      cats: cats.map(c2 => ({ name: c2[0], base: c2[baseIdx], history: c2[historyIdx] })),
      override: (ci, t) => movMap[keyOf(ch, ci, t)],
      ruleFor: name => resolveMixRule(inputMap, ch, name),
      cellRuleFor: (name, period) => inputMap[mixInputKey(ch, name, period)] || null,
      weights,
      allowNegative,
      zeroMissing
    });
    const mixFc = run((src && src.mixInput) || this.state.mixInput, 1, 3, (c, ci, t) => this.mixKey(c, ci, t), false, true);
    const cogsFc = run((src && src.cogsInput) || this.state.cogsInput, 2, 4, (c, ci, t) => this.cogsKey(c, ci, t), true, false);
    meta.mix = mixFc;
    meta.cogs = cogsFc;
    const out = new Array(n).fill(null);
    for (let t = 0; t < n; t++) {
      cats.forEach((_, ci) => {
        const mx = mixFc.values[ci][t], cg = cogsFc.values[ci][t];
        if (mx === null || mx === undefined || cg === null || cg === undefined) return;
        out[t] = (out[t] === null ? 0 : out[t]) + mx * cg;
      });
    }
    return out;
  }

  fmt(v, unit) {
    if (typeof v !== "number" || !Number.isFinite(v)) return "—";
    if (unit === "%") return this.numFixed(v * 100, 1) + "%";
    if (unit === "×") return this.numFixed(v, 2);
    if (unit === "#") return Math.abs(v) < 10 && !Number.isInteger(v) ? this.numFixed(v, 2) : Math.round(v).toLocaleString("en-GB");
    return Math.abs(v) >= 1000 ? Math.round(v).toLocaleString("en-GB") : this.numFixed(v, 2);
  }
  isAovRow(r) { return !!r && /(^|_)aov$/.test(r.k); }
  isOrdersRow(r) { return !!r && /(^|_)orders$/.test(r.k); }
  // AOV shows 2dp and forecast orders 1dp so displayed figures multiply back to the displayed sales
  rowFmt(v, r, actual) {
    if (typeof v !== "number" || !Number.isFinite(v)) return "—";
    const fixed = this.rowDp(r);
    if (fixed !== null) return this.dpFmt(v, r.unit, fixed);
    const dp = this.isAovRow(r) ? 2 : (this.isOrdersRow(r) && !actual) ? 1 : -1;
    if (dp < 0) return this.fmt(v, r.unit);
    return v.toLocaleString("en-GB", { minimumFractionDigits: dp, maximumFractionDigits: dp });
  }
  dpFmt(v, unit, dp) {
    const pct = unit === "%";
    return (pct ? v * 100 : v).toLocaleString("en-GB", { minimumFractionDigits: dp, maximumFractionDigits: dp }) + (pct ? "%" : "");
  }
  numFixed(v, digits) {
    return typeof v === "number" && Number.isFinite(v) ? Number.prototype.toFixed.call(v, digits) : "—";
  }
  sym() { return { GBP: "£", EUR: "€", USD: "$", AUD: "$" }[this.state.ccy] || "£"; }
  money(v) {
    if (typeof v !== "number" || !Number.isFinite(v)) return "—";
    const x = Math.abs(v);
    const s = x >= 1e6 ? this.numFixed(x / 1e6, 2) + "m" : x >= 1000 ? this.numFixed(x / 1000, 1) + "k" : this.numFixed(x, 0);
    return (v < 0 ? "−" : "") + this.sym() + s;
  }
  sum(arr, a, b) { let t = 0; if (!arr) return 0; for (let i = a; i <= b; i++) if (typeof arr[i] === "number") t += arr[i]; return t; }
  fyRange(id) {
    const M = this.state.data.months, s = this.state.fyStart, st = this.state;
    const cut = this.cutIdx();
    if (id === "l12") return [Math.max(0, cut - 11), M.length - 1];
    if (id === "custom") {
      let from = st.customFrom, to = st.customTo;
      if (st.version !== "fc_v5") {
        const local = (st.pubView || {})[st.version];
        const pub = (st.pubs || []).find(p => p.id === st.version);
        if (local) {
          from = local[0];
          to = local[1];
        } else if (pub && pub.settings && (pub.settings.viewFrom || pub.settings.viewTo)) {
          from = periodIndex(M, pub.settings.viewFrom);
          to = periodIndex(M, pub.settings.viewTo);
        }
      }
      const a = Math.max(0, Math.min(M.length - 1, from === null || from === undefined ? Math.max(0, cut - 11) : from));
      const b = Math.max(a, Math.min(M.length - 1, to === null || to === undefined ? M.length - 1 : to));
      return [a, b];
    }
    if (id === "all") return [0, M.length - 1];
    const mm = /^fy(\d\d)(\d\d)$/.exec(id);
    const year = mm ? 2000 + (+mm[1]) : null;
    if (!year) return [0, M.length - 1];
    const startYm = year * 100 + s;
    const endM = s === 1 ? 12 : s - 1, endYm = (s === 1 ? year : year + 1) * 100 + endM;
    let a = M.indexOf(startYm), b = M.indexOf(endYm);
    if (a < 0) a = startYm < M[0] ? 0 : M.length - 1;
    if (b < 0) b = endYm > M[M.length - 1] ? M.length - 1 : 0;
    return [Math.min(a, b), Math.max(a, b)];
  }

  edit(ch, key, i, raw, unit) {
    if (this.state.version !== "fc_v5") return;
    const num = parseFloat(String(raw).replace(/[^0-9.\-]/g, ""));
    if (isNaN(num)) return;
    const val = unit === "%" ? num / 100 : num;
    const series = (this.state.inputs[ch] || {})[key];
    const before = Array.isArray(series) ? series[i] : null;
    if (before === val) return;
    const n = this.state.data.months.length;
    this.setState(s => {
      const inputs = Object.assign({}, s.inputs);
      const one = Object.assign({}, inputs[ch]);
      one[key] = Array.isArray(one[key]) ? one[key].slice() : new Array(n).fill(null);
      one[key][i] = val;
      inputs[ch] = one;
      return { inputs };
    });
    const items = [{ kind: "input", ch: ch, key: key, i: i, label: key, period: this.state.data.months[i], before: before, after: val }];
    if (this.isManualInput(ch, key)) items.push({ kind: "structure", ch, label: "manual · " + key, period: this.state.data.months[i], before, after: val });
    this.pushBatch(items, "UI");
  }

  isManualInput(ch, shortKey) {
    const drafts = this.state.fdraft || {};
    return Object.keys(drafts).some(k => drafts[k] && drafts[k].manual && drafts[k].channel === ch && this.draftShortKey(drafts[k]) === shortKey);
  }

  renderVals() {
    let st = this.state;
    if (!st.data || !st.inputs) {
      return { rowH: "34px", rows: [], cols: [], tabs: [], sections: [], channels: [], monthCount: "…", cutoffChip: "Loading", collapseLabel: "Hide controls", exportNote: "", menuBg: "#fff", menuFg: "#4D6389", saveStatus: "", saveStatusFg: "var(--ink-4)", canSave: false, saveLabel: "Save", saveDraft: () => {}, versionShort: "Loading", lockLabel: "", lockNote: "", lockAction: "", scenRailLabel: "Scenario", lockLabel: "Locked", saveStatusNote: "", toggleLock: () => {}, cutoffLabel: "…", channelTitle: "Growth Model", versionChip: "Loading version", sheetList: "", parityLabel: "Loading", parityBg: "#EDF1F8", parityFg: "#4D6389", parityDot: "#C8D4EA", showPlan: true };
    }
    this.syncActualsBindings();
    st = this.state;
    const D = st.data;
    const activePub = (st.pubs || []).find(p => p.id === st.version);
    const cut = (activePub && typeof activePub.cutoffIdx === "number")
      ? activePub.cutoffIdx
      : st.version === "actual" ? this.actualCutIdx() : this.cutIdx();
    const n = D.months.length;
    const chAll = Object.keys(D.channels).filter(c => c !== "all" && D.channels[c]);
    const chBase = baseChannels(D);
    let chSel = (st.chSel || []).filter(c => chAll.indexOf(c) >= 0);
    if (chSel.length !== 1 && chAll.length) chSel = [chAll[0]];
    const ch = chSel.length === 1 ? chSel[0] : "all";
    const isAll = ch === "all";
    const combinedCh = !isAll && isCombined(D, ch);
    const memberRows = combinedCh ? this.memberSourceRows(ch) : null;
    const memberLabels = combinedCh ? membersOf(D, ch).map(m => D.channels[m].label).join(" + ") : "";
    const chScopeLabel = chSel.length && chSel.length < chBase.length
      ? chSel.map(cid => D.channels[cid].label).join(" + ")
      : (chAll.length === 1 ? D.channels[chAll[0]].label : "All channels");
    const conf = isAll
      ? { label: chScopeLabel, model: "group", sheets: "GROUP_SUMMARY · SHP_SUMMARY · AMZ_SUMMARY · TTS_SUMMARY", total: { orders: [], aov: [], sales: [] } }
      : D.channels[ch];
    const cohort = conf.model === "cohort", blocks = channelBlocks(ch, this.state.data || D) || [];
    const zero = this.zeroScen(D);
    const base = this.run(ch, zero);
    const chScen = this.scenFor(ch);
    const scenArg = isAll ? { __byCh: st.scenByCh } : chScen;
    const scen = this.run(ch, scenArg);
    const ROWS = base.__rows || [];

    // ---- versions available to every comparison ----
    const VERSIONS = this.workingVersionEntries()
     .concat(st.pubs.map(p => ({ id: p.id, label: p.name + " · published " + p.at, short: p.name, type: "FORECAST", grp: "published", kind: "model" })))
     .concat([
      { id: "actual", label: "Actual · bound data", short: "Actual", type: "ACTUAL", grp: "system", kind: "file", truncate: true },
      { id: "fit", label: "System fit · trend and seasonality forecast", short: "System fit", type: "SYSTEM_FIT", grp: "system", kind: "model" },
      { id: "scen_session", label: "Scenario · this session", short: "Scenario · session", type: "SCENARIO", grp: "scenario", kind: "model" }
     ])
     .concat(st.savedScens.map(sc => ({ id: sc.id, label: "Scenario · " + sc.name, short: sc.name, type: "SCENARIO", grp: "scenario", kind: "model" })))
     .filter(v => st.shadowed.indexOf(v.id) < 0);
    const pristineInputs = {};
    Object.keys(D.channels).forEach(cid => {
      const c2 = D.channels[cid], one = {};
      buildRows(cid, D).forEach(r => {
        if (!r.ed) return;
        const s2 = r.store === "inputs" ? actualSeriesOf(c2, r.bindKey) : storedSeries(cid, D, r);
        one[r.ed] = Array.isArray(s2) ? s2.slice() : D.months.map(() => null);
      });
      pristineInputs[cid] = one;
    });
    const spec = id => {
      if (id === "fc_v5") return { kind: "model", inputs: st.inputs, rov: Object.assign({ __mov: st.mov }, st.rov), cohortInput: st.cohortInput, cohortGuards: st.cohortGuards, mixInput: st.mixInput, cogsInput: st.cogsInput, scen: zero };
      if (id === "fit") {
        const fit = this.systemFit(this.cutIdx(), pristineInputs);
        return { kind: "model", inputs: fit.inputs, rov: {}, cohortInput: fit.cohortInput, cohortGuards: st.cohortGuards, mixInput: fit.mixInput, cogsInput: fit.mixInput, scen: zero };
      }
      if (id === "scen_session") return { kind: "model", inputs: st.inputs, rov: st.rov, cohortInput: st.cohortInput, cohortGuards: st.cohortGuards, scen: Object.assign({}, this.scenFor(ch), { __byCh: st.scenByCh }) };
      const pub = st.pubs.find(p => p.id === id);
      if (pub) {
        const pubRov = Object.assign({}, pub.rov || {});
        if (pub.mov && typeof pub.mov === "object") pubRov.__mov = pub.mov;
        return {
          kind: "model",
          inputs: pub.inputs || {},
          rov: pubRov,
          cohortInput: pub.cohortInput || NO_COHORT_INPUT,
          cohortGuards: pub.cohortGuards || null,
          cohortAuto: pub.cohortAuto || NO_COHORT_INPUT,
          mixInput: pub.mixInput || NO_COHORT_INPUT,
          cogsInput: pub.cogsInput || NO_COHORT_INPUT,
          scen: zero,
          cutoffIdx: typeof pub.cutoffIdx === "number" ? pub.cutoffIdx : undefined,
          mov: pub.mov || {}
        };
      }
      const saved = st.savedScens.find(s2 => s2.id === id);
      if (saved) return { kind: "model", inputs: saved.inputs, rov: saved.rov, cohortInput: st.cohortInput, cohortGuards: st.cohortGuards, scen: Object.assign({}, saved.scenByCh[ch] || zero, { __byCh: saved.scenByCh }) };
      if (id === "scen_spend20") return { kind: "model", inputs: st.inputs, rov: st.rov, cohortInput: st.cohortInput, cohortGuards: st.cohortGuards, scen: Object.assign({}, zero, { spend: 0.2 }) };
      if (id === "actual") return { kind: "file", truncate: true, cutoffIdx: this.actualCutIdx() };
      return { kind: "file", truncate: false };
    };
    const runCache = {};
    const runFor = (id, cid) => {
      const key = id + "|" + cid;
      if (runCache[key]) return runCache[key];
      const sp = spec(id);
      const g = this.run(cid, sp.scen, null, { inputs: sp.inputs, rov: sp.rov, cohortInput: sp.cohortInput, cohortGuards: sp.cohortGuards, cohortAuto: sp.cohortAuto, mixInput: sp.mixInput, cogsInput: sp.cogsInput });
      runCache[key] = g;
      return g;
    };
    const fileSeries = (cid, blkId, metric) => {
      const c2 = D.channels[cid];
      if (!c2) return [];
      if (metric === "new_cust") {
        const r2 = acqRowOf(c2, "new_cust");
        return r2 && Array.isArray(r2.values) ? r2.values : [];
      }
      const src2 = c2[blkId];
      if (!src2) return [];
      if (metric === "orders") return Array.isArray(src2.totalOrders) ? src2.totalOrders : [];
      if (metric === "aov") return Array.isArray(src2.aov) ? src2.aov : [];
      return Array.isArray(src2.sales) ? src2.sales : [];
    };
    const seriesFor = (id, cid, blkId, metric) => {
      const sp = spec(id);
      if (sp.kind === "file") {
        const arr = fileSeries(cid, blkId, metric).slice();
        if (sp.truncate) for (let i = (typeof sp.cutoffIdx === "number" ? sp.cutoffIdx : cut) + 1; i < arr.length; i++) arr[i] = null;
        return arr;
      }
      const g = runFor(id, cid);
      if (metric === "new_cust") return g.new_cust || [];
      return g[blkId + "_" + (metric === "orders" ? "orders" : metric === "aov" ? "aov" : "sales")] || [];
    };



    let worst = 0, worstLabel = "";
    const sumFile = key => {
      const out = new Array(n).fill(null);
      Object.keys(D.channels).forEach(cid => {
        const tot = D.channels[cid] && D.channels[cid].total;
        const arr = tot && Array.isArray(tot[key]) ? tot[key] : null;
        if (!arr) return;
        for (let i = 0; i < n; i++) if (typeof arr[i] === "number") out[i] = (out[i] === null ? 0 : out[i]) + arr[i];
      });
      return out;
    };
    const emptySeries = new Array(n).fill(null);
    const fileTot = isAll ? sumFile("sales") : ((conf.total && conf.total.sales) || emptySeries);
    const fileOrd = isAll ? sumFile("orders") : ((conf.total && conf.total.orders) || emptySeries);
    for (let i = 0; i <= cut; i++) {
      const pairs = [[base.tot_sales ? base.tot_sales[i] : (base[blocks[0] + "_sales"] || [])[i], fileTot[i], "total sales"],
                     [base.tot_orders ? base.tot_orders[i] : (base[blocks[0] + "_orders"] || [])[i], fileOrd[i], "orders"]];
      pairs.forEach(p => {
        const a = p[0], b = p[1];
        if (typeof a !== "number" || typeof b !== "number" || !b) return;
        const d = Math.abs(a - b) / Math.abs(b);
        if (d > worst) { worst = d; worstLabel = p[2]; }
      });
    }
    const fit = (base.__meta && base.__meta.fit && (base.__meta.fit[blocks[0]] || base.__meta.fit.subs)) || null;
    const useParity = cohort || isAll;
    const parityOk = useParity ? worst < 0.005 : (fit ? fit.mape < 0.05 : true);
    const fitBlockName = BL[blocks[0]] || "Subs";
    const parityLabel = useParity
      ? (parityOk ? "Parity ±" + this.numFixed(worst * 100, 3) + "%" : "Parity drift " + this.numFixed(worst * 100, 2) + "% · " + worstLabel)
      : "MAPE " + (fit && fit.mape != null ? this.numFixed(fit.mape * 100, 2) : "—") + "%";

    const fyTag = y => st.fyStart === 1 ? "FY-" + String(y).slice(2) : "FY-" + String(y).slice(2) + "/" + String(y + 1).slice(2);
    const rr = this.fyRange(st.range), ra = rr[0];
    const rb = rr[1];
    const fyStart = st.fyStart;
    const fyOf = ym => { const y = Math.floor(ym / 100), m = ym % 100; return m >= fyStart ? y : y - 1; };
    const fyLabel = ym => fyTag(fyOf(ym));
    const qOf = ym => Math.floor((((ym % 100) - fyStart) + 12) % 12 / 3) + 1;
    const buckets = [];
    if (st.gran === "month") {
      for (let i = ra; i <= rb; i++) buckets.push({ label: ml(D.months[i]), idxs: [i] });
    } else {
      const seen = {};
      for (let i = ra; i <= rb; i++) {
        const ym = D.months[i];
        const key = st.gran === "year" ? fyLabel(ym) : "Q" + qOf(ym) + " " + fyLabel(ym).replace("FY-", "");
        if (!seen[key]) { seen[key] = { label: key, idxs: [] }; buckets.push(seen[key]); }
        seen[key].idxs.push(i);
      }
    }
    const colW = st.gran === "month" ? 78 : st.gran === "quarter" ? 94 : 110;
    const cols = buckets.map(bk => {
      const allActual = bk.idxs.every(i => i <= cut), anyActual = bk.idxs.some(i => i <= cut);
      return {
        i: bk.idxs[0], idxs: bk.idxs, label: bk.label, single: bk.idxs.length === 1,
        range: st.gran === "month" ? "" : ml(D.months[bk.idxs[0]]) + (bk.idxs.length > 1 ? " to " + ml(D.months[bk.idxs[bk.idxs.length - 1]]) : "") + " · " + bk.idxs.length + (bk.idxs.length === 1 ? " month" : " months"),
        bg: allActual ? "#EDF1F8" : anyActual ? "#F3F7FC" : "#FFFFFF",
        fg: allActual ? "#4D6389" : "#08234C"
      };
    });
    const rowMeta = {}; ROWS.forEach(r => { rowMeta[r.k] = r; });
    const sumIdx = (arr, idxs) => sumCells(idxs.map(i => (arr ? arr[i] : null)));
    const aggVal = (grid, rk, idxs) => this.periodValue(grid, rk, idxs);

    const verOf = id => VERSIONS.find(v => v.id === id) || VERSIONS[0];
    const gridFor = (id, cid) => {
      const sp = spec(id);
      if (sp.kind === "model") return this.run(cid, sp.scen, null, { inputs: sp.inputs, rov: sp.rov, cohortInput: sp.cohortInput, cohortGuards: sp.cohortGuards, cohortAuto: sp.cohortAuto, mixInput: sp.mixInput, cogsInput: sp.cogsInput });
      const fileSrc = { actual: true, truncate: !!sp.truncate, inputs: pristineInputs, cutoffIdx: sp.cutoffIdx };
      if (cid === "all") return this.runGroup(this.chIds().map(c3 => gridFor(id, c3)));
      return D.channels[cid] ? this.run(cid, null, null, fileSrc) : {};
    };
    const cohortChannelIds = Object.keys(D.channels || {}).filter(cid => cid !== "all" && D.channels[cid] && D.channels[cid].model === "cohort");
    const flagCountsOf = id => {
      const sp = spec(id);
      if (sp.kind !== "model" || !sp.cohortGuards) return [];
      return cohortChannelIds.reduce((acc, cid) => {
        const meta = gridFor(id, cid).__meta || {};
        channelBlocks(cid, D).forEach(b => {
          const count = meta.flagCount ? meta.flagCount[b] || 0 : 0;
          if (count) acc.push({ cid, b, count, label: (D.channels[cid].label || channelCode(cid)) + " " + (BL[b] || b) + " cohorts" });
        });
        return acc;
      }, []);
    };
    const flagTotal = list => list.reduce((a, x) => a + x.count, 0);
    const flagListOf = id => {
      const sp = spec(id);
      if (sp.kind !== "model" || !sp.cohortGuards) return [];
      const pub = (st.pubs || []).find(p => p.id === id);
      const reviews = (pub ? pub.flagReviews : st.flagReviews) || {};
      const out = [];
      cohortChannelIds.forEach(cid => {
        const meta = gridFor(id, cid).__meta || {};
        channelBlocks(cid, D).forEach(b => {
          const flags = meta.flags ? meta.flags[b] : null;
          const rates = meta.rates ? meta.rates[b] : null;
          const legacy = meta.legacy ? meta.legacy[b] : null;
          if (!flags || !rates) return;
          flags.forEach((row, j) => (row || []).forEach((f, t) => {
            if (!f || !f.length || (legacy && legacy.folded[j])) return;
            const key = cellReviewKey(cid, b, j, t);
            const value = rates[j] ? rates[j][t] : null;
            const rules = flagRulesOf(f);
            const accepted = reviewHolds(reviews[key], value, rules);
            const reopened = accepted ? null : reviewReopened(reviews[key], value, rules);
            out.push({ key, cid, b, j, t, value, flags: f, review: accepted ? reviews[key] : null, accepted, reopened: reopened ? reopenText(reopened) : "" });
          }));
        });
      });
      return out;
    };
    const isActual = st.version === "actual";
    const isSysFit = st.version === "fit";
    const sysLocked = isActual || isSysFit;
    const locked = sysLocked || !!st.locks[st.version];
    const isDraft = st.version === "fc_v5" && !locked;
    const unsaved = this.hasUnsavedChanges();
    const unsavedCount = unsaved ? (st.log || []).filter(l => (l.seq || 0) > (st.clSavedSeq || 0)).length : 0;
    const canDropMonth = isDraft && this.forecastMonthsRemovable() > 0;
    const scenActive = Object.keys(zero).some(k => chScen[k] !== 0);
    const planGrid = scenActive ? scen : (isDraft ? base : gridFor(st.version, ch));
    const cmpOn = st.cmpVersion !== "none";
    const cmpGrid = cmpOn ? gridFor(st.cmpVersion, ch) : null;
    const sel = st.cmpSel;
    const showAbs = cmpOn && sel.abs, showPct = cmpOn && sel.pct, showVal = !cmpOn || sel.value;
    const lines = (showVal ? 1 : 0) + (showAbs ? 1 : 0) + (showPct ? 1 : 0);
    const deltaMode = cmpOn && !sel.value;
    const versionRec = VERSIONS.find(v => v.id === st.version) || VERSIONS[2];
    const visible = ROWS.filter(r => !r.hide);
    const SEC_ORDER = ["acq", "subs", "otp", "total", "pl", "kpi"];
    const BAND_OF = { acq: "acq", subs: "rev", otp: "rev", total: "rev", pl: "pl", kpi: "kpi" };
    const BAND_LABEL = { acq: "Acquisition", rev: "Revenue", pl: "Profit", kpi: "Other" };
    const visibleSorted = this.ordered(visible, SEC_ORDER, ch).filter(r => !this.cfgOf(r.k, ch).hide);
    let lastSec = null;
    const secsShown = {};
    visible.forEach(r => { secsShown[BAND_OF[r.sec] || r.sec] = 1; });
    const multiSec = Object.keys(secsShown).length > 1;
    const typedResolve = this.rowTokenResolver(ROWS);
    // formulas name drivers by key tail (gross_sales, shipping_revenue); the grid rows use short keys
    const tailRows = {};
    ROWS.forEach(r => { const tail = String(r.key || "").split(".").pop(); if (tail) (tailRows[tail] = tailRows[tail] || []).push(r.k); });
    const explainResolve = t => {
      const k = typedResolve(t);
      if (ROWS.some(x => x.k === k)) return k;
      const c = tailRows[t];
      return c ? (c.find(x => x.indexOf("tot_") === 0) || c[0]) : k;
    };
    const planCellKey = (k, ci) => "plan:" + k + ":" + ci;
    const monthGrain = st.gran === "month";
    // Quarter and Year cells are read-only; the card shows how the months roll up into the figure
    const rollExplain = (r, c, cellShown) => {
      const g = planGrid, idxs = c.idxs;
      const allActual = idxs.every(i => i <= cut);
      const nameOf = k => (rowMeta[k] ? rowMeta[k].name : k);
      const fmtAt = (row, v, actual) => row.unit === "%" && this.rowDp(row) === null && typeof v === "number" && Number.isFinite(v) ? this.numFixed(v * 100, 2) + "%" : this.rowFmt(v, row, actual);
      const shown = cellShown === "—" ? cellShown : fmtAt(r, aggVal(g, r.k, idxs), allActual);
      const monthVal = i => { const v = (g[r.k] || [])[i]; return typeof v !== "number" || !Number.isFinite(v) ? null : v; };
      const rows = idxs.map(i => ({ tone: i <= cut ? "actual" : "forecast", label: ml(D.months[i]), value: monthVal(i) === null ? "—" : fmtAt(r, monthVal(i), i <= cut) }));
      const mode = totalsModeOf(rowMeta[r.k]);
      let steps;
      if (mode === "no_totals") {
        steps = [r.name + " has no quarter or year total", "= " + shown];
      } else if (mode === "formula") {
        const resolveTotals = this.calcResolver(g.__rows || ROWS);
        const totalsFormula = String(rowMeta[r.k].totalsFormula || "");
        const refValue = id => totalsModeOf(rowMeta[id]) === "no_totals" ? sumIdx((g.__raw || g)[id], idxs) : aggVal(g, id, idxs);
        const swap = f => totalsFormula.replace(/[A-Za-z_][A-Za-z0-9_.]*/g, t => { const id = resolveTotals(t); return id ? f(id) : t; })
          .replace(/\s*\*\s*/g, " × ").replace(/\s*\/\s*/g, " ÷ ");
        steps = [r.name + " = " + swap(nameOf), "= " + swap(id => rowMeta[id] ? fmtAt(rowMeta[id], refValue(id), allActual) : "—") + " = " + shown];
      } else {
        const parts = rows.filter(x => x.value !== "—").map(x => x.value);
        steps = [r.name + " = sum of the " + idxs.length + (idxs.length === 1 ? " month" : " months"), "= " + (parts.length ? parts.join(" + ") : "—") + " = " + shown];
      }
      const src = this.srcOf(r);
      const tokenRe = /[A-Za-z_][A-Za-z0-9_.]*/g;
      const basis = src === "input"
        ? "Each month is an input: actual to the cutoff, forecast input after it."
        : String(r.formula || "").trim()
          ? "Each month: " + (src === "formula" ? r.name + " = " : "") + String(r.formula).trim()
            .replace(tokenRe, t => { if (FN.indexOf(t) >= 0) return t; const row = ROWS.find(x => x.k === explainResolve(t)); return row ? row.name : t; })
            .replace(/\s*\*\s*/g, " × ").replace(/\s*\/\s*/g, " ÷ ")
          : "";
      if (basis) steps.push(basis);
      const empty = shown === "—" ? "No value in this period yet, the months above are empty. " : "";
      return { title: r.name + " · " + c.label, result: shown, rows, steps, note: empty + c.range + ". Blue = actual month, amber = forecast month.", highlights: [] };
    };
    const explainFormula = (r, c, ci, shown, skipNote) => {
      const formula = String(r.formula || "").trim();
      const tokenRe = /[A-Za-z_][A-Za-z0-9_.]*/g;
      const opOf = t => {
        if (FN.indexOf(t) >= 0) return null;
        const k = explainResolve(t);
        const row = ROWS.find(x => x.k === k);
        return row && row.k !== r.k ? row : null;
      };
      const ops = [];
      (formula.match(tokenRe) || []).forEach(t => { const o = opOf(t); if (o && ops.indexOf(o) < 0) ops.push(o); });
      if (!ops.length) return null;
      const tone = c.idxs.every(i => i <= cut) ? "actual" : "forecast";
      const valueOf = o => this.rowFmt(aggVal(planGrid, o.k, c.idxs), o, tone === "actual");
      const pretty = s => s.replace(/\s*\*\s*/g, " × ").replace(/\s*\/\s*/g, " ÷ ");
      const named = pretty(formula.replace(tokenRe, t => { const o = opOf(t); return o ? o.name : t; }));
      const steps = [r.name + " = " + named];
      if (c.single) steps.push("= " + pretty(formula.replace(tokenRe, t => { const o = opOf(t); return o ? valueOf(o) : t; })) + " = " + shown);
      return {
        title: r.name + " · " + c.label,
        result: shown,
        rows: ops.map(o => ({ tone, label: o.name, sub: o.key, value: valueOf(o) })),
        steps,
        note: [c.single ? "" : "Quarter and year figures follow each driver's quarter and year totals setting.", skipNote || ""].filter(Boolean).join(" "),
        highlights: ops.map(o => ({ key: planCellKey(o.k, ci), tone }))
      };
    };
    const explainOverwrite = (r, c, ci, shown, ow) => {
      const formula = String(r.overwrite || "").trim();
      const partRe = /"[^"]*"|[A-Za-z_][A-Za-z0-9_.]*/g;
      const opOf = t => {
        if (t.charAt(0) === "\"" || FN.indexOf(t) >= 0 || isOverwriteInput(t)) return null;
        const row = ROWS.find(x => x.k === explainResolve(t));
        return row && row.k !== r.k ? row : null;
      };
      const ops = [];
      (formula.match(partRe) || []).forEach(t => { const o = opOf(t); if (o && ops.indexOf(o) < 0) ops.push(o); });
      const input = this.rowFmt(ow.input, r, true);
      const valueOf = o => this.rowFmt(aggVal(planGrid, o.k, c.idxs), o, true);
      const swap = f => formula.replace(partRe, t => isOverwriteInput(t) ? f(null) : (opOf(t) ? f(opOf(t)) : t))
        .replace(/\s*\*\s*/g, " × ").replace(/\s*\/\s*/g, " ÷ ");
      const steps = [r.name + " = " + swap(o => (o ? o.name : OVERWRITE_INPUT)), "= " + swap(o => (o ? valueOf(o) : input)) + " = " + shown];
      if (!ow.applied) steps.push("The formula has no result this month, so the input " + input + " is used.");
      return {
        title: r.name + " · " + c.label,
        result: shown,
        rows: [{ tone: "actual", label: OVERWRITE_INPUT, sub: "input value", value: input }].concat(ops.map(o => ({ tone: "actual", label: o.name, sub: o.key, value: valueOf(o) }))),
        steps,
        note: "Overwrite formula · recalculates the actual months up to the cutoff.",
        highlights: ops.map(o => ({ key: planCellKey(o.k, ci), tone: "actual" }))
      };
    };
    const canAddDriver = isDraft && !isAll && !!st.canAuthor;
    const driverUsedBy = target => {
      const self = [target.k, target.key, keyLeaf(target.key)];
      const refs = f => (String(f || "").match(/[A-Za-z_][A-Za-z0-9_.]*/g) || []).some(t => self.indexOf(t) >= 0);
      return ROWS.filter(o => o !== target && ((o.src === "formula" && refs(o.formula)) || (o.totalsMode === "formula" && refs(o.totalsFormula)))).map(o => o.name);
    };
    const rowsOut = [];
    visibleSorted.forEach(r => {
      const bandKey = BAND_OF[r.sec] || r.sec;
      if (multiSec && bandKey !== lastSec) {
        rowsOut.push({
          isBand: 1, hasTag: false, cursor: "default", name: (BAND_LABEL[bandKey] || SECTION_LABEL[r.sec] || r.sec) + (bandKey === "kpi" ? " KPIs - for context only" : ""), unit: "", src: "",
          nameBg: "#E4EBF7", nameFg: "#08234C", fw: 600, size: "10.5px", ls: "0.1em", tt: "uppercase",
          labelOverflow: "visible", labelClip: "clip", indent: "10px", cellTint: "",
          topBorder: lastSec ? "1px solid #C8D4EA" : "1px solid transparent",
          onClick: null, onHover: null, onLeave: null, onSrc: null, srcTitle: "", srcFg: "#4D6389", srcBg: "transparent", srcCursor: "default",
          cells: cols.map(() => ({ isText: true, isInput: false, text: "", parts: [], deltas: [], bg: "#E4EBF7", fg: "#4D6389", fw: 400, edge: "1px solid transparent", onChange: null, onPaste: null }))
        });
      }
      const topBorder = "1px solid transparent";
      lastSec = bandKey;
      const isFormulaRow = this.srcOf(r) === "formula";
      const cfg = this.cfgOf(r.k, ch), cfgBg = this.cfgBg(cfg.bg);
      const numFw = (r.total || cfg.numBold) ? 600 : 400;
      const cells = cols.map((c, ci) => {
        const actual = c.idxs.every(i => i <= cut);
        const v = aggVal(planGrid, r.k, c.idxs);
        // a driver converted to formula or binding stops being typed
        const inputCell = !!r.ed && this.srcOf(r) === "input" && (!actual || !!r.manual) && isDraft && monthGrain && c.single && !scenActive && !deltaMode;
        const parts = [];
        if (showVal) parts.push({ text: this.rowFmt(v, r, actual), fg: v === null ? "#8094B5" : "#08234C", fw: numFw, size: "12.5px" });
        if (showAbs || showPct) {
          const bv = aggVal(cmpGrid, r.k, c.idxs);
          const bad = v === null || v === undefined || bv === null || bv === undefined;
          const d = bad ? null : v - bv;
          const rdp = this.rowDp(r);
          const fine = this.isAovRow(r) || this.isOrdersRow(r) || rdp !== null;
          const tiny = bad ? false : rdp !== null ? Math.abs(r.unit === "%" ? d * 100 : d) < 0.5 * Math.pow(10, -rdp) : (r.unit === "%" ? Math.abs(d) < 0.0005 : this.isAovRow(r) ? Math.abs(d) < 0.005 : this.isOrdersRow(r) ? Math.abs(d) < 0.05 : r.unit === "£" ? Math.abs(d) < 0.5 : Math.abs(d) < 0.005);
          const dfg = (bad || tiny) ? "#8094B5" : this.changeFg(d, cfg.inverse);
          const dFmt = x => fine ? this.rowFmt(x, r, actual) : r.unit === "£" ? Math.round(x).toLocaleString("en-GB") : this.fmt(x, r.unit);
          if (showAbs) parts.push({ text: (bad || tiny) ? "—" : (d >= 0 ? "+" : "−") + dFmt(Math.abs(d)), fg: dfg, fw: 500, size: "11px" });
          if (showPct) parts.push({ text: (bad || tiny || !bv) ? "—" : (d >= 0 ? "+" : "−") + this.numFixed(Math.abs((d / bv) * 100), 1) + "%", fg: dfg, fw: 500, size: "11px" });
        }
        const shown = parts.length ? parts[0].text : "—";
        const skipNote = showVal && v !== null ? skippedNote(planGrid.__meta && planGrid.__meta.skipped, r.k, c.idxs) : "";
        const ovr = isDraft && !!st.bound.find(o => o.ch === ch && o.key === r.ed && o.i === c.i);
        const commit = inputCell ? (raw => this.edit(ch, r.ed, c.i, raw, r.unit)) : null;
        const ow = r.overwrite && monthGrain && c.single ? (((planGrid.__meta && planGrid.__meta.overwrite) || {})[r.k] || [])[c.i] : null;
        return {
          cellKey: planCellKey(r.k, ci),
          explain: (!showVal || inputCell) ? null : ow ? (() => explainOverwrite(r, c, ci, shown, ow)) : monthGrain ? (isFormulaRow && v !== null && v !== undefined ? (() => explainFormula(r, c, ci, shown, skipNote)) : null) : (() => rollExplain(r, c, shown)),
          isInput: inputCell, isText: !inputCell, text: shown, parts: parts, deltas: parts.slice(1), ovr: ovr, skipNote,
          fg: parts.length ? parts[0].fg : "#8094B5", fw: numFw,
          bg: actual ? (ovr ? "#E3F3FC" : "#EDF1F8") : (inputCell ? "#FFFDEB" : "#FBFCFE"),
          onCommit: commit,
          onChange: commit,
          onPaste: inputCell ? (e => { const txt = e.clipboardData && e.clipboardData.getData("text"); if (txt && this.pasteRow(ch, r.ed, c.i, r.unit, txt, r.name)) e.preventDefault(); }) : null
        };
      });
      const link = this.memberLink(r, memberRows);
      const sourceFormula = !link && formulaReadsSources(r);
      const eSrc = link ? link.src : sourceFormula ? "source" : this.srcOf(r);
      const opens = r.opens || (link && link.opens) || (sourceFormula ? "source" : null);
      const opensSrc = link ? link.src : r.src;
      rowsOut.push({
        name: r.name, src: r.manual ? "manual" : eSrc, unit: r.unit === "£" ? this.sym() : r.unit,
        fw: (cfg.bold || r.total) ? 600 : 400, topBorder,
        indent: (14 + cfg.indent * 16) + "px",
        hasTag: true, cursor: opens ? "pointer" : "default", size: "12.5px", ls: "0", tt: "none", nameFg: "var(--ink)",
        labelOverflow: "hidden", labelClip: "ellipsis",
        onHover: e => {
          const x = e && e.clientX ? e.clientX : 0, y = e && e.clientY ? e.clientY : 0;
          if (st.hoverRow !== r.k || st.hoverX !== x) this.setState({ hoverRow: r.k, hoverX: x, hoverY: y });
        },
        onLeave: () => { if (st.hoverRow === r.k) this.setState({ hoverRow: null }); },
        nameBg: cfgBg || (r.total ? "#F5F8FA" : "#FFFFFF"),
        cellTint: cfgBg,
        srcFg: r.manual ? "#B26A00" : eSrc === "input" ? "#0052CD" : opens ? "#0060a8" : "#8094B5",
        srcBg: r.manual ? "#FFF4E5" : eSrc === "input" ? "#EAF1FD" : opens ? "#E3F3FC" : "#F5F8FA",
        srcCursor: opens ? "pointer" : "default",
        srcTitle: r.manual ? MANUAL_DRIVER_NOTE : opens ? (opens === "mix" ? "Open the product mix" + (link ? " · summed across " + memberLabels : "") : opens === "source" ? "Open marketing sources" + (link ? " · summed across " + memberLabels : "") : opensSrc === "cohort" ? "Open the " + BL[opens] + " cohort triangle" + (link ? " · summed across " + memberLabels : "") : opensSrc === "base" ? "Open the stock and flow model" : "Open the channel models behind this rollup") : (link ? "Rolled up from " + memberLabels : ""),
        onSrc: opens ? (e => {
          e.stopPropagation();
          if (opens === "mix") {
            const patch = { screen: "mix", hoverRow: null };
            if (isAll) {
              const prefer = Object.keys(D.channels).find(cid => (PRODUCT_MIX[cid] || []).length) || Object.keys(D.channels)[0];
              if (prefer) patch.chSel = [prefer];
            }
            this.setState(patch);
            return;
          }
          if (opens === "source") {
            const patch = { screen: "source", hoverRow: null };
            if (isAll) {
              const prefer = Object.keys(D.channels).find(cid => channelHasSources(cid)) || Object.keys(D.channels)[0];
              if (prefer) patch.chSel = [prefer];
            }
            this.setState(patch);
            return;
          }
          const patch = { screen: "cohorts", block: opens, hoverRow: null };
          if (isAll) {
            const prefer = Object.keys(D.channels).find(cid => D.channels[cid] && D.channels[cid].model === "cohort") || Object.keys(D.channels)[0];
            if (prefer) patch.chSel = [prefer];
          }
          this.setState(patch);
        }) : null,
      onClick: () => {
        if (opens === "mix") {
          const patch = { screen: "mix", hoverRow: null };
          if (isAll) {
            const prefer = Object.keys(D.channels).find(cid => (PRODUCT_MIX[cid] || []).length) || Object.keys(D.channels)[0];
            if (prefer) patch.chSel = [prefer];
          }
          this.setState(patch);
          return;
        }
        if (opens === "source") {
          const patch = { screen: "source", hoverRow: null };
          if (isAll) {
            const prefer = Object.keys(D.channels).find(cid => channelHasSources(cid)) || Object.keys(D.channels)[0];
            if (prefer) patch.chSel = [prefer];
          }
          this.setState(patch);
          return;
        }
        if (opens && (opensSrc === "cohort" || opensSrc === "base" || opensSrc === "rollup")) {
          const patch = { screen: "cohorts", block: opens, hoverRow: null };
          if (isAll) {
            const prefer = Object.keys(D.channels).find(cid => D.channels[cid] && D.channels[cid].model === "cohort") || Object.keys(D.channels)[0];
            if (prefer) patch.chSel = [prefer];
          }
          this.setState(patch);
          return;
        }
      },
        cells
      });
    });
    const rows = rowsOut;

    const secIds = ["all", "acq"].concat(blocks).concat(blocks.length > 1 ? ["total"] : []).concat(["pl"]);
    const sections = secIds.map(id => ({
      label: id === "all" ? "All drivers" : SECTION_LABEL[id],
      count: id === "all" ? ROWS.length : ROWS.filter(r => r.sec === id).length,
      bg: st.section === id ? "#EAF1FD" : "transparent", fg: st.section === id ? "#0052CD" : "#4D6389",
      fw: st.section === id ? 500 : 400, onClick: () => this.setState({ section: id, screen: "plan" })
    }));

    const channels = chAll.map((id, ci) => {
      const selected = chSel.indexOf(id) >= 0;
      return {
        label: D.channels[id].label,
        model: isCombined(D, id) ? "Combined · " + membersOf(D, id).map(m => D.channels[m].label).join(" + ")
          : D.channels[id].model === "cohort" ? "Cohort model" : isCustom(D, id) ? "Custom model" : "Base model · stock and flow",
        selected,
        bg: selected ? "#EAF1FD" : "transparent",
        fg: "#08234C", subFg: "#8094B5",
        pillBg: selected ? "#0052CD" : "transparent",
        pillFg: selected ? "#fff" : "#4D6389",
        border: "#C8D4EA",
        fw: selected ? 500 : 400,
        divider: ci === 0 ? "none" : "inset 1px 0 0 #DCE4F2",
        onClick: () => {
          this.setState(prev => {
            const blks = channelBlocks(id, this.state.data || D);
            const patch = { chSel: [id], block: blks.length ? blks[0] : prev.block };
            if (isCombined(D, id) && ["cohorts", "mix", "source"].indexOf(prev.screen) >= 0) patch.screen = "plan";
            return patch;
          });
        }
      };
    });

    const secondTab = isAll ? "Models" : cohort ? "Cohort" : "Base model";

    const chartRow = ROWS.find(r => r.k === st.hoverRow) || ROWS[ROWS.length - 1];
    const chartFmt = v => this.isAovRow(chartRow) || (chartRow.unit === "£" && this.rowDp(chartRow) !== null) ? this.sym() + this.rowFmt(v, chartRow, false) : chartRow.unit === "£" ? this.money(v) : this.rowFmt(v, chartRow, false);
    const chart = (() => {
      if (!chartRow) return { empty: true, name: "", pathA: "", pathF: "", pathC: "", boundary: -1, hiLabel: "—", loLabel: "—", first: "", last: "", meta: "" };
      const W = 1000, H = 120, top = 12, bot = 104;
      const pts = cols.map((c, k) => ({ x: cols.length > 1 ? (k / (cols.length - 1)) * W : W / 2, v: aggVal(planGrid, chartRow.k, c.idxs), cmp: cmpOn ? aggVal(cmpGrid, chartRow.k, c.idxs) : null, actual: c.idxs.every(i => i <= cut), label: c.label }));
      const vals = [];
      pts.forEach(p => { if (typeof p.v === "number") vals.push(p.v); if (typeof p.cmp === "number") vals.push(p.cmp); });
      if (!vals.length) return { empty: true, name: chartRow.name, pathA: "", pathF: "", pathC: "", boundary: -1, hiLabel: "—", loLabel: "—", first: "", last: "", meta: "" };
      let lo = Math.min.apply(null, vals), hi = Math.max.apply(null, vals);
      if (hi === lo) { hi = hi + Math.abs(hi || 1) * 0.05; lo = lo - Math.abs(lo || 1) * 0.05; }
      const y = v => bot - ((v - lo) / (hi - lo)) * (bot - top);
      const seg = (sel, filter) => {
        let d = "", open = false;
        pts.forEach(p => {
          const v = sel(p);
          if (typeof v !== "number" || (filter && !filter(p))) { open = false; return; }
          d += (open ? "L" : "M") + this.numFixed(p.x, 1) + " " + this.numFixed(y(v), 1) + " ";
          open = true;
        });
        return d.trim();
      };
      let bIdx = -1;
      pts.forEach((p, k) => { if (p.actual) bIdx = k; });
      const bx = bIdx >= 0 && bIdx < pts.length - 1 ? pts[bIdx].x : -1;
      const fmtV = chartFmt;
      return {
        empty: false, name: chartRow.name, unit: chartRow.unit,
        pathA: seg(p => p.v, p => p.actual),
        pathF: seg(p => p.v, p => !p.actual || (bIdx >= 0 && pts.indexOf(p) === bIdx)),
        pathC: cmpOn ? seg(p => p.cmp) : "",
        boundaryX: bx, hasBoundary: bx >= 0,
        hiLabel: fmtV(hi), loLabel: fmtV(lo),
        first: pts[0].label, last: pts[pts.length - 1].label,
        meta: (st.gran === "month" ? "monthly" : st.gran === "quarter" ? "quarterly" : "annual") + " · " + ml(D.months[ra]) + " to " + ml(D.months[rb])
      };
    })();

    // one line per financial year over its 12 months, limited to the selected period: current FY actuals (blue) then forecast (orange), earlier FYs grey
    const trend = (() => {
      if (!st.hoverRow || st.screen !== "plan" || !chartRow) return null;
      const src = planGrid[chartRow.k] || [];
      const labels = []; for (let j = 0; j < 12; j++) labels.push(MN[(st.fyStart - 1 + j) % 12]);
      const byFy = {};
      D.months.forEach((ym, i) => {
        if (i < ra || i > rb) return;
        const fy = fyOf(ym), slot = ((ym % 100) - st.fyStart + 12) % 12;
        const g = byFy[fy] || (byFy[fy] = { fy, vals: labels.map(() => null), act: labels.map(() => false) });
        const v = src[i];
        g.vals[slot] = typeof v === "number" && Number.isFinite(v) ? v : null;
        g.act[slot] = i <= cut;
      });
      const curFy = fyOf(D.months[cut]);
      const series = [];
      Object.keys(byFy).map(Number).sort((a, b) => a - b).forEach(fy => {
        const g = byFy[fy], tag = fyTag(fy);
        if (fy < curFy) { series.push({ kind: "past", label: tag, data: g.vals }); return; }
        const lastAct = g.act.lastIndexOf(true);
        const actual = g.vals.map((v, j) => g.act[j] ? v : null);
        // the forecast line starts at the last actual point so the two colours join
        const fc = g.vals.map((v, j) => (!g.act[j] || j === lastAct) ? v : null);
        if (fy === curFy && actual.some(v => v !== null)) series.push({ kind: "actual", label: tag + " actual", data: actual });
        if (fc.some((v, j) => v !== null && !g.act[j])) series.push({ kind: "forecast", label: tag + " forecast", data: fc });
      });
      if (!series.some(s => s.data.some(v => v !== null))) return null;
      return { labels, series, fmt: chartFmt };
    })();

    const tabDefs = st.screen === "plan" ? [] : [["plan", "Home"]];

    const showChangeLog = st.screen === "changelog";
    const clFilter = Object.assign({}, CHANGE_LOG_FILTER, st.clFilter);
    const clServer = st.clServer || CHANGE_LOG_EMPTY;
    const clHasFilter = !!(clFilter.from || clFilter.to || clFilter.user || clFilter.channel || clFilter.driver);
    const clRows = [];
    const clDrivers = [];
    const clChannels = [];
    let clPendingSaves = 0, clPendingChanges = 0;
    if (showChangeLog) {
      const byKey = {}, byEd = {};
      chAll.forEach(cid => this.mergeDraftRows(buildRows(cid, D), cid).forEach(r => {
        const hit = { ch: cid, row: r };
        if (r.key) byKey[r.key] = hit;
        if (r.ed) byEd[cid + "|" + r.ed] = hit;
      }));
      const chLabel = cid => (cid && D.channels[cid] ? D.channels[cid].label : (cid || ""));
      const valueOf = (row, v) => {
        if (v === null || v === undefined || v === "") return "—";
        const num = Number(v);
        if (!Number.isFinite(num)) return String(v);
        if (!row) return num.toLocaleString("en-GB", { maximumFractionDigits: 4 });
        return this.rowDp(row) !== null ? this.rowFmt(num, row, false) : this.fmt(num, row.unit);
      };
      const monthOf = p => /^\d{6}$/.test(String(p)) ? ml(+p) : "—";
      const plural = (n, word) => n + " " + word + (n === 1 ? "" : "s");
      const shortKey = key => String(key || "").replace(/^[^.]+\./, "");
      const driverSummary = drivers => {
        if (drivers.length === 1) return { driver: drivers[0].name, driverKey: shortKey(drivers[0].key), driverNote: "" };
        const names = drivers.map(d => d.name);
        return {
          driver: plural(drivers.length, "driver"),
          driverKey: "",
          driverNote: names.slice(0, 3).join(", ") + (names.length > 3 ? " +" + (names.length - 3) + " more" : "")
        };
      };
      const pushBatch = (b, items) => {
        if (b.count === 1 && items.length === 1) {
          clRows.push(Object.assign({}, items[0], { kind: "single", id: b.id, date: b.date, user: b.user, driverKey: shortKey(items[0].driverKey), pending: b.pending, onUndo: b.onUndo }));
          return;
        }
        const open = !!st.clOpen[b.id];
        clRows.push(Object.assign({
          kind: "group",
          id: b.id,
          date: b.date,
          user: b.user,
          channel: b.channels.join(", "),
          month: plural(b.count, "change"),
          from: "",
          to: "",
          open,
          onToggle: () => this.toggleChangeLogBatch(b.id, !b.pending),
          pending: b.pending,
          onUndo: b.onUndo
        }, driverSummary(b.drivers)));
        if (!open) return;
        const loaded = b.pending ? { items } : st.clItems[b.id];
        if (!loaded || loaded.loading) clRows.push({ kind: "status", id: b.id + ":status", text: "Loading…" });
        else if (loaded.error) clRows.push({ kind: "status", id: b.id + ":status", text: loaded.error, onRetry: () => this.loadChangeLogBatch(b.id) });
        else (b.pending ? items : loaded.items.map(serverItem)).forEach(it => clRows.push(Object.assign({}, it, { kind: "item", driverKey: shortKey(it.driverKey) })));
      };
      const serverItem = e => {
        const hit = byKey[e.driverKey] || null;
        const base = {
          id: e.id,
          channel: chLabel(e.channel || (hit && hit.ch)),
          driver: hit ? hit.row.name : (e.label || e.driverKey || "Driver"),
          driverKey: e.driverKey || ""
        };
        if (e.source === PUBLISH_SOURCE) return Object.assign(base, { driver: "Published version", driverKey: "", month: monthOf(e.period), from: "—", to: e.afterText || "—" });
        if (e.source === SCENARIO_SOURCE) return Object.assign(base, { driver: "Scenario", driverKey: "", month: "—", from: e.beforeText || "—", to: e.afterText || "Deleted" });
        if (e.source === CUTOFF_SOURCE) return Object.assign(base, { driver: "Actuals cutoff", driverKey: "", month: "—", from: monthOf(e.beforeText), to: monthOf(e.afterText) });
        if (e.source === AUTO_SOURCE) {
          const [ch, blk] = String(e.field || "").split("|");
          const ruleText = text => {
            const [method, n, ...flags] = String(text || "").split(" ");
            return COHORT_SCREEN_NAME[method] && +n > 0 ? describeCohortRule({ method, n: +n, season: flags.indexOf("season") >= 0, trend: flags.indexOf("trend") >= 0 }) : "—";
          };
          return Object.assign(base, { channel: chLabel(ch), driver: "Auto forecast · " + (BL[blk] || blk) + " cohorts", driverKey: "", month: "—", from: ruleText(e.beforeText), to: ruleText(e.afterText) });
        }
        if (e.source === DELETED_DRIVER_SOURCE) return Object.assign(base, { month: "—", from: "Driver", to: "Deleted" });
        if (e.source === CREATED_DRIVER_SOURCE) return Object.assign(base, { month: "—", from: "Driver", to: "Created" });
        if (e.field) return Object.assign(base, { month: SETTING_LABEL[e.field] || e.field, from: e.beforeText || "—", to: e.afterText || "—" });
        return Object.assign(base, { month: monthOf(e.period), from: valueOf(hit && hit.row, e.before), to: valueOf(hit && hit.row, e.after) });
      };
      const fromMs = clFilter.from ? new Date(clFilter.from + "T00:00:00").getTime() : null;
      const toMs = clFilter.to ? new Date(clFilter.to + "T23:59:59.999").getTime() : null;

      st.log.forEach(l => {
        if ((l.seq || 0) <= (st.clSavedSeq || 0) || clFilter.user) return;
        if ((fromMs !== null && !(l.at >= fromMs)) || (toMs !== null && !(l.at <= toMs))) return;
        const items = [];
        l.items.forEach((it, idx) => {
          let hit = null, driver = it.label || "", month = monthOf(it.period), from, to;
          if (it.key === "cutoff_period") {
            driver = "Actuals cutoff";
            from = it.before == null ? "—" : ml(it.before);
            to = it.after == null ? "—" : ml(it.after);
          } else if (it.kind === "input") {
            hit = byEd[it.ch + "|" + it.key] || null;
            driver = hit ? hit.row.name : it.key;
            from = valueOf(hit && hit.row, it.before);
            to = valueOf(hit && hit.row, it.after);
          } else if (it.kind === "structure" || it.kind === "cohort_input" || it.kind === "cohort_guards" || it.kind === "mix_input" || it.kind === "cogs_input") {
            month = it.kind === "structure" ? "—" : "Forecast";
            from = it.before == null ? "—" : String(it.before);
            to = it.after == null ? "—" : String(it.after);
          } else {
            const unitRow = { unit: it.kind === "rate" ? "%" : "" };
            from = valueOf(unitRow, it.before);
            to = valueOf(unitRow, it.after);
          }
          const ch = hit ? hit.ch : (it.ch || "");
          const driverKey = hit ? hit.row.key : "";
          if (clFilter.channel && ch !== clFilter.channel) return;
          if (clFilter.driver && driverKey !== clFilter.driver) return;
          items.push({ id: l.batch + ":" + idx, ch, channel: chLabel(ch), driver, driverKey, month, from, to });
        });
        if (!items.length) return;
        clPendingSaves++;
        clPendingChanges += items.length;
        const drivers = [];
        items.forEach(it => { if (!drivers.some(d => d.key === it.driverKey && d.name === it.driver)) drivers.push({ key: it.driverKey, name: it.driver }); });
        pushBatch({
          id: l.batch,
          date: atLabel(l.at),
          user: "You",
          count: items.length,
          channels: Array.from(new Set(items.map(it => it.channel).filter(Boolean))),
          drivers,
          pending: true,
          onUndo: () => this.undoBatch(l.batch)
        }, items);
      });

      clServer.batches.forEach(b => {
        const drivers = (b.drivers || []).map(d => {
          const hit = byKey[d.driverKey];
          return { key: d.driverKey, name: hit ? hit.row.name : (d.label || d.driverKey) };
        });
        pushBatch({
          id: b.batchId,
          date: atLabel(Date.parse(b.at)),
          user: (st.users || {})[b.actorId] || "Unknown user",
          count: b.count,
          channels: (b.channels || []).map(chLabel),
          drivers,
          pending: false,
          onUndo: null
        }, (b.items || []).map(serverItem));
      });

      chAll.forEach(cid => clChannels.push({ value: cid, label: chLabel(cid) }));
      Object.keys(byKey).forEach(k => {
        const hit = byKey[k];
        if (!hit.row.ed || (clFilter.channel && hit.ch !== clFilter.channel)) return;
        clDrivers.push({ value: k, label: clFilter.channel ? hit.row.name : chLabel(hit.ch) + " · " + hit.row.name });
      });
      clDrivers.sort((a, b) => a.label.localeCompare(b.label));
    }
    const clSaves = clServer.total + clPendingSaves;
    const clChanges = clServer.changes + clPendingChanges;
    const changeLog = {
      rows: clRows,
      total: clSaves,
      loading: clServer.loading,
      error: clServer.error,
      summary: clServer.loading && !clServer.loaded
        ? "Loading…"
        : clChanges + (clHasFilter ? " matching" : "") + (clChanges === 1 ? " change" : " changes") + " in " + clSaves + (clSaves === 1 ? " save" : " saves"),
      empty: clServer.loading ? "Loading…" : clHasFilter ? "No changes match these filters." : "No changes recorded yet.",
      filter: clFilter,
      users: Object.keys(st.users || {}).map(id => ({ value: id, label: st.users[id] })).sort((a, b) => a.label.localeCompare(b.label)),
      channels: clChannels,
      drivers: clDrivers,
      hasFilter: clHasFilter,
      setFilter: (key, value) => this.setChangeLogFilter(key, value),
      clearFilters: () => this.clearChangeLogFilters(),
      onRetry: () => this.loadChangeLog(false),
      hasMore: clServer.batches.length < clServer.total,
      moreLabel: clServer.loading ? "Loading…" : "Show more",
      onMore: () => this.loadChangeLog(true)
    };

    const horizonNow = n - cut - 1;
    const pubSettings = (activePub && activePub.settings) ? activePub.settings : null;
    const cohortTenure = (pubSettings && pubSettings.cohortTenure) || st.cohortTenure || (D.settings && D.settings.cohortTenure) || "unbounded";
    const versionGuards = spec(st.version).cohortGuards;
    const engineVersion = versionGuards ? versionGuards.engine || COHORT_GUARD_ENGINE_VERSION : st.engineVersion || D.engineVersion || "";
    const amzCutoffValue = (pubSettings && pubSettings.amzCutoff) || st.amzCutoff || "";
    const modelParams = [
      { key: "forecast_horizon_months", value: String(horizonNow), note: "to " + ml(D.months[n - 1]) + " · forecast months after the cutoff",
        edit: isDraft ? "select" : "", options: isDraft ? buildHorizonOptions(horizonNow) : [],
        onChange: e => {
          const m = +e.target.value, d = m - horizonNow;
          if (d > 0) this.extendHorizon(d);
          else if (d < 0) this.trimHorizon(-d);
        } },
      { key: "engine_version", value: engineVersion || "—", note: "TypeScript, Node and browser" }
    ].map(p => Object.assign({ edit: "", options: [], onChange: null, isEdit: !!p.edit, isRead: !p.edit }, p, { isEdit: !!p.edit, isRead: !p.edit }));
    const mcpClasses = [
      { cls: "READ", effect: "none", consent: "implicit", fg: "#4D6389", bg: "#F5F8FA" },
      { cls: "SCENARIO", effect: "ephemeral session", consent: "implicit", fg: "#4D6389", bg: "#F5F8FA" },
      { cls: "DRAFT_WRITE", effect: "mutates a draft", consent: "implicit, reversible", fg: "#0052CD", bg: "#EAF1FD" },
      { cls: "PUBLISH", effect: "creates an immutable version", consent: "explicit human act", fg: "#E5484D", bg: "#FDECEC" },
      { cls: "MODEL_AUTHORING", effect: "structural change", consent: "CXDATA only", fg: "#0052CD", bg: "#EAF1FD" }
    ];

    const findings = st.screen === "governance" || st.publishOpen ? this.reviewFindings(chAll, cid => gridFor("fc_v5", cid), this.cutIdx()) : [];
    const guardNotes = isDraft && (st.screen === "governance" || st.publishOpen) ? this.guardFindings(chAll, cid => gridFor("fc_v5", cid)) : [];
    const pubSpec = isDraft ? spec("fc_v5") : null;
    const pubPicker = !!pubSpec && pubSpec.kind === "model" && !!pubSpec.cohortGuards && !usesFlatTail(pubSpec.cohortGuards.engine);
    const pubOpenFlags = pubPicker && (st.screen === "governance" || st.publishOpen) ? flagListOf("fc_v5").filter(f => !f.accepted) : [];
    const pubFadeNotes = pubPicker ? guardNotes.filter(f => f.fadeNeeds) : [];
    const flagFindings = [];
    pubOpenFlags.forEach(f => {
      const id = f.cid + "|" + f.b + "|flags";
      const hit = flagFindings.find(x => x.id === id);
      if (hit) { hit.count++; return; }
      flagFindings.push({
        id, kind: "flags", count: 1, hint: "", action: "Review flags",
        label: (D.channels[f.cid].label || channelCode(f.cid)) + " · " + (BL[f.b] || f.b) + " cohorts",
        detail: "Red cells that break a rule. Accept each one with a note, or change its value.",
        onAction: () => { this.setState({ screen: "cohorts", publishOpen: false }); this.openFlagPanel("flags", "open"); this.goToCohortCell(f.cid, f.b, f.j, f.t); }
      });
    });
    flagFindings.forEach(x => { x.title = x.label + ": " + x.count + (x.count === 1 ? " flag" : " flags") + " to review"; });
    const reviewItems = findings.concat(flagFindings, pubFadeNotes.map(f => Object.assign({}, f, { id: f.id + "|block", kind: "fade" })));
    const errCount = reviewItems.length;
    const pubTrim = st.pubName.trim();
    const pubTarget = pubTrim ? (VERSIONS.filter(v => v.grp === "published" && v.short.toLowerCase() === pubTrim.toLowerCase())[0] || null) : null;
    const pubTargetLocked = pubTarget ? !!st.locks[pubTarget.id] : false;
    const isCloneLoaded = !!st.versionCtx && st.versionCtx.kind === "clone";
    const createSource = st.pubs.find(p => p.id === st.version) || null;
    const createMode = !!createSource && !!st.canCreateVersion && !!this.onCreateVersion;
    const createMax = typeof D.actualCutoffIdx === "number" ? D.actualCutoffIdx : (D.cutoffIdx ?? 0);
    const createCutoffOpts = createMode && st.createOpen
      ? D.months.slice(0, createMax + 1).map((ym, i) => ({ value: String(i), label: ml(ym) })).reverse()
      : [];
    const pubReady = isDraft && !!pubTrim && !pubTargetLocked && (!pubTarget || st.pubConfirm.trim() === "OVERWRITE");

    const GROUPS = [
      { id: "plan", label: "Plan", screens: ["plan", "cohorts"] },
      { id: "analysis", label: "Analysis", screens: ["scenario", "variance"] },
      { id: "review", label: "Review", screens: ["authoring", "governance", "validate", "changelog"] }
    ];
    const tabsOut = tabDefs.map(t => ({
      label: t[1],
      fg: st.screen === t[0] ? "#0052CD" : "#4D6389", fw: st.screen === t[0] ? 500 : 400,
      tabBg: st.screen === t[0] ? "#EAF1FD" : "transparent",
      onClick: () => this.setState({ screen: t[0], hoverRow: null })
    }));

    // ---- cohort triangle ----
    const chOrder = Object.keys(D.channels);
    const cohortMembers = combinedCh
      ? membersOf(D, ch).filter(m => D.channels[m].model === "cohort").sort((x, y) => chOrder.indexOf(x) - chOrder.indexOf(y))
      : [];
    const memberCohorts = cohortMembers.length > 0;
    const triangle = cohort || memberCohorts;
    const cohortBlocks = memberCohorts
      ? cohortMembers.reduce((acc, m) => acc.concat(channelBlocks(m, D).filter(b => acc.indexOf(b) < 0)), [])
      : blocks;
    const allBlocks = triangle && cohortBlocks.length > 1 && st.block === ALL_BLOCKS;
    const blk = cohortBlocks.indexOf(st.block) >= 0 && triangle ? st.block : cohortBlocks[0];
    const summedCohorts = allBlocks || memberCohorts;
    const cohortCols = cols.map(c => ({ label: c.label, bg: c.bg, fg: c.fg }));
    const cohW = st.gran === "month" ? 62 : st.gran === "quarter" ? 80 : 96;
    const cmpMeta = cmpOn && cohort ? (gridFor(st.cmpVersion, ch).__meta || null) : null;
    const viewSpec = spec(st.version);
    const cohortSrc = viewSpec.kind === "model" ? planGrid : base;
    const viewMeta = viewSpec.kind === "model" && cohort && cohortSrc.__meta ? cohortSrc.__meta : null;
    const memberPlan = cid => scenActive ? this.run(cid, scenArg) : isDraft ? this.run(cid, zero) : gridFor(st.version, cid);
    const parseYm = label => {
      if (label === null || label === undefined) return NaN;
      if (typeof label === "number") return label;
      const s = String(label).trim();
      if (/^\d{6}$/.test(s)) return +s;
      const m = /^(\d{4})[-/]?(\d{1,2})$/.exec(s);
      if (m) return (+m[1]) * 100 + (+m[2]);
      return +s;
    };
    const blockView = (b, cid) => {
      const own = !cid || cid === ch;
      const vch = own ? ch : cid;
      const vConf = own ? conf : D.channels[cid];
      const vPlan = own ? planGrid : memberPlan(cid);
      const vSrc = own ? cohortSrc : (viewSpec.kind === "model" ? vPlan : this.run(cid, zero));
      const vMeta = own ? viewMeta : (viewSpec.kind === "model" && vSrc.__meta ? vSrc.__meta : null);
      const vCmp = own ? cmpMeta : (cmpOn ? (gridFor(st.cmpVersion, cid).__meta || null) : null);
      const bCohorts = vConf[b] && Array.isArray(vConf[b].cohorts) ? vConf[b].cohorts : [];
      const bSizes = own && !cohort ? [] : ((vSrc.__meta ? vSrc.__meta.sizes[b] : null) || []);
      const bRates = vMeta && vMeta.rates ? vMeta.rates[b] : null;
      const bKinds = vMeta && vMeta.rateKinds ? vMeta.rateKinds[b] : null;
      const bCmpSizes = (vCmp && vCmp.sizes ? vCmp.sizes[b] : null) || [];
      const bCmpRates = vCmp && vCmp.rates && spec(st.cmpVersion).kind === "model" ? vCmp.rates[b] : null;
      const bEntrants = Array.isArray(vPlan[b + "_new"]) ? vPlan[b + "_new"] : [];
      const cmpRate = (j, t) => {
        if (!cmpOn) return null;
        if (bCmpRates) return bCmpRates[j] && typeof bCmpRates[j][t] === "number" ? bCmpRates[j][t] : null;
        const fileRatio = bCohorts[j] ? bCohorts[j].ratio[t] : null;
        return fileRatio === null || fileRatio === undefined ? null : fileRatio;
      };
      const birthIndexOf = j => {
        if (j < 0 || !bCohorts[j]) return -1;
        const birthYm = parseYm(bCohorts[j].label);
        return !isNaN(birthYm) ? D.months.indexOf(birthYm) : -1;
      };
      const planBirthRatio = (i, sizeAt) => {
        const ent = bEntrants[i];
        if (typeof ent !== "number") return null;
        if (typeof sizeAt === "number" && sizeAt > 0) return { ratio: ent / sizeAt, ovr: false, fromPlan: true };
        return { ratio: 1, ovr: false, ordersOverride: ent, fromPlan: true };
      };
      const resolveRatio = (j, i, fileRatio, sizeAt) => {
        const birthIdx = birthIndexOf(j);
        const isBirth = birthIdx === i;
        if (isBirth && j >= 0) {
          if (i > cut) {
            const fromPlan = planBirthRatio(i, sizeAt);
            if (fromPlan) return fromPlan;
            if (fileRatio !== null && fileRatio !== undefined) return { ratio: fileRatio, ovr: false, fromPlan: false };
            return { ratio: null, ovr: false, fromPlan: true };
          }
          if (fileRatio !== null && fileRatio !== undefined) return { ratio: fileRatio, ovr: false, fromPlan: false };
          return { ratio: null, ovr: false };
        }
        if (bRates && j >= 0) {
          const kind = bKinds && bKinds[j] ? bKinds[j][i] : null;
          const r = bRates[j] ? bRates[j][i] : null;
          return { ratio: typeof r === "number" ? r : null, ovr: kind === "override", computed: kind === "rule" || kind === "fallback", fallback: kind === "fallback" };
        }
        const hasOvr = j >= 0 && i > cut && st.rov[this.rovKey(vch, b, j, i)] !== undefined;
        if (hasOvr) return { ratio: this.rate(vch, b, j, i, fileRatio), ovr: true };
        if (fileRatio !== null && fileRatio !== undefined) {
          return { ratio: j >= 0 && i > cut ? this.rate(vch, b, j, i, fileRatio) : fileRatio, ovr: false };
        }
        return { ratio: null, ovr: false };
      };
      const label = own ? BL[b] + " cohorts" : vConf.label + (cohortBlocks.length > 1 ? " · " + BL[b] : "");
      const bLegacy = vMeta && vMeta.legacy ? vMeta.legacy[b] || null : null;
      const bGuards = vMeta && vMeta.guards ? vMeta.guards[b] || null : null;
      return { id: vch + "|" + b, label, b, cohorts: bCohorts, sizes: bSizes, modelRates: bRates, modelKinds: bKinds, cmpSizes: bCmpSizes, entrants: bEntrants, cmpRate, birthIndexOf, resolveRatio, legacy: bLegacy, guards: bGuards };
    };
    const blkView = blockView(blk);
    const { sizes, modelRates, modelKinds, cmpSizes, cmpRate, birthIndexOf, resolveRatio } = blkView;
    const entrantsSeries = blkView.entrants;
    const viewCohortInput = viewSpec.cohortInput || st.cohortInput;
    const cohortLabelOf = j => (conf[blk] && Array.isArray(conf[blk].cohorts) && conf[blk].cohorts[j] ? String(conf[blk].cohorts[j].label) : "");
    const settingsPicker = viewSpec.kind === "model" && !!viewSpec.cohortGuards && !usesFlatTail(viewSpec.cohortGuards.engine);
    const viewAutoChoices = viewSpec.cohortAuto || st.cohortAuto || {};
    const ruleFieldsFor = (cid, b, label) => {
      const own = viewCohortInput[cohortInputKey(cid, b, label)] || null;
      const tabRule = viewCohortInput[cohortInputKey(cid, b)] || null;
      const autoChoice = settingsPicker && !tabRule ? viewAutoChoices[cohortGuardKey(cid, b)] || null : null;
      const isAuto = settingsPicker && !label && !own;
      const channelRule = settingsPicker && !tabRule ? (autoChoice ? autoChoice.rule : DEFAULT_COHORT_RULE) : resolveCohortRule(viewCohortInput, cid, b);
      const rule = own || channelRule;
      const limits = rule.method === "fixed" || isAuto ? null : COHORT_N_LIMITS[rule.method];
      const apply = next => this.setCohortInput(cid, b, label || null, next);
      const channelText = settingsPicker && !tabRule ? "Auto" + (autoChoice ? " · " + describeCohortChoice(autoChoice.rule) : "") : describeCohortRule(channelRule);
      if (settingsPicker) {
        return {
          title: label ? ml(+label) + " · forecast method" : "Forecast method",
          method: isAuto ? "auto" : rule.method,
          methodOpts: (label ? [] : [{ value: "auto", label: "Auto" }]).concat(PICKER_METHODS.map(m => ({ value: m, label: COHORT_SCREEN_NAME[m] }))),
          isFixed: false,
          hideN: isAuto,
          nLabel: rule.method === "prev" ? "months back" : "cohorts",
          nValue: limits ? String(rule.n) : "",
          nHint: limits ? limits[0] + "–" + limits[1] : "",
          canDec: !!limits && isDraft && rule.n > limits[0],
          canInc: !!limits && isDraft && rule.n < limits[1],
          onDec: () => { if (limits && rule.n > limits[0]) apply(Object.assign({}, rule, { n: rule.n - 1 })); },
          onInc: () => { if (limits && rule.n < limits[1]) apply(Object.assign({}, rule, { n: rule.n + 1 })); },
          pctValue: "",
          summary: isAuto ? channelText : describeCohortRule(rule),
          inherited: !!label && !own,
          disabled: !isDraft,
          onMethod: e => apply(e.target.value === "auto" ? null : migrateCohortRule(defaultRuleFor(e.target.value, rule))),
          onN: raw => {
            const v = parseInt(String(raw).replace(/[^0-9]/g, ""), 10);
            if (!isNaN(v) && limits) apply(Object.assign({}, rule, { n: Math.max(limits[0], Math.min(limits[1], v)) }));
          },
          onPct: () => {},
          canReset: isDraft && !!own,
          resetLabel: label ? "Use default · " + channelText : "Reset to Auto",
          onReset: () => { apply(null); if (label) this.setState({ cohortRulePop: null }); },
          onClose: () => this.setState({ cohortRulePop: null })
        };
      }
      return {
        title: label ? ml(+label) + " · forecast method" : "Forecast method",
        method: rule.method,
        methodOpts: COHORT_METHODS.map(m => ({ value: m, label: COHORT_METHOD_LABEL[m] })),
        isFixed: rule.method === "fixed",
        nLabel: rule.method === "prev" ? "months back" : "cohorts",
        nValue: limits ? String(rule.n) : "",
        nHint: limits ? limits[0] + "–" + limits[1] : "",
        canDec: !!limits && isDraft && rule.n > limits[0],
        canInc: !!limits && isDraft && rule.n < limits[1],
        onDec: () => { if (limits && rule.n > limits[0]) apply({ method: rule.method, n: rule.n - 1 }); },
        onInc: () => { if (limits && rule.n < limits[1]) apply({ method: rule.method, n: rule.n + 1 }); },
        pctValue: rule.method === "fixed" ? this.numFixed(rule.value * 100, 1) : "",
        summary: describeCohortRule(rule),
        inherited: !!label && !own,
        disabled: !isDraft,
        onMethod: e => apply(defaultRuleFor(e.target.value, rule)),
        onN: raw => {
          const v = parseInt(String(raw).replace(/[^0-9]/g, ""), 10);
          if (!isNaN(v) && limits) apply({ method: rule.method, n: Math.max(limits[0], Math.min(limits[1], v)) });
        },
        onPct: raw => {
          const v = parseFloat(String(raw).replace(/[^0-9.]/g, ""));
          if (!isNaN(v)) apply({ method: "fixed", value: Math.max(0, Math.min(100, v)) / 100 });
        },
        canReset: isDraft && !!own,
        resetLabel: label ? "Use default · " + describeCohortRule(channelRule) : "Reset to " + describeCohortRule(DEFAULT_COHORT_RULE),
        onReset: () => { apply(null); if (label) this.setState({ cohortRulePop: null }); },
        onClose: () => this.setState({ cohortRulePop: null })
      };
    };
    const ruleFields = label => ruleFieldsFor(ch, blk, label);
    const viewMixInput = viewSpec.mixInput || st.mixInput;
    const viewCogsInput = viewSpec.cogsInput || st.cogsInput;
    const mixRuleFields = (name, period, kind) => {
      const cellLevel = !!name && !!period;
      const isCogs = kind === "cogs";
      const map = isCogs ? viewCogsInput : viewMixInput;
      const own = name ? map[mixInputKey(ch, name, cellLevel ? period : null)] || null : null;
      const parentRule = cellLevel ? resolveMixRule(map, ch, name) : resolveMixRule(map, ch);
      const rule = own || parentRule;
      const limits = rule.method === "fixed" ? null : COHORT_N_LIMITS[rule.method];
      const apply = next => this.setMixInput(ch, name || null, next, cellLevel ? period : null, isCogs ? "cogs" : "mix");
      const openHere = !!name && st.mixRulePop === name && (st.mixRuleKind || "mix") === (isCogs ? "cogs" : "mix");
      const open = openHere && (cellLevel ? st.mixRuleAt === period : st.mixRuleAt == null);
      return {
        title: name ? name + (isCogs ? " COGS %" : "") + (cellLevel ? " · " + ml(period) : "") + " · forecast method" : (isCogs ? "COGS % forecast method" : "Forecast method"),
        method: rule.method,
        methodOpts: COHORT_METHODS.map(m => ({ value: m, label: COHORT_METHOD_LABEL[m] })),
        isFixed: rule.method === "fixed",
        nLabel: "months",
        nValue: limits ? String(rule.n) : "",
        nHint: limits ? limits[0] + "–" + limits[1] : "",
        canDec: !!limits && isDraft && rule.n > limits[0],
        canInc: !!limits && isDraft && rule.n < limits[1],
        onDec: () => { if (limits && rule.n > limits[0]) apply({ method: rule.method, n: rule.n - 1 }); },
        onInc: () => { if (limits && rule.n < limits[1]) apply({ method: rule.method, n: rule.n + 1 }); },
        pctValue: rule.method === "fixed" ? this.numFixed(rule.value * 100, 1) : "",
        summary: describeMixRule(rule),
        inherited: !!name && !own,
        inheritedLabel: cellLevel ? "Row method · " : "Channel default · ",
        scopeLabel: cellLevel ? "this month only" : "this category only",
        disabled: !isDraft,
        onMethod: e => apply(defaultRuleFor(e.target.value, rule)),
        onN: raw => {
          const v = parseInt(String(raw).replace(/[^0-9]/g, ""), 10);
          if (!isNaN(v) && limits) apply({ method: rule.method, n: Math.max(limits[0], Math.min(limits[1], v)) });
        },
        onPct: raw => {
          const v = parseFloat(String(raw).replace(/[^0-9.]/g, ""));
          if (!isNaN(v)) apply({ method: "fixed", value: Math.max(0, Math.min(100, v)) / 100 });
        },
        canReset: isDraft && !!(name ? own : map[mixInputKey(ch)]),
        resetLabel: name ? (cellLevel ? "Use row · " : "Use default · ") + describeMixRule(parentRule) : "Reset to " + describeMixRule(DEFAULT_COHORT_RULE),
        onReset: () => { apply(null); if (name) this.setState({ mixRulePop: null, mixRuleAt: null }); },
        onClose: () => this.setState({ mixRulePop: null, mixRuleAt: null }),
        tag: mixRuleTag(rule),
        pillLabel: "forecast method for " + (name || "") + (isCogs ? " COGS %" : ""),
        own: !!own,
        open,
        onToggle: name && !cellLevel ? () => this.setState({ mixRulePop: open ? null : name, mixRuleAt: null, mixRuleKind: isCogs ? "cogs" : "mix" }) : null,
        onOpen: cellLevel && isDraft ? (() => this.setState({ mixRulePop: name, mixRuleAt: period, mixRuleKind: isCogs ? "cogs" : "mix" })) : null
      };
    };
    const cohortInputGroups = Object.keys(D.channels || {})
      .filter(cid => cid !== "all" && D.channels[cid] && D.channels[cid].model === "cohort")
      .map(cid => ({
        label: D.channels[cid].label || channelCode(cid),
        blocks: channelBlocks(cid, D).filter(b => D.channels[cid][b]).map(b => {
          const prefix = cohortInputKey(cid, b) + "|";
          const rows = Object.keys(viewCohortInput)
            .filter(k => k.indexOf(prefix) === 0)
            .sort()
            .map(k => {
              const label = k.slice(prefix.length);
              return {
                label: ml(+label),
                summary: describeCohortRule(viewCohortInput[k]),
                onRemove: isDraft ? () => this.setCohortInput(cid, b, label, null) : null
              };
            });
          return { id: cid + "-" + b, label: BL[b] || b, fields: ruleFieldsFor(cid, b, null), rows };
        })
      }))
      .filter(g => g.blocks.length);
    const cohortGuardsView = (() => {
      const gSpec = st.screen === "authoring" ? spec(st.version) : null;
      if (!gSpec || gSpec.kind !== "model" || !gSpec.cohortGuards) return null;
      const settings = gSpec.cohortGuards;
      const allScopes = cohortChannelIds.reduce((acc, cid) => acc.concat(channelBlocks(cid, D).filter(b => D.channels[cid][b]).map(b => {
        const meta = gridFor(st.version, cid).__meta || {};
        return {
          key: cohortGuardKey(cid, b), cid, b,
          label: (D.channels[cid].label || channelCode(cid)) + " " + (BL[b] || b) + " cohorts",
          resolved: meta.guards ? meta.guards[b] : null,
          changed: (meta.changed && meta.changed[b]) || {},
          flagCount: (meta.flagCount && meta.flagCount[b]) || 0,
          own: (settings.scopes || {})[cohortGuardKey(cid, b)] || {}
        };
      })), []).filter(s => s.resolved);
      const scopes = allScopes.filter(s => isAll || s.cid === ch);
      if (!scopes.length) return null;
      const current = scopes.find(s => s.key === st.guardScope) || scopes[0];
      const pick = s => this.setState({ chSel: isAll && scopes.indexOf(s) >= 0 ? st.chSel : [s.cid], guardScope: s.key });
      const R = current.resolved;
      const consts = resolveConstants(settings.constants);
      const help = key => guardHelp(key, consts, !!R.v4);
      const userNote = info => guardUserNote(info);
      const plural = (n, one, many) => n + " " + (n === 1 ? one : many);
      const pctText = v => (typeof v === "number" ? this.numFixed(v * 100, 2) + "%" : "");
      const changed = current.changed;
      const field = (p, extra) => {
        const info = R.params[p];
        const isUser = !!info && info.source === "user";
        const needs = !!info && info.value === null && !R.off[GUARD_OF_PARAM[p]] && (RETENTION_PARAMS.indexOf(p) < 0 || R.needs.indexOf(p) >= 0);
        const sys = info ? formatGuardValue(p, info.system) : "";
        const tuned = !!info && /^Set by back test/.test(info.reason);
        return Object.assign({
          id: p, key: current.key + "|" + p + "|" + JSON.stringify(info ? info.value : null),
          label: PARAM_GUIDE[p].label,
          value: isUser ? formatGuardValue(p, info.value) : "",
          placeholder: sys ? sys + (tuned ? " from back test" : " from data") : needs ? "Needs a decision" : "",
          status: isUser ? "user" : needs ? "needs" : "system",
          note: isUser ? userNote(info) : needs ? "Needs a decision · " + info.reason : tuned ? info.reason : "System default · " + (info ? info.reason : ""),
          disabled: !isDraft,
          help: help(p),
          onCommit: text => this.setGuardParam(current.key, p, text),
          onClear: () => this.resetGuardParam(current.key, p)
        }, extra);
      };
      const shown = (id, label, text, reason, helpKey) => ({ id, label, shown: text || "Not enough history yet", reason, help: help(helpKey || id), readOnly: true });
      const readParam = (p, extra) => {
        const info = R.params[p];
        return Object.assign(shown(p, PARAM_GUIDE[p].label, info ? formatGuardValue(p, info.value) : "", info ? (info.source === "user" ? userNote(info) : info.reason) : ""), extra);
      };
      const counts = {
        legacy: plural(changed.legacy || 0, "cohort bundled", "cohorts bundled"),
        credible: plural(changed.credible || 0, "cohort left out", "cohorts left out"),
        tail: R.flatTail ? plural(changed.tail || 0, "cell uses this rate", "cells use this rate") : plural(changed.tail || 0, "cell filled by the fade", "cells filled by the fade"),
        cap: plural(changed.cap || 0, "cell capped", "cells capped"),
        qa: plural(current.flagCount, "red cell", "red cells")
      };
      const groups = ageGroupsOf(R.bands);
      const limitsInfo = R.params.trendLimits;
      const ownLimits = current.own.user && current.own.user.trendLimits && Array.isArray(current.own.user.trendLimits.value) ? current.own.user.trendLimits.value : [];
      const sysLimits = limitsInfo && Array.isArray(limitsInfo.system) ? limitsInfo.system : [];
      const limitBox = i => {
        const side = i % 2 === 0 ? "fall" : "rise";
        const mine = typeof ownLimits[i] === "number";
        const g = groups[Math.floor(i / 2)];
        return {
          id: "trendLimits-" + i, key: current.key + "|limit|" + i + "|" + (mine ? ownLimits[i] : ""),
          label: (side === "fall" ? "Largest fall a year, " : "Largest rise a year, ") + g.name,
          value: mine ? limitPct(ownLimits[i], side) : "",
          placeholder: (limitPct(sysLimits[i], side) || "0") + " from data",
          status: mine ? "user" : "system",
          disabled: !isDraft,
          onCommit: text => this.setGuardLimit(current.key, i, text)
        };
      };
      const limitsUser = ownLimits.some(v => typeof v === "number");
      const topChange = maxYearlyChange(R.limits);
      const symmetric = groups.every((_, b) => limitPct(R.limits[2 * b], "fall") === limitPct(R.limits[2 * b + 1], "rise"));
      const cutoff = R.params.legacyCutoff;
      const trendWindow = R.params.trendWindow && typeof R.params.trendWindow.value === "number" ? R.params.trendWindow.value : null;
      const userBoxes = s => Object.keys((s.own && s.own.user) || {}).reduce((acc, p) => {
        const u = s.own.user[p];
        const n = p === "trendLimits" && u && Array.isArray(u.value) ? u.value.filter(v => typeof v === "number").length : 1;
        return n ? acc.concat([{ p, n }]) : acc;
      }, []);
      const basic = {
        help: help("basic"),
        desc: "The three decisions you are most likely to make. A blank box uses the value from your data, shown in light grey; type to override it and clear the box to go back.",
        cutoff: field("legacyCutoff", {
          desc: "Earlier cohorts are grouped into one bundle that fades over time. They still count in your totals, but the forecast never learns from them.",
          note: (cutoff && cutoff.source === "user" ? userNote(cutoff) : cutoff && cutoff.value === null ? "Needs a decision · " + cutoff.reason : "System default · " + (cutoff ? cutoff.reason : "")) + " · " + counts.legacy
        }),
        retention: R.v3 ? {
          change: field("retentionChange", { desc: RETENTION_CHANGE_DESC }),
          start: field("retentionChangeStart", { desc: RETENTION_START_DESC, months: this.retentionStartMonths(R) }),
          signal: {
            label: "Year on year signal · read only",
            help: help("retentionSignal"),
            desc: "How the newest cohorts compare with the cohorts born a year earlier at the same ages. A guide for the retention change; the forecast does not use it.",
            groups: groups.map((g, b) => {
              const s = R.signal[b];
              return { name: g.name, months: g.months, change: s && typeof s.change === "number" ? (s.change > 0 ? "+" : "") + this.numFixed(s.change * 100, 1) + "%" : "Not enough history", pairs: s ? plural(s.pairs, "pair", "pairs") : "0 pairs" };
            })
          }
        } : null,
        trend: R.v3 ? null : {
          help: help("trendLimits"),
          label: PARAM_GUIDE.trendLimits.label + ", per age group",
          desc: "How far this year's improvement or decline in repeat orders can move the forecast. Widen it for a bull case, narrow it for a cautious one.",
          used: R.trendUsed,
          unusedNote: "Not used: this forecast method has no trend",
          lead: limitsUser ? "Your values:" : "From data:",
          summary: topChange === "0" ? "no yearly change" : "up to " + topChange + "% a year" + (symmetric ? " in either direction" : ""),
          sourceLabel: limitsUser ? userNote(limitsInfo) : "System default",
          groups: groups.map((g, b) => ({ name: g.name, months: g.months, fall: limitBox(2 * b), rise: limitBox(2 * b + 1) }))
        },
        window: R.v3 ? null : (() => {
          const info = R.params.trendWindow;
          const isUser = !!info && info.source === "user";
          const sys = info && typeof info.system === "number" ? info.system : 12;
          const now = trendWindow || sys;
          return {
            id: "trendWindow",
            label: PARAM_GUIDE.trendWindow.label,
            help: help("trendWindow"),
            desc: "The trend compares the latest cohorts with the same number of cohorts just before them. Whole years cancel out seasonal swings: 12 months is the default, and 24 months needs at least 4 years of cohorts.",
            status: isUser ? "user" : "system",
            note: !R.trendUsed ? "Not used: this forecast method has no trend" : isUser ? userNote(info) : "System default · " + (info ? info.reason : ""),
            disabled: !isDraft,
            options: TREND_WINDOW_CHOICES.map(m => ({ id: String(m), label: m + " months" + (m === sys ? " (default)" : ""), on: m === now })),
            onPick: m => (m === now ? false : m === sys ? this.resetGuardParam(current.key, "trendWindow") : this.setGuardParam(current.key, "trendWindow", String(m)))
          };
        })(),
        years: R.v3 ? null : field("trendApplications", Object.assign({
          label: trendWindow && trendWindow !== 12 ? "Times the trend is applied" : PARAM_GUIDE.trendApplications.label,
          desc: trendWindow && trendWindow !== 12
            ? "1 means the change measured over " + trendWindow + " months is applied once, then held flat. 2 applies it again."
            : "1 means one year of improvement or decline, then held flat. 2 lets the change build again in the second year.",
          placeholder: R.params.trendApplications ? formatGuardValue("trendApplications", R.params.trendApplications.system) + " by default" : ""
        }, R.trendUsed ? null : { note: "Not used: this forecast method has no trend" })),
        season: R.flatTail ? null : {
          label: "Monthly seasonality factors",
          help: help("season"),
          count: R.seasonUsed ? "Used by the forecast method" : "Not used by the forecast method",
          desc: R.v4
            ? "How much busier or quieter each calendar month is than the months around it, measured from your actuals. Used when Monthly seasonality is on in the forecast method."
            : "How much busier or quieter each calendar month is than an average month, measured from your actuals. Used when Monthly seasonality is on in the forecast method.",
          note: R.factorsMeasured ? "" : "Under 12 months of actuals, so every month uses 1.000.",
          factors: MN.map((name, m) => ({ name, text: this.numFixed(R.monthFactors[m], 3) }))
        }
      };
      const bundleItems = !R.v3 ? [] : (R.v4 ? [] : [field("bundleRetentionWindow")]).concat([
        Object.assign(
          shown("bundleRetention", "Bundle months used",
            R.bundle ? formatMonth(D.months[R.bundle.months[0]]) + " to " + formatMonth(D.months[R.bundle.months[R.bundle.months.length - 1]]) : R.bundleNeeds ? "Bundle retention needs more months" : "",
            R.bundle ? Math.round(R.bundle.now).toLocaleString("en-GB") + " bundle orders against " + Math.round(R.bundle.before).toLocaleString("en-GB") + " in the same months a year earlier · " + this.numFixed(R.bundle.yearly * 100, 1) + "% kept a year"
              : R.bundleNeeds ? "Fewer matched months after the bundle cutoff than the window, so the share kept uses the last 12 months against the 12 before" : "", R.v4 ? "legacy" : "bundleRetentionWindow"),
          R.bundleNeeds ? { status: "needs" } : null
        )
      ]);
      const ownUses = (gridFor(st.version, current.cid).__meta || {}).methods;
      const ownCount = ownUses && ownUses[current.b] ? ownUses[current.b].filter(m => m === "own").length : 0;
      const sections = [
        { id: "legacy", title: GUARD_LABEL.legacy, count: counts.legacy, help: help("legacy"),
          desc: "Cohorts that started before the month in Basic settings, forecast as one block that fades over time.",
          items: [field("legacyRetention")].concat(bundleItems, [readParam("legacyCeiling")]) },
        R.v4 ? { id: "own", title: GUARD_LABEL.own, count: plural(ownCount, "older cohort", "older cohorts"), help: help("own"),
          desc: "Older cohorts always continue from their own latest actual with the typical decay of recent cohorts. Newer cohorts use the method chosen in the forecast bar. A method set on a cohort always wins.",
          items: [field("ownHistoryMinMonths", R.params.ownHistoryMinMonths && R.params.ownHistoryMinMonths.source !== "user" && R.ownMinMonths !== null
            ? { placeholder: R.ownMinMonths + " from data", note: "System default · Set " + thresholdSource(R) } : null)] }
          : R.v3 ? { id: "own", title: GUARD_LABEL.own, count: plural(ownCount, "cohort uses its own history", "cohorts use their own history"), help: help("own"),
          desc: "Mature cohorts continue from their own latest actuals and the typical decay of recent cohorts. Newer cohorts follow the tab method. A method set on a cohort always wins.",
          items: [field("ownHistoryOn"), field("ownHistoryMinMonths")] } : null,
        { id: "credible", title: GUARD_LABEL.credible, count: counts.credible, help: help("credible"),
          desc: "Only cohorts with enough first month orders shape the forecast. Smaller cohorts still get a forecast of their own.",
          items: [field("minSize"), readParam("k", { reason: "Set in the forecast method" })] },
        R.flatTail
          ? { id: "tail", title: "Long-term repeat rate", count: counts.tail, help: help("tailFlat"),
            desc: "Past the ages with enough evidence, every cohort settles at one repeat rate measured from mature customers.",
            items: [
              shown("tailRate", "Long-term repeat rate", pctText(R.tailRate), R.tailAges.length ? "Average of ages " + R.tailAges[0] + " to " + R.tailAges[R.tailAges.length - 1] : R.params.tailWindow ? R.params.tailWindow.reason : ""),
              readParam("tailWindow")
            ] }
          : { id: "tail", title: GUARD_LABEL.tail, count: counts.tail, help: help("tail"),
            desc: "Past the ages with enough evidence, each cohort continues from its own latest rate and fades a little each month.",
            items: [
              Object.assign(
                shown("tailFade", "Monthly fade",
                  typeof R.fade === "number" ? this.numFixed(R.fade * 100, 1) + "% kept each month · " + (R.fadeFrom === "curve" ? "from mature cohorts" : "from the bundle") : R.fadeNeeds ? "Needs a decision" : "",
                  R.fadeFrom === "curve" ? "Size-weighted month on month change over ages " + R.fadeAges[0] + " to " + R.fadeAges[R.fadeAges.length - 1]
                    : R.fadeFrom === "bundle" ? (R.params.legacyRetention && R.params.legacyRetention.source === "user" ? "Share of bundle orders kept each month, set by user" : "Share of bundle orders kept each month")
                    : "No well-evidenced ages from age " + consts.tailStartAge + " and no bundle history. Set " + PARAM_GUIDE.legacyRetention.label + " in " + GUARD_LABEL.legacy + "."),
                R.fadeNeeds ? { status: "needs" } : null
              ),
              readParam("tailWindow")
            ] },
        { id: "cap", title: GUARD_LABEL.cap, count: counts.cap, help: help("cap"),
          desc: R.v3
            ? "For each age group: the best real rate seen × (1 + headroom). Normal forecasts never reach it; it only catches errors."
            : "For each age group: the highest real rate seen × that group's largest rise allowed. Normal forecasts never reach it; it only catches errors.",
          items: R.v3 ? [field("ceilingHeadroom", { placeholder: R.headroom.length ? R.headroom.map(h => this.numFixed(h * 100, 1) + "%").join(", ") + " from data" : "" })] : [],
          capsHelp: help("rateCap"),
          headroom: R.v3,
          caps: groups.map((g, b) => {
            const from = R.v3 ? R.capFrom[b] : null;
            return Object.assign({ name: g.name, months: g.months, text: typeof R.caps[b] === "number" ? this.numFixed(R.caps[b] * 100, 1) + "%" : "Not enough history yet" }, R.v3 ? {
              best: from ? this.numFixed(from.rate * 100, 1) + "% · " + ml(parseYm(D.channels[current.cid][current.b].cohorts[from.j].label)) + " cohort in " + formatMonth(D.months[from.t]) : "—",
              headroom: typeof R.headroom[b] === "number" ? this.numFixed(R.headroom[b] * 100, 1) + "%" : "—"
            } : null);
          }) },
        { id: "qa", title: GUARD_LABEL.qa, count: counts.qa, help: help("qa"),
          desc: "Turns a forecast cell red when it looks out of line with real results. It never changes a number.",
          items: [readParam("qaMultiple")] }
      ].filter(Boolean);
      const constants = settings.constants || {};
      const searchText = [current.label, "Basic settings", "Advanced settings", "Where these settings apply", "How the system sets defaults", PARAM_GUIDE.legacyCutoff.label]
        .concat(R.v3 ? [PARAM_GUIDE.retentionChange.label, PARAM_GUIDE.retentionChangeStart.label] : [PARAM_GUIDE.trendLimits.label, PARAM_GUIDE.trendApplications.label])
        .concat(sections.map(s => s.title + " " + s.desc + " " + s.items.map(it => it.label).join(" ")))
        .concat(scopes.map(s => s.label))
        .concat(Object.keys(METHOD_CONSTANTS).map(k => CONSTANT_GUIDE[k].label))
        .join(" ");
      return {
        info: isDraft
          ? "Forecast guardrails for each channel and cohort model. Blank boxes follow the data and update by themselves; a value you type wins until you clear it. Click Save in the top bar to keep changes."
          : "Guardrail values stored with this version. Switch to the working draft to change them.",
        intro: "Keep repeat order forecasts grounded in real evidence. Every value starts from this channel and cohort model's own history and updates by itself when the data refreshes. Select the info button beside anything to learn what it is, why it matters, how it is set and when to change it.",
        searchText,
        readOnly: !isDraft,
        scope: current.key,
        scopeLabel: current.label,
        scopeOpts: scopes.map(s => ({ value: s.key, label: s.label })),
        onScope: e => this.setState({ guardScope: e.target.value }),
        help: { channel: help("channel"), advanced: help("advanced"), always: help("always"), where: help("where"), admin: help("admin") },
        basic,
        summary: [counts.legacy, plural(changed.tail || 0, "cell on the long-term rate", "cells on the long-term rate"), counts.cap, counts.qa].join(" · "),
        sections,
        alwaysOn: R.v4
          ? "Forecasts learn from actual results only. The back test sets the older cohort threshold when new actuals arrive" + (typeof R.tunedError === "number" ? " · back test error " + this.numFixed(R.tunedError * 100, 1) + "%" : "") + "."
          : R.v3
          ? "Forecasts learn from actual results only. The back test sets the bundle window and own history settings each time the cutoff moves" + (typeof R.tunedError === "number" ? " · back test error " + this.numFixed(R.tunedError * 100, 1) + "%" : "") + "."
          : "Forecasts learn from actual results only, and the trend is measured over " + (trendWindow || "") + " months against the " + (trendWindow || "") + " before, by age group.",
        where: allScopes.map(s => {
          const boxes = userBoxes(s);
          const cut = s.resolved.params.legacyCutoff;
          return {
            key: s.key, label: s.label, selected: s.key === current.key,
            bundleBefore: cut && typeof cut.value === "number" ? formatMonth(cut.value) : "None",
            bundleUser: !!cut && cut.source === "user",
            userCount: boxes.reduce((n, x) => n + x.n, 0),
            userTitle: boxes.map(x => PARAM_GUIDE[x.p].label).join(", "),
            red: s.flagCount,
            onClick: () => pick(s)
          };
        }),
        constants: Object.keys(METHOD_CONSTANTS).map(k => {
          const isUser = typeof constants[k] === "number";
          return {
            id: k, key: k + "|" + (isUser ? constants[k] : METHOD_CONSTANTS[k]),
            label: CONSTANT_GUIDE[k].label,
            value: formatConstant(k, isUser ? constants[k] : METHOD_CONSTANTS[k]),
            status: isUser ? "user" : "system",
            note: isUser ? "Set by user · method default " + formatConstant(k, METHOD_CONSTANTS[k]) : "",
            disabled: !isDraft,
            help: help(k),
            onCommit: text => this.setGuardConstant(k, text),
            onClear: () => this.resetGuardConstant(k)
          };
        })
      };
    })();
    const rateView = st.view === "rate";
    const cohLines = (showVal ? 1 : 0) + (showAbs ? 1 : 0) + (showPct ? 1 : 0);
    const modelSources = viewMeta && viewMeta.rateSources ? viewMeta.rateSources[blk] : null;
    const blkFlags = viewMeta && viewMeta.flags ? viewMeta.flags[blk] : null;
    const blkGuards = viewMeta && viewMeta.guards ? viewMeta.guards[blk] : null;
    const blkV3 = !!(blkGuards && blkGuards.v3);
    const blkMethods = blkV3 && viewMeta.methods ? viewMeta.methods[blk] : null;
    const flagsAt = (j, t) => (blkFlags && j >= 0 && blkFlags[j] ? blkFlags[j][t] || null : null);
    const guardPct = x => this.numFixed(x * 100, 1) + "%";
    const guardLinesOf = notes => (notes || []).map(g => ({
      label: GUARD_LABEL[g.guard] || g.guard,
      text: [
        g.detail || "",
        typeof g.before === "number" && typeof g.after === "number" ? guardPct(g.before) + " → " + guardPct(g.after) : "",
        g.param && g.value !== undefined && g.value !== null ? PARAM_GUIDE[g.param].label + " " + formatGuardValue(g.param, g.value) : ""
      ].filter(Boolean).join(" · ")
    }));
    const flagLinesOf = flags => (flags || []).map(f => ({
      label: GUARD_FLAG_RULE[f.rule],
      text: "Threshold " + guardPct(f.threshold) + (typeof f.expected === "number" ? " · expected " + guardPct(f.expected) : "")
    }));
    const explainCell = (j, t, isOvr, sizeAt, uplift) => {
      const pct = x => this.numFixed(x * 100, 1) + "%";
      const toneOf = tt => (tt <= cut ? "actual" : "forecast");
      const count = x => Math.round(x).toLocaleString("en-GB");
      const cohortName = jj => {
        const label = cohortLabelOf(jj);
        const ym = parseYm(label);
        return isNaN(ym) ? label : ml(ym);
      };
      const who = (jj, tt) => {
        const b = birthIndexOf(jj);
        return cohortName(jj) + " cohort · " + (b >= 0 ? "month " + (tt - b) : ml(D.months[tt]));
      };
      const tail = rate => {
        const steps = [];
        let value = rate;
        if (t > cut && uplift) {
          steps.push(pct(value) + " × (1 + " + pct(uplift) + " scenario uplift) = " + pct(value * (1 + uplift)));
          value *= 1 + uplift;
        }
        if (!rateView && typeof sizeAt === "number") {
          steps.push(pct(value) + " × " + count(sizeAt) + " entrants = " + count(value * sizeAt) + " orders");
          return { steps, result: count(value * sizeAt) + " orders" };
        }
        return { steps, result: pct(value) };
      };
      if (isOvr) {
        const rule = resolveCohortRule(viewCohortInput, ch, blk, cohortLabelOf(j));
        const r = modelRates && modelRates[j] && typeof modelRates[j][t] === "number" ? modelRates[j][t] : st.rov[this.rovKey(ch, blk, j, t)];
        if (typeof r !== "number") return null;
        const end = tail(r);
        return {
          title: "Manual override",
          rows: [{ label: "Entered by you", value: pct(r) }],
          steps: end.steps,
          result: end.result,
          note: "Clear the cell to go back to " + describeCohortRule(rule) + ".",
          flags: flagLinesOf(flagsAt(j, t))
        };
      }
      const src = modelSources && modelSources[j] ? modelSources[j][t] : null;
      if (!src) return null;
      const takenOut = !!(src.season && src.season.takenOut && blkGuards);
      const factorOfT = x => blkGuards.monthFactors[(D.months[x] % 100) - 1];
      const terms = (src.terms || []).map(p => (takenOut ? Object.assign({}, p, { rate: p.rate / factorOfT(p.t), actual: p.rate }) : p));
      const termSub = (p, extra) => [typeof p.actual === "number" ? pct(p.actual) + " ÷ " + MN[(D.months[p.t] % 100) - 1] + " factor " + this.numFixed(factorOfT(p.t), 3) + " · seasonality taken out" : "", extra].filter(Boolean).join(" · ") || undefined;
      const end = tail(src.result);
      const core = typeof src.base === "number" ? src.base : src.result;
      const flatTailView = !!(blkGuards && blkGuards.flatTail);
      const title = src.fade ? "Long-term fade"
        : src.method === "fallback" ? (flatTailView || !src.rule ? "Average curve" : describeCohortRule(src.rule))
        : src.method === "carry" ? "Carried forward"
        : src.method === "own" ? COHORT_SCREEN_NAME.chain + " · own history"
        : describeCohortRule(src.rule);
      let rows = [], steps = [], note = "";
      const fadeFromText = f => f.from === "curve" ? "from mature cohorts, ages " + f.ages[0] + " to " + f.ages[f.ages.length - 1] : "from the bundle";
      switch (src.fade ? "fade" : src.step === "start" ? "start" : src.method) {
        case "fade": {
          const own = terms[0], f = src.fade, ag = f.age;
          const blended = !!ag && ag.share > 0;
          rows = [
            { label: "This cohort · " + ml(D.months[own.t]), value: pct(own.rate), tone: toneOf(own.t) },
            { label: "Monthly fade · " + fadeFromText(f), value: pct(typeof f.pooled === "number" ? f.pooled : f.value) + " kept each month", tone: "actual" }
          ].concat(blended ? [{ label: "Age " + ag.age + " · " + ag.cohorts + (ag.cohorts === 1 ? " cohort" : " cohorts"), value: pct(ag.rate) + " kept", tone: "actual" }] : []);
          steps = (blended ? [this.numFixed(ag.share, 2) + " × " + pct(ag.rate) + " + " + this.numFixed(1 - ag.share, 2) + " × " + pct(f.pooled) + " = " + pct(ag.value) + " kept at age " + ag.age] : [])
            .concat([pct(own.rate) + " × " + this.numFixed(f.value, 3) + (f.months > 1 ? "^" + f.months : "") + " = " + pct(core)]);
          note = "Too few well-sized cohorts at this age, so the cohort continues from its own latest rate."
            + (blended ? " The fade at this age blends the cohorts that reached it with the overall monthly fade." : "");
          break;
        }
        case "start": {
          const totalW = terms.reduce((a, p) => a + (p.weight || 0), 0);
          rows = terms.map(p => ({ label: who(p.j, p.t), value: pct(p.rate), sub: termSub(p, count(p.weight || 0) + " customers"), tone: toneOf(p.t) }));
          steps = ["Sum of rate × customers ÷ " + count(totalW) + " customers = " + pct(core)];
          note = "No repeat history yet · weighted average of " + terms.map(p => cohortName(p.j)).join(", ");
          break;
        }
        case "prev":
          rows = terms.map(p => ({ label: who(p.j, p.t), value: pct(p.rate), sub: termSub(p), tone: toneOf(p.t) }));
          steps = ["Same month of age, " + src.rule.n + (src.rule.n === 1 ? " cohort" : " cohorts") + " earlier = " + pct(core)];
          break;
        case "avg":
          rows = terms.map(p => ({ label: who(p.j, p.t), value: pct(p.rate), sub: termSub(p), tone: toneOf(p.t) }));
          steps = ["(" + terms.map(p => pct(p.rate)).join(" + ") + ") ÷ " + terms.length + " = " + pct(core)];
          break;
        case "wavg": {
          const totalW = terms.reduce((a, p) => a + p.weight, 0);
          rows = terms.map(p => ({ label: who(p.j, p.t), value: pct(p.rate), sub: termSub(p, count(p.weight) + " customers"), tone: toneOf(p.t) }));
          steps = terms.length <= 4
            ? ["(" + terms.map(p => pct(p.rate) + " × " + count(p.weight)).join(" + ") + ") ÷ " + count(totalW) + " = " + pct(core)]
            : ["Sum of rate × customers ÷ " + count(totalW) + " customers = " + pct(core)];
          break;
        }
        case "chain": {
          const own = terms[0];
          const f = src.factor;
          rows = [{ label: "This cohort last month (" + ml(D.months[own.t]) + ")", value: pct(own.rate), tone: toneOf(own.t) }];
          if (f) {
            rows.push({
              label: f.fromCurve ? "Drop-off factor · average curve" : "Drop-off factor · last " + f.cohorts + (f.cohorts === 1 ? " cohort" : " cohorts"),
              value: "× " + this.numFixed(f.value, 3),
              sub: pct(f.num) + " ÷ " + pct(f.den),
              tone: "actual"
            });
            steps = [pct(own.rate) + " × " + this.numFixed(f.value, 3) + " = " + pct(core)];
          } else {
            steps = ["No comparable cohorts yet · held flat at " + pct(core)];
          }
          break;
        }
        case "seasonal": {
          const base = terms[0];
          const tr = src.trend;
          rows = [{ label: who(base.j, base.t) + " (last year)", value: pct(base.rate), tone: toneOf(base.t) }];
          if (tr) {
            rows.push({
              label: "Trend · last " + tr.pairs + (tr.pairs === 1 ? " cohort" : " cohorts") + " vs a year earlier",
              value: "× " + this.numFixed(tr.value, 3),
              sub: pct(tr.num) + " ÷ " + pct(tr.den) + (tr.capped ? " · capped" : "")
            });
            steps = [pct(base.rate) + " × " + this.numFixed(tr.value, 3) + " = " + pct(src.result)];
          } else {
            steps = ["No year-on-year history · trend 1.000 = " + pct(src.result)];
          }
          break;
        }
        case "own": {
          const o = src.own;
          if (!o) break;
          const decay = o.decays.reduce((a, d) => a * d.value, 1);
          const fromFade = o.decays.some(d => d.fromFade);
          rows = o.anchorMonths.map(m => ({ label: "This cohort · " + ml(D.months[m.t]), value: pct(m.rate), sub: m.level !== m.rate ? "at age " + o.age + ": " + pct(m.level) : undefined, tone: toneOf(m.t) }));
          if (o.decays.length) rows.push({ label: "Typical decay · ages " + o.decays[0].age + " to " + (o.decays[o.decays.length - 1].age + 1), value: "× " + this.numFixed(decay, 3), sub: fromFade ? "includes the long-term fade" : undefined, tone: "actual" });
          steps = (o.anchorMonths.length > 1 ? ["Average of " + o.anchorMonths.length + " latest actual months = " + pct(o.anchor)] : [])
            .concat(o.decays.length ? [pct(o.anchor) + " × " + this.numFixed(decay, 3) + " = " + pct(core)] : []);
          note = "A mature cohort continues from its own latest actuals with the typical month-on-month decay of other cohorts.";
          break;
        }
        case "fixed":
          rows = [{ label: "Fixed rate", value: pct(src.result) }];
          break;
        case "carry":
          rows = terms.map(p => ({ label: "Last known · " + ml(D.months[p.t]), value: pct(p.rate), tone: toneOf(p.t) }));
          break;
        default:
          if (src.curve) {
            rows = [{ label: (src.step === "tail" ? "Long-term tail rate · " : "Size-weighted average of ") + src.curve.cohorts + (src.curve.cohorts === 1 ? " cohort" : " cohorts") + " at month " + src.curve.age, value: pct(core), tone: "actual" }];
          } else {
            rows = terms.map(p => ({ label: who(p.j, p.t), value: pct(p.rate), sub: termSub(p, p.weight ? count(p.weight) + " customers" : ""), tone: toneOf(p.t) }));
            steps = ["Size-weighted average of " + terms.length + (terms.length === 1 ? " cohort" : " cohorts") + " = " + pct(core)];
          }
          note = !src.rule ? ""
            : flatTailView ? describeCohortRule(src.rule) + " had no source cohort for this cell."
            : src.curve ? "No cohort has a real result at this age yet, so the latest age with real results is used."
            : "Too few recent cohorts at this age, so every well-sized cohort at this age is used.";
      }
      if (typeof src.base === "number") {
        let v = src.base;
        const parts = [pct(v)];
        if (src.season) {
          const m = src.season.month - 1;
          v *= src.season.value;
          parts.push((src.season.ratio ? MN[m] + " ÷ " + MN[typeof src.season.from === "number" ? src.season.from - 1 : (m + 11) % 12] + " factor " : MN[m] + " factor ") + this.numFixed(src.season.value, 3));
        }
        if (src.trend) {
          v *= src.trend.value;
          parts.push("trend " + this.numFixed(src.trend.value, 3));
        }
        if (parts.length > 1) steps.push(parts.join(" × ") + " = " + pct(v));
        if (src.season && !src.season.measured) note = [note, "Under 12 months of actuals, so every month factor is 1.000."].filter(Boolean).join(" ");
        if (takenOut) note = [note, "Each source rate has its own month's seasonality taken out, then the " + MN[src.season.month - 1] + " factor is applied."].filter(Boolean).join(" ");
        if (src.carry) {
          const c = src.carry;
          rows.push({ label: "Typed by you · " + ml(D.months[c.t]), value: pct(c.rate), tone: "forecast" });
          steps.push(pct(c.rate) + " × " + pct(c.now) + " ÷ " + pct(c.before) + " = " + pct((c.rate * c.now) / c.before));
          note = [note, "Carries your typed value forward along the method's month-on-month shape."].filter(Boolean).join(" ");
        }
        if (src.change) {
          const c = src.change;
          rows.push({ label: "Retention change · from " + ml(c.start), value: (c.value > 0 ? "+" : "") + pct(c.value), tone: "forecast" });
          steps.push(pct(c.before) + " × (1 " + (c.value < 0 ? "− " : "+ ") + pct(Math.abs(c.value)) + ") = " + pct(c.before * (1 + c.value)));
        }
      }
      if (src.cap) {
        const c = src.cap;
        const g = typeof c.factor === "number" ? c.factor : null;
        rows.push({ label: "Best real rate · " + cohortName(c.j) + " cohort in " + ml(D.months[c.t]), value: pct(c.best), sub: "+ " + pct(c.headroom) + " headroom" + (g !== null ? " · seasonality taken out" : ""), tone: "actual" });
        steps.push("Uncapped " + pct(c.uncapped) + " · capped at " + pct(c.best) + " × (1 + " + pct(c.headroom) + ")" + (g !== null ? " × " + MN[(D.months[t] % 100) - 1] + " factor " + this.numFixed(g, 3) : "") + " = " + pct(src.result));
      }
      const seen = {};
      const highlights = terms.map(p => ({ j: p.j, t: p.t }))
        .concat(src.factor ? src.factor.cells : [], src.trend ? src.trend.cells : [], src.curve ? src.curve.cells : [], src.fade ? src.fade.cells : [], src.carry ? [{ j: src.carry.j, t: src.carry.t }] : [], src.cap ? [{ j: src.cap.j, t: src.cap.t }] : [])
        .filter(c => {
          const key = c.j + ":" + c.t;
          if (c.j < 0 || seen[key]) return false;
          seen[key] = true;
          return true;
        })
        .map(c => {
          const ym = parseYm(cohortLabelOf(c.j));
          return { key: c.j + ":" + c.t, alt: isNaN(ym) ? "" : "g" + Math.floor(ym / 100) + ":" + c.t, tone: toneOf(c.t) };
        });
      return { title, rows, steps: steps.concat(end.steps), result: end.result, note, highlights, guards: guardLinesOf(src.guards), flags: flagLinesOf(flagsAt(j, t)) };
    };
    const pickerOn = !!(viewSpec.kind === "model" && viewSpec.cohortGuards && !usesFlatTail(viewSpec.cohortGuards.engine)) && cohort && !memberCohorts;
    const viewOvrInfo = ((activePub ? activePub.overrideInfo : st.overrideInfo) || {});
    const viewRov = (viewSpec.kind === "model" && viewSpec.rov) || st.rov || {};
    const pctOf = x => (typeof x === "number" ? this.numFixed(x * 100, 1) + "%" : "—");
    const shortDate = iso => {
      const d = new Date(iso);
      return isNaN(d.getTime()) ? "" : d.getDate() + " " + MN[d.getMonth()] + " " + String(d.getFullYear() % 100).padStart(2, "0");
    };
    const whoWhen = info => (info ? (info.by || "Someone") + " on " + shortDate(info.at) : "");
    const acceptedLine = review => "Accepted by " + (review.by || "someone") + " on " + shortDate(review.at) + (review.note ? ": " + review.note : "");
    const cohortNameOf = (cid, b, j) => {
      const co = D.channels[cid] && D.channels[cid][b] ? D.channels[cid][b].cohorts[j] : null;
      const ym = parseYm(co && co.label);
      return isNaN(ym) ? "Bundle" : ml(ym) + " cohort";
    };
    const scopeNameOf = (cid, b) => (D.channels[cid].label || channelCode(cid)) + " · " + (BL[b] || b) + " cohorts";
    const flagList = pickerOn ? flagListOf(st.version) : [];
    const blkFlagList = flagList.filter(f => f.cid === ch && f.b === blk);
    const flagStates = {}, rowMarks = {};
    const rowMarkOf = j => rowMarks[j] || (rowMarks[j] = { open: 0, accepted: 0, ovr: 0 });
    blkFlagList.forEach(f => {
      flagStates[f.j + ":" + f.t] = f.accepted ? "accepted" : "open";
      const r = rowMarkOf(f.j);
      if (f.accepted) r.accepted++; else r.open++;
    });
    const flagStateAt = (j, t) => flagStates[j + ":" + t] || null;
    const overrideListOf = () => {
      if (!pickerOn) return [];
      const out = [];
      Object.keys(viewRov).forEach(k => {
        const p = k.split("|");
        if (p.length !== 4 || !/^\d+$/.test(p[2]) || !/^\d+$/.test(p[3]) || cohortChannelIds.indexOf(p[0]) < 0) return;
        out.push({ key: k, kind: "cell", cid: p[0], b: p[1], j: +p[2], t: +p[3], value: viewRov[k], info: viewOvrInfo[k] || null });
      });
      Object.keys(viewCohortInput).forEach(k => {
        const p = k.split("|");
        if (p.length !== 3 || cohortChannelIds.indexOf(p[0]) < 0) return;
        const cohorts = D.channels[p[0]][p[1]] ? D.channels[p[0]][p[1]].cohorts : [];
        const j = cohorts.findIndex(c => c && String(c.label) === p[2]);
        out.push({ key: k, kind: "cohort", cid: p[0], b: p[1], j, t: null, rule: viewCohortInput[k], info: viewOvrInfo[k] || null });
      });
      return out.sort((x, y) => (x.cid + x.b).localeCompare(y.cid + y.b) || x.j - y.j || (x.t || 0) - (y.t || 0));
    };
    const overrideList = overrideListOf();
    const blkOvrList = overrideList.filter(o => o.cid === ch && o.b === blk);
    blkOvrList.forEach(o => { if (o.j >= 0) rowMarkOf(o.j).ovr++; });
    const blkTabRule = pickerOn ? viewCohortInput[cohortInputKey(ch, blk)] || null : null;
    const blkAuto = viewMeta && viewMeta.auto ? viewMeta.auto[blk] || null : null;
    const blkRuleNow = blkTabRule || (blkAuto ? blkAuto.rule : DEFAULT_COHORT_RULE);
    const blkMonths = pickerOn ? actualMonthsOf({ cohorts: conf[blk] && Array.isArray(conf[blk].cohorts) ? conf[blk].cohorts : [], cut }) : 0;
    const TIP_SEASON = "Each calendar month gets its own adjustment, measured from all your actuals: every January you have, every February, and so on. If January has usually been weaker than a typical month, January forecasts are lowered; if March has usually been stronger, March is raised. One unusual year cannot set it on its own. Needs 12 months of actuals.";
    const TIP_TREND = "Compares cohorts from the last 12 months with the 12 months before, at the same ages. If newer cohorts repeat more or less, the forecast moves by part of that change, within a limit your data sets for each age group, for 1 year.";
    const TIP_SEASON_RATIO = "Each calendar month gets its own adjustment: how much busier or quieter it has been than the months around it, averaged across the years you have. Each forecast is adjusted by its month's factor divided by the factors of the months its source rates came from, so a busy month is never lifted twice. Needs 12 months of actuals.";
    const seasonTipOf = months => (seasonAllowed(months) ? (blkGuards && blkGuards.v4 ? TIP_SEASON_RATIO : TIP_SEASON) : "Needs 12 months of actuals: you have " + months + ".");
    const trendTipOf = (months, method) => method === "chain" ? "Already starts from each cohort's latest actual." : months < 24 ? "Needs 24 months of actuals: you have " + months + "." : TIP_TREND;
    const pickerMethods = PICKER_MAIN.map(m => ({ id: m, label: COHORT_SCREEN_NAME[m], tip: COHORT_METHOD_TIP[m], group: "main" }))
      .concat(PICKER_OTHER.map(m => ({ id: m, label: COHORT_SCREEN_NAME[m], tip: COHORT_METHOD_TIP[m], group: "other" })));
    const accText = a => (typeof a === "number" ? " (" + Math.round(a * 100) + "% accurate)" : "");
    const panelFocus = (cid, b, j, t) => this.goToCohortCell(cid, b, j, t);
    const forecastRow = (() => {
      if (!pickerOn || isAll || allBlocks || !blk) return null;
      const rule = blkRuleNow;
      const months = blkMonths;
      const autoReady = months >= AUTO_MIN_MONTHS;
      const autoOn = !blkTabRule && autoReady;
      const acc = blkAuto && typeof blkAuto.accuracy === "number" ? Math.round(blkAuto.accuracy * 100) : null;
      const windowMonths = blkAuto && blkAuto.window ? blkAuto.window : resolveConstants(viewSpec.cohortGuards.constants).autoWindow;
      const v4 = !!(blkGuards && blkGuards.v4);
      const olderN = v4 && blkMethods ? blkMethods.filter(m => m === "own").length : 0;
      const newerN = v4 && blkMethods ? blkMethods.filter(m => m === "tab").length : 0;
      const threshold = v4 ? blkGuards.ownMinMonths : null;
      const plural = (n, one, many) => n + " " + (n === 1 ? one : many);
      const olderLines = !v4 ? [] : threshold === null
        ? [
          "No cohort is older yet.",
          "After " + AUTO_MIN_MONTHS + " months of actuals, your data sets how many actual months a cohort needs.",
          "Until then, every cohort uses the newer cohorts option."
        ]
        : [
          "Once a cohort has " + threshold + " actual months, it continues from its own latest actual and follows the usual month to month drop of recent cohorts.",
          threshold + " is set " + thresholdSource(blkGuards) + ".",
          plural(olderN, "older cohort", "older cohorts") + " · " + plural(newerN, "newer cohort", "newer cohorts")
        ];
      const olderTip = olderLines.join("\n");
      const apply = next => this.setCohortInput(ch, blk, null, next);
      const [nMin, nMax] = RECENT_N_LIMITS;
      const nFor = m => (m === rule.method ? rule.n : m === "prev" ? 1 : Math.max(nMin, Math.min(nMax, rule.n || 3)));
      const v3 = blkV3;
      const retentionOn = v3 && blkGuards.retention.value !== 0 && blkGuards.retention.start !== null;
      const retentionMonths = v3 ? this.retentionStartMonths(blkGuards) : null;
      const pick = m => {
        const next = { method: m, n: nFor(m) };
        if (rule.season && seasonAllowed(months)) next.season = true;
        if (!v3 && rule.trend && trendAllowed(months, m)) next.trend = true;
        this.setState({ forecastMenu: false });
        apply(next);
      };
      const showN = rule.method === "wavg" || rule.method === "avg";
      const seasonOk = seasonAllowed(months), trendOk = trendAllowed(months, rule.method);
      const changedKey = cohortGuardKey(ch, blk);
      const changed = isDraft ? (st.autoChanged || {})[changedKey] : null;
      const trendYear = blkGuards && typeof blkGuards.trendYear === "number" ? blkGuards.trendYear : null;
      const years = blkGuards && blkGuards.params && blkGuards.params.trendApplications && typeof blkGuards.params.trendApplications.value === "number" ? blkGuards.params.trendApplications.value : 1;
      const trendHeld = !!(blkGuards && blkGuards.trendHeld);
      const trendMonths = blkGuards && blkGuards.params && blkGuards.params.trendWindow && typeof blkGuards.params.trendWindow.value === "number" ? blkGuards.params.trendWindow.value : 12;
      const trendLimitsInfo = blkGuards && blkGuards.params ? blkGuards.params.trendLimits : null;
      const openN = blkFlagList.filter(f => !f.accepted).length;
      const accN = blkFlagList.length - openN;
      const ovrN = blkOvrList.length;
      const firstOpen = blkFlagList.find(f => !f.accepted);
      const panelView = !st.flagPanel ? "" : st.flagPanel.tab === "overrides" ? "overrides" : st.flagPanel.filter === "accepted" ? "accepted" : "open";
      return {
        disabled: !isDraft,
        forecastTip: "How future repeat orders are worked out. Auto is selected by default.",
        autoOn,
        autoDisabled: !isDraft || !autoReady,
        autoLabel: autoReady && acc !== null ? "Auto · " + acc + "% accurate" : "Auto",
        autoTip: autoReady
          ? "Auto tries every option on your last " + windowMonths + " months of actuals" + (v4 && windowMonths >= FULL_YEAR_WINDOW ? ", so every calendar month is checked," : "") + " and uses the most accurate, switches included." + (acc !== null && v4 && windowMonths < FULL_YEAR_WINDOW ? " " + acc + "% accurate · " + windowMonths + " months tested." : "") + (acc !== null ? " For example, " + acc + "% accurate means its forecasts for those months were " + (100 - acc) + "% away from what actually happened, on average." : "") + " It re-checks when new actuals arrive; published versions never change." + (blkAuto ? " Now using: " + describeCohortChoice(blkAuto.rule) + "." : "")
          : "Needs 18 months of actuals: you have " + months + ".",
        onAuto: () => { if (isDraft && autoReady && blkTabRule) apply(null); },
        autoChanged: changed ? {
          tip: "After the latest data refresh, Auto switched from " + describeCohortChoice(changed.from.rule) + accText(changed.from.accuracy) + " to " + describeCohortChoice(changed.to.rule) + accText(changed.to.accuracy) + ". This is recorded in the version history. Published versions are not affected.",
          onSeen: () => this.dismissAutoChanged(changedKey)
        } : null,
        methodLabel: COHORT_SCREEN_NAME[rule.method] || "",
        methodTip: v4
          ? [
            { title: NEWER_COHORTS, lines: ["Use the option picked in this list to work out their future months.", "Open the list and hover the info icon beside each option to see what it does."] },
            { title: OLDER_COHORTS, lines: olderLines }
          ]
          : "How each cohort's future months are worked out. Open the list and hover the info icon beside each option to see what it does.",
        newerLabel: v4 ? NEWER_COHORTS : "",
        mainTitle: v4 ? NEWER_COHORTS + ": main options" : "Main options",
        otherTitle: v4 ? NEWER_COHORTS + ": other options" : "Other options",
        menuFooter: v4 ? { text: "Older cohorts always use " + COHORT_SCREEN_NAME.chain, tip: olderTip } : null,
        menuOpen: isDraft && !!st.forecastMenu,
        onMenu: () => { if (isDraft) this.setState(s => ({ forecastMenu: !s.forecastMenu })); },
        onMenuClose: () => this.setState({ forecastMenu: false }),
        main: pickerMethods.filter(m => m.group === "main").map(m => Object.assign({}, m, { selected: rule.method === m.id, onPick: () => pick(m.id) })),
        other: pickerMethods.filter(m => m.group === "other").map(m => Object.assign({}, m, { selected: rule.method === m.id, onPick: () => pick(m.id) })),
        showN,
        nText: String(rule.n || ""),
        nTip: "Cohorts: how many recent cohorts are used.",
        canDec: isDraft && showN && rule.n > nMin,
        canInc: isDraft && showN && rule.n < nMax,
        onDec: () => { if (showN && rule.n > nMin) apply(Object.assign({}, rule, { n: rule.n - 1 })); },
        onInc: () => { if (showN && rule.n < nMax) apply(Object.assign({}, rule, { n: rule.n + 1 })); },
        season: { on: !!rule.season, disabled: !isDraft || !seasonOk, tip: seasonTipOf(months), onToggle: () => apply(Object.assign({}, rule, { season: !rule.season })) },
        trend: v3 ? null : { on: !!rule.trend, disabled: !isDraft || !trendOk, tip: trendTipOf(months, rule.method), onToggle: () => apply(Object.assign({}, rule, { trend: !rule.trend })) },
        retention: v3 ? {
          on: retentionOn,
          text: "Retention change " + (retentionOn ? (blkGuards.retention.value > 0 ? "+" : "") + this.numFixed(blkGuards.retention.value * 100, 1) + "% from " + ml(blkGuards.retention.start) : "0%"),
          tip: "A planned change in how many customers come back. It multiplies every forecast repeat rate, the bundle included, from the start month. The forecast follows the data at 0%. Select to change it.",
          open: !!st.retentionPop,
          disabled: !isDraft,
          onOpen: () => this.setState(s => ({ retentionPop: !s.retentionPop })),
          onClose: () => this.setState({ retentionPop: false }),
          change: {
            label: PARAM_GUIDE.retentionChange.label,
            desc: RETENTION_CHANGE_DESC,
            value: blkGuards.params.retentionChange && blkGuards.params.retentionChange.source === "user" ? formatGuardValue("retentionChange", blkGuards.params.retentionChange.value) : "",
            placeholder: formatGuardValue("retentionChange", blkGuards.params.retentionChange ? blkGuards.params.retentionChange.system : 0)
          },
          start: {
            label: PARAM_GUIDE.retentionChangeStart.label,
            desc: RETENTION_START_DESC,
            value: retentionMonths.value,
            options: retentionMonths.options.map(o => ({ value: o.value, label: formatMonth(o.value) }))
          },
          onApply: (changeText, startYm) => {
            const ok = this.setRetentionChange(changedKey, changeText, startYm);
            if (ok) this.setState({ retentionPop: false });
            return ok;
          },
          canReset: isDraft && [blkGuards.params.retentionChange, blkGuards.params.retentionChangeStart].some(p => p && p.source === "user"),
          onReset: () => { if (this.resetRetentionChange(changedKey)) this.setState({ retentionPop: false }); }
        } : null,
        trendPill: !v3 && rule.trend && trendYear !== null ? (trendHeld ? "Held at 0%" : (trendYear >= 0 ? "+" : "−") + this.numFixed(Math.abs(trendYear) * 100, 1) + "% " + trendPeriodText(trendMonths) + " · " + trendTimesText(trendMonths, years)) : "",
        trendHeld,
        trendPillTip: trendYear === null ? "" : trendHeld
          ? "Measured from your actuals: repeat rates are " + (trendYear >= 0 ? "rising" : "falling") + " by " + this.numFixed(Math.abs(trendYear) * 100, 1) + "% " + trendPeriodText(trendMonths) + ", but none of it is applied because Largest yearly change in retention is 0%" + (trendLimitsInfo && trendLimitsInfo.source === "user" ? " (your setting)." : ". " + (trendLimitsInfo && trendLimitsInfo.reason ? trendLimitsInfo.reason + "." : "")) + " To use the trend, go to Settings and set Largest yearly change in retention, for example −10% and +10%."
          : trendMonths === 12
            ? "Year on year trend measured from your actuals: repeat rates are " + (trendYear >= 0 ? "rising" : "falling") + " by " + this.numFixed(Math.abs(trendYear) * 100, 1) + "% a year compared with the same months a year earlier. The forecast carries this change forward for " + years + (years === 1 ? " year" : " years") + ", then holds it flat. To change the limits, go to Settings and edit Largest yearly change in retention and Years the trend is carried forward."
            : "Trend measured from your actuals: repeat rates of the latest " + trendMonths + " months of cohorts are " + (trendYear >= 0 ? "higher" : "lower") + " by " + this.numFixed(Math.abs(trendYear) * 100, 1) + "% than the " + trendMonths + " months before. The forecast applies this change " + (years === 1 ? "once" : years + " times") + ", then holds it flat. To change it, go to Settings and edit Months compared to measure the trend, Largest yearly change in retention and Times the trend is applied.",
        openText: openN ? openN + " to review" : "",
        openActive: panelView === "open",
        acceptedActive: panelView === "accepted",
        overridesActive: panelView === "overrides",
        openTip: "Red cells that break a rule and still need someone to accept or change them. Select to review them.",
        onOpenFlags: () => {
          this.openFlagPanel("flags", "open");
          if (firstOpen) panelFocus(firstOpen.cid, firstOpen.b, firstOpen.j, firstOpen.t);
        },
        acceptedText: accN ? accN + " accepted" : "",
        acceptedTip: "Flags someone has reviewed and accepted. Select to see them.",
        onAcceptedFlags: () => this.openFlagPanel("flags", "accepted"),
        overridesText: ovrN ? ovrN + (ovrN === 1 ? " override" : " overrides") : "",
        overridesTip: "Values and cohort choices someone has set by hand. Select to see them.",
        onOverrides: () => this.openFlagPanel("overrides", "open"),
        fixedNote: isDraft ? [st.fixedNote ? "Fixed percentage is no longer a forecast method. Its rates were kept as overrides." : "", st.trendNote ? "Year on year trend is no longer a forecast option. It was removed from " + st.trendNote + (st.trendNote === 1 ? " rule." : " rules.") + " Use Retention change to plan a change." : ""].filter(Boolean).join(" ") : "",
        onFixedNoteClose: () => this.setState({ fixedNote: false, trendNote: 0 })
      };
    })();
    const flagPanel = (() => {
      const fp = st.flagPanel;
      if (!fp || !pickerOn) return null;
      const accepted = fp.filter === "accepted";
      const shown = blkFlagList.filter(f => f.accepted === accepted);
      const focus = st.focusCell;
      const isFocus = (cid, b, j, t) => !!focus && focus.ch === cid && focus.blk === b && focus.j === j && focus.t === t;
      const engineOf = (() => {
        if (fp.tab !== "overrides") return () => null;
        const cache = {};
        return o => {
          if (o.kind !== "cell") return null;
          if (!cache[o.cid]) {
            const stripped = {};
            Object.keys(viewRov).forEach(k => { if (k.indexOf(o.cid + "|") !== 0) stripped[k] = viewRov[k]; });
            const sp = viewSpec.kind === "model" ? viewSpec : {};
            cache[o.cid] = (this.run(o.cid, sp.scen || zero, null, { inputs: sp.inputs, rov: stripped, cohortInput: sp.cohortInput, cohortGuards: sp.cohortGuards, cohortAuto: sp.cohortAuto, mixInput: sp.mixInput, cogsInput: sp.cogsInput }).__meta || {}).rates || {};
          }
          const r = cache[o.cid][o.b];
          return r && r[o.j] && typeof r[o.j][o.t] === "number" ? r[o.j][o.t] : null;
        };
      })();
      return {
        tab: fp.tab,
        onClose: () => this.closeFlagPanel(),
        only: !!fp.only,
        onlyLabel: fp.tab === "overrides" ? "Show overridden rows only" : "Show flagged rows only",
        onOnly: () => this.setFlagPanel({ only: !fp.only }),
        flagsEmpty: accepted ? "No accepted flags." : "No flags to review.",
        flags: shown.map(f => ({
          key: f.key,
          scope: scopeNameOf(f.cid, f.b),
          where: cohortNameOf(f.cid, f.b, f.j) + " · " + ml(D.months[f.t]),
          what: f.accepted
            ? pctOf(f.value) + " kept" + (f.review.note ? ". Note: \"" + f.review.note + "\"" : "")
            : pctOf(f.value) + " · " + f.flags.map(x => GUARD_FLAG_RULE[x.rule]).join(" · ") + (f.reopened ? ". " + f.reopened : ""),
          status: f.accepted ? "Accepted by " + (f.review.by || "someone") + " on " + shortDate(f.review.at) : "Open",
          accepted: f.accepted,
          focused: isFocus(f.cid, f.b, f.j, f.t),
          onGo: () => panelFocus(f.cid, f.b, f.j, f.t),
          onAccept: isDraft && !f.accepted ? () => this.acceptFlag(f.cid, f.b, f.j, f.t) : null
        })),
        overridesEmpty: "No overrides.",
        overrides: blkOvrList.map(o => {
          const engine = engineOf(o);
          const tab = resolveCohortRule(viewCohortInput, o.cid, o.b);
          return {
            key: o.key,
            scope: scopeNameOf(o.cid, o.b),
            where: o.j >= 0 ? cohortNameOf(o.cid, o.b, o.j) + (o.kind === "cell" ? " · " + ml(D.months[o.t]) : "") : "Cohort " + o.key.split("|")[2],
            what: o.kind === "cell"
              ? "Set by user: " + pctOf(o.value) + (engine !== null ? " · method gave " + pctOf(engine) : "")
              : "Own choice: " + describeCohortRule(o.rule) + (viewCohortInput[cohortInputKey(o.cid, o.b)] ? " · tab: " + describeCohortChoice(tab) : " · tab: Auto"),
            who: o.info ? whoWhen(o.info) : "",
            note: o.info && o.info.note ? o.info.note : "",
            focused: o.kind === "cell" && isFocus(o.cid, o.b, o.j, o.t),
            onGo: () => panelFocus(o.cid, o.b, Math.max(0, o.j), o.t),
            onClear: isDraft ? () => this.clearOverride(o.key) : null
          };
        })
      };
    })();
    const reviewCard = (() => {
      const rc = st.reviewCell;
      if (!rc || !pickerOn || rc.ch !== ch || rc.blk !== blk) return null;
      const f = blkFlagList.find(x => x.j === rc.j && x.t === rc.t);
      if (!f) return null;
      const kind = modelKinds && modelKinds[rc.j] ? modelKinds[rc.j][rc.t] : null;
      const trace = explainCell(rc.j, rc.t, kind === "override", sizes[rc.j], chScen["rep_" + blk] || 0);
      return {
        title: cohortNameOf(ch, blk, rc.j) + " · " + ml(D.months[rc.t]),
        value: pctOf(f.value),
        rules: flagLinesOf(f.flags),
        trace: trace ? { title: trace.title, rows: trace.rows || [], steps: trace.steps || [] } : null,
        accepted: f.accepted,
        acceptedText: f.accepted ? acceptedLine(f.review) : f.reopened || "",
        canAccept: isDraft && !f.accepted,
        canChange: isDraft && rc.t > cut,
        valueText: typeof f.value === "number" ? this.numFixed(f.value * 100, 1) : "",
        onAccept: () => this.acceptFlag(ch, blk, rc.j, rc.t),
        onChange: raw => { this.editRate(ch, blk, rc.j, rc.t, raw); this.closeReview(); },
        onReopen: f.accepted && isDraft ? () => this.reopenFlag(ch, blk, rc.j, rc.t) : null,
        onCancel: () => this.closeReview()
      };
    })();
    const focusKey = pickerOn && st.focusCell && st.focusCell.ch === ch && st.focusCell.blk === blk ? st.focusCell.j + ":" + st.focusCell.t : "";
    const cellFor = (ratios, sizeAt, j, col) => {
      const idxs = col.idxs, single = idxs.length === 1, t = idxs[0];
      const uplift = (chScen["rep_" + blk] || 0);
      let rateSum = null, cmpSum = null, anyOvr = false, ordersOverride = null, fromPlan = false, computed = false, fellBack = false;
      idxs.forEach(i => {
        const fileRatio = ratios[i];
        const resolved = resolveRatio(j, i, fileRatio, sizeAt);
        if (resolved.ovr) anyOvr = true;
        if (resolved.fromPlan) fromPlan = true;
        if (resolved.computed) computed = true;
        if (resolved.fallback) fellBack = true;
        if (resolved.ordersOverride != null && single) ordersOverride = resolved.ordersOverride;
        if (resolved.ratio === null || resolved.ratio === undefined) return;
        rateSum = (rateSum === null ? 0 : rateSum) + resolved.ratio * (i > cut ? 1 + uplift : 1);
        if (cmpOn) {
          const cr = j >= 0 ? cmpRate(j, i) : fileRatio;
          if (cr !== null) cmpSum = (cmpSum === null ? 0 : cmpSum) + cr;
        }
      });
      const cmpSizeAt = j >= 0 ? cmpSizes[j] : sizeAt;
      const valOf = (rs, sz) => rs === null ? null : (rateView ? rs : ((sz === null || sz === undefined) ? null : sz * rs));
      let v = valOf(rateSum, sizeAt);
      if (!rateView && v === null && ordersOverride != null) v = ordersOverride;
      const cv = cmpOn ? valOf(cmpSum, cmpSizeAt) : null;
      const matured = idxs.every(i => i <= cut);
      const birthIdx = birthIndexOf(j);
      const isBirth = birthIdx >= 0 && t === birthIdx;
      const absent = birthIdx >= 0 && t < birthIdx;
      const editable = isDraft && rateView && single && j >= 0 && t > cut && !deltaMode && !absent && !isBirth;
      const hasVal = v !== null && v !== undefined && Number.isFinite(v);
      const planLocked = hasVal && (isBirth || fromPlan || matured);
      const fmtC = x => typeof x !== "number" || !Number.isFinite(x) ? "—" : rateView ? this.numFixed(x * 100, 1) : Math.round(x).toLocaleString("en-GB");
      const parts = [];
      if (showVal) parts.push({
        text: fmtC(v),
        size: "11.5px",
        fw: anyOvr ? 600 : (planLocked ? 600 : 400),
        fg: !hasVal ? "#C8D4EA" : anyOvr ? "#0052CD" : planLocked ? "#08234C" : "#4D6389"
      });
      if (showAbs || showPct) {
        const bad = v === null || cv === null;
        const d = bad ? null : v - cv;
        const tiny = bad ? false : (rateView ? Math.abs(d) < 0.0005 : Math.abs(d) < 0.5);
        const dfg = (bad || tiny) ? "#8094B5" : d > 0 ? "#1A7F4B" : "#E5484D";
        if (showAbs) parts.push({ text: (bad || tiny) ? "—" : (d >= 0 ? "+" : "−") + fmtC(Math.abs(d)), size: "10px", fw: 500, fg: dfg });
        if (showPct) parts.push({ text: (bad || tiny || !cv) ? "—" : (d >= 0 ? "+" : "−") + this.numFixed(Math.abs((d / cv) * 100), 1) + "%", size: "10px", fw: 500, fg: dfg });
      }
      const shade = rateSum === null ? null : (single ? rateSum : rateSum / idxs.length);
      const commit = editable ? (raw => this.editRate(ch, blk, j, t, raw)) : null;
      const darkBlueBg = hasVal && planLocked
        ? "rgba(0,82,205," + this.numFixed(0.04 + Math.min(0.26, (shade || rateSum || 0.5) * 0.26), 3) + ")"
        : null;
      const tip = anyOvr ? "Manual override"
        : fellBack ? "No source cohort · average of matured cohorts at this age"
        : computed ? describeCohortRule(resolveCohortRule(viewCohortInput, ch, blk, cohortLabelOf(j))) : "";
      const flagged = single && hasVal ? flagsAt(j, t) : null;
      const flagState = flagged && pickerOn ? flagStateAt(j, t) : flagged ? "open" : null;
      const accepted = flagState === "accepted";
      if (flagged && parts.length) parts[0].fg = accepted ? "#0F7A55" : "#B42318";
      const review = accepted ? blkFlagList.find(f => f.j === j && f.t === t) : null;
      const baseExplain = tip ? (single ? explainCell(j, t, anyOvr, sizeAt, uplift) : null) || { title: tip, rows: [], steps: [], result: "" }
        : flagged ? { title: "Red cell", rows: [], steps: [], result: fmtC(v) + (rateView ? "%" : " orders"), flags: flagLinesOf(flagged) } : null;
      const explain = baseExplain && review ? Object.assign({}, baseExplain, { review: acceptedLine(review.review) }) : baseExplain;
      const reviewable = !!flagState && pickerOn && single && j >= 0;
      const asInput = editable && !reviewable;
      return {
        isInput: asInput, isText: !asInput, text: parts.length ? parts[0].text : "—", parts: parts, deltas: parts.slice(1),
        tip: tip || (flagged ? "Red cell" : ""),
        explain: explain,
        flagged: !!flagged,
        flagState,
        ovrMark: pickerOn && single && anyOvr,
        focused: !!focusKey && single && focusKey === j + ":" + t,
        onReview: reviewable ? () => this.openReview(ch, blk, j, t) : null,
        cellKey: single && j >= 0 ? j + ":" + t : "",
        onCommit: commit,
        onChange: commit,
        bg: flagged ? (accepted ? "#E5F5EC" : "#FDECEC") : !hasVal ? (editable ? "#FFFDEB" : "#FFFFFF") : (darkBlueBg || (anyOvr ? "rgba(0,179,255,0.16)" : editable ? "#FFFDEB" : "rgba(0,179,255,0.06)")),
        fg: parts.length ? parts[0].fg : "#C8D4EA",
        fw: anyOvr || planLocked ? 600 : 400,
        edge: idxs[idxs.length - 1] === cut ? "2px solid #08234C" : "1px solid transparent"
      };
    };

    const fmtCount = x => typeof x === "number" && Number.isFinite(x) ? Math.round(x).toLocaleString("en-GB") : "—";
    let cohortRows = [];
    const viewBlocks = allBlocks ? cohortBlocks : [blk];
    const cohortViews = memberCohorts
      ? cohortMembers.reduce((acc, m) => acc.concat(viewBlocks.filter(b => channelBlocks(m, D).indexOf(b) >= 0).map(b => blockView(b, m))), [])
      : !cohort ? [] : allBlocks ? cohortBlocks.map(b => blockView(b)) : [blkView];
    if (cohortViews.some(v => v.cohorts.length)) {
      const parts = [];
      cohortViews.forEach(v => v.cohorts.forEach((c, j) => {
        const ym = parseYm(c.label);
        if (j === 0 || isNaN(ym) || (v.legacy && v.legacy.folded[j])) return;
        const ent = v.entrants[D.months.indexOf(ym)];
        const size = v.sizes[j];
        parts.push({ v, j, ym, ratio: c.ratio || new Array(n).fill(null), size, entrants: typeof ent === "number" ? ent : (typeof size === "number" ? size : null), group: String(Math.floor(ym / 100)) });
      }));
      const items = summedCohorts
        ? Array.from(new Set(parts.map(p => p.ym))).map(ym => {
          const own = parts.filter(p => p.ym === ym);
          const known = own.filter(p => p.entrants !== null);
          return { j: -1, ym, parts: own, entrants: known.length ? known.reduce((a, p) => a + p.entrants, 0) : null, group: own[0].group };
        })
        : parts;
      items.sort((x, y) => x.ym - y.ym);
      const partsOf = members => members.reduce((acc, it) => acc.concat(it.parts || [it]), []);
      const order = Array.from(new Set(items.map(i => i.group))).sort();
      const cutoffYm = D.months[cut];
      const focusYear = String(Math.floor((cutoffYm || D.months[0] || 2025) / 100));
      const sumEntrants = members => members.reduce((acc, it) => it.entrants === null ? acc : (acc === null ? 0 : acc) + it.entrants, null);
      const legacyViews = cohortViews.filter(v => v.legacy);
      const legacyAt = colDef => {
        let ord = null, size = 0;
        legacyViews.forEach(v => colDef.idxs.forEach(i2 => {
          const o = v.legacy.orders[i2];
          if (typeof o !== "number") return;
          ord = (ord === null ? 0 : ord) + o * (i2 > cut ? 1 + (chScen["rep_" + v.b] || 0) : 1);
          size += v.legacy.size;
        }));
        return { ord, size };
      };
      const aggregateCells = (members, gid, plain, withLegacy) => cols.map(colDef => {
        let ord = null, wNum = 0, wDen = 0, cOrd = null, cNum = 0, cDen = 0;
        const byView = {};
        const repeatOnly = pickerOn && rateView && !plain;
        if (withLegacy) {
          const lg = legacyAt(colDef);
          if (lg.ord !== null) { ord = lg.ord; wNum += lg.ord; wDen += lg.size; }
        }
        partsOf(members).forEach(it => {
          const part = byView[it.v.id] || (byView[it.v.id] = { label: it.v.label, b: it.v.b, ord: null, num: 0, den: 0 });
          const birthIdx = repeatOnly ? D.months.indexOf(it.ym) : -1;
          colDef.idxs.forEach(i2 => {
            if (repeatOnly && i2 <= birthIdx) return;
            const resolved = it.v.resolveRatio(it.j, i2, it.ratio[i2], it.size);
            const r = resolved.ratio;
            if (r !== null && r !== undefined && it.size !== null && it.size !== undefined) {
              const eff = r * (i2 > cut ? 1 + (chScen["rep_" + it.v.b] || 0) : 1);
              ord = (ord === null ? 0 : ord) + it.size * eff;
              wNum += it.size * eff; wDen += it.size;
              part.ord = (part.ord === null ? 0 : part.ord) + it.size * eff;
              part.num += it.size * eff; part.den += it.size;
            } else if (!rateView && resolved.ordersOverride != null) {
              ord = (ord === null ? 0 : ord) + resolved.ordersOverride;
              part.ord = (part.ord === null ? 0 : part.ord) + resolved.ordersOverride;
            }
            if (!cmpOn) return;
            const cr = it.v.cmpRate(it.j, i2);
            const cs = it.v.cmpSizes[it.j];
            if (cr === null || cr === undefined || cs === null || cs === undefined) return;
            cOrd = (cOrd === null ? 0 : cOrd) + cs * cr;
            cNum += cs * cr; cDen += cs;
          });
        });
        const rate = wDen ? wNum / wDen : null;
        const cRate = cDen ? cNum / cDen : null;
        const shown = rateView ? (typeof rate === "number" ? this.numFixed(rate * 100, 1) : "—") : (typeof ord === "number" ? Math.round(ord).toLocaleString("en-GB") : "—");
        const empty = ord === null && rate === null;
        const matured = colDef.idxs.every(i2 => i2 <= cut);
        const gParts = showVal ? [{ text: shown, size: "11.5px", fw: plain && !matured ? 400 : 600, fg: empty ? "#C8D4EA" : plain && !matured ? "#4D6389" : "#08234C" }] : [];
        if (showAbs || showPct) {
          const v = rateView ? rate : ord, cv = rateView ? cRate : cOrd;
          const bad = v === null || cv === null;
          const d = bad ? null : v - cv;
          const tiny = bad ? false : (rateView ? Math.abs(d) < 0.0005 : Math.abs(d) < 0.5);
          const dfg = (bad || tiny) ? "#8094B5" : d > 0 ? "#1A7F4B" : "#E5484D";
          const fmtG = x => typeof x !== "number" || !Number.isFinite(x) ? "—" : rateView ? this.numFixed(x * 100, 1) : Math.round(x).toLocaleString("en-GB");
          if (showAbs) gParts.push({ text: (bad || tiny) ? "—" : (d >= 0 ? "+" : "−") + fmtG(Math.abs(d)), size: "10px", fw: 500, fg: dfg });
          if (showPct) gParts.push({ text: (bad || tiny || !cv) ? "—" : (d >= 0 ? "+" : "−") + this.numFixed(Math.abs((d / cv) * 100), 1) + "%", size: "10px", fw: 500, fg: dfg });
        }
        const explain = summedCohorts && !empty ? (() => {
          const pct = x => this.numFixed(x * 100, 1) + "%";
          const count = x => Math.round(x).toLocaleString("en-GB");
          const base = colDef.idxs.length > 1 ? "entrant-months" : "entrants";
          const tone = matured ? "actual" : "forecast";
          const used = cohortViews.map(v => byView[v.id]).filter(p => p && (p.ord !== null || p.den));
          const rows = used.map(p => rateView
            ? { label: p.label, sub: count(p.num) + " orders ÷ " + count(p.den) + " " + base, value: p.den ? pct(p.num / p.den) : "—", tone }
            : { label: p.label, value: p.ord === null ? "—" : count(p.ord) + " orders", tone });
          const steps = rateView
            ? ["(" + used.map(p => count(p.num)).join(" + ") + ") orders ÷ (" + used.map(p => count(p.den)).join(" + ") + ") " + base + " = " + (typeof rate === "number" ? pct(rate) : "—")]
            : [used.map(p => count(p.ord || 0)).join(" + ") + " = " + (typeof ord === "number" ? count(ord) : "—") + " orders"];
          return {
            title: memberCohorts ? conf.label + " · " + (allBlocks ? "All cohorts" : BL[blk] + " cohorts") : used.map(p => BL[p.b]).join(" + "),
            rows,
            steps,
            result: rateView ? (typeof rate === "number" ? pct(rate) : "—") : (typeof ord === "number" ? count(ord) + " orders" : "—"),
            note: memberCohorts
              ? "Read only · summed from " + cohortMembers.map(m => D.channels[m].label).join(" + ") + ". Edit on each channel."
              : "Read only · edit on " + cohortBlocks.map(b => BL[b] + " cohorts").join(" or ") + "."
          };
        })() : null;
        return {
          isInput: false, isText: true, text: shown, onChange: null,
          parts: gParts, deltas: gParts.slice(1), explain,
          bg: empty ? "#FFFFFF" : plain ? (matured ? "rgba(0,82,205," + this.numFixed(0.04 + Math.min(0.26, (rate || 0.5) * 0.26), 3) + ")" : "rgba(0,179,255,0.06)") : (matured ? "#EDF1F8" : "#F7FAFD"),
          fg: empty ? "#C8D4EA" : plain && !matured ? "#4D6389" : "#08234C", fw: plain && !matured ? 400 : 600,
          edge: colDef.idxs[colDef.idxs.length - 1] === cut ? "2px solid #08234C" : "1px solid transparent",
          cellKey: gid && colDef.idxs.length === 1 ? "g" + gid + ":" + colDef.idxs[0] : ""
        };
      });
      if (legacyViews.length) {
        const count = x => Math.round(x).toLocaleString("en-GB");
        const legacyExplain = colDef => {
          if (legacyViews.length !== 1 || colDef.idxs.length !== 1) return null;
          const v = legacyViews[0], src = v.legacy.sources[colDef.idxs[0]];
          if (!src) return null;
          const retention = v.guards && v.guards.params.legacyRetention ? v.guards.params.legacyRetention : null;
          const steps = src.method === "actual"
            ? ["Sum of orders across the folded cohorts = " + count(src.result)]
            : [(src.method === "seasonal" ? ml(D.months[src.from]) + " actual " : "Average month ") + count(src.base) + " orders × " + this.numFixed(src.retention, 3) + " to the power " + src.power + (typeof src.change === "number" ? " × (1 " + (src.change < 0 ? "− " : "+ ") + this.numFixed(Math.abs(src.change) * 100, 1) + "% retention change)" : "") + " = " + count(src.result)];
          return {
            title: "Legacy block · cohorts before " + ml(v.legacy.cutoff),
            rows: [{ label: src.method === "actual" ? "Actual orders" : "Legacy monthly retention", value: src.method === "actual" ? count(src.result) : this.numFixed(src.retention, 3), tone: src.method === "actual" ? "actual" : "forecast" }]
              .concat(typeof src.change === "number" ? [{ label: "Retention change", value: (src.change > 0 ? "+" : "") + this.numFixed(src.change * 100, 1) + "%", tone: "forecast" }] : []),
            steps,
            result: count(src.result) + " orders",
            note: src.method === "actual" ? "" : retention ? retention.reason + "." : ""
          };
        };
        cohortRows.push({
          label: legacyViews.length === 1 ? "Pre " + ml(legacyViews[0].legacy.cutoff) : "Legacy cohorts",
          note: "",
          entrants: fmtCount(legacyViews.reduce((a, v) => a + v.legacy.size, 0)),
          entrantsFg: "#8094B5", nameBg: "#F5F8FA", fw: 600, marker: "", indent: "14px",
          cursor: "default", markerBg: "transparent", onToggle: null, legacy: true,
          cells: cols.map(colDef => {
            const lg = legacyAt(colDef);
            const matured = colDef.idxs.every(i2 => i2 <= cut);
            const rate = lg.ord !== null && lg.size > 0 ? lg.ord / lg.size : null;
            const shown = rateView ? (rate !== null ? this.numFixed(rate * 100, 1) : "—") : (lg.ord !== null ? count(lg.ord) : "—");
            const empty = lg.ord === null;
            const fg = empty ? "#C8D4EA" : matured ? "#08234C" : "#4D6389";
            return {
              isInput: false, isText: true, text: shown, onChange: null,
              parts: showVal ? [{ text: shown, size: "11.5px", fw: 500, fg }] : [], deltas: [],
              explain: empty ? null : legacyExplain(colDef),
              bg: empty ? "#FFFFFF" : matured ? "#EDF1F8" : "#F7FAFD", fg, fw: 500,
              edge: colDef.idxs[colDef.idxs.length - 1] === cut ? "2px solid #08234C" : "1px solid transparent",
              cellKey: ""
            };
          }),
          rowCss: ""
        });
      }
      order.forEach(gid => {
        const members = items.filter(i => i.group === gid);
        if (!members.length) return;
        const open = st.groups[gid] === undefined ? (gid === focusYear) : !!st.groups[gid];
        cohortRows.push({
          label: gid,
          note: members.length + " months",
          entrants: fmtCount(sumEntrants(members)),
          entrantsFg: "#08234C", nameBg: "#F5F8FA", fw: 600, marker: open ? "−" : "+", indent: "14px",
          cursor: "pointer", markerBg: "#E4EBF7", onToggle: () => this.setState(s => { const g = Object.assign({}, s.groups); g[gid] = !g[gid]; return { groups: g }; }),
          cells: aggregateCells(members, gid), rowCss: ""
        });
        if (!open) return;
        members.forEach(it => {
          if (summedCohorts) {
            const birthIdx = D.months.indexOf(it.ym);
            cohortRows.push({
              label: ml(it.ym),
              note: "",
              entrants: fmtCount(it.entrants),
              entrantsFg: birthIdx > cut ? "#0052CD" : "#4D6389",
              nameBg: birthIdx > cut ? "#FBFCFE" : "#FFFFFF",
              fw: 400, marker: "", indent: "30px", cursor: "default", markerBg: "transparent", onToggle: null,
              cells: aggregateCells([it], null, true), rowCss: "",
              hasRule: false, ruleTag: "", ruleOwn: false, ruleTitle: "", ruleOpen: false, nameZ: 2, onRuleToggle: null, rulePop: null
            });
            return;
          }
          const forecastCohort = it.j - 1 > cut;
          const label = String(it.ym);
          const rowKey = cohortInputKey(ch, blk, label);
          const ownRule = viewCohortInput[rowKey] || null;
          const ruleOpen = isDraft && st.cohortRulePop === rowKey;
          const mark = rowMarks[it.j] || null;
          const fp = st.flagPanel;
          if (pickerOn && fp && fp.only && !(fp.tab === "overrides" ? mark && mark.ovr : mark && (mark.open || mark.accepted))) return;
          const use = pickerOn && blkMethods ? blkMethods[it.j] || (ownRule ? "user" : "tab") : null;
          const useTag = use === "own" ? COHORT_CHIP_NAME.chain : use === "user" && ownRule ? cohortRuleTag(ownRule) : use ? cohortRuleTag(blkRuleNow) : null;
          const ownMonths = () => {
            const b0 = D.months.indexOf(it.ym);
            let count = 0;
            for (let t = b0 + 1; t <= cut; t++) if (typeof it.ratio[t] === "number") count++;
            return count;
          };
          const useTitle = use === "own" && blkGuards && blkGuards.v4 ? "Older cohort: " + ownMonths() + " actual months, so it uses its own history." + (isDraft ? " Click to choose another method." : "")
            : use === "own" ? COHORT_SCREEN_NAME.chain + " · from this cohort's own history, applied automatically" : use === "user" && ownRule ? describeCohortRuleFull(ownRule) + " · set by user" : use ? describeCohortRuleFull(blkRuleNow) + " · the tab method, applied automatically" : null;
          cohortRows.push({
            chip: pickerOn && ruleOpen ? {
              title: ml(it.ym) + " cohort",
              note: "Applies to this cohort only. Auto never changes it.",
              own: ownRule,
              tab: blkRuleNow,
              months: blkMonths,
              methods: pickerMethods,
              seasonTip: seasonTipOf(blkMonths),
              trendTipOf: method => trendTipOf(blkMonths, method),
              seasonOk: seasonAllowed(blkMonths),
              trendOk: method => trendAllowed(blkMonths, method),
              onApply: next => { this.setCohortInput(ch, blk, label, next); this.setState({ cohortRulePop: null }); },
              onCancel: () => this.setState({ cohortRulePop: null })
            } : null,
            label: ml(it.ym),
            note: "",
            entrants: fmtCount(it.entrants),
            entrantsFg: forecastCohort ? "#0052CD" : "#4D6389",
            nameBg: forecastCohort ? "#FBFCFE" : "#FFFFFF",
            fw: 400, marker: "", indent: "30px", cursor: "default", markerBg: "transparent", onToggle: null,
            cells: cols.map(colDef => cellFor(it.ratio, it.size, it.j, colDef)), rowCss: "",
            hasRule: isDraft || !!ownRule,
            ruleTag: useTag || (ownRule ? cohortRuleTag(ownRule) : "default"),
            ruleOwn: !!ownRule,
            ruleTitle: useTitle || (pickerOn ? describeCohortRuleFull(ownRule || blkRuleNow) : ownRule ? describeCohortRule(ownRule) : "Uses the channel forecast method"),
            ruleOpen,
            nameZ: ruleOpen ? 30 : 2,
            onRuleToggle: isDraft ? (e => { e.stopPropagation(); this.setState({ cohortRulePop: ruleOpen ? null : rowKey }); }) : null,
            rulePop: ruleOpen && !pickerOn ? ruleFields(label) : null
          });
        });
      });
      if (items.length) cohortRows.push({
        label: "Total",
        note: pickerOn && rateView ? "Repeat rate" : "",
        entrants: fmtCount(legacyViews.reduce((a, v) => (a === null ? 0 : a) + v.legacy.size, sumEntrants(items))),
        entrantsFg: "#08234C", nameBg: "#EDF1F8", fw: 600, marker: "", indent: "14px",
        cursor: "default", markerBg: "transparent", onToggle: null,
        cells: aggregateCells(items, null, false, true), rowCss: "position:sticky;bottom:0;z-index:3;box-shadow:0 -1px 0 0 #DCE4F2"
      });
    }

    // ---- base model panel ----
    const bfit = base.__meta && base.__meta.fit ? base.__meta.fit[blocks[0]] : null;
    let backtest = [], baseParams = [], baseDivergence = "—", baseForecastMonths = n - cut - 1, backtestMonths = 0;
    if (!cohort && bfit) {
      const emax = Math.max.apply(null, bfit.backtest.map(b => Math.abs(b.err))) || 1;
      backtest = bfit.backtest.map(b => ({
        month: ml(D.months[b.i]), actual: Math.round(b.actual).toLocaleString("en-GB"), pred: Math.round(b.pred).toLocaleString("en-GB"),
        err: (b.err > 0 ? "+" : "−") + Math.abs(Math.round(b.err)).toLocaleString("en-GB"),
        fg: Math.abs(b.err) / b.actual > 0.05 ? "#E5484D" : "#4D6389",
        width: (Math.abs(b.err) / emax) * 100, fill: b.err < 0 ? "#E5484D" : "#1A7F4B"
      }));
      backtestMonths = backtest.length;
      const subsFit = base.__meta.fit.subs, otpFit = base.__meta.fit.otp;
      baseParams = [
        { label: "carry_over_rate · subs", value: this.numFixed(subsFit && subsFit.r, 3), note: "fitted, months 1 to " + (cut + 1) },
        { label: "carry_over_rate · OTP", value: this.numFixed(otpFit && otpFit.r, 3), note: "fitted on the same window" },
        { label: "back-test MAPE · " + fitBlockName.toLowerCase(), value: this.numFixed(bfit.mape != null ? bfit.mape * 100 : null, 2) + "%", note: "one step ahead, " + backtestMonths + " month" + (backtestMonths === 1 ? "" : "s") }
      ];
      let dv = 0;
      blocks.forEach(b => {
        const f = base.__meta.fit[b];
        if (!f) return;
        for (let t = cut + 1; t < n; t++) {
          const model = base[b + "_orders"][t], wb = f.workbook[t];
          if (typeof model === "number" && typeof wb === "number") dv += model - wb;
        }
      });
      baseDivergence = (dv > 0 ? "+" : "−") + Math.abs(Math.round(dv)).toLocaleString("en-GB") + " orders";
    }

    // ---- scenario ----
    const sl = (key, label, field, min, max, step) => {
      const v = typeof chScen[field] === "number" ? chScen[field] : 0, on = v !== 0;
      return {
        field: field, label: label, key: key, min: min, max: max, step: step, value: v,
        display: on ? (v > 0 ? "+" : "") + this.numFixed(v * 100, 0) + "%" : "—",
        labelFg: on ? "#08234C" : "#4D6389", valFg: on ? "#0052CD" : "#C8D4EA", fw: on ? 600 : 400,
        rk: ch + "." + field + "." + v,
        // React's onChange IS the input event — keep it DOM-only so dragging never recomputes
        onChange: e => {
          const x = parseFloat(e.target.value);
          this._drag = { ch: ch, field: field, v: x };
          const el = document.querySelector('[data-scen-read="' + field + '"]');
          if (!el) return;
          el.textContent = x === 0 || !Number.isFinite(x) ? "—" : (x > 0 ? "+" : "") + Number.prototype.toFixed.call(x * 100, 0) + "%";
          el.style.color = x === 0 ? "#C8D4EA" : "#0052CD";
          el.style.fontWeight = x === 0 ? "400" : "600";
        },
        // release commits once
        onPointerUp: () => this.commitDrag(),
        onKeyUp: () => this.commitDrag()
      };
    };
    const scenOn = st.scenarioOn || {};
    const rowNameByKey = {};
    ROWS.forEach(r => { if (r.key) rowNameByKey[r.key] = r.name; });
    const levers = this.scenarioLevers(ch, D).map(l => Object.assign({}, l, {
      label: rowNameByKey[l.row.key] || l.name,
      on: l.keys.some(k => scenOn[k] !== false),
      shown: l.rows.some(r => !r.hide && !this.cfgOf(r.k, ch).hide)
    }));
    const sliders = [], scenGroups = {};
    levers.filter(l => l.on && l.shown).forEach((l, i) => {
      const item = sl("Driver " + (i + 1) + " · " + l.row.key, l.label, l.lever, -1, 1, 0.01);
      if (!l.group) {
        sliders.push(item);
        return;
      }
      let g = scenGroups[l.group];
      if (!g) {
        const open = (st.scenOpen || {})[l.group] !== false;
        const chName = (isAll || combinedCh) && D.channels[l.groupCh] ? " · " + D.channels[l.groupCh].label : "";
        g = scenGroups[l.group] = {
          field: "group:" + l.group, group: true, open, children: [],
          label: (rowNameByKey[l.row.key] || l.row.name) + chName,
          toggle: () => this.setState(s => ({ scenOpen: Object.assign({}, s.scenOpen, { [l.group]: !open }) }))
        };
        sliders.push(g);
      }
      g.children.push(Object.assign(item, { label: l.name }));
    });
    Object.keys(scenGroups).forEach(id => {
      const g = scenGroups[id], changed = g.children.filter(c => c.value !== 0).length;
      Object.assign(g, {
        display: changed ? changed + " of " + g.children.length + " changed" : g.children.length + (g.children.length === 1 ? " source" : " sources"),
        labelFg: changed ? "#08234C" : "#4D6389", valFg: changed ? "#0052CD" : "#8094B5", fw: changed ? 600 : 400
      });
    });

    const scenRangeId = st.range;
    const srr = this.fyRange(scenRangeId), sa = srr[0], sb = srr[1];
    const salesKey = base.tot_sales ? "tot_sales" : blocks[0] + "_sales";
    const ordersKey = base.tot_orders ? "tot_orders" : blocks[0] + "_orders";
    const scenBaseSpecRaw = spec(st.version);
    const scenBaseSpec = { kind: scenBaseSpecRaw.kind, inputs: scenBaseSpecRaw.inputs || st.inputs, rov: scenBaseSpecRaw.rov || st.rov, cohortInput: scenBaseSpecRaw.cohortInput || st.cohortInput, cohortGuards: scenBaseSpecRaw.cohortGuards, cohortAuto: scenBaseSpecRaw.cohortAuto, scen: scenBaseSpecRaw.scen || zero };
    const scenSrc = { inputs: scenBaseSpec.inputs, rov: scenBaseSpec.rov, cohortInput: scenBaseSpec.cohortInput, cohortGuards: scenBaseSpec.cohortGuards, cohortAuto: scenBaseSpec.cohortAuto };
    const scenTotal = {}; Object.keys(zero).forEach(k => scenTotal[k] = (scenBaseSpec.scen[k] || 0) + chScen[k]);
    if (isAll) { scenTotal.__byCh = {}; Object.keys(D.channels).forEach(cid => { const one = {}; Object.keys(zero).forEach(k => one[k] = (scenBaseSpec.scen[k] || 0) + this.scenFor(cid)[k]); scenTotal.__byCh[cid] = one; }); }
    const sBase = this.run(ch, scenBaseSpec.scen, null, scenSrc);
    const sScen = this.run(ch, scenTotal, null, scenSrc);
    const cmpDef = [];
    blocks.forEach(b => { cmpDef.push([BL[b] + " orders", b + "_orders", 0, 0]); cmpDef.push([BL[b] + " sales", b + "_sales", 1, 0]); });
    cmpDef.push(["Total orders", ordersKey, 0, 1]); cmpDef.push(["Total sales", salesKey, 1, 1]);
    const compare = cmpDef.map(c => {
      const b = this.sum(sBase[c[1]], sa, sb), s = this.sum(sScen[c[1]], sa, sb), d = s - b;
      const f = v => c[2] ? this.money(v) : Math.round(v).toLocaleString("en-GB");
      return { label: c[0], fw: c[3] ? 600 : 400, base: f(b), scen: f(s), delta: Math.abs(d) < 1 ? "—" : (d > 0 ? "+" : "−") + f(Math.abs(d)).replace("−", ""), fg: Math.abs(d) < 1 ? "#8094B5" : d > 0 ? "#7d9210" : "#E5484D" };
    });

    // ---- authoring ----
    const a = st.auth;
    const setAuth = patch => this.setState(s => ({ auth: Object.assign({}, s.auth, patch) }));
    const tokens = a.src === "formula" ? (a.formula.replace(/"[^"]*"/g, " ").match(/[A-Za-z_][A-Za-z0-9_.]*/g) || []).filter(x => FN.indexOf(x) < 0 && DIMS.indexOf(x) < 0) : [];
    const resolved = [], unknown = [];
    tokens.forEach(x => {
      const ext = this.channelRef(ch, x);
      const row = ext ? ext.row : ROWS.find(r => r.k === x || r.key === x || r.key.split(".").pop() === x || (r.previousKeys || []).indexOf(x) >= 0);
      if (row) { if (resolved.indexOf(row) < 0) resolved.push(row); } else if (unknown.indexOf(x) < 0 && x !== "entrants") unknown.push(x);
    });
    const refFixes = [];
    unknown.forEach(x => {
      const ext = this.channelRef(ch, x);
      const pool = ext ? this.channelRows(ext.cid).rows : ROWS.filter(r => r.key !== a.key && r.k !== st.editing);
      suggestDriverKeys(x, pool).forEach(s => refFixes.push({
        token: x, key: s.key, name: s.name,
        onClick: () => { if (!st.draftSaving) setAuth({ formula: replaceFormulaToken(this.state.auth.formula, x, s.key) }); }
      }));
    });
    const hasAcross = /ACROSS_COHORTS/.test(a.formula);
    const cohortRefs = resolved.filter(r => r.tmp.indexOf("cohort_period") >= 0);
    const inferredTmp = /\[c/.test(a.formula) && !hasAcross ? "[cohort_period, activity_period]" : "[activity_period]";
    const declaredTmp = a.tmp === "cohort" ? "[cohort_period, activity_period]" : a.tmp === "none" ? "[]" : "[activity_period]";
    const opDims = []; resolved.forEach(r => DIMS.forEach(d => { if (r.dim.indexOf(d) >= 0 && opDims.indexOf(d) < 0) opDims.push(d); }));
    // ACROSS(dimension, …) reduces the named dimension — what the formula produces, not what the operands carry
    const reduced = (a.formula.match(/ACROSS\(\s*([A-Za-z_]+)/g) || []).map(m => m.replace(/ACROSS\(\s*/, ""));
    const authTotalsMode = totalsModeOf(a);
    const aggregatesAway = authTotalsMode !== "no_totals";
    const excess = (this.state.editing && aggregatesAway) ? [] : opDims.filter(d => a.dim.indexOf(d) < 0 && reduced.indexOf(d) < 0);
    const declaredDim = a.dim.length ? "[" + a.dim.join(", ") + "]" : "[]";
    const selfRef = tokens.indexOf(a.key) >= 0 || resolved.some(r => r.key === a.key);
    const ck = (ok, code, title, detail) => ({ code, title, detail, bar: ok ? "#B0CB1F" : "#E5484D", fg: ok ? "#5f7009" : "#E5484D", status: ok ? "PASS" : "FAIL", bg: ok ? "#F7FAEC" : "#FDECEC" });
    const implicitReduction = /\[c/.test(a.formula) && !hasAcross && declaredTmp === "[activity_period]";
    const keyText = String(a.key || "").trim();
    const keyChanged = keyText !== ((st.editing && (ROWS.find(r => r.k === st.editing) || {}).key) || "");
    const keyOwner = keyChanged ? ROWS.find(r => r.k !== st.editing && (r.key === keyText || (!!keyLocal(keyText) && (keyLocal(r.key) === keyLocal(keyText) || r.k === keyLocal(keyText))))) : null;
    const keyTaken = !!keyOwner;
    const keyMalformed = keyChanged && !/^[A-Za-z_][A-Za-z0-9_]*(\.[A-Za-z0-9_]+)*$/.test(keyText);
    const totalsText = authTotalsMode === "formula" ? String(a.totalsFormula || "").trim() : "";
    const totalsResolve = this.calcResolver(ROWS);
    const totalsTokens = formulaRefs(parseFormula(totalsText));
    const totalsUnknown = totalsTokens.filter(t => !totalsResolve(t) && t !== keyText);
    const totalsSelf = totalsTokens.some(t => t === keyText || (!!st.editing && totalsResolve(t) === st.editing));
    const totalsValid = authTotalsMode !== "formula" || isArithmeticFormula(totalsText);
    const totalsFixes = [];
    totalsUnknown.forEach(x => {
      suggestDriverKeys(x, ROWS.filter(r => r.key !== a.key && r.k !== st.editing)).forEach(s => totalsFixes.push({
        token: x, key: s.key, name: s.name,
        onClick: () => { if (!st.draftSaving) setAuth({ totalsFormula: replaceFormulaToken(this.state.auth.totalsFormula, x, s.key) }); }
      }));
    });
    const exampleRows = ROWS.filter(r => r.key && r.key !== keyText && r.k !== st.editing && !this.cfgOf(r.k, ch).hide);
    const exampleNum = exampleRows.find(r => r.unit === "£") || exampleRows[0];
    const exampleDen = exampleRows.find(r => r.unit === "#" && r !== exampleNum) || exampleRows.find(r => r !== exampleNum);
    const customCh = !isAll && isCustom(D, ch);
    const refChs = customCh ? Object.keys(D.channels).filter(c => c !== "all" && c !== ch && !isCustom(D, c)) : [];
    const refLocals = refChs.slice(0, 2).map(c => {
      const { rows, resolve } = this.channelRows(c);
      return rows.map(r => (resolve(keyLeaf(r.key)) === r.k ? keyLeaf(r.key) : keyLocal(r.key))).filter(Boolean);
    });
    const refShared = refLocals.length > 1 ? refLocals[0].find(k => refLocals[1].indexOf(k) >= 0) : null;
    const refTokens = refShared ? refChs.slice(0, 2).map(c => c + "." + refShared) : refLocals.length && refLocals[0].length ? [refChs[0] + "." + refLocals[0][0]] : [];
    const refExample = refTokens.length > 1 ? "SUM(" + refTokens.join(", ") + ")" : refTokens[0] || "";
    const formulaExample = customCh
      ? (refExample ? "e.g. " + refExample : "")
      : exampleNum && exampleDen ? "e.g. " + exampleNum.key + " / " + exampleDen.key : "";
    const formulaNote = customCh
      ? "Read a driver from another channel as channel.driver_key" + (refTokens.length ? ", for example " + refTokens[0] : "") + ". " +
        (refChs.length ? "Channels you can read: " + refChs.map(c => D.channels[c].label + " (" + c + ")").join(", ") + ". " : "") +
        "Drivers of this channel are used by their own key. Other custom channels can't be read. " +
        "Combine them with + - * / and brackets. A + leaves the month blank when any part is blank, so use " +
        (refTokens.length > 1 ? refExample : "SUM(a, b)") + " to add channels and skip blanks, or COALESCE(a, 0) to count a blank as 0."
      : "Refer to other drivers by their key and combine them with + - * / and brackets. A + leaves the month blank when any part is blank, so use SUM(a, b) to skip blanks, or COALESCE(a, 0) to count a blank as 0.";
    const rollupText = String(a.rollup || "").trim();
    const rollupUsed = combinedCh && (isRollupSource(a.src) || isInputSource(a.src));
    const rollupResolve = t => totalsResolve(t) || (keyText && [keyText, keyLocal(keyText), keyLeaf(keyText)].indexOf(t) >= 0 ? keyLeaf(keyText) : null);
    const rollupValid = !rollupUsed || (rollupText ? isValidRollup(rollupText, rollupResolve) : !isRollupSource(a.src));
    const editingRow = st.editing ? ROWS.find(r => r.k === st.editing) : null;
    const overwriteUsed = a.src === "input" && !combinedCh && !(editingRow && editingRow.manual);
    const overwriteFormula = overwriteUsed ? String(a.overwrite || "").trim() : "";
    const overwriteNode = parseFormula(overwriteFormula);
    const overwriteTokens = overwriteRefs(overwriteFormula);
    const overwriteUnknown = overwriteTokens.filter(t => !totalsResolve(t) && t !== keyText);
    const overwriteSelf = overwriteTokens.some(t => t === keyText || (!!st.editing && totalsResolve(t) === st.editing));
    const overwriteValid = !overwriteFormula || (!!overwriteNode && formulaFunctions(overwriteNode).every(f => FORMULA_FUNCTIONS.indexOf(f) >= 0));
    const overwriteFixes = [];
    overwriteUnknown.forEach(x => {
      suggestDriverKeys(x, ROWS.filter(r => r.key !== a.key && r.k !== st.editing)).forEach(s => overwriteFixes.push({
        token: x, key: s.key, name: s.name,
        onClick: () => { if (!st.draftSaving) setAuth({ overwrite: replaceFormulaToken(this.state.auth.overwrite, x, s.key) }); }
      }));
    });
    const checks = [
      ck(a.src !== "formula" || !!a.formula.trim(), "FORMULA", a.src !== "formula" ? "Not a formula driver" : (a.formula.trim() ? "Expression present" : "A formula driver needs an expression"), a.src === "formula" ? "e.g. subs_orders * cost_per_order" : "—"),
      Object.assign(ck(unknown.length === 0, "REFERENCES", a.src !== "formula" ? "No formula to resolve — " + a.src + " driver" : unknown.length ? "Unresolved reference: " + unknown.join(", ") : "All references resolve to driver_id", unknown.length ? (refFixes.length ? "Did you mean:" : "No driver has a similar key. Check the key in Model structure.") : resolved.length ? resolved.map(r => r.key).join("  ·  ") : (a.src === "input" ? "Typed by planners each period" : a.src === "binding" ? "Read from the bound source" : "No driver references yet")), { fixes: refFixes }),
      ck(!selfRef, "CYCLE", selfRef ? "Circular reference: the driver references itself" : "No cycle in the dependency graph", "Topological sort runs at model load; a cycle fails with the path named."),
      ck(!implicitReduction, "TEMPORAL_SHAPE", implicitReduction ? "Implicit reduction across the cohort axis" : "Inferred temporal shape " + inferredTmp, cohortRefs.length ? "Cohort operands: " + cohortRefs.map(r => r.k).join(", ") : "Declared " + declaredTmp),
      ck(excess.length === 0, "DIMENSIONALITY", excess.length ? "Operands carry " + excess.join(", ") + " but the result is declared " + declaredDim : (reduced.length ? "ACROSS reduces " + reduced.join(", ") + " to " + declaredDim : this.state.editing && aggregatesAway && opDims.length ? "Operands carry " + opDims.join(", ") + ", combined by " + TOTALS_LABEL[authTotalsMode].toLowerCase() + " to " + declaredDim : "Operand dimensionality broadcasts up to " + declaredDim), opDims.length ? "Operands: [" + opDims.join(", ") + "]" : "Scalar operands broadcast everywhere."),
      ck(totalsValid && !totalsSelf, "TOTALS_FORMULA", authTotalsMode !== "formula" ? "Quarter and year totals: " + TOTALS_LABEL[authTotalsMode] : !totalsText ? "A totals formula needs an expression" : totalsSelf ? "Circular reference: the totals formula uses this driver" : totalsValid ? "Totals formula present" : "Totals formula can only use driver keys, numbers, + - * / and brackets", formulaExample || "—"),
      Object.assign(ck(totalsUnknown.length === 0, "TOTALS_REFERENCES", authTotalsMode !== "formula" ? "No totals formula to resolve" : totalsUnknown.length ? "Unresolved reference: " + totalsUnknown.join(", ") : "All totals formula references resolve to driver_id", totalsUnknown.length ? (totalsFixes.length ? "Did you mean:" : "No driver has a similar key. Check the key in Model structure.") : totalsTokens.map(t => (ROWS.find(r => r.k === totalsResolve(t)) || {}).key || t).join("  ·  ") || "—"), { fixes: totalsFixes }),
      ck(!keyTaken && !keyMalformed, "DRIVER_KEY", keyTaken ? "Driver key " + keyText + " is already used by " + keyOwner.name + " (" + keyOwner.key + ")" : keyMalformed ? "Driver key must use letters, numbers, underscores and dots, starting with a letter" : "Driver key " + (keyText || "—") + " is unique", keyTaken ? "Delete " + keyOwner.name + " or give it another key first, then rename this one." : "Formulas that use this driver are updated to the new key when you apply.")
    ].concat(overwriteFormula ? [
      Object.assign(ck(overwriteValid && !overwriteSelf && overwriteUnknown.length === 0, "OVERWRITE_FORMULA", !overwriteValid ? "Overwrite formula can only use INPUT, driver keys, numbers, functions, + - * / and brackets" : overwriteSelf ? "Use INPUT for this driver's own value, not its key" : overwriteUnknown.length ? "Unresolved reference: " + overwriteUnknown.join(", ") : "Overwrite formula recalculates the actual months up to the cutoff", overwriteUnknown.length ? (overwriteFixes.length ? "Did you mean:" : "No driver has a similar key. Check the key in Model structure.") : "e.g. INPUT - (INPUT / (ad_spend * ad_spend_manual_total))"), { fixes: overwriteFixes })
    ] : []).concat(combinedCh ? [
      ck(rollupValid, "ROLLUP_RULE", !rollupUsed ? "No rollup rule — " + a.src + " driver" : !rollupText ? (isRollupSource(a.src) ? "A rollup driver needs a rule" : "No rule · actual months stay empty") : rollupValid ? "Rollup rule present" : "Rollup rule can only use " + ROLLUP_FUNCTIONS.join(", ") + " over driver keys, with numbers, + - * / and brackets", "e.g. SUM(ad_spend) / SUM(new_customers)")
    ] : []);
    const authValid = checks.every(c => c.status === "PASS");
    const seg = (field, opts, labels) => opts.map(o => ({
      id: o, label: labels[o] || o,
      bg: a[field] === o ? "#0052CD" : "#fff",
      fg: a[field] === o ? "#fff" : "#4D6389",
      border: a[field] === o ? "#0052CD" : "#C8D4EA",
      disabled: !!st.draftSaving,
      onClick: () => { if (!st.draftSaving) setAuth({ [field]: o }); }
    }));
    const editRow = st.editing ? ROWS.find(r => r.k === st.editing) : null;
    const authBuiltIn = !!editRow && !editRow.isDraftRow && !(st.fdraft[editRow.key] || {}).isNew;
    const authManual = !!editRow && !!editRow.manual && a.src === "input";
    const authMember = combinedCh && editRow ? this.memberSource(editRow, memberRows) : null;
    const combinedSources = authMember ? ["input", "formula", authMember.option] : COMBINED_SOURCES;
    const authAdvancedIssue = checks.some(c => c.status === "FAIL" && (c.code === "DIMENSIONALITY" || c.code === "TEMPORAL_SHAPE")) || !String(a.key || "").trim();
    const authShapeLocked = authBuiltIn && !authAdvancedIssue;
    const authOwn = editRow ? levers.filter(l => l.keys.indexOf(editRow.key) >= 0) : [];
    const authLever = !editRow ? null
      : authOwn.length
        ? { levers: authOwn.map(l => l.lever), keys: authOwn.reduce((acc, l) => acc.concat(l.keys.filter(k => acc.indexOf(k) < 0)), []), on: authOwn.some(l => l.on) }
        : (editRow.src !== "rollup" ? { levers: [editRow.k], keys: [editRow.key], on: false } : null);
    const authScenOn = authLever ? (a.scenOn === undefined ? authLever.on : !!a.scenOn) : false;
    const authTotals = authTotalsMode === "formula" && totalsText ? "Formula · " + totalsText : TOTALS_LABEL[authTotalsMode];
    const authShape = (() => {
      const split = a.dim.length ? "Split by " + a.dim.map(d => (DIM_LABEL[d] || d).toLowerCase()).join(" and ") : "One value for the whole business";
      const time = a.tmp === "cohort" ? "by cohort and month" : a.tmp === "none" ? "no time split" : "by month";
      const total = authTotalsMode === "add_up" ? "quarters and years add up"
        : authTotalsMode === "formula" ? "quarters and years use the totals formula" : "no quarter or year total";
      return split + " · " + time + " · " + total;
    })();
    const rowByToken = t => ROWS.find(r => r.k === t || r.key === t || r.key.split(".").pop() === t);
    const readableFormula = f => String(f || "")
      .replace(/[A-Za-z_][A-Za-z0-9_.]*/g, t => { const r = FN.indexOf(t) < 0 ? rowByToken(t) : null; return r ? r.name : t; })
      .replace(/\s*\*\s*/g, " × ").replace(/\s*\/\s*/g, " ÷ ");
    const authFormulaReadable = a.src === "formula" && a.formula.trim() ? readableFormula(a.formula) : "";
    const authBindingKey = editRow && editRow.bindsActuals && isInputSource(a.src) ? (actualsKeyOf(a.binding) || editRow.bindKey) : null;
    const authBindingBound = authBindingKey
      ? (actualSeriesOf(D.channels[ch], authBindingKey) || []).filter(v => v !== null && v !== undefined).length
      : null;
    const authUsedIn = (() => {
      const self = editRow ? [editRow.k, editRow.key, editRow.key.split(".").pop()] : [];
      if (a.key) self.push(a.key, a.key.split(".").pop());
      return ROWS.filter(r => r !== editRow && r.src === "formula" && r.formula)
        .filter(r => (String(r.formula).replace(/"[^"]*"/g, " ").match(/[A-Za-z_][A-Za-z0-9_.]*/g) || []).some(t => self.indexOf(t) >= 0))
        .map(r => ({ name: r.name, formula: r.name + " = " + readableFormula(r.formula) }));
    })();
    const authLookSummary = (() => {
      if (!st.editing) return "";
      const c = this.cfgOf(st.editing, ch);
      const colour = { tint: "Grey", lime: "Green", amber: "Amber", cyan: "Blue" }[c.bg];
      return [c.bold ? "Bold text" : "Regular text", c.numBold ? "Bold numbers" : "Regular numbers", c.indent ? "Indent " + c.indent : "No indent", colour ? colour + " background" : "No background", c.dp === null ? "Automatic rounding" : c.dp + " decimal places", c.inverse ? "Increase is red" : "Increase is green", c.hide ? "Hidden" : "Shown"].join(" · ");
    })();

    const grr = this.fyRange(st.range);
    const groupTotal = this.sum(planGrid.tot_sales, grr[0], grr[1]) || 1;
    const groupCards = chBase.map(cid => {
      const g4 = gridFor(st.version, cid);
      const blks = channelBlocks(cid, this.state.data || D) || [];
      const sales = this.sum(g4.tot_sales || (blks[0] ? g4[blks[0] + "_sales"] : null), grr[0], grr[1]);
      const orders = this.sum(g4.tot_orders || (blks[0] ? g4[blks[0] + "_orders"] : null), grr[0], grr[1]);
      const fitc = g4.__meta && g4.__meta.fit && blks[0] ? g4.__meta.fit[blks[0]] : null;
      return {
        label: D.channels[cid].label,
        model: D.channels[cid].model === "cohort" ? "Cohort model" : "Base model · stock and flow",
        sheets: D.channels[cid].sheets,
        orderTypes: blks.map(x => BL[x]).join(" + "),
        sales: this.money(sales), orders: Math.round(orders || 0).toLocaleString("en-GB"),
        share: this.numFixed(typeof sales === "number" ? (sales / groupTotal) * 100 : null, 1) + (typeof sales === "number" ? "%" : ""),
        barW: Math.max(2, typeof sales === "number" ? (sales / groupTotal) * 100 : 0),
        basis: D.channels[cid].model === "cohort" ? "Repurchase % by cohort, fitted at or before the cutoff" : "Carry-over rate " + this.numFixed(fitc && fitc.r, 3) + ", fitted on pre-cutoff history",
        onClick: () => this.setState({ channel: cid, block: blks[0] || "otp" })
      };
    });

    const membersWith = has => combinedCh ? membersOf(D, ch).filter(has).sort((x, y) => chOrder.indexOf(x) - chOrder.indexOf(y)) : [];
    const sourceMembers = membersWith(channelHasSources);
    const mixMembers = membersWith(m => (PRODUCT_MIX[m] || []).length > 0);
    const summedNote = list => list.length ? "Summed from " + list.map(m => D.channels[m].label).join(" + ") + " · read only" : "";
    const ownMix = !isAll && !combinedCh && !!(PRODUCT_MIX[ch] || []).length;

    return this.withSettingsFilter({
      rowH: (lines > 1 ? (this.props.density === "compact" ? 14 : 18) + lines * 15 : (this.props.density === "compact" ? 28 : 34)) + "px",
      colW: colW + "px",
      cohortW: 284 + cols.length * cohW + (st.gran === "month" ? 32 : 0), cohW: cohW + "px",
      cohRowH: (cohLines > 1 ? 12 + cohLines * 15 : 28) + "px",
      cohortAddFg: isDraft ? "#0052CD" : "#C8D4EA",
      cohortDropFg: canDropMonth ? "#0052CD" : "#C8D4EA",
      monthCount: n + " months", cutoffChip: "Cutoff " + ml(D.months[cut]), cutoffLabel: ml(D.months[cut]),
      cutoffFg: "var(--ink)",
      overwriteOpen: st.cutoffPending !== null,
      overwriteTitle: st.cutoffPending === null ? "" : "Move cutoff to " + ml(D.months[st.cutoffPending]),
      overwriteCount: st.cutoffPending === null ? "" : (st.cutoffPending - cut) + " month" + (st.cutoffPending - cut === 1 ? "" : "s"),
      overwriteRows: st.cutoffPending === null ? [] : (() => {
        const out = [];
        for (let i = cut + 1; i <= st.cutoffPending; i++) {
          const fc = (planGrid.tot_sales || [])[i];
          const act = isAll ? sumFile("sales")[i] : ((conf.total && conf.total.sales) || [])[i];
          const d = (typeof fc === "number" && typeof act === "number") ? act - fc : null;
          out.push({
            period: ml(D.months[i]),
            forecast: typeof fc === "number" ? this.money(fc) : "—",
            actual: typeof act === "number" ? this.money(act) : "—",
            delta: d === null ? "—" : (d >= 0 ? "+" : "−") + this.money(Math.abs(d)).replace("−", ""),
            fg: d === null ? "#8094B5" : d >= 0 ? "#1A7F4B" : "#E5484D"
          });
        }
        return out;
      })(),
      overwriteText: st.overwriteText,
      onOverwriteText: e => this.setState({ overwriteText: e.target.value }),
      overwriteReady: st.overwriteText.trim().toUpperCase() === "OVERWRITE",
      overwriteBg: st.overwriteText.trim().toUpperCase() === "OVERWRITE" ? "#E5484D" : "#EDF1F8",
      overwriteFg: st.overwriteText.trim().toUpperCase() === "OVERWRITE" ? "#fff" : "#8094B5",
      confirmOverwrite: () => {
        if (st.overwriteText.trim().toUpperCase() !== "OVERWRITE") return;
        this.applyCutoff(st.cutoffPending);
      },
      cancelOverwrite: () => this.setState({ cutoffPending: null, overwriteText: "" }),
      cutoffMenu: st.cutoffOpen && !locked && isDraft, cutoffMax: ml(D.months[D.cutoffIdx]),
      cutoffLocked: locked || !isDraft, cutoffUnlocked: !locked && isDraft,
      cutoffIntro: "The last period with bound actuals. Pulling it back refits every cohort curve and back-tests the model against the months you hold out. It cannot run past " + ml(D.months[D.cutoffIdx]) + " — later periods have no actuals to bind.",
      toggleCutoff: () => { if (!locked && isDraft) this.setState({ cutoffOpen: !st.cutoffOpen }); },
      cutoffOpts: isDraft ? this.buildCutoffOpts(cut, D, st, fyOf, fyLabel, qOf, ml) : [],
      channelTitle: conf.label,
      modelLabel: (cohort ? "Cohort model" : "Base model · stock and flow") + " · base forecast draft",
      sheetList: conf.sheets,
      parityLabel, parityBg: parityOk ? "#F7FAEC" : "#FDECEC", parityFg: parityOk ? "#5f7009" : "#E5484D", parityDot: parityOk ? "#B0CB1F" : "#E5484D",
      cols, rows, tabs: tabsOut, sections, channels,
      chart, chartName: chart.name, chartMeta: chart.meta, chartEmpty: chart.empty, chartHasData: !chart.empty,
      chartTrend: trend,
      chartOpen: !!st.hoverRow && st.screen === "plan",
      chartLeft: Math.max(12, Math.min(st.hoverX + 18, ((typeof window !== "undefined" ? window.innerWidth : 1200) || 1200) - 542)) + "px",
      chartTop: Math.max(12, Math.min(st.hoverY - 96, ((typeof window !== "undefined" ? window.innerHeight : 800) || 800) - 420)) + "px",
      chartCmpOn: cmpOn, chartCmpLabel: cmpOn ? verOf(st.cmpVersion).short : "",
      scenRail: st.scenRail,
      exitScenario: () => this.setState(s => {
        const by = Object.assign({}, s.scenByCh);
        Object.keys(by).forEach(cid => { by[cid] = Object.assign({}, zero); });
        return { scenByCh: by, scenRail: false, scenMode: false, scenNaming: false, scenName: "", cmpVersion: "none" };
      }),
      scenNaming: st.scenNaming, scenNamingOff: !st.scenNaming,
      scenName: st.scenName,
      onScenName: e => this.setState({ scenName: e.target.value }),
      startSaveScenario: () => this.setState({ scenNaming: true, scenName: st.scenName || "Scenario " + (st.scenSeq + 1) }),
      confirmSaveScenario: () => {
        this.setState(s => {
          const name = (s.scenName || "").trim() || "Scenario " + (s.scenSeq + 1);
          const id = "scen_saved_" + (s.scenSeq + 1);
          return {
            scenSeq: s.scenSeq + 1,
            savedScens: s.savedScens.concat([{ id: id, name: name, scenByCh: JSON.parse(JSON.stringify(s.scenByCh)), inputs: JSON.parse(JSON.stringify(s.inputs)), rov: Object.assign({}, s.rov), createdBy: "", createdOn: Date.now() }]),
            scenByCh: (() => { const by = Object.assign({}, s.scenByCh); Object.keys(by).forEach(cid => { by[cid] = Object.assign({}, zero); }); return by; })(),
            scenNaming: false, scenName: "", scenRail: false, scenMode: false, version: id, cmpVersion: "none"
          };
        });
        this.noteSettingsDirty();
      },
      cancelSaveScenario: () => this.setState({ scenNaming: false }),
      scenActive: scenActive,
      scenBanner: scenActive ? "Scenario · ephemeral until saved" : "",
      cmpVersion: st.scenMode ? "__new" : st.cmpVersion,
      onCmpVersion: e => {
        const v = e.target.value;
        if (v === "__new") this.setState({ scenMode: true, scenRail: true, cmpVersion: st.version });
        else this.setState({ cmpVersion: v, scenMode: false });
      },
      cmpOpts: [{ value: "none", label: "Compare: off" }]
        .concat(VERSIONS.filter(v => v.id !== st.version && !v.remote).map(v => ({ value: v.id, label: "vs " + v.short + ((v.id === "actual" || v.id === "fit" || st.locks[v.id]) ? " · locked" : "") }))),
      showNewScenario: !st.scenMode,
      startScenario: () => this.setState({ scenMode: true, scenRail: true, cmpVersion: st.version }),
      cmpActuals: st.cmpVersion === "actual",
      cmpActualsNote: "Actuals stop at " + ml(D.months[this.actualCutIdx()]) + " — forecast months read —",
      cmpOn: cmpOn,
      bridgeOpen: cmpOn,
      cmpModes: [["value", "Value"], ["abs", "Change"], ["pct", "Change %"]].map(m => ({
        label: m[1],
        bg: sel[m[0]] ? "#0052CD" : "#fff", fg: sel[m[0]] ? "#fff" : "#4D6389", border: sel[m[0]] ? "#0052CD" : "#C8D4EA",
        onClick: () => this.setState(s => {
          const next = Object.assign({}, s.cmpSel); next[m[0]] = !next[m[0]];
          if (!next.value && !next.abs && !next.pct) return {};
          return { cmpSel: next };
        })
      })),
      onExport: () => {
        const chans = chAll;
        const vSpec = spec(st.version);
        const scenOf = cid => {
          const sc = scenActive ? scenArg : vSpec.scen;
          return sc && sc.__byCh && sc.__byCh[cid] ? sc.__byCh[cid] : (sc || null);
        };
        const grid = {}, rowDefs = {}, blocksBy = {}, sizesBy = {}, scaleBy = {}, cmpBy = {};
        const cmpRec = cmpOn ? verOf(st.cmpVersion) : null;
        chans.forEach(cid => {
          const g2 = cid === ch ? planGrid : scenActive ? this.run(cid, scenArg) : isDraft ? this.run(cid, zero) : gridFor(st.version, cid);
          if (cmpOn) cmpBy[cid] = gridFor(st.cmpVersion, cid);
          scaleBy[cid] = vSpec.kind === "model" || scenActive ? this.sourceScale(cid, scenOf(cid)) : null;
          grid[cid] = g2;
          rowDefs[cid] = this.ordered(this.mergeDraftRows(buildRows(cid, D), cid), ["acq", "subs", "otp", "total", "pl", "kpi"], cid)
            .filter(r => !this.cfgOf(r.k, cid).hide)
            .map(r => {
              const d = st.fdraft[r.key], eSrc = this.srcOf(r), cfg = this.cfgOf(r.k, cid);
              if (!d && eSrc === r.src && !cfg.bold) return r;
              return Object.assign({}, r, {
                src: eSrc,
                formula: (d && d.formula) ? d.formula : r.formula,
                // a driver converted away from input no longer has a typed series
                ed: eSrc === "input" ? r.ed : null,
                total: r.total || (cfg.bold ? 1 : 0)
              });
            });
          blocksBy[cid] = channelBlocks(cid, this.state.data || D);
          sizesBy[cid] = (g2.__meta && g2.__meta.sizes) || {};
        });
        if (cmpOn && isAll) cmpBy.all = cmpGrid;
        const vRov = Object.keys(vSpec.rov || {}).filter(k => k !== "__mov");
        const vCohort = vSpec.cohortInput || {};
        this.exportExcel({
          range: [ra, rb], gran: st.gran, channels: chans, rollup: baseChannels(D).filter(c => !isCustom(D, c)), grid: grid, rowDefs: rowDefs, blocks: blocksBy, sizes: sizesBy,
          sourceScale: scaleBy, truncate: !!vSpec.truncate, cut: isActual ? cut : undefined,
          compare: cmpRec ? { label: cmpRec.short, grid: cmpBy, sel: st.cmpSel } : null,
          versionLabel: versionRec.short + (scenActive ? " + scenario" : ""),
          flagReviews: vSpec.kind === "model" && vSpec.cohortGuards && !usesFlatTail(vSpec.cohortGuards.engine) ? ((activePub ? activePub.flagReviews : st.flagReviews) || {}) : null,
          guardEngine: vSpec.kind === "model" && vSpec.cohortGuards ? vSpec.cohortGuards.engine || null : null,
          guardConstants: vSpec.kind === "model" && vSpec.cohortGuards ? vSpec.cohortGuards.constants || null : null,
          mixInput: vSpec.kind === "model" ? vSpec.mixInput || st.mixInput : null,
          cogsInput: vSpec.kind === "model" ? vSpec.cogsInput || st.cogsInput : null,
          cohortInput: vCohort,
          filename: "growth-model-" + driverKeySlug(versionRec.short) + (scenActive ? "-scenario" : "") + (cmpRec ? "-vs-" + driverKeySlug(cmpRec.short) : "") + "-" + (chans.length > 1 ? "all-channels" : chans[0]) + "-" + st.range + ".xlsx",
          meta: [
            ["version", versionRec.short],
            ["version_type", versionRec.type],
            ["compared with", cmpRec ? cmpRec.short + " · " + ["value", "abs", "pct"].filter(k => st.cmpSel[k]).map(k => ({ value: "Value", abs: "Change", pct: "Change %" })[k]).join(", ") : "none"],
            ["channels", chans.map(cid => D.channels[cid].label).join(" · ")],
            ["cutoff_period", String(D.months[cut])],
            ["period exported", ml(D.months[ra]) + " to " + ml(D.months[rb])],
            ["granularity on screen", st.gran],
            ["scenario applied", scenActive ? "yes · ephemeral session scenario" : versionRec.type === "SCENARIO" ? "yes · " + versionRec.short : "no"],
            ["repurchase overrides", String(vRov.length)],
            ["cohort forecast methods", Object.keys(vCohort).map(k => k + " = " + describeCohortRule(vCohort[k])).join(" · ") || describeCohortRule(DEFAULT_COHORT_RULE)],
            ["engine_version", engineVersion || st.engineVersion || D.engineVersion || ""],
            ["exported", new Date().toLocaleString("en-GB")],
            ["note", "Actual months are values. Forecast months carry formulas: edit an input or a cohort repurchase rate and Excel recalculates the whole model."]
          ]
        }, XlsxExport);
      },
      onRefreshActuals: () => {
        if (typeof this.refreshActualsHandler === "function") void this.refreshActualsHandler();
        this.setState({ menuOpen: false });
      },
      hasRefreshActuals: typeof this.refreshActualsHandler === "function",
      exportNote: st.exportNote || "",
      hasExportNote: !!st.exportNote,
      menuScreens: [["authoring", "Settings"], ["governance", "Review"], ["changelog", "Change log"]].map(s => ({
        id: s[0],
        label: s[1],
        bg: st.screen === s[0] ? "#EAF1FD" : "transparent",
        fg: st.screen === s[0] ? "#0052CD" : "#08234C",
        fw: st.screen === s[0] ? 500 : 400,
        onClick: () => {
          this.setState({ screen: s[0], menuOpen: false });
          if (s[0] === "changelog") void this.loadChangeLog(false);
        }
      })),
      menuOpen: st.menuOpen,
      toggleMenu: () => this.setState({ menuOpen: !st.menuOpen }),
      menuBg: st.menuOpen ? "#EAF1FD" : (errCount > 0 ? "#FDECEC" : "#fff"),
      menuFg: st.menuOpen ? "#0052CD" : (errCount > 0 ? "#E5484D" : "#4D6389"),
      barsOpen: !st.barsCollapsed,
      barsCollapsed: st.barsCollapsed,
      toggleBars: () => this.setState({ barsCollapsed: !st.barsCollapsed, menuOpen: false }),
      collapseLabel: st.barsCollapsed ? "Show controls" : "Hide controls",
      addCol: () => {
        if (!isDraft) return;
        this.extendHorizon(1);
        this.setState({ customTo: this.state.data.months.length - 1 });
        this.noteSettingsDirty();
      },
      dropCol: () => {
        if (canDropMonth) this.trimHorizon(1);
      },
      addColFg: isDraft ? "#0052CD" : "#C8D4EA",
      dropColFg: canDropMonth ? "#0052CD" : "#C8D4EA",
      colNote: isDraft ? "Add " + ml(nextPeriod(D.months[n - 1])) + " · copies " + ml(D.months[n - 1]) : "Switch to Forecast working to add months",
      dropNote: canDropMonth ? "Remove forecast month " + ml(D.months[n - 1]) : (isDraft ? "Actual months up to the cutoff cannot be removed" : "Switch to Forecast working to remove months"),
      grans: [["month", "Month"], ["quarter", "Quarter"], ["year", "Year"]].map((g, i) => ({
        label: g[1], selected: st.gran === g[0], bg: st.gran === g[0] ? "#0052CD" : "transparent", fg: st.gran === g[0] ? "#fff" : "#4D6389",
        fw: st.gran === g[0] ? 500 : 400, divider: i === 0 ? "none" : "inset 1px 0 0 #DCE4F2",
        onClick: () => this.setState({ gran: g[0] })
      })),
      granNote: st.gran === "month" ? "" : "Rolled up to " + st.gran + " — rates recomputed from their components, cohort LTV weighted by new customers, payback left blank. Editing is monthly.",
      isRolled: st.gran !== "month", isMonthGrain: st.gran === "month",
      hasPasteNote: !!st.pasteNote, pasteNote: st.pasteNote,
      pasteBg: st.pasteBad ? "#FFF8E0" : "#F1F6DC", pasteFg: st.pasteBad ? "#7a5d00" : "#5f7009",
      clearPaste: () => this.setState({ pasteNote: "" }),
      customFrom: String(ra), customTo: String(rb),
      monthOpts: D.months.map((m, i) => ({ value: String(i), label: ml(m) })),
      onCustomFrom: e => this.setViewBounds(+e.target.value, null),
      onCustomTo: e => this.setViewBounds(null, +e.target.value),
      rangeWindow: ml(D.months[ra]) + " to " + ml(D.months[rb]),
      hasCrumb: st.screen === "cohorts" || st.screen === "mix" || st.screen === "source",
      crumb: st.screen === "mix" ? "Product mix" : st.screen === "source" ? "Marketing sources" : isAll ? "Channel models" : allBlocks ? "All cohorts" : triangle ? BL[blk] + " cohorts" : "Stock and flow",
      showMix: st.screen === "mix" && !isAll && (!combinedCh || mixMembers.length > 0),
      showSource: st.screen === "source" && !isAll && (!combinedCh || sourceMembers.length > 0),
      mixSummedNote: summedNote(mixMembers),
      sourceSummedNote: summedNote(sourceMembers),
      mixW: 320 + cols.length * colW + 20,
      sourceW: 320 + cols.length * colW + 20,
      mixMissing: !isAll && !combinedCh && !(PRODUCT_MIX[ch] || []).length,
      mixPresent: ownMix || mixMembers.length > 0,
      sourceMissing: !isAll && !combinedCh && !channelHasSources(ch),
      sourcePresent: !isAll && (channelHasSources(ch) || sourceMembers.length > 0),
      canAddSource: isDraft && !locked && !isAll && channelHasSources(ch),
      sourceNames: isAll ? [] : (SESSION_SOURCES[ch] || []).map(s => s.name),
      onAddSource: name => this.addSessionSource(ch, name),
      canAddDriver,
      addDriverEditor: !isAll && isCustom(D, ch),
      addDriverSections: planSectionsFor(blocks).filter(s => s !== "kpi").map(id => ({ id, label: SECTION_LABEL[id] })),
      addDriverUnits: ["currency", "count", "percentage", "ratio"].map(id => ({ id, label: UNIT_LABEL[id] })),
      driverNameTaken: name => this.planDriverTaken(ch, name),
      onAddDriver: (name, sec, unit) => this.addPlanDriver(ch, name, sec, unit),
      mixMissingNote: "No product_mix rows bound for " + conf.label + ". Add categories below (or load GROWTH_PRODUCT_MIX with CHANNEL matching the catalog key, e.g. shp). Mix % is editable after the cutoff.",
      mixNote: combinedCh ? "Each category's sales and COGS are added up across " + memberLabels + ". Mix % is summed category sales over summed gross sales, and COGS % is summed COGS over summed category sales. Edit categories, values and forecast methods on each channel." : "Actual months are bound. Forecast months follow the forecast method — change it here, click a category's method, or right-click a month. Typed cells win. A red Mix total means that month is not 100% — adjust any category to fix it. Product COGS % works the same way with its own forecast method and has no 100% total rule.",
      mixRule: ownMix ? mixRuleFields(null, null, "mix") : null,
      cogsRule: ownMix ? mixRuleFields(null, null, "cogs") : null,
      sourceMissingNote: "No GROWTH_SESSION_COST rows bound for " + conf.label + ". Ad spend and Sessions stay on the plan until marketing sources are loaded.",
      canEditMixStructure: isDraft && !locked && !isAll && !combinedCh,
      onSeedMix: () => this.seedDefaultProductMix(ch),
      mixCategoryNames: isAll ? [] : (PRODUCT_MIX[ch] || []).map(r => String(r[0])),
      onAddMixCategory: name => {
        const label = String(name || "").trim();
        if (!label) return;
        this.addProductCategory(ch, label, (PRODUCT_MIX[ch] || []).length ? 0 : 1, null);
      },
      mixRows: combinedCh ? this.combinedMixRows(ch, mixMembers, memberPlan, cols, cut) : (() => {
        const cats = PRODUCT_MIX[ch] || [];
        const out = [];
        const grossSeries = planGrid.tot_sales || planGrid[blocks[0] + "_sales"] || [];
        const grossOf = c3 => sumIdx(grossSeries, c3.idxs);
        const metaOf = kind => planGrid.__meta && planGrid.__meta[kind] ? planGrid.__meta[kind] : null;
        const mixMeta = metaOf("mix"), cogsMeta = metaOf("cogs");
        const pct2 = v => typeof v === "number" ? this.numFixed(v * 100, 2) + "%" : "—";
        const mixCellKey = (ci, t, kind) => (kind || "mix") + ":" + ci + ":" + t;
        const explainMix = (ci, name, t, kind) => {
          const isCogs = kind === "cogs";
          const meta = metaOf(isCogs ? "cogs" : "mix");
          const map = isCogs ? viewCogsInput : viewMixInput;
          const v = meta.values[ci][t], vk = meta.kinds[ci][t];
          const title = name + (isCogs ? " COGS %" : "") + " · " + ml(D.months[t]);
          const result = pct2(v);
          if (t <= cut) return { title, result, rows: [], steps: [], note: cats[ci] && cats[ci][5] ? MANUAL_MIX_ACTUAL_NOTE : isCogs ? "Bound actual COGS % for this month." : "Bound actual mix for this month.", highlights: [], srcs: [] };
          if (vk === "override") return { title, result, rows: [], steps: ["Typed value " + result], note: "Typed values win. Clear the cell to use the forecast method.", highlights: [], srcs: [], typed: true };
          const own = map[mixInputKey(ch, name, D.months[t])] || null;
          const rule = own || resolveMixRule(map, ch, name);
          const grid = own ? meta.values : meta.base;
          const srcs = mixRuleSources(rule, t).filter(i => i >= 0).sort((a, b) => a - b);
          const at = i => grid[ci][i];
          const has = srcs.filter(i => typeof at(i) === "number");
          const rows = srcs.map(i => ({
            tone: i <= cut ? "actual" : "forecast",
            label: ml(D.months[i]),
            sub: meta.kinds[ci][i] === "override" && own ? "typed" : "",
            value: pct2(at(i))
          }));
          let step = "";
          if (vk === "fallback") step = "Not enough history · last value carried = " + result;
          else if (rule.method === "prev") step = ml(D.months[srcs[0]]) + " = " + result;
          else if (rule.method === "avg") step = "(" + has.map(i => pct2(at(i))).join(" + ") + ") ÷ " + has.length + " = " + result;
          else if (rule.method === "wavg") step = "Σ(" + (isCogs ? "COGS %" : "mix") + " × gross sales) ÷ Σ gross sales over " + has.length + " months = " + result;
          else if (rule.method === "chain") step = pct2(at(t - 1)) + " × " + this.numFixed(at(t - 1) ? v / at(t - 1) : 1, 3) + " own curve = " + result;
          else if (rule.method === "seasonal") step = pct2(at(t - 12)) + " × trend " + this.numFixed(at(t - 12) ? v / at(t - 12) : 1, 3) + " = " + result;
          else step = "Fixed " + result;
          return {
            title, result, rows, steps: [step],
            note: (own ? "Month method · " : "Row method · ") + describeMixRule(rule),
            highlights: srcs.map(i => ({ key: mixCellKey(ci, i, kind), tone: i <= cut ? "actual" : "forecast" })),
            srcs
          };
        };
        const cellTrace = (ci, name, kind) => {
          const t = st.mixRulePop === name && st.mixRuleAt && (st.mixRuleKind || "mix") === kind ? D.months.indexOf(st.mixRuleAt) : -1;
          if (!metaOf(kind) || t <= cut) return null;
          const e = explainMix(ci, name, t, kind);
          const used = e.rows.map(r => r.label + " " + r.value).join(" · ");
          return {
            srcs: new Set(e.srcs),
            calc: e.typed ? "Typed value " + e.result + " is used. Clear the cell to apply this method." : (used ? used + " → " : "") + ml(D.months[t]) + " " + e.result
          };
        };
        const mixAt = (ci, t) => (mixMeta && mixMeta.values[ci] ? mixMeta.values[ci][t] : this.mixPct(ch, ci, t, cats[ci][1]));
        const cogsAt = (ci, t) => (cogsMeta && cogsMeta.values[ci] ? cogsMeta.values[ci][t] : this.cogsPct(ch, ci, t, cats[ci][2]));
        const weighted = (at, ci, c3) => {
          if (c3.idxs.length === 1) return at(ci, c3.idxs[0]);
          let num = 0, den = 0;
          c3.idxs.forEach(t => {
            const v = at(ci, t);
            if (typeof v !== "number") return;
            const w = typeof grossSeries[t] === "number" && grossSeries[t] > 0 ? grossSeries[t] : 1;
            num += v * w;
            den += w;
          });
          return den ? num / den : null;
        };
        const mixOf = (ci, c3) => weighted(mixAt, ci, c3);
        const cogsOf = (ci, c3) => weighted(cogsAt, ci, c3);
        const catCogs = (ci, c3) => {
          let s = null;
          c3.idxs.forEach(t => {
            const g0 = grossSeries[t], m0 = mixAt(ci, t), k0 = cogsAt(ci, t);
            if (typeof g0 !== "number" || typeof m0 !== "number" || typeof k0 !== "number") return;
            s = (s === null ? 0 : s) + g0 * m0 * k0;
          });
          return s;
        };
        const edge = c3 => c3.idxs[c3.idxs.length - 1] === cut ? "2px solid #08234C" : "1px solid transparent";
        const band = label => {
          out.push({
            label: label, nameBg: "#E4EBF7", labelFg: "#08234C", fw: 600, size: "10.5px", ls: "0.1em", tt: "uppercase",
            tag: "", hasTag: false, tagFg: "#4D6389", tagBg: "transparent",
            cells: cols.map(c3 => ({ isInput: false, isText: true, text: "", onChange: null, bg: "#E4EBF7", fg: "#4D6389", fw: 400, edge: edge(c3) }))
          });
        };
        const row = (label, tag, tagOn, valOf, fmt, opts) => {
          const pk = (opts && opts.kind) || "mix";
          const trace = opts && opts.mixName ? cellTrace(opts.ci, opts.mixName, pk) : null;
          const manual = !!(opts && opts.ci !== undefined && cats[opts.ci] && cats[opts.ci][5]);
          out.push({
            label: label, nameBg: "#FFFFFF", labelFg: "var(--ink)", fw: (opts && opts.fw) || 400, size: "12.5px", ls: "0", tt: "none",
            tag: tag, hasTag: true,
            tagFg: manual && tagOn ? "#B26A00" : tagOn ? "#0052CD" : "#8094B5",
            tagBg: manual && tagOn ? "#FFF4E5" : tagOn ? "#EAF1FD" : "#F5F8FA",
            title: manual ? MANUAL_CATEGORY_NOTE : "",
            onDelete: manual && isDraft && !locked && !isAll ? () => this.removeProductCategory(ch, opts.ci) : null,
            rule: (opts && opts.rule) || null,
            cells: cols.map(c3 => {
              const single = c3.idxs.length === 1, actual = c3.idxs.every(i => i <= cut);
              const r2 = valOf(c3, single, actual);
              const period = opts && opts.mixName && single && !actual ? D.months[c3.idxs[0]] : null;
              const cellRule = period ? mixRuleFields(opts.mixName, period, pk) : null;
              if (cellRule && cellRule.open && trace) cellRule.calc = trace.calc;
              const mixT = opts && opts.mixName && single && metaOf(pk) ? c3.idxs[0] : -1;
              return {
                cellKey: mixT >= 0 ? mixCellKey(opts.ci, mixT, pk) : "",
                explain: mixT >= 0 ? (() => explainMix(opts.ci, opts.mixName, mixT, pk)) : null,
                srcHi: !!trace && single && trace.srcs.has(c3.idxs[0]),
                onContext: cellRule && cellRule.onOpen ? (e => { e.preventDefault(); cellRule.onOpen(); }) : null,
                popOpen: !!cellRule && cellRule.open,
                cellRule: cellRule && cellRule.open ? cellRule : null,
                ruleOwn: !!cellRule && cellRule.own,
                isInput: !!r2.editable, isText: !r2.editable, text: r2.v === null || r2.v === undefined ? "—" : fmt(r2.v),
                onCommit: r2.onCommit || r2.onChange || null, onChange: r2.onChange || null, onPaste: r2.onPaste || null,
                bg: r2.editable ? "#FFFDEB" : (opts && opts.totalBg) ? (r2.bad ? "#FDECEC" : "#F5F8FA") : (actual ? "#EDF1F8" : "#FBFCFE"),
                fg: r2.bad ? "#E5484D" : (r2.ovr || (cellRule && cellRule.own)) ? "#0052CD" : actual ? "#4D6389" : "#08234C",
                fw: (opts && opts.fw) || (r2.ovr ? 600 : 400),
                edge: edge(c3)
              };
            })
          });
        };
        const money = v => (v === null || v === undefined || isNaN(v)) ? "—" : Math.round(v).toLocaleString("en-GB");
        const pct = v => typeof v === "number" && Number.isFinite(v) ? this.numFixed(v * 100, 1) : "—";

        const inputRow = (c2, ci, kind, valOf) => row(c2[0], c2[5] ? "manual" : "input", true, (c3, single, actual) => {
          const t = c3.idxs[0];
          const manual = !!c2[5];
          const editable = isDraft && single && !locked && (!actual || manual);
          const commit = editable ? (raw => this.editMix(ch, ci, t, raw, kind)) : null;
          const hist = manual ? c2[kind === "cogs" ? 4 : 3] : null;
          return {
            v: valOf(ci, c3), editable: editable,
            ovr: single && (actual ? !!hist && typeof hist[String(D.months[t])] === "number" : st.mov[this.prodKey(kind, ch, ci, t)] !== undefined),
            onCommit: commit,
            onChange: commit,
            onPaste: editable ? (e => { const txt = e.clipboardData && e.clipboardData.getData("text"); if (txt && this.pasteMix(ch, ci, t, txt, kind)) e.preventDefault(); }) : null
          };
        }, pct, { ci, rule: mixRuleFields(c2[0], null, kind), mixName: c2[0], kind });

        band("1 · % mix");
        cats.forEach((c2, ci) => inputRow(c2, ci, "mix", mixOf));
        row("Mix total", "check", false, c3 => {
          let tot = 0; cats.forEach((c2, ci) => { tot += mixOf(ci, c3); });
          return { v: cats.length ? tot : null, bad: cats.length ? Math.abs(tot - 1) > 0.0005 : false };
        }, pct, { fw: 600, totalBg: 1 });

        band("2 · Gross sales excl discounts and tax");
        cats.forEach((c2, ci) => row(c2[0], "formula", false, c3 => {
          const g0 = grossOf(c3), m0 = mixOf(ci, c3);
          return { v: g0 === null || m0 === null ? null : g0 * m0 };
        }, money, { ci }));
        row("Gross sales", "total", false, c3 => ({ v: grossOf(c3) }), money, { fw: 600, totalBg: 1 });

        band("3 · Product COGS %");
        cats.forEach((c2, ci) => inputRow(c2, ci, "cogs", cogsOf));
        row("Blended product COGS %", "total", false, c3 => {
          const g0 = grossOf(c3);
          if (g0) {
            let s = null;
            cats.forEach((c2, ci) => { const v = catCogs(ci, c3); if (v !== null) s = (s === null ? 0 : s) + v; });
            return { v: s === null ? null : s / g0 };
          }
          let b2 = null; cats.forEach((c2, ci) => { const m0 = mixOf(ci, c3), k0 = cogsOf(ci, c3); if (typeof m0 === "number" && typeof k0 === "number") b2 = (b2 === null ? 0 : b2) + m0 * k0; });
          return { v: b2 };
        }, pct, { fw: 600, totalBg: 1 });

        band("4 · Product COGS £");
        cats.forEach((c2, ci) => row(c2[0], "formula", false, c3 => ({ v: catCogs(ci, c3) }), money, { ci }));
        row("Product COGS", "total", false, c3 => ({ v: sumIdx(planGrid.cogs, c3.idxs) }), money, { fw: 600, totalBg: 1 });

        return out;
      })(),
      sourceRows: combinedCh ? this.combinedSourceRows(ch, sourceMembers, cols, cut) : this.sourceScreenRows(ch, cols, cut, isDraft && !locked),
      showPlan: st.screen === "plan",
      showCohorts: st.screen === "cohorts" && triangle && !isAll,
      showBase: st.screen === "cohorts" && !cohort && !isAll && !combinedCh,
      showGroup: st.screen === "cohorts" && isAll,
      showScenario: st.screen === "scenario", showVariance: st.screen === "variance",
      showAuthoring: st.screen === "authoring", showValidate: st.screen === "validate",
      showGovernance: st.screen === "governance",

      publishOpen: st.publishOpen,
      closePublish: () => { if (!st.publishing) this.setState({ publishOpen: false }); },
      publishing: !!st.publishing,
      stopClose: e => e.stopPropagation(),
      publishCount: errCount > 0 ? String(errCount) : "",
      hasPublishCount: errCount > 0,
      publishBadgeBg: errCount > 0 ? "#FDECEC" : "#F1F6DC", publishBadgeFg: errCount > 0 ? "#E5484D" : "#5f7009",
      version: st.version,
      versionGroups: (() => {
        const GRP = [
          { id: "working", label: "", dot: "#E0A100", fg: "#7A5200", bg: "#FFF6DD", hover: "#FCEFC9" },
          { id: "published", label: "Forecast · published", dot: "#8094B5", fg: "#08234C", bg: "#EDF1F8", hover: "#E3E9F4" },
          { id: "scenario", label: "Scenarios", dot: "#7A4FD0", fg: "#5B33A8", bg: "#F1EBFC", hover: "#E8DEFA" },
          { id: "system", label: "System created", dot: "#8094B5", fg: "#4D6389", bg: "#F5F8FA", hover: "#EDF1F8" }
        ];
        return GRP.map((g, gi) => ({
          label: g.label, fg: g.fg, hasLabel: !!g.label,
          topBorder: gi === 0 ? "none" : "1px solid #EDF1F8",
          topGap: gi === 0 ? "0" : "4px",
          rows: VERSIONS.filter(v => v.grp === g.id).map(v => {
            const lk = v.id === "actual" || v.id === "fit" || !!st.locks[v.id], sel = v.id === st.version;
            const del = (v.grp === "published" && !lk) || (v.grp === "scenario" && v.id !== "scen_session") || (!!v.clone && !!st.canCreateVersion && !!this.onDeleteVersion);
            return {
              label: v.short, locked: lk, dot: v.id === "actual" ? "#B0CB1F" : g.dot, fw: sel ? 500 : 400,
              bg: sel ? g.bg : "#fff", hoverBg: sel ? g.bg : g.hover,
              fg: sel ? g.fg : "#08234C",
              canDelete: del && st.delAsk !== v.id,
              deleteTitle: "Delete " + v.short,
              onDelete: e => { e.stopPropagation(); this.setState({ delAsk: v.id, switchAsk: null }); },
              onClick: () => this.selectVersion(v)
            };
          })
        })).filter(g => g.rows.length);
      })(),
      switchAsk: !!st.switchAsk,
      switchMsg: st.switchAsk ? "You have unsaved changes. Save them before opening " + st.switchAsk.label + ", or discard them." : "",
      switchSave: () => { void this.resolveSwitch(true); },
      switchDiscard: () => { void this.resolveSwitch(false); },
      switchCancel: () => this.setState({ switchAsk: null }),
      deleteAsk: !!st.delAsk,
      deleteMsg: (() => {
        const v = VERSIONS.find(x => x.id === st.delAsk);
        if (!v) return "";
        if (v.clone) return "Delete " + v.short + "? This working version and its saved edits go with it.";
        return "Delete " + v.short + "? " + (v.grp === "published" ? "The published snapshot and its audit trail go with it." : "The scenario and its slider values go with it.");
      })(),
      cancelDelete: () => this.setState({ delAsk: null }),
      confirmDelete: () => {
        const v = VERSIONS.find(x => x.id === st.delAsk);
        if (v && v.clone) {
          this.setState({ delAsk: null, versionOpen: false });
          if (this.onDeleteVersion && v.target) void Promise.resolve(this.onDeleteVersion(v.target));
          return;
        }
        this.confirmLocalDelete();
      },
      versionMenu: st.versionOpen,
      toggleVersionMenu: () => this.setState({ versionOpen: !st.versionOpen }),
      versionLocked: locked, versionShort: versionRec.short,
      versionPill: versionRec.grp === "working"
        ? { suffix: " · Draft", dot: "#E0A100", bg: "#FFF6DD", border: "#F1D48A", fg: "#7A5200", lock: false }
        : versionRec.grp === "scenario"
          ? { suffix: " · Scenario", dot: "#7A4FD0", bg: "#F1EBFC", border: "#D5C6F3", fg: "#5B33A8", lock: false }
          : versionRec.grp === "published"
            ? { suffix: " · Published", dot: "", bg: "#EDF1F8", border: "#C8D4EA", fg: "#4D6389", lock: true }
            : null,
      lockLabel: isActual ? "Actual is always locked" : isSysFit ? "System fit is always locked" : locked ? versionRec.short + " is locked" : versionRec.short + " is unlocked",
      lockNote: isActual ? "Bound data, not a version — actuals as of yesterday. Nothing here can be edited or unlocked." : isSysFit ? "System forecast from trend and seasonality: same month last year × growth of the last 3 months. Nothing here can be edited or unlocked." : locked ? "Published values are immutable while locked" : "Editing copies this version into a new draft",
      lockAction: locked ? "Unlock" : "Lock",
      lockToggleable: !sysLocked,
      toggleLock: () => this.setState(s => {
        const l = Object.assign({}, s.locks); l[s.version] = !l[s.version]; return { locks: l };
      }),
      saveStatus: st.draftSaving ? "Saving…" : (st.draftSaveFailed ? "Save failed" : (unsaved ? (unsavedCount ? unsavedCount + (unsavedCount === 1 ? " unsaved change" : " unsaved changes") : "Unsaved changes") : st.savedAt ? "Saved " + new Date(st.savedAt).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }) : "No changes")),
      saveStatusNote: st.draftSaving ? "Saving draft…" : (st.draftSaveFailed ? "Last save failed — fix the error banner and click Save again" : (unsaved ? "Unsaved changes — click Save to keep them" : st.savedAt ? "Draft saved " + new Date(st.savedAt).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit" }) + " BST" : "No changes yet")),
      saveStatusFg: st.draftSaving ? "#0052CD" : (st.draftSaveFailed ? "#E5484D" : (unsaved ? "#C0262D" : "var(--ink-4)")),
      canSave: unsaved && !st.draftSaving && !st.publishing,
      saveLabel: st.draftSaving ? "Saving…" : "Save",
      saveDraft: () => { if (unsaved && !st.draftSaving && !st.publishing) void this.flushDraftSave(); },
      draftSaving: !!st.draftSaving,
      draftSaveFailed: !!st.draftSaveFailed,
      versionType: versionRec.type,
      versionChip: (isAll ? "Rollup · 3 models" : cohort ? "Cohort model" : "Base model") + " · " + versionRec.type + " " + (isDraft ? "draft" : versionRec.label),

      onVersion: e => this.setState({ version: e.target.value }),
      readOnly: !isDraft,
      readOnlyNote: isDraft ? "" : isActual ? "Actual version — bound data as of yesterday, always locked" : locked ? "Locked — " + versionRec.short + " is published" : versionRec.type === "SYSTEM_FIT" ? "System fit version — system created, cannot be edited" : versionRec.type === "SCENARIO" ? "Scenario version — adjust it from Create new scenario" : "Unlocked — editing " + versionRec.short + " copies it into a new draft",
      findings: reviewItems,
      guardFindings: guardNotes.filter(f => !(pubPicker && f.fadeNeeds)),
      reviewTodo: errCount,
      reviewTitle: errCount === 0
        ? "Ready to publish"
        : errCount + (errCount === 1 ? " problem" : " problems") + " to fix before you publish",
      reviewNote: errCount === 0
        ? "Every formula works and every forecast month has a value."
        : pubPicker
          ? "Fix formula errors, fill empty forecast months, review every flag and decide the long-term fade, then publish."
          : "Fix formula errors and fill empty forecast months, then publish.",
      changeLog, showChangeLog,
      modelParams,
      cohortInputGroups,
      cohortGuardsView,
      cohortInputNote: isDraft
        ? "Fills the yellow forecast cells on the Cohorts screen. A cohort row rule beats the channel default, and a typed cell beats both. Click Save in the top bar to keep changes."
        : "Rules stored with this version. Switch to the working draft to change them.",
      amzCutoff: amzCutoffValue,
      cohortTenure,
      engineVersion: engineVersion || "",
      goValidate: createMode
        ? () => { if (!st.creating) this.openCreateVersion(); }
        : () => { if (!st.publishing) this.setState({ publishOpen: true, menuOpen: false }); },
      publishHeaderLabel: createMode ? (st.creating ? "Creating…" : "Create new version") : (st.publishing ? "Publishing…" : "Publish"),
      publishHeaderCursor: (createMode ? st.creating : st.publishing) ? "wait" : "pointer",
      publishHeaderDisabled: createMode ? !!st.creating : !!st.publishing,
      createVersionMode: createMode,
      createOpen: createMode && !!st.createOpen,
      createSourceName: createSource ? createSource.name : "",
      createName: st.createName || "",
      onCreateName: e => this.setState({ createName: e.target.value }),
      createCutoff: typeof st.createCutoff === "number" ? String(st.createCutoff) : "",
      createCutoffOpts: createCutoffOpts,
      onCreateCutoff: e => this.setState({ createCutoff: Number(e.target.value) }),
      creating: !!st.creating,
      createReady: createMode && !st.creating && !!String(st.createName || "").trim(),
      createLabel: st.creating ? "Creating…" : "Create working version",
      doCreateVersion: () => { void this.submitCreateVersion(); },
      closeCreate: () => { if (!st.creating) this.setState({ createOpen: false }); },
      hasBlockers: errCount > 0,
      openReviewLabel: errCount + (errCount === 1 ? " Item" : " Items") + " to Review",
      goGovernance: () => this.setState({ screen: "governance", publishOpen: false }),
      groupCards, groupRangeLabel: ml(D.months[this.fyRange(st.range)[0]]) + " to " + ml(D.months[this.fyRange(st.range)[1]]),
      isAll: isAll,
      rollupNote: isAll ? "Aggregated across " + (() => { const ls = (chSel.length ? chSel : chBase).map(cid => D.channels[cid].label); return ls.length > 1 ? ls.slice(0, -1).join(", ") + " and " + ls[ls.length - 1] : ls[0]; })() + " — read only. Edit drivers on a channel." : "",
      cohortCols,
      cohortRows,
      cohortNote: [
        memberCohorts ? "Summed from " + cohortMembers.map(m => D.channels[m].label).join(" + ") + " · read only" : "",
        st.gran !== "month" && st.view === "rate" ? "Rates sum within each " + (st.gran === "quarter" ? "quarter" : "year") + " — orders in period over cohort size" : "",
        !pickerOn && Object.keys(st.rov).length ? Object.keys(st.rov).length + (Object.keys(st.rov).length === 1 ? " override" : " overrides") : ""
      ].filter(Boolean).join(" · "),
      cohortRule: cohort && !isAll && !allBlocks && blk && !pickerOn ? ruleFields(null) : null,
      forecastRow,
      flagPanel,
      reviewCard,
      cohortFocusKey: focusKey,
      viewToggle: [["rate", "Repurchase %"], ["orders", "Orders"]].map((v, i) => {
        const on = st.view === v[0];
        return { label: v[1], selected: on, bg: on ? "#0052CD" : "transparent", fg: on ? "#fff" : "#4D6389", fw: on ? 500 : 400, divider: i ? "inset 1px 0 0 #DCE4F2" : "none", onClick: () => this.setState({ view: v[0] }) };
      }),
      blockToggle: (triangle && cohortBlocks.length > 1 ? cohortBlocks.concat([ALL_BLOCKS]) : cohortBlocks).map((id, i) => {
        const on = id === ALL_BLOCKS ? allBlocks : !allBlocks && blk === id;
        return { label: id === ALL_BLOCKS ? "All" : BL[id] + " cohorts", selected: on, bg: on ? "#0052CD" : "transparent", fg: on ? "#fff" : "#4D6389", fw: on ? 500 : 400, divider: i ? "inset 1px 0 0 #DCE4F2" : "none", onClick: () => this.setState({ block: id }) };
      }),
      baseParams, backtest, baseDivergence, baseForecastMonths, backtestMonths,
      backtestHeading: backtestMonths
        ? ("Back-test · one step ahead on the last " + backtestMonths + " actual month" + (backtestMonths === 1 ? "" : "s"))
        : "Back-test · one step ahead",
      baseBlockLabel: fitBlockName + " · orders in month",
      sliders, compare,
      scenEmptyNote: sliders.length ? "" : "No driver shown on the plan has its scenario switch on. Turn one on from Edit driver in Settings.",
      scenBaseLabel: "Base = " + versionRec.short,
      scenRangeLabel: ml(D.months[sa]) + " to " + ml(D.months[sb]),
      resetScenario: () => { this._drag = null; this.setState(s => {
        const by = Object.assign({}, s.scenByCh);
        (ch === "all" ? Object.keys(by).concat(["all"]) : [ch]).forEach(cid => { by[cid] = Object.assign({}, zero); });
        return { scenByCh: by };
      }); },
      scenHeadNote: (isAll ? "All channels" : conf.label) + " · vs " + versionRec.short + " · " + ml(D.months[sa]) + " to " + ml(D.months[sb]),
      scenScopeNote: isAll ? "Group view — sliders apply to every channel at once." : conf.label + " only. Each channel keeps its own scenario.",
      scenDirtyNote: (() => {
        const dirty = Object.keys(D.channels).filter(cid => Object.keys(zero).some(k => this.scenFor(cid)[k] !== 0)).map(cid => D.channels[cid].label);
        return dirty.length ? "Scenario active on " + dirty.join(" · ") : "No scenario active on any channel.";
      })(),
      scenDirtyFg: Object.keys(D.channels).some(cid => Object.keys(zero).some(k => this.scenFor(cid)[k] !== 0)) ? "#1A7F4B" : "#8094B5",
      auth: a,
      authKeyChange: e => setAuth({ key: e.target.value, keyTouched: true }),
      authNameChange: e => {
        const name = e.target.value;
        setAuth(!st.editing && !a.keyTouched ? { name, key: (isAll ? "group" : channelNs(ch)) + "." + driverKeySlug(name) } : { name });
      },
      authFormulaChange: e => setAuth({ formula: e.target.value }),
      authBindingChange: e => setAuth({ binding: e.target.value }),
      isOverwrite: overwriteUsed,
      authOverwriteChange: e => setAuth({ overwrite: e.target.value }),
      authBindingNote: authBindingBound === null ? "" : authBindingBound
        ? "Actuals load from growth_driver_actuals · DRIVER_KEY = " + authBindingKey + " · " + authBindingBound + (authBindingBound === 1 ? " month" : " months") + " bound."
        : "No actual key found: growth_driver_actuals has no rows for DRIVER_KEY = " + authBindingKey + ". Actual months stay empty until it does.",
      authBindingBound: !!authBindingBound,
      authTotalsFormulaChange: e => setAuth({ totalsFormula: e.target.value }),
      authFormulaExample: formulaExample,
      authFormulaNote: formulaNote,
      unitSeg: seg("unit", ["currency", "percentage", "count", "ratio"], UNIT_LABEL),
      authBuiltIn, authShapeLocked, authShape, authLookSummary, authUsedIn, authFormulaReadable,
      authTotals,
      authTotalsNote: authTotalsMode === "formula"
        ? "Quarters and years run this formula on the period totals of the drivers it uses. The All channels view runs it on the totals across channels."
        : authTotalsMode === "no_totals"
          ? "No quarter or year figure, and no All channels figure for this driver."
          : "Quarters and years add up the months. The All channels view adds up every channel.",
      authTotalsFormulaReadable: totalsText && totalsValid ? readableFormula(totalsText) : "",
      authSrcNote: authManual ? MANUAL_DRIVER_NOTE
        : combinedCh && isInputSource(a.src) ? "Planners type the forecast values on the plan. Actual months roll up from the channels it combines with the rule below."
        : authMember && isRollupSource(a.src) ? COMBINED_SRC_NOTE[authMember.option] + " " + memberLabels + " roll up into this channel with the rule below, for actuals and forecast."
        : SRC_NOTE[a.src] || "",
      authCombined: combinedCh,
      isRollupRule: rollupUsed,
      authRollupChange: e => setAuth({ rollup: e.target.value }),
      authRollupNote: "Use " + ROLLUP_FUNCTIONS.join(", ") + " over driver keys to combine " + membersOf(D, ch).map(m => D.channels[m].label).join(" + ") + ". WAVG(value, weight) weights the value by another driver. Bare keys use this channel's own values.",
      authRollupReadable: rollupUsed && rollupText && rollupValid ? readableFormula(rollupText) : "",
      authManual,
      authManualNote: "Typed on the plan for every month, including actuals. Saved in the app, not Snowflake, so there is no formula or binding.",
      authLever: !!authLever,
      authScenOn,
      toggleAuthScen: () => { if (!st.draftSaving && st.canAuthor) setAuth({ scenOn: !authScenOn }); },
      secSeg: (() => {
        const cur = planSectionOf(a.sec);
        const opts = planSectionsFor(blocks);
        if (opts.indexOf(cur) < 0) opts.push(cur);
        return opts.map(id => ({
          id, label: SECTION_LABEL[id],
          bg: cur === id ? "#0052CD" : "#fff", fg: cur === id ? "#fff" : "#4D6389", border: cur === id ? "#0052CD" : "#C8D4EA",
          disabled: !!st.draftSaving,
          onClick: () => { if (!st.draftSaving) setAuth({ sec: id }); }
        }));
      })(),
      authSecNote: planSectionOf(a.sec) === "kpi"
        ? "Context only · shows actuals up to the cutoff, no forecast."
        : "Shows actuals and forecast under " + SECTION_LABEL[planSectionOf(a.sec)] + " on the plan.",
      srcSeg: PLAN_SOURCES.filter(o => combinedCh ? combinedSources.indexOf(o) >= 0 : o !== ROLLUP_SOURCE).map(o => {
        const rolls = !!authMember && o === authMember.option;
        const on = rolls ? isRollupSource(a.src) : (SRC_ALIAS[a.src] || a.src) === o;
        const locked = !on && !rolls && MODEL_SOURCES.indexOf(o) >= 0;
        return {
          id: o, label: o === "input" && authManual ? "MANUAL" : SRC_LABEL[o],
          bg: on ? "#0052CD" : "#fff", fg: on ? "#fff" : "#4D6389", border: on ? "#0052CD" : "#C8D4EA",
          disabled: !!st.draftSaving || locked,
          onClick: () => {
            if (st.draftSaving || on || locked) return;
            if (rolls) {
              setAuth({ src: ROLLUP_SOURCE, formula: "" });
              return;
            }
            const prose = !/[+\-*\/()]/.test(a.formula) || /manual input|bound ·|Σ /.test(a.formula);
            if (o === "formula") {
              const binding = String(a.binding || "").trim();
              const fromBinding = prose && /[+\-*\/()]/.test(binding) ? binding : "";
              const keepBinding = fromBinding || /^growth_driver_actuals\b/i.test(binding) ? "" : binding;
              setAuth(Object.assign({ src: o, binding: keepBinding }, fromBinding ? { formula: fromBinding } : prose ? { formula: "" } : null));
              return;
            }
            setAuth({ src: o, formula: "" });
          }
        };
      }),
      tmpSeg: seg("tmp", ["activity", "cohort", "none"], TMP_LABEL),
      totalsSeg: TOTALS_MODES.map(o => ({
        id: o, label: TOTALS_LABEL[o],
        bg: authTotalsMode === o ? "#0052CD" : "#fff",
        fg: authTotalsMode === o ? "#fff" : "#4D6389",
        border: authTotalsMode === o ? "#0052CD" : "#C8D4EA",
        disabled: !!st.draftSaving,
        onClick: () => { if (!st.draftSaving) setAuth({ totalsMode: o }); }
      })),
      dimChips: DIMS.map(d => ({
        id: d, label: DIM_LABEL[d] || d,
        bg: a.dim.indexOf(d) >= 0 ? "#0052CD" : "#fff",
        fg: a.dim.indexOf(d) >= 0 ? "#fff" : "#4D6389",
        border: a.dim.indexOf(d) >= 0 ? "#0052CD" : "#C8D4EA",
        disabled: !!st.draftSaving,
        onClick: () => { if (!st.draftSaving) setAuth({ dim: a.dim.indexOf(d) >= 0 ? a.dim.filter(x => x !== d) : a.dim.concat([d]) }); }
      })),
      isFormula: a.src === "formula", isBinding: a.src === "binding", isFitted: a.src === "fitted", isTotalsFormula: authTotalsMode === "formula",
      ccyOpts: [["GBP", "£ GBP"], ["EUR", "€ EUR"], ["USD", "$ USD"], ["AUD", "$ AUD"]].map(c => ({
        label: c[1],
        bg: st.ccy === c[0] ? "#0052CD" : "#fff", fg: st.ccy === c[0] ? "#fff" : "#4D6389",
        border: st.ccy === c[0] ? "#0052CD" : "#C8D4EA", fw: st.ccy === c[0] ? 500 : 400,
        onClick: () => { this.setState({ ccy: c[0] }); this.noteSettingsDirty(); }
      })),
      ccyNote: "One reporting currency per client. Bound sources are converted on ingest, never at display time, so a published version cannot drift with the FX rate.",
      structureTitle: conf.label + " · " + (isAll ? "rollup of the channel drivers" : cohort ? "cohort model" : isCustom(D, ch) ? "custom model, formulas can read {channel}.{driver} from other channels" : "base model, stock and flow"),
      structureNote: isAll ? "All channels has no drivers of its own. It shows every driver from every channel and combines each one with that driver's quarter and year totals setting: Add up sums the channels, Formula reruns the totals formula on the channel totals, and No totals shows nothing. Pick a channel to add or edit drivers." : "",
      structFormulaHead: combinedCh ? "Formula or rollup rule" : "Formula or binding",
      clientSettingsTitle: "Client",
      resetLayout: () => { this.setState({ rowCfg: {}, rowOrd: {} }); this.noteLayoutDirty(); },
      hasLayout: Object.keys(st.rowCfg).length > 0 || Object.keys(st.rowOrd).length > 0,
      canAuthor: !!st.canAuthor,
      authOpen: st.authOpen && !!st.canAuthor,
      closeAuth: () => this.setState({ authOpen: false, editing: null }),
      authTitle: st.editing ? "Edit driver" : "New driver",
      authIntro: st.editing
        ? "Apply the structural changes here, then click Save in the top bar to keep them in the model draft. Publishing creates one immutable revision."
        : "Add the driver here, then click Save in the top bar to keep it in the model draft. Publishing creates one immutable revision.",
      authPendingNote: "Changes stay local until you click Save in the top bar.",
      newDriver: () => {
        if (!st.canAuthor || isAll) return;
        this.setState({
          authOpen: true, editing: null,
          auth: { key: channelNs(ch) + ".new_driver", name: "New driver", unit: "currency", src: "formula", dim: ["channel"], tmp: "activity", totalsMode: "add_up", totalsFormula: "", formula: "", binding: "", overwrite: "", sec: "kpi" }
        });
      },
      structureMeta: (() => {
        if (isAll) return ROWS.length + " drivers rolled up from " + this.chIds().length + " channels";
        const parts = [ROWS.length + " drivers", versionRec.short];
        const nd = Object.keys(st.fdraft).filter(k => this.isDriverUnsaved(k)).length;
        const nc = Object.keys(st.rowCfg).filter(k => { const c = st.rowCfg[k]; return c && (c.bold || c.numBold || c.hide || c.indent || c.sec || c.inverse || roundingDp(c.dp) !== null || (c.bg && c.bg !== "none")); }).length;
        const nr = Object.keys(st.rowOrd).length;
        if (nd) parts.push(nd + " unsaved");
        if (nc) parts.push(nc + " restyled");
        if (nr) parts.push(nr + (nr === 1 ? " section reordered" : " sections reordered"));
        return parts.join(" · ");
      })(),
      structure: isAll ? [] : (() => {
        // same order and grouping as the plan table
        const ORD = ["acq", "subs", "otp", "total", "pl", "kpi"];
        const BAND = { acq: "acq", subs: "rev", otp: "rev", total: "rev", pl: "pl", kpi: "kpi" };
        const LBL = { acq: "Acquisition", rev: "Revenue", pl: "Profit", kpi: "Other" };
        const ordered = this.ordered(ROWS, ORD, ch);
        const posIn = r => { const sib = ordered.filter(x => x.sec === r.sec); return [sib.indexOf(r), sib.length]; };
        let lastBand = null, num = 0;
        const out = [];
        ordered.forEach(r => {
          const band = BAND[r.sec] || r.sec;
          if (band !== lastBand) {
            out.push({ isBand: 1, isRow: false, name: LBL[band] || band, n: "", key: "", src: "", formula: "", bind: "", canEdit: false, isDraft: false, fw: 600, topBorder: lastBand ? "1px solid #C8D4EA" : "1px solid transparent", srcFg: "#08234C", srcBg: "transparent", onClick: null, onEdit: null });
            lastBand = band;
          }
          num++;
          const row = this.structRow(r, num, st, ROWS, memberLabels, memberRows);
          const pos = posIn(r);
          row.canUp = pos[0] > 0; row.canDown = pos[0] < pos[1] - 1;
          row.upFg = row.canUp ? "#4D6389" : "#DCE4F2";
          row.downFg = row.canDown ? "#4D6389" : "#DCE4F2";
          row.onUp = e => { e.stopPropagation(); this.moveRow(ROWS, r.sec, r.k, -1, ch); };
          row.onDown = e => { e.stopPropagation(); this.moveRow(ROWS, r.sec, r.k, 1, ch); };
          row.canDelete = canAddDriver && (!!(st.fdraft[r.key] || {}).isNew || catalogOf(ch, D).some(c => c.key === r.key));
          row.deleteBlockedBy = row.canDelete ? driverUsedBy(r) : [];
          row.onDelete = row.canDelete && !row.deleteBlockedBy.length ? () => this.removePlanDriver(ch, r.key) : null;
          row.cloneOptions = canAddDriver && chAll.length > 1 ? () => this.cloneTargets(ch, r.k) : null;
          row.onClone = row.cloneOptions ? ids => this.cloneRowToChannels(ch, r.k, ids) : null;
          out.push(row);
        });
        return out;
      })(),
      terminalNote: (() => {
        const pl = ROWS.filter(r => r.sec === "pl");
        const term = pl.length ? pl[pl.length - 1] : ROWS[ROWS.length - 1];
        return "Terminal node is " + (term || {}).name + " · " + (term || {}).key + ". Everything above it is a driver of it; the Other rows below carry context and drive nothing.";
      })(),
      hasPresentation: !!st.editing,
      presWeight: (() => {
        const cur = st.editing ? this.cfgOf(st.editing, ch).bold : false;
        return [["Regular", false], ["Bold", true]].map(o => ({
          label: o[0], fw: o[1] ? 600 : 400,
          bg: cur === o[1] ? "#0052CD" : "#fff", fg: cur === o[1] ? "#fff" : "#4D6389", border: cur === o[1] ? "#0052CD" : "#C8D4EA",
          disabled: !!st.draftSaving,
          onClick: () => { if (!st.draftSaving) this.setCfg(st.editing, { bold: o[1] }, ch); }
        }));
      })(),
      presNumWeight: (() => {
        const cur = st.editing ? this.cfgOf(st.editing, ch).numBold : false;
        return [["Regular", false], ["Bold", true]].map(o => ({
          label: o[0], fw: o[1] ? 600 : 400,
          bg: cur === o[1] ? "#0052CD" : "#fff", fg: cur === o[1] ? "#fff" : "#4D6389", border: cur === o[1] ? "#0052CD" : "#C8D4EA",
          disabled: !!st.draftSaving,
          onClick: () => { if (!st.draftSaving) this.setCfg(st.editing, { numBold: o[1] }, ch); }
        }));
      })(),
      presIndent: (() => {
        const cur = st.editing ? this.cfgOf(st.editing, ch).indent : 0;
        return [["None", 0], ["One", 1], ["Two", 2]].map(o => ({
          label: o[0],
          bg: cur === o[1] ? "#0052CD" : "#fff", fg: cur === o[1] ? "#fff" : "#4D6389", border: cur === o[1] ? "#0052CD" : "#C8D4EA",
          disabled: !!st.draftSaving,
          onClick: () => { if (!st.draftSaving) this.setCfg(st.editing, { indent: o[1] }, ch); }
        }));
      })(),
      presRound: (() => {
        const cur = st.editing ? this.cfgOf(st.editing, ch).dp : null;
        return [null].concat(ROUNDING_DP).map(dp => ({
          label: dp === null ? "Auto" : dp + " dp",
          bg: cur === dp ? "#0052CD" : "#fff", fg: cur === dp ? "#fff" : "#4D6389", border: cur === dp ? "#0052CD" : "#C8D4EA",
          disabled: !!st.draftSaving,
          onClick: () => { if (!st.draftSaving) this.setCfg(st.editing, { dp }, ch); }
        }));
      })(),
      presDirection: (() => {
        const cur = st.editing ? this.cfgOf(st.editing, ch).inverse : false;
        return [["direct", "Direct", "increase is green", false], ["inverse", "Inverse", "increase is red", true]].map(o => ({
          id: o[0], label: o[1], hint: o[2], checked: cur === o[3],
          upFg: this.changeFg(1, o[3]), downFg: this.changeFg(-1, o[3]),
          disabled: !!st.draftSaving,
          onSelect: () => { if (!st.draftSaving && cur !== o[3]) this.setCfg(st.editing, { inverse: o[3] }, ch); }
        }));
      })(),
      presBg: (() => {
        const cur = st.editing ? this.cfgOf(st.editing, ch).bg : "none";
        return [["None", "none"], ["Grey", "tint"], ["Green", "lime"], ["Amber", "amber"], ["Blue", "cyan"]].map(o => ({
          label: o[0], swatch: this.cfgBg(o[1]) || "#fff",
          fg: cur === o[1] ? "#0052CD" : "#4D6389", border: cur === o[1] ? "#0052CD" : "#C8D4EA",
          disabled: !!st.draftSaving,
          onClick: () => { if (!st.draftSaving) this.setCfg(st.editing, { bg: o[1] }, ch); }
        }));
      })(),
      presVisibleNote: (st.editing && this.cfgOf(st.editing, ch).hide)
        ? "Hidden from the plan table. It still computes, and anything downstream of it still resolves."
        : "Shown on the plan table.",
      presVisibleLabel: (st.editing && this.cfgOf(st.editing, ch).hide) ? "Show on plan" : "Hide from plan",
      presToggleHide: () => { if (st.editing && !st.draftSaving) this.setCfg(st.editing, { hide: !this.cfgOf(st.editing, ch).hide }, ch); },
      channelName: conf.label,
      fyMonths: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"].map((m, i) => ({
        label: m,
        bg: st.fyStart === i + 1 ? "#0052CD" : "#fff", fg: st.fyStart === i + 1 ? "#fff" : "#4D6389",
        border: st.fyStart === i + 1 ? "#0052CD" : "#C8D4EA", fw: st.fyStart === i + 1 ? 500 : 400,
        onClick: () => { this.setState({ fyStart: i + 1 }); this.noteSettingsDirty(); }
      })),
      fyNote: (() => {
        const MNs = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        const endM = st.fyStart === 1 ? 12 : st.fyStart - 1;
        return "FY runs " + MNs[st.fyStart - 1] + " to " + MNs[endM - 1] + ". Q1 starts " + MNs[st.fyStart - 1] + "; the cutoff sits in " + fyTag(fyOf(D.months[cut])) + ".";
      })(),
      checks, authBtnBg: authValid && st.canAuthor ? "#0052CD" : "#EDF1F8", authBtnFg: authValid && st.canAuthor ? "#fff" : "#8094B5",
      authCommit: () => {
        if (!authValid || !st.canAuthor) return;
        const a = st.auth;
        const key = (a.key || "").trim();
        if (!key) return;
        const wasEditing = st.editing;
        const prevRow = wasEditing ? (ROWS.find(r => r.k === wasEditing) || {}) : {};
        const previousKey = wasEditing ? (prevRow.key || null) : null;
        const builtIn = !!wasEditing && !prevRow.isDraftRow && !((st.fdraft[previousKey || key] || {}).isNew);
        const shortKey = builtIn && prevRow.k ? prevRow.k : this.draftShortKey({ key, shortKey: null });
        const before = wasEditing ? (prevRow.formula || prevRow.src || "") : "";
        const existingKeys = Object.keys(st.fdraft || {});
        if (!wasEditing && (ROWS.some(r => r.key === key) || existingKeys.indexOf(key) >= 0)) return;
        const src = String(a.src || "formula").toLowerCase();
        const totalsMode = totalsModeOf(a);
        const totalsFormula = totalsMode === "formula" ? String(a.totalsFormula || "").trim() : "";
        const formula = src === "input" || src === "binding" || src === "fitted" || isRollupSource(src) ? "" : (a.formula || "");
        const custom = !builtIn;
        const sec = planSectionOf(a.sec);
        const prevSec = wasEditing ? planSectionOf(prevRow.sec) : sec;
        const homeSec = planSectionOf(prevRow.homeSec || prevRow.sec);
        const renamed = !!previousKey && previousKey !== key;
        const bindingInput = String(a.binding || "").trim();
        const binding = prevRow.bindsActuals && bindingInput === prevRow.bind ? "" : bindingInput;
        this.setState(prev => {
          const fdraft = Object.assign({}, prev.fdraft);
          const prior = fdraft[previousKey || key] || {};
          const originalKey = prior.previousKey || (renamed ? previousKey : null);
          const manual = custom && !!prior.manual && src === "input";
          if (renamed && fdraft[previousKey]) delete fdraft[previousKey];
          fdraft[key] = {
            key,
            previousKey: originalKey && originalKey !== key ? originalKey : null,
            name: a.name,
            src: src,
            unit: a.unit,
            dim: a.dim || [],
            tmp: a.tmp,
            totalsMode,
            totalsFormula,
            formula: formula,
            binding,
            isNew: custom,
            shortKey,
            channel: ch,
            section: custom ? sec : homeSec,
            ...(combinedCh ? { rollup: String(a.rollup || "").trim() } : null),
            ...(overwriteUsed && overwriteFormula ? { overwrite: overwriteFormula } : null),
            ...(manual ? { manual: true, values: prior.values || [] } : null)
          };
          const next: any = { fdraft, authOpen: false, editing: null };
          if (renamed && !isAll) {
            this.rewriteDriverRefs(fdraft, ROWS, ch, prevRow, previousKey, key, !!combinedCh);
            const moved = (map, field) => {
              if (!map || map[previousKey] === undefined) return;
              next[field] = Object.assign({}, map, { [key]: map[previousKey] });
              delete next[field][previousKey];
            };
            moved(prev.rowDesc, "rowDesc");
            moved(prev.scenarioOn, "scenarioOn");
          }
          if (builtIn && renamed && renameCatalogKey(prev.data, ch, previousKey, key)) {
            this._tokenIdx = null;
            next.data = prev.data;
          }
          if (src === "input") {
            const n = (prev.data && prev.data.months) ? prev.data.months.length : 0;
            const inputs = Object.assign({}, prev.inputs);
            Object.keys(inputs).forEach(cid => {
              if (cid === "all") return;
              if (!inputs[cid][shortKey]) {
                inputs[cid] = Object.assign({}, inputs[cid], { [shortKey]: new Array(n).fill(null) });
              }
            });
            const oldShort = prior.shortKey || (previousKey ? keyLeaf(previousKey) : null);
            if (manual && oldShort && oldShort !== shortKey && inputs[ch] && Array.isArray(inputs[ch][oldShort])) {
              inputs[ch] = Object.assign({}, inputs[ch], { [shortKey]: inputs[ch][oldShort].slice() });
            }
            next.inputs = inputs;
          }
          return next;
        });
        if (!custom && sec !== prevSec) this.setCfg(wasEditing, { sec: sec === homeSec ? null : sec }, ch);
        if (authLever && a.scenOn !== undefined && !!a.scenOn !== authLever.on) {
          this.setScenarioLever(isAll ? "all" : ch, authLever.levers, authLever.keys.map(k => (renamed && k === previousKey ? key : k)), !!a.scenOn);
        }
        const items = [{ kind: "structure", ch: ch, key: key, i: cut, label: (wasEditing ? "edit · " : "new driver · ") + a.name, period: D.months[cut], before: before || "—", after: src === "formula" ? (formula || src) : src }];
        if (wasEditing && sec !== prevSec) items.push({ kind: "structure", ch: ch, key: key, i: cut, label: "section · " + a.name, period: D.months[cut], before: SECTION_LABEL[prevSec], after: SECTION_LABEL[sec] });
        this.pushBatch(items, "UI");
      },
      authBtnLabel: !st.canAuthor ? "Authoring requires Update permission" : (st.draftSaving ? "Saving…" : (authValid ? (st.editing ? "Apply changes to " + st.auth.name : "Add " + st.auth.name + " to the model draft") : "Fix " + checks.filter(c => c.status === "FAIL").length + " compile error(s)")),
      authNote: !st.canAuthor
        ? "MODEL_AUTHORING is gated on GrowthModel.Update."
        : st.draftSaving
          ? "Saving structural change to the draft…"
          : st.draftSaveFailed
            ? "Last draft save failed — see the red banner, fix the issue, then Save again."
            : authValid
            ? ""
            : "Fix the issues shown in red to continue.",
      publishVersionLabel: versionRec.short,
      publishFlags: !st.publishOpen || !isDraft ? []
        : pubPicker
          ? pubOpenFlags.map(f => ({
              label: scopeNameOf(f.cid, f.b),
              value: cohortNameOf(f.cid, f.b, f.j) + " · " + ml(D.months[f.t]),
              onGo: () => { this.setState({ publishOpen: false, screen: "cohorts" }); this.goToCohortCell(f.cid, f.b, f.j, f.t); }
            })).concat(pubFadeNotes.map(f => ({
              label: scopeNameOf(f.cid, f.b),
              value: GUARD_LABEL.tail + " needs a decision",
              onGo: () => { this.setState({ publishOpen: false }); f.onAction(); }
            })))
          : flagCountsOf("fc_v5").map(x => ({ label: x.label, value: x.count + " flagged", onGo: null })),
      publishFlagsNote: "Red cells will publish as they are. Check them on the Cohorts screen if they are not expected.",
      publishGuardNotes: guardNotes.filter(f => !(pubPicker && f.fadeNeeds)).map(f => f.title),
      pubName: st.pubName, pubConfirm: st.pubConfirm,
      onPubName: e => this.setState({ pubName: e.target.value, pubConfirm: "" }),
      onPubConfirm: e => this.setState({ pubConfirm: e.target.value }),
      pubNeedsOverwrite: pubTarget && !pubTargetLocked,
      pubNeedsUnlock: !!pubTargetLocked,
      unlockTarget: () => { if (pubTarget) this.setState(s => { const l = Object.assign({}, s.locks); l[pubTarget.id] = false; return { locks: l }; }); },
      pubMsg: !isDraft ? "Publishing works from Forecast working. Switch to it in the version picker, then publish." :
              !pubTrim ? "A new name saves a new published version. An existing name overwrites it, if it is unlocked." :
              pubTargetLocked ? pubTrim + " exists and is locked. Remove its lock first, then publish over it." :
              pubTarget ? pubTrim + " already exists and is unlocked. Type OVERWRITE to replace it — its current values are lost." :
              "New version. " + pubTrim + " saves as published and locked; " + (isCloneLoaded ? "this working version closes." : "Forecast working carries on unchanged."),
      pubMsgBg: (pubTargetLocked || (pubTarget && st.pubConfirm.trim() !== "OVERWRITE" && pubTrim)) ? "rgba(229,72,77,0.16)" : "rgba(255,255,255,0.06)",
      pubMsgDot: pubTargetLocked ? "#E5484D" : pubTarget ? "#FFED00" : pubReady ? "#B0CB1F" : "rgba(255,255,255,.35)",
      pubMsgFg: pubTargetLocked ? "#ffd9da" : "rgba(255,255,255,.72)",
      publishLabel: st.publishing ? "Publishing…" : (!isDraft ? "Not the working version" : !pubTrim ? "Name the version" : pubTargetLocked ? "Locked — unlock first" : (pubTarget && st.pubConfirm.trim() !== "OVERWRITE") ? "Type OVERWRITE to confirm" : pubTarget ? "Overwrite " + pubTrim : "Publish " + pubTrim),
      publishBg: st.publishing ? "#003FA0" : (pubReady ? (pubTarget ? "#E5484D" : "#0052CD") : "rgba(255,255,255,0.10)"),
      publishFg: st.publishing || pubReady ? "#fff" : "rgba(255,255,255,0.40)",
      publishCursor: st.publishing ? "wait" : (pubReady ? "pointer" : "not-allowed"),
      doPublish: () => {
        if (!pubReady || st.publishing) return;
        const confirm = st.pubConfirm;
        const pubTrimLocal = pubTrim;
        this.setState({ publishing: true });
        if (this.onPublish) {
          void Promise.resolve(this.onPublish({ name: pubTrimLocal, confirm }));
        } else {
          this.setState({ publishing: false });
        }
      },
      publishNote: !isDraft ? "" : isCloneLoaded ? "Publishing closes this working version and opens the published one. Publishing also saves your current changes first." : "Forecast working is never consumed by publishing — it stays editable, so there is always a live version to plan in. Publishing also saves your current changes to the draft."
    });
  }

  withSettingsFilter(vm) {
    const q = String(this.state.settingsQuery || "").trim().toLowerCase();
    const has = (...parts) => !q || parts.some(p => p !== null && p !== undefined && String(p).toLowerCase().indexOf(q) >= 0);
    const sections = [
      { id: "structure", label: "Model structure", chip: "Structure", kicker: "Model structure", title: vm.structureTitle,
        info: "Every driver in the version you are on. Reorder with the arrows, hide a row from the plan, or open Edit to change its source, formula and presentation. Use New calculated driver to add one: declare its key, source, dimensionality and formula, then click Save in the top bar to keep it in the draft. " + vm.terminalNote,
        keywords: "drivers layout reorder hide edit add a driver new calculated driver formula" },
      { id: "params", label: "Model settings", chip: "Parameters", kicker: "Model settings", title: "Versioned with the revision",
        info: "Settings that configure the model rather than take part in its arithmetic. Changes are kept when you click Save in the top bar and travel with published versions.",
        keywords: "forecast horizon engine" },
      { id: "cohort", label: "Cohort input", chip: "Cohort input", kicker: "Cohort input", title: "Forecast repurchase method",
        info: vm.cohortInputNote,
        keywords: "cohorts forecast repurchase method rule yellow " + COHORT_METHODS.map(m => COHORT_METHOD_LABEL[m]).join(" ") },
      { id: "guards", label: "Cohort model settings", chip: "Guardrails", kicker: "Cohort model settings", title: "Forecast guardrails",
        info: vm.cohortGuardsView ? vm.cohortGuardsView.info : "",
        keywords: "guardrails forecast bundle cohorts trend retention ceiling red cells warnings long-term repeat rate needs a decision defaults " + Object.keys(PARAM_GUIDE).map(p => PARAM_GUIDE[p].label).join(" ") },
      { id: "client", label: "Client settings", chip: "Client & FY", kicker: "Client settings", title: vm.clientSettingsTitle || "Client",
        info: "Applies to every channel, version and export. Changing it re-cuts every quarter and year boundary.",
        keywords: "financial year currency" }
    ];
    const whole = {};
    sections.forEach(s => { whole[s.id] = !!q && has(s.label, s.kicker, s.title, s.keywords); });

    const structRows = (vm.structure || []).filter(r => r.isRow && (whole.structure || has(r.name, r.key, r.src, r.formula, r.bind, r.desc)));
    const keep = new Set(structRows);
    const structure = (vm.structure || []).filter((r, i, all) => {
      if (!r.isBand) return keep.has(r);
      for (let x = i + 1; x < all.length && !all[x].isBand; x++) if (keep.has(all[x])) return true;
      return false;
    });
    const modelParams = (vm.modelParams || []).filter(p => whole.params || has(p.key, p.value, p.note));    const cohortInputGroups = (vm.cohortInputGroups || []).map(g => {
      const blocks = g.blocks.map(b => {
        if (whole.cohort || has(g.label + " " + b.label, b.fields.summary)) return b;
        const rows = b.rows.filter(r => has(r.label, r.summary));
        return rows.length ? Object.assign({}, b, { rows }) : null;
      }).filter(Boolean);
      return blocks.length ? Object.assign({}, g, { blocks }) : null;
    }).filter(Boolean);
    const cohortBlocks = cohortInputGroups.reduce((acc, g) => acc + g.blocks.length, 0);
    const client = {
      fy: whole.client || has("financial_year_start_month", "financial year", vm.fyNote),
      ccy: whole.client || has("reporting_currency", "currency", vm.ccyNote, this.state.ccy)
    };
    const counts = {
      structure: structRows.length,
      params: modelParams.length,
      cohort: (vm.cohortInputGroups || []).length ? cohortBlocks : 0,
      client: (client.fy ? 1 : 0) + (client.ccy ? 1 : 0),
      guards: vm.cohortGuardsView && (whole.guards || has(vm.cohortGuardsView.searchText)) ? 1 : 0
    };
    const settingsSections = sections
      .filter(s => (s.id !== "cohort" || (vm.cohortInputGroups || []).length) && (s.id !== "guards" || vm.cohortGuardsView))
      .map(s => Object.assign({}, s, {
        count: counts[s.id],
        visible: counts[s.id] > 0 || (s.id === "structure" && !q && !vm.structureNote),
        badge: q ? String(counts[s.id]) : "",
        chipBg: q && counts[s.id] ? "#EAF1FD" : "#fff",
        chipFg: q && !counts[s.id] ? "#C8D4EA" : q ? "#0052CD" : "#4D6389",
        chipBorder: q && counts[s.id] ? "#0052CD" : "#DCE4F2"
      }));
    const sectionOf = {};
    settingsSections.forEach(s => { sectionOf[s.id] = s; });
    return Object.assign(vm, {
      structure,
      modelParams,
      cohortInputGroups,
      settingsQuery: this.state.settingsQuery || "",
      settingsFiltering: !!q,
      settingsSections,
      settingsSection: sectionOf,
      settingsClient: client,
      settingsNoMatch: !!q && !settingsSections.some(s => s.visible),
      settingsNoMatchNote: q ? "Nothing in Settings matches “" + String(this.state.settingsQuery).trim() + "”." : "",
      onSettingsQuery: e => this.setState({ settingsQuery: e.target.value }),
      onSettingsQueryKey: e => { if (e.key === "Escape") this.setState({ settingsQuery: "" }); },
      clearSettingsQuery: () => this.setState({ settingsQuery: "" })
    });
  }
}

